/*! For license information please see sellMyCar.86aedd5eb7b8193f6ae9.js.LICENSE.txt */
(() => {
  "use strict";
  var e = {
      175: (e, t) => {
        const n = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/,
          r = /^[\u0021-\u003A\u003C-\u007E]*$/,
          o =
            /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i,
          a = /^[\u0020-\u003A\u003D-\u007E]*$/,
          l = Object.prototype.toString,
          i = (() => {
            const e = function () {};
            return (e.prototype = Object.create(null)), e;
          })();
        function s(e, t, n) {
          do {
            const n = e.charCodeAt(t);
            if (32 !== n && 9 !== n) return t;
          } while (++t < n);
          return n;
        }
        function c(e, t, n) {
          for (; t > n; ) {
            const n = e.charCodeAt(--t);
            if (32 !== n && 9 !== n) return t + 1;
          }
          return n;
        }
        function u(e) {
          if (-1 === e.indexOf("%")) return e;
          try {
            return decodeURIComponent(e);
          } catch (t) {
            return e;
          }
        }
      },
      122: (e) => {
        e.exports = function e(t, n) {
          if (t === n) return !0;
          if (t && n && "object" == typeof t && "object" == typeof n) {
            if (t.constructor !== n.constructor) return !1;
            var r, o, a;
            if (Array.isArray(t)) {
              if ((r = t.length) != n.length) return !1;
              for (o = r; 0 !== o--; ) if (!e(t[o], n[o])) return !1;
              return !0;
            }
            if (t.constructor === RegExp)
              return t.source === n.source && t.flags === n.flags;
            if (t.valueOf !== Object.prototype.valueOf)
              return t.valueOf() === n.valueOf();
            if (t.toString !== Object.prototype.toString)
              return t.toString() === n.toString();
            if ((r = (a = Object.keys(t)).length) !== Object.keys(n).length)
              return !1;
            for (o = r; 0 !== o--; )
              if (!Object.prototype.hasOwnProperty.call(n, a[o])) return !1;
            for (o = r; 0 !== o--; ) {
              var l = a[o];
              if (!e(t[l], n[l])) return !1;
            }
            return !0;
          }
          return t !== t && n !== n;
        };
      },
      4: (e, t, n) => {
        var r = n(853),
          o = n(43),
          a = n(950);
        function l(e) {
          var t = "https://react.dev/errors/" + e;
          if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for (var n = 2; n < arguments.length; n++)
              t += "&args[]=" + encodeURIComponent(arguments[n]);
          }
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        function i(e) {
          return !(
            !e ||
            (1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType)
          );
        }
        var s = Symbol.for("react.element"),
          c = Symbol.for("react.transitional.element"),
          u = Symbol.for("react.portal"),
          d = Symbol.for("react.fragment"),
          f = Symbol.for("react.strict_mode"),
          p = Symbol.for("react.profiler"),
          m = Symbol.for("react.provider"),
          h = Symbol.for("react.consumer"),
          v = Symbol.for("react.context"),
          y = Symbol.for("react.forward_ref"),
          g = Symbol.for("react.suspense"),
          b = Symbol.for("react.suspense_list"),
          w = Symbol.for("react.memo"),
          x = Symbol.for("react.lazy");
        Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
        var S = Symbol.for("react.offscreen");
        Symbol.for("react.legacy_hidden"), Symbol.for("react.tracing_marker");
        var k = Symbol.for("react.memo_cache_sentinel"),
          C = Symbol.iterator;
        function E(e) {
          return null === e || "object" !== typeof e
            ? null
            : "function" === typeof (e = (C && e[C]) || e["@@iterator"])
            ? e
            : null;
        }
        var N = Symbol.for("react.client.reference");
        function P(e) {
          if (null == e) return null;
          if ("function" === typeof e)
            return e.$$typeof === N ? null : e.displayName || e.name || null;
          if ("string" === typeof e) return e;
          switch (e) {
            case d:
              return "Fragment";
            case u:
              return "Portal";
            case p:
              return "Profiler";
            case f:
              return "StrictMode";
            case g:
              return "Suspense";
            case b:
              return "SuspenseList";
          }
          if ("object" === typeof e)
            switch (e.$$typeof) {
              case v:
                return (e.displayName || "Context") + ".Provider";
              case h:
                return (e._context.displayName || "Context") + ".Consumer";
              case y:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e =
                      "" !== (e = t.displayName || t.name || "")
                        ? "ForwardRef(" + e + ")"
                        : "ForwardRef"),
                  e
                );
              case w:
                return null !== (t = e.displayName || null)
                  ? t
                  : P(e.type) || "Memo";
              case x:
                (t = e._payload), (e = e._init);
                try {
                  return P(e(t));
                } catch (n) {}
            }
          return null;
        }
        var j,
          z,
          T = o.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          R = Object.assign;
        function _(e) {
          if (void 0 === j)
            try {
              throw Error();
            } catch (n) {
              var t = n.stack.trim().match(/\n( *(at )?)/);
              (j = (t && t[1]) || ""),
                (z =
                  -1 < n.stack.indexOf("\n    at")
                    ? " (<anonymous>)"
                    : -1 < n.stack.indexOf("@")
                    ? "@unknown:0:0"
                    : "");
            }
          return "\n" + j + e + z;
        }
        var O = !1;
        function A(e, t) {
          if (!e || O) return "";
          O = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var r = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (t) {
                    var n = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(n.prototype, "props", {
                        set: function () {
                          throw Error();
                        },
                      }),
                      "object" === typeof Reflect && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(n, []);
                      } catch (o) {
                        var r = o;
                      }
                      Reflect.construct(e, [], n);
                    } else {
                      try {
                        n.call();
                      } catch (a) {
                        r = a;
                      }
                      e.call(n.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (l) {
                      r = l;
                    }
                    (n = e()) &&
                      "function" === typeof n.catch &&
                      n.catch(function () {});
                  }
                } catch (i) {
                  if (i && r && "string" === typeof i.stack)
                    return [i.stack, r.stack];
                }
                return [null, null];
              },
            };
            r.DetermineComponentFrameRoot.displayName =
              "DetermineComponentFrameRoot";
            var o = Object.getOwnPropertyDescriptor(
              r.DetermineComponentFrameRoot,
              "name"
            );
            o &&
              o.configurable &&
              Object.defineProperty(r.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot",
              });
            var a = r.DetermineComponentFrameRoot(),
              l = a[0],
              i = a[1];
            if (l && i) {
              var s = l.split("\n"),
                c = i.split("\n");
              for (
                o = r = 0;
                r < s.length && !s[r].includes("DetermineComponentFrameRoot");

              )
                r++;
              for (
                ;
                o < c.length && !c[o].includes("DetermineComponentFrameRoot");

              )
                o++;
              if (r === s.length || o === c.length)
                for (
                  r = s.length - 1, o = c.length - 1;
                  1 <= r && 0 <= o && s[r] !== c[o];

                )
                  o--;
              for (; 1 <= r && 0 <= o; r--, o--)
                if (s[r] !== c[o]) {
                  if (1 !== r || 1 !== o)
                    do {
                      if ((r--, 0 > --o || s[r] !== c[o])) {
                        var u = "\n" + s[r].replace(" at new ", " at ");
                        return (
                          e.displayName &&
                            u.includes("<anonymous>") &&
                            (u = u.replace("<anonymous>", e.displayName)),
                          u
                        );
                      }
                    } while (1 <= r && 0 <= o);
                  break;
                }
            }
          } finally {
            (O = !1), (Error.prepareStackTrace = n);
          }
          return (n = e ? e.displayName || e.name : "") ? _(n) : "";
        }
        function L(e) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              return _(e.type);
            case 16:
              return _("Lazy");
            case 13:
              return _("Suspense");
            case 19:
              return _("SuspenseList");
            case 0:
            case 15:
              return (e = A(e.type, !1));
            case 11:
              return (e = A(e.type.render, !1));
            case 1:
              return (e = A(e.type, !0));
            default:
              return "";
          }
        }
        function D(e) {
          try {
            var t = "";
            do {
              (t += L(e)), (e = e.return);
            } while (e);
            return t;
          } catch (n) {
            return "\nError generating stack: " + n.message + "\n" + n.stack;
          }
        }
        function F(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do {
              0 !== (4098 & (t = e).flags) && (n = t.return), (e = t.return);
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function M(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (
              (null === t &&
                null !== (e = e.alternate) &&
                (t = e.memoizedState),
              null !== t)
            )
              return t.dehydrated;
          }
          return null;
        }
        function I(e) {
          if (F(e) !== e) throw Error(l(188));
        }
        function V(e) {
          var t = e.tag;
          if (5 === t || 26 === t || 27 === t || 6 === t) return e;
          for (e = e.child; null !== e; ) {
            if (null !== (t = V(e))) return t;
            e = e.sibling;
          }
          return null;
        }
        var W = Array.isArray,
          H = a.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          B = { pending: !1, data: null, method: null, action: null },
          U = [],
          $ = -1;
        function q(e) {
          return { current: e };
        }
        function Y(e) {
          0 > $ || ((e.current = U[$]), (U[$] = null), $--);
        }
        function K(e, t) {
          $++, (U[$] = e.current), (e.current = t);
        }
        var Q = q(null),
          X = q(null),
          G = q(null),
          J = q(null);
        function Z(e, t) {
          switch ((K(G, t), K(X, e), K(Q, null), (e = t.nodeType))) {
            case 9:
            case 11:
              t = (t = t.documentElement) && (t = t.namespaceURI) ? Xu(t) : 0;
              break;
            default:
              if (
                ((t = (e = 8 === e ? t.parentNode : t).tagName),
                (e = e.namespaceURI))
              )
                t = Gu((e = Xu(e)), t);
              else
                switch (t) {
                  case "svg":
                    t = 1;
                    break;
                  case "math":
                    t = 2;
                    break;
                  default:
                    t = 0;
                }
          }
          Y(Q), K(Q, t);
        }
        function ee() {
          Y(Q), Y(X), Y(G);
        }
        function te(e) {
          null !== e.memoizedState && K(J, e);
          var t = Q.current,
            n = Gu(t, e.type);
          t !== n && (K(X, e), K(Q, n));
        }
        function ne(e) {
          X.current === e && (Y(Q), Y(X)),
            J.current === e && (Y(J), (Dd._currentValue = B));
        }
        var re = Object.prototype.hasOwnProperty,
          oe = r.unstable_scheduleCallback,
          ae = r.unstable_cancelCallback,
          le = r.unstable_shouldYield,
          ie = r.unstable_requestPaint,
          se = r.unstable_now,
          ce = r.unstable_getCurrentPriorityLevel,
          ue = r.unstable_ImmediatePriority,
          de = r.unstable_UserBlockingPriority,
          fe = r.unstable_NormalPriority,
          pe = r.unstable_LowPriority,
          me = r.unstable_IdlePriority,
          he = r.log,
          ve = r.unstable_setDisableYieldValue,
          ye = null,
          ge = null;
        function be(e) {
          if (
            ("function" === typeof he && ve(e),
            ge && "function" === typeof ge.setStrictMode)
          )
            try {
              ge.setStrictMode(ye, e);
            } catch (t) {}
        }
        var we = Math.clz32
            ? Math.clz32
            : function (e) {
                return 0 === (e >>>= 0) ? 32 : (31 - ((xe(e) / Se) | 0)) | 0;
              },
          xe = Math.log,
          Se = Math.LN2;
        var ke = 128,
          Ce = 4194304;
        function Ee(e) {
          var t = 42 & e;
          if (0 !== t) return t;
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194176 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return 62914560 & e;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return e;
          }
        }
        function Ne(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return 0;
          var r = 0,
            o = e.suspendedLanes,
            a = e.pingedLanes,
            l = e.warmLanes;
          e = 0 !== e.finishedLanes;
          var i = 134217727 & n;
          return (
            0 !== i
              ? 0 !== (n = i & ~o)
                ? (r = Ee(n))
                : 0 !== (a &= i)
                ? (r = Ee(a))
                : e || (0 !== (l = i & ~l) && (r = Ee(l)))
              : 0 !== (i = n & ~o)
              ? (r = Ee(i))
              : 0 !== a
              ? (r = Ee(a))
              : e || (0 !== (l = n & ~l) && (r = Ee(l))),
            0 === r
              ? 0
              : 0 !== t &&
                t !== r &&
                0 === (t & o) &&
                ((o = r & -r) >= (l = t & -t) ||
                  (32 === o && 0 !== (4194176 & l)))
              ? t
              : r
          );
        }
        function Pe(e, t) {
          return (
            0 === (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t)
          );
        }
        function je(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
            case 8:
              return t + 250;
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function ze() {
          var e = ke;
          return 0 === (4194176 & (ke <<= 1)) && (ke = 128), e;
        }
        function Te() {
          var e = Ce;
          return 0 === (62914560 & (Ce <<= 1)) && (Ce = 4194304), e;
        }
        function Re(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function _e(e, t) {
          (e.pendingLanes |= t),
            268435456 !== t &&
              ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0));
        }
        function Oe(e, t, n) {
          (e.pendingLanes |= t), (e.suspendedLanes &= ~t);
          var r = 31 - we(t);
          (e.entangledLanes |= t),
            (e.entanglements[r] =
              1073741824 | e.entanglements[r] | (4194218 & n));
        }
        function Ae(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n; ) {
            var r = 31 - we(n),
              o = 1 << r;
            (o & t) | (e[r] & t) && (e[r] |= t), (n &= ~o);
          }
        }
        function Le(e) {
          return 2 < (e &= -e)
            ? 8 < e
              ? 0 !== (134217727 & e)
                ? 32
                : 268435456
              : 8
            : 2;
        }
        function De() {
          var e = H.p;
          return 0 !== e ? e : void 0 === (e = window.event) ? 32 : Gd(e.type);
        }
        var Fe = Math.random().toString(36).slice(2),
          Me = "__reactFiber$" + Fe,
          Ie = "__reactProps$" + Fe,
          Ve = "__reactContainer$" + Fe,
          We = "__reactEvents$" + Fe,
          He = "__reactListeners$" + Fe,
          Be = "__reactHandles$" + Fe,
          Ue = "__reactResources$" + Fe,
          $e = "__reactMarker$" + Fe;
        function qe(e) {
          delete e[Me], delete e[Ie], delete e[We], delete e[He], delete e[Be];
        }
        function Ye(e) {
          var t = e[Me];
          if (t) return t;
          for (var n = e.parentNode; n; ) {
            if ((t = n[Ve] || n[Me])) {
              if (
                ((n = t.alternate),
                null !== t.child || (null !== n && null !== n.child))
              )
                for (e = sd(e); null !== e; ) {
                  if ((n = e[Me])) return n;
                  e = sd(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function Ke(e) {
          if ((e = e[Me] || e[Ve])) {
            var t = e.tag;
            if (
              5 === t ||
              6 === t ||
              13 === t ||
              26 === t ||
              27 === t ||
              3 === t
            )
              return e;
          }
          return null;
        }
        function Qe(e) {
          var t = e.tag;
          if (5 === t || 26 === t || 27 === t || 6 === t) return e.stateNode;
          throw Error(l(33));
        }
        function Xe(e) {
          var t = e[Ue];
          return (
            t ||
              (t = e[Ue] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            t
          );
        }
        function Ge(e) {
          e[$e] = !0;
        }
        var Je = new Set(),
          Ze = {};
        function et(e, t) {
          tt(e, t), tt(e + "Capture", t);
        }
        function tt(e, t) {
          for (Ze[e] = t, e = 0; e < t.length; e++) Je.add(t[e]);
        }
        var nt = !(
            "undefined" === typeof window ||
            "undefined" === typeof window.document ||
            "undefined" === typeof window.document.createElement
          ),
          rt = RegExp(
            "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
          ),
          ot = {},
          at = {};
        function lt(e, t, n) {
          if (
            ((o = t),
            re.call(at, o) ||
              (!re.call(ot, o) &&
                (rt.test(o) ? (at[o] = !0) : ((ot[o] = !0), 0))))
          )
            if (null === n) e.removeAttribute(t);
            else {
              switch (typeof n) {
                case "undefined":
                case "function":
                case "symbol":
                  return void e.removeAttribute(t);
                case "boolean":
                  var r = t.toLowerCase().slice(0, 5);
                  if ("data-" !== r && "aria-" !== r)
                    return void e.removeAttribute(t);
              }
              e.setAttribute(t, "" + n);
            }
          var o;
        }
        function it(e, t, n) {
          if (null === n) e.removeAttribute(t);
          else {
            switch (typeof n) {
              case "undefined":
              case "function":
              case "symbol":
              case "boolean":
                return void e.removeAttribute(t);
            }
            e.setAttribute(t, "" + n);
          }
        }
        function st(e, t, n, r) {
          if (null === r) e.removeAttribute(n);
          else {
            switch (typeof r) {
              case "undefined":
              case "function":
              case "symbol":
              case "boolean":
                return void e.removeAttribute(n);
            }
            e.setAttributeNS(t, n, "" + r);
          }
        }
        function ct(e) {
          switch (typeof e) {
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
              return e;
            default:
              return "";
          }
        }
        function ut(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === t || "radio" === t)
          );
        }
        function dt(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = ut(e) ? "checked" : "value",
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = "" + e[t];
              if (
                !e.hasOwnProperty(t) &&
                "undefined" !== typeof n &&
                "function" === typeof n.get &&
                "function" === typeof n.set
              ) {
                var o = n.get,
                  a = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return o.call(this);
                    },
                    set: function (e) {
                      (r = "" + e), a.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[t];
                    },
                  }
                );
              }
            })(e));
        }
        function ft(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return (
            e && (r = ut(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== n && (t.setValue(e), !0)
          );
        }
        function pt(e) {
          if (
            "undefined" ===
            typeof (e =
              e || ("undefined" !== typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        var mt = /[\n"\\]/g;
        function ht(e) {
          return e.replace(mt, function (e) {
            return "\\" + e.charCodeAt(0).toString(16) + " ";
          });
        }
        function vt(e, t, n, r, o, a, l, i) {
          (e.name = ""),
            null != l &&
            "function" !== typeof l &&
            "symbol" !== typeof l &&
            "boolean" !== typeof l
              ? (e.type = l)
              : e.removeAttribute("type"),
            null != t
              ? "number" === l
                ? ((0 === t && "" === e.value) || e.value != t) &&
                  (e.value = "" + ct(t))
                : e.value !== "" + ct(t) && (e.value = "" + ct(t))
              : ("submit" !== l && "reset" !== l) || e.removeAttribute("value"),
            null != t
              ? gt(e, l, ct(t))
              : null != n
              ? gt(e, l, ct(n))
              : null != r && e.removeAttribute("value"),
            null == o && null != a && (e.defaultChecked = !!a),
            null != o &&
              (e.checked =
                o && "function" !== typeof o && "symbol" !== typeof o),
            null != i &&
            "function" !== typeof i &&
            "symbol" !== typeof i &&
            "boolean" !== typeof i
              ? (e.name = "" + ct(i))
              : e.removeAttribute("name");
        }
        function yt(e, t, n, r, o, a, l, i) {
          if (
            (null != a &&
              "function" !== typeof a &&
              "symbol" !== typeof a &&
              "boolean" !== typeof a &&
              (e.type = a),
            null != t || null != n)
          ) {
            if (
              !(
                ("submit" !== a && "reset" !== a) ||
                (void 0 !== t && null !== t)
              )
            )
              return;
            (n = null != n ? "" + ct(n) : ""),
              (t = null != t ? "" + ct(t) : n),
              i || t === e.value || (e.value = t),
              (e.defaultValue = t);
          }
          (r =
            "function" !== typeof (r = null != r ? r : o) &&
            "symbol" !== typeof r &&
            !!r),
            (e.checked = i ? e.checked : !!r),
            (e.defaultChecked = !!r),
            null != l &&
              "function" !== typeof l &&
              "symbol" !== typeof l &&
              "boolean" !== typeof l &&
              (e.name = l);
        }
        function gt(e, t, n) {
          ("number" === t && pt(e.ownerDocument) === e) ||
            e.defaultValue === "" + n ||
            (e.defaultValue = "" + n);
        }
        function bt(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < n.length; o++) t["$" + n[o]] = !0;
            for (n = 0; n < e.length; n++)
              (o = t.hasOwnProperty("$" + e[n].value)),
                e[n].selected !== o && (e[n].selected = o),
                o && r && (e[n].defaultSelected = !0);
          } else {
            for (n = "" + ct(n), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === n)
                return (
                  (e[o].selected = !0), void (r && (e[o].defaultSelected = !0))
                );
              null !== t || e[o].disabled || (t = e[o]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function wt(e, t, n) {
          null == t ||
          ((t = "" + ct(t)) !== e.value && (e.value = t), null != n)
            ? (e.defaultValue = null != n ? "" + ct(n) : "")
            : e.defaultValue !== t && (e.defaultValue = t);
        }
        function xt(e, t, n, r) {
          if (null == t) {
            if (null != r) {
              if (null != n) throw Error(l(92));
              if (W(r)) {
                if (1 < r.length) throw Error(l(93));
                r = r[0];
              }
              n = r;
            }
            null == n && (n = ""), (t = n);
          }
          (n = ct(t)),
            (e.defaultValue = n),
            (r = e.textContent) === n &&
              "" !== r &&
              null !== r &&
              (e.value = r);
        }
        function St(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType)
              return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var kt = new Set(
          "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
            " "
          )
        );
        function Ct(e, t, n) {
          var r = 0 === t.indexOf("--");
          null == n || "boolean" === typeof n || "" === n
            ? r
              ? e.setProperty(t, "")
              : "float" === t
              ? (e.cssFloat = "")
              : (e[t] = "")
            : r
            ? e.setProperty(t, n)
            : "number" !== typeof n || 0 === n || kt.has(t)
            ? "float" === t
              ? (e.cssFloat = n)
              : (e[t] = ("" + n).trim())
            : (e[t] = n + "px");
        }
        function Et(e, t, n) {
          if (null != t && "object" !== typeof t) throw Error(l(62));
          if (((e = e.style), null != n)) {
            for (var r in n)
              !n.hasOwnProperty(r) ||
                (null != t && t.hasOwnProperty(r)) ||
                (0 === r.indexOf("--")
                  ? e.setProperty(r, "")
                  : "float" === r
                  ? (e.cssFloat = "")
                  : (e[r] = ""));
            for (var o in t)
              (r = t[o]), t.hasOwnProperty(o) && n[o] !== r && Ct(e, o, r);
          } else for (var a in t) t.hasOwnProperty(a) && Ct(e, a, t[a]);
        }
        function Nt(e) {
          if (-1 === e.indexOf("-")) return !1;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        var Pt = new Map([
            ["acceptCharset", "accept-charset"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
            ["crossOrigin", "crossorigin"],
            ["accentHeight", "accent-height"],
            ["alignmentBaseline", "alignment-baseline"],
            ["arabicForm", "arabic-form"],
            ["baselineShift", "baseline-shift"],
            ["capHeight", "cap-height"],
            ["clipPath", "clip-path"],
            ["clipRule", "clip-rule"],
            ["colorInterpolation", "color-interpolation"],
            ["colorInterpolationFilters", "color-interpolation-filters"],
            ["colorProfile", "color-profile"],
            ["colorRendering", "color-rendering"],
            ["dominantBaseline", "dominant-baseline"],
            ["enableBackground", "enable-background"],
            ["fillOpacity", "fill-opacity"],
            ["fillRule", "fill-rule"],
            ["floodColor", "flood-color"],
            ["floodOpacity", "flood-opacity"],
            ["fontFamily", "font-family"],
            ["fontSize", "font-size"],
            ["fontSizeAdjust", "font-size-adjust"],
            ["fontStretch", "font-stretch"],
            ["fontStyle", "font-style"],
            ["fontVariant", "font-variant"],
            ["fontWeight", "font-weight"],
            ["glyphName", "glyph-name"],
            ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
            ["glyphOrientationVertical", "glyph-orientation-vertical"],
            ["horizAdvX", "horiz-adv-x"],
            ["horizOriginX", "horiz-origin-x"],
            ["imageRendering", "image-rendering"],
            ["letterSpacing", "letter-spacing"],
            ["lightingColor", "lighting-color"],
            ["markerEnd", "marker-end"],
            ["markerMid", "marker-mid"],
            ["markerStart", "marker-start"],
            ["overlinePosition", "overline-position"],
            ["overlineThickness", "overline-thickness"],
            ["paintOrder", "paint-order"],
            ["panose-1", "panose-1"],
            ["pointerEvents", "pointer-events"],
            ["renderingIntent", "rendering-intent"],
            ["shapeRendering", "shape-rendering"],
            ["stopColor", "stop-color"],
            ["stopOpacity", "stop-opacity"],
            ["strikethroughPosition", "strikethrough-position"],
            ["strikethroughThickness", "strikethrough-thickness"],
            ["strokeDasharray", "stroke-dasharray"],
            ["strokeDashoffset", "stroke-dashoffset"],
            ["strokeLinecap", "stroke-linecap"],
            ["strokeLinejoin", "stroke-linejoin"],
            ["strokeMiterlimit", "stroke-miterlimit"],
            ["strokeOpacity", "stroke-opacity"],
            ["strokeWidth", "stroke-width"],
            ["textAnchor", "text-anchor"],
            ["textDecoration", "text-decoration"],
            ["textRendering", "text-rendering"],
            ["transformOrigin", "transform-origin"],
            ["underlinePosition", "underline-position"],
            ["underlineThickness", "underline-thickness"],
            ["unicodeBidi", "unicode-bidi"],
            ["unicodeRange", "unicode-range"],
            ["unitsPerEm", "units-per-em"],
            ["vAlphabetic", "v-alphabetic"],
            ["vHanging", "v-hanging"],
            ["vIdeographic", "v-ideographic"],
            ["vMathematical", "v-mathematical"],
            ["vectorEffect", "vector-effect"],
            ["vertAdvY", "vert-adv-y"],
            ["vertOriginX", "vert-origin-x"],
            ["vertOriginY", "vert-origin-y"],
            ["wordSpacing", "word-spacing"],
            ["writingMode", "writing-mode"],
            ["xmlnsXlink", "xmlns:xlink"],
            ["xHeight", "x-height"],
          ]),
          jt =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function zt(e) {
          return jt.test("" + e)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : e;
        }
        var Tt = null;
        function Rt(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var _t = null,
          Ot = null;
        function At(e) {
          var t = Ke(e);
          if (t && (e = t.stateNode)) {
            var n = e[Ie] || null;
            e: switch (((e = t.stateNode), t.type)) {
              case "input":
                if (
                  (vt(
                    e,
                    n.value,
                    n.defaultValue,
                    n.defaultValue,
                    n.checked,
                    n.defaultChecked,
                    n.type,
                    n.name
                  ),
                  (t = n.name),
                  "radio" === n.type && null != t)
                ) {
                  for (n = e; n.parentNode; ) n = n.parentNode;
                  for (
                    n = n.querySelectorAll(
                      'input[name="' + ht("" + t) + '"][type="radio"]'
                    ),
                      t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var o = r[Ie] || null;
                      if (!o) throw Error(l(90));
                      vt(
                        r,
                        o.value,
                        o.defaultValue,
                        o.defaultValue,
                        o.checked,
                        o.defaultChecked,
                        o.type,
                        o.name
                      );
                    }
                  }
                  for (t = 0; t < n.length; t++)
                    (r = n[t]).form === e.form && ft(r);
                }
                break e;
              case "textarea":
                wt(e, n.value, n.defaultValue);
                break e;
              case "select":
                null != (t = n.value) && bt(e, !!n.multiple, t, !1);
            }
          }
        }
        var Lt = !1;
        function Dt(e, t, n) {
          if (Lt) return e(t, n);
          Lt = !0;
          try {
            return e(t);
          } finally {
            if (
              ((Lt = !1),
              (null !== _t || null !== Ot) &&
                (Mc(), _t && ((t = _t), (e = Ot), (Ot = _t = null), At(t), e)))
            )
              for (t = 0; t < e.length; t++) At(e[t]);
          }
        }
        function Ft(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = n[Ie] || null;
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" !== typeof n) throw Error(l(231, t, typeof n));
          return n;
        }
        var Mt = !1;
        if (nt)
          try {
            var It = {};
            Object.defineProperty(It, "passive", {
              get: function () {
                Mt = !0;
              },
            }),
              window.addEventListener("test", It, It),
              window.removeEventListener("test", It, It);
          } catch (Sf) {
            Mt = !1;
          }
        var Vt = null,
          Wt = null,
          Ht = null;
        function Bt() {
          if (Ht) return Ht;
          var e,
            t,
            n = Wt,
            r = n.length,
            o = "value" in Vt ? Vt.value : Vt.textContent,
            a = o.length;
          for (e = 0; e < r && n[e] === o[e]; e++);
          var l = r - e;
          for (t = 1; t <= l && n[r - t] === o[a - t]; t++);
          return (Ht = o.slice(e, 1 < t ? 1 - t : void 0));
        }
        function Ut(e) {
          var t = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === t && (e = 13)
              : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function $t() {
          return !0;
        }
        function qt() {
          return !1;
        }
        function Yt(e) {
          function t(t, n, r, o, a) {
            for (var l in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = o),
            (this.target = a),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(l) && ((t = e[l]), (this[l] = t ? t(o) : o[l]));
            return (
              (this.isDefaultPrevented = (
                null != o.defaultPrevented
                  ? o.defaultPrevented
                  : !1 === o.returnValue
              )
                ? $t
                : qt),
              (this.isPropagationStopped = qt),
              this
            );
          }
          return (
            R(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" !== typeof e.returnValue &&
                      (e.returnValue = !1),
                  (this.isDefaultPrevented = $t));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" !== typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = $t));
              },
              persist: function () {},
              isPersistent: $t,
            }),
            t
          );
        }
        var Kt,
          Qt,
          Xt,
          Gt = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          Jt = Yt(Gt),
          Zt = R({}, Gt, { view: 0, detail: 0 }),
          en = Yt(Zt),
          tn = R({}, Zt, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: pn,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== Xt &&
                    (Xt && "mousemove" === e.type
                      ? ((Kt = e.screenX - Xt.screenX),
                        (Qt = e.screenY - Xt.screenY))
                      : (Qt = Kt = 0),
                    (Xt = e)),
                  Kt);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : Qt;
            },
          }),
          nn = Yt(tn),
          rn = Yt(R({}, tn, { dataTransfer: 0 })),
          on = Yt(R({}, Zt, { relatedTarget: 0 })),
          an = Yt(
            R({}, Gt, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          ln = Yt(
            R({}, Gt, {
              clipboardData: function (e) {
                return "clipboardData" in e
                  ? e.clipboardData
                  : window.clipboardData;
              },
            })
          ),
          sn = Yt(R({}, Gt, { data: 0 })),
          cn = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          un = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          dn = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function fn(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : !!(e = dn[e]) && !!t[e];
        }
        function pn() {
          return fn;
        }
        var mn = Yt(
            R({}, Zt, {
              key: function (e) {
                if (e.key) {
                  var t = cn[e.key] || e.key;
                  if ("Unidentified" !== t) return t;
                }
                return "keypress" === e.type
                  ? 13 === (e = Ut(e))
                    ? "Enter"
                    : String.fromCharCode(e)
                  : "keydown" === e.type || "keyup" === e.type
                  ? un[e.keyCode] || "Unidentified"
                  : "";
              },
              code: 0,
              location: 0,
              ctrlKey: 0,
              shiftKey: 0,
              altKey: 0,
              metaKey: 0,
              repeat: 0,
              locale: 0,
              getModifierState: pn,
              charCode: function (e) {
                return "keypress" === e.type ? Ut(e) : 0;
              },
              keyCode: function (e) {
                return "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
              },
              which: function (e) {
                return "keypress" === e.type
                  ? Ut(e)
                  : "keydown" === e.type || "keyup" === e.type
                  ? e.keyCode
                  : 0;
              },
            })
          ),
          hn = Yt(
            R({}, tn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            })
          ),
          vn = Yt(
            R({}, Zt, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: pn,
            })
          ),
          yn = Yt(
            R({}, Gt, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          gn = Yt(
            R({}, tn, {
              deltaX: function (e) {
                return "deltaX" in e
                  ? e.deltaX
                  : "wheelDeltaX" in e
                  ? -e.wheelDeltaX
                  : 0;
              },
              deltaY: function (e) {
                return "deltaY" in e
                  ? e.deltaY
                  : "wheelDeltaY" in e
                  ? -e.wheelDeltaY
                  : "wheelDelta" in e
                  ? -e.wheelDelta
                  : 0;
              },
              deltaZ: 0,
              deltaMode: 0,
            })
          ),
          bn = Yt(R({}, Gt, { newState: 0, oldState: 0 })),
          wn = [9, 13, 27, 32],
          xn = nt && "CompositionEvent" in window,
          Sn = null;
        nt && "documentMode" in document && (Sn = document.documentMode);
        var kn = nt && "TextEvent" in window && !Sn,
          Cn = nt && (!xn || (Sn && 8 < Sn && 11 >= Sn)),
          En = String.fromCharCode(32),
          Nn = !1;
        function Pn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== wn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function jn(e) {
          return "object" === typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var zn = !1;
        var Tn = {
          color: !0,
          date: !0,
          datetime: !0,
          "datetime-local": !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function Rn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!Tn[e.type] : "textarea" === t;
        }
        function _n(e, t, n, r) {
          _t ? (Ot ? Ot.push(r) : (Ot = [r])) : (_t = r),
            0 < (t = Du(t, "onChange")).length &&
              ((n = new Jt("onChange", "change", null, n, r)),
              e.push({ event: n, listeners: t }));
        }
        var On = null,
          An = null;
        function Ln(e) {
          ju(e, 0);
        }
        function Dn(e) {
          if (ft(Qe(e))) return e;
        }
        function Fn(e, t) {
          if ("change" === e) return t;
        }
        var Mn = !1;
        if (nt) {
          var In;
          if (nt) {
            var Vn = "oninput" in document;
            if (!Vn) {
              var Wn = document.createElement("div");
              Wn.setAttribute("oninput", "return;"),
                (Vn = "function" === typeof Wn.oninput);
            }
            In = Vn;
          } else In = !1;
          Mn = In && (!document.documentMode || 9 < document.documentMode);
        }
        function Hn() {
          On && (On.detachEvent("onpropertychange", Bn), (An = On = null));
        }
        function Bn(e) {
          if ("value" === e.propertyName && Dn(An)) {
            var t = [];
            _n(t, An, e, Rt(e)), Dt(Ln, t);
          }
        }
        function Un(e, t, n) {
          "focusin" === e
            ? (Hn(), (An = n), (On = t).attachEvent("onpropertychange", Bn))
            : "focusout" === e && Hn();
        }
        function $n(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return Dn(An);
        }
        function qn(e, t) {
          if ("click" === e) return Dn(t);
        }
        function Yn(e, t) {
          if ("input" === e || "change" === e) return Dn(t);
        }
        var Kn =
          "function" === typeof Object.is
            ? Object.is
            : function (e, t) {
                return (
                  (e === t && (0 !== e || 1 / e === 1 / t)) ||
                  (e !== e && t !== t)
                );
              };
        function Qn(e, t) {
          if (Kn(e, t)) return !0;
          if (
            "object" !== typeof e ||
            null === e ||
            "object" !== typeof t ||
            null === t
          )
            return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var o = n[r];
            if (!re.call(t, o) || !Kn(e[o], t[o])) return !1;
          }
          return !0;
        }
        function Xn(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function Gn(e, t) {
          var n,
            r = Xn(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t))
                return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = Xn(r);
          }
        }
        function Jn(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? Jn(e, t.parentNode)
                  : "contains" in e
                  ? e.contains(t)
                  : !!e.compareDocumentPosition &&
                    !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function Zn(e) {
          for (
            var t = pt(
              (e =
                null != e &&
                null != e.ownerDocument &&
                null != e.ownerDocument.defaultView
                  ? e.ownerDocument.defaultView
                  : window).document
            );
            t instanceof e.HTMLIFrameElement;

          ) {
            try {
              var n = "string" === typeof t.contentWindow.location.href;
            } catch (r) {
              n = !1;
            }
            if (!n) break;
            t = pt((e = t.contentWindow).document);
          }
          return t;
        }
        function er(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (("input" === t &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === t ||
              "true" === e.contentEditable)
          );
        }
        function tr(e, t) {
          var n = Zn(t);
          t = e.focusedElem;
          var r = e.selectionRange;
          if (
            n !== t &&
            t &&
            t.ownerDocument &&
            Jn(t.ownerDocument.documentElement, t)
          ) {
            if (null !== r && er(t))
              if (
                ((e = r.start),
                void 0 === (n = r.end) && (n = e),
                "selectionStart" in t)
              )
                (t.selectionStart = e),
                  (t.selectionEnd = Math.min(n, t.value.length));
              else if (
                (n =
                  ((e = t.ownerDocument || document) && e.defaultView) ||
                  window).getSelection
              ) {
                n = n.getSelection();
                var o = t.textContent.length,
                  a = Math.min(r.start, o);
                (r = void 0 === r.end ? a : Math.min(r.end, o)),
                  !n.extend && a > r && ((o = r), (r = a), (a = o)),
                  (o = Gn(t, a));
                var l = Gn(t, r);
                o &&
                  l &&
                  (1 !== n.rangeCount ||
                    n.anchorNode !== o.node ||
                    n.anchorOffset !== o.offset ||
                    n.focusNode !== l.node ||
                    n.focusOffset !== l.offset) &&
                  ((e = e.createRange()).setStart(o.node, o.offset),
                  n.removeAllRanges(),
                  a > r
                    ? (n.addRange(e), n.extend(l.node, l.offset))
                    : (e.setEnd(l.node, l.offset), n.addRange(e)));
              }
            for (e = [], n = t; (n = n.parentNode); )
              1 === n.nodeType &&
                e.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
            for (
              "function" === typeof t.focus && t.focus(), t = 0;
              t < e.length;
              t++
            )
              ((n = e[t]).element.scrollLeft = n.left),
                (n.element.scrollTop = n.top);
          }
        }
        var nr =
            nt && "documentMode" in document && 11 >= document.documentMode,
          rr = null,
          or = null,
          ar = null,
          lr = !1;
        function ir(e, t, n) {
          var r =
            n.window === n
              ? n.document
              : 9 === n.nodeType
              ? n
              : n.ownerDocument;
          lr ||
            null == rr ||
            rr !== pt(r) ||
            ("selectionStart" in (r = rr) && er(r)
              ? (r = { start: r.selectionStart, end: r.selectionEnd })
              : (r = {
                  anchorNode: (r = (
                    (r.ownerDocument && r.ownerDocument.defaultView) ||
                    window
                  ).getSelection()).anchorNode,
                  anchorOffset: r.anchorOffset,
                  focusNode: r.focusNode,
                  focusOffset: r.focusOffset,
                }),
            (ar && Qn(ar, r)) ||
              ((ar = r),
              0 < (r = Du(or, "onSelect")).length &&
                ((t = new Jt("onSelect", "select", null, t, n)),
                e.push({ event: t, listeners: r }),
                (t.target = rr))));
        }
        function sr(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()),
            (n["Webkit" + e] = "webkit" + t),
            (n["Moz" + e] = "moz" + t),
            n
          );
        }
        var cr = {
            animationend: sr("Animation", "AnimationEnd"),
            animationiteration: sr("Animation", "AnimationIteration"),
            animationstart: sr("Animation", "AnimationStart"),
            transitionrun: sr("Transition", "TransitionRun"),
            transitionstart: sr("Transition", "TransitionStart"),
            transitioncancel: sr("Transition", "TransitionCancel"),
            transitionend: sr("Transition", "TransitionEnd"),
          },
          ur = {},
          dr = {};
        function fr(e) {
          if (ur[e]) return ur[e];
          if (!cr[e]) return e;
          var t,
            n = cr[e];
          for (t in n)
            if (n.hasOwnProperty(t) && t in dr) return (ur[e] = n[t]);
          return e;
        }
        nt &&
          ((dr = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete cr.animationend.animation,
            delete cr.animationiteration.animation,
            delete cr.animationstart.animation),
          "TransitionEvent" in window || delete cr.transitionend.transition);
        var pr = fr("animationend"),
          mr = fr("animationiteration"),
          hr = fr("animationstart"),
          vr = fr("transitionrun"),
          yr = fr("transitionstart"),
          gr = fr("transitioncancel"),
          br = fr("transitionend"),
          wr = new Map(),
          xr =
            "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(
              " "
            );
        function Sr(e, t) {
          wr.set(e, t), et(t, [e]);
        }
        var kr = [],
          Cr = 0,
          Er = 0;
        function Nr() {
          for (var e = Cr, t = (Er = Cr = 0); t < e; ) {
            var n = kr[t];
            kr[t++] = null;
            var r = kr[t];
            kr[t++] = null;
            var o = kr[t];
            kr[t++] = null;
            var a = kr[t];
            if (((kr[t++] = null), null !== r && null !== o)) {
              var l = r.pending;
              null === l ? (o.next = o) : ((o.next = l.next), (l.next = o)),
                (r.pending = o);
            }
            0 !== a && Tr(n, o, a);
          }
        }
        function Pr(e, t, n, r) {
          (kr[Cr++] = e),
            (kr[Cr++] = t),
            (kr[Cr++] = n),
            (kr[Cr++] = r),
            (Er |= r),
            (e.lanes |= r),
            null !== (e = e.alternate) && (e.lanes |= r);
        }
        function jr(e, t, n, r) {
          return Pr(e, t, n, r), Rr(e);
        }
        function zr(e, t) {
          return Pr(e, null, null, t), Rr(e);
        }
        function Tr(e, t, n) {
          e.lanes |= n;
          var r = e.alternate;
          null !== r && (r.lanes |= n);
          for (var o = !1, a = e.return; null !== a; )
            (a.childLanes |= n),
              null !== (r = a.alternate) && (r.childLanes |= n),
              22 === a.tag &&
                (null === (e = a.stateNode) || 1 & e._visibility || (o = !0)),
              (e = a),
              (a = a.return);
          o &&
            null !== t &&
            3 === e.tag &&
            ((a = e.stateNode),
            (o = 31 - we(n)),
            null === (e = (a = a.hiddenUpdates)[o]) ? (a[o] = [t]) : e.push(t),
            (t.lane = 536870912 | n));
        }
        function Rr(e) {
          if (50 < jc) throw ((jc = 0), (zc = null), Error(l(185)));
          for (var t = e.return; null !== t; ) t = (e = t).return;
          return 3 === e.tag ? e.stateNode : null;
        }
        var _r = {},
          Or = new WeakMap();
        function Ar(e, t) {
          if ("object" === typeof e && null !== e) {
            var n = Or.get(e);
            return void 0 !== n
              ? n
              : ((t = { value: e, source: t, stack: D(t) }), Or.set(e, t), t);
          }
          return { value: e, source: t, stack: D(t) };
        }
        var Lr = [],
          Dr = 0,
          Fr = null,
          Mr = 0,
          Ir = [],
          Vr = 0,
          Wr = null,
          Hr = 1,
          Br = "";
        function Ur(e, t) {
          (Lr[Dr++] = Mr), (Lr[Dr++] = Fr), (Fr = e), (Mr = t);
        }
        function $r(e, t, n) {
          (Ir[Vr++] = Hr), (Ir[Vr++] = Br), (Ir[Vr++] = Wr), (Wr = e);
          var r = Hr;
          e = Br;
          var o = 32 - we(r) - 1;
          (r &= ~(1 << o)), (n += 1);
          var a = 32 - we(t) + o;
          if (30 < a) {
            var l = o - (o % 5);
            (a = (r & ((1 << l) - 1)).toString(32)),
              (r >>= l),
              (o -= l),
              (Hr = (1 << (32 - we(t) + o)) | (n << o) | r),
              (Br = a + e);
          } else (Hr = (1 << a) | (n << o) | r), (Br = e);
        }
        function qr(e) {
          null !== e.return && (Ur(e, 1), $r(e, 1, 0));
        }
        function Yr(e) {
          for (; e === Fr; )
            (Fr = Lr[--Dr]), (Lr[Dr] = null), (Mr = Lr[--Dr]), (Lr[Dr] = null);
          for (; e === Wr; )
            (Wr = Ir[--Vr]),
              (Ir[Vr] = null),
              (Br = Ir[--Vr]),
              (Ir[Vr] = null),
              (Hr = Ir[--Vr]),
              (Ir[Vr] = null);
        }
        var Kr = null,
          Qr = null,
          Xr = !1,
          Gr = null,
          Jr = !1,
          Zr = Error(l(519));
        function eo(e) {
          throw (ao(Ar(Error(l(418, "")), e)), Zr);
        }
        function to(e) {
          var t = e.stateNode,
            n = e.type,
            r = e.memoizedProps;
          switch (((t[Me] = e), (t[Ie] = r), n)) {
            case "dialog":
              zu("cancel", t), zu("close", t);
              break;
            case "iframe":
            case "object":
            case "embed":
              zu("load", t);
              break;
            case "video":
            case "audio":
              for (n = 0; n < Nu.length; n++) zu(Nu[n], t);
              break;
            case "source":
              zu("error", t);
              break;
            case "img":
            case "image":
            case "link":
              zu("error", t), zu("load", t);
              break;
            case "details":
              zu("toggle", t);
              break;
            case "input":
              zu("invalid", t),
                yt(
                  t,
                  r.value,
                  r.defaultValue,
                  r.checked,
                  r.defaultChecked,
                  r.type,
                  r.name,
                  !0
                ),
                dt(t);
              break;
            case "select":
              zu("invalid", t);
              break;
            case "textarea":
              zu("invalid", t),
                xt(t, r.value, r.defaultValue, r.children),
                dt(t);
          }
          ("string" !== typeof (n = r.children) &&
            "number" !== typeof n &&
            "bigint" !== typeof n) ||
          t.textContent === "" + n ||
          !0 === r.suppressHydrationWarning ||
          Hu(t.textContent, n)
            ? (null != r.popover && (zu("beforetoggle", t), zu("toggle", t)),
              null != r.onScroll && zu("scroll", t),
              null != r.onScrollEnd && zu("scrollend", t),
              null != r.onClick && (t.onclick = Bu),
              (t = !0))
            : (t = !1),
            t || eo(e);
        }
        function no(e) {
          for (Kr = e.return; Kr; )
            switch (Kr.tag) {
              case 3:
              case 27:
                return void (Jr = !0);
              case 5:
              case 13:
                return void (Jr = !1);
              default:
                Kr = Kr.return;
            }
        }
        function ro(e) {
          if (e !== Kr) return !1;
          if (!Xr) return no(e), (Xr = !0), !1;
          var t,
            n = !1;
          if (
            ((t = 3 !== e.tag && 27 !== e.tag) &&
              ((t = 5 === e.tag) &&
                (t =
                  !("form" !== (t = e.type) && "button" !== t) ||
                  Ju(e.type, e.memoizedProps)),
              (t = !t)),
            t && (n = !0),
            n && Qr && eo(e),
            no(e),
            13 === e.tag)
          ) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(l(317));
            e: {
              for (e = e.nextSibling, n = 0; e; ) {
                if (8 === e.nodeType)
                  if ("/$" === (t = e.data)) {
                    if (0 === n) {
                      Qr = id(e.nextSibling);
                      break e;
                    }
                    n--;
                  } else ("$" !== t && "$!" !== t && "$?" !== t) || n++;
                e = e.nextSibling;
              }
              Qr = null;
            }
          } else Qr = Kr ? id(e.stateNode.nextSibling) : null;
          return !0;
        }
        function oo() {
          (Qr = Kr = null), (Xr = !1);
        }
        function ao(e) {
          null === Gr ? (Gr = [e]) : Gr.push(e);
        }
        var lo = Error(l(460)),
          io = Error(l(474)),
          so = { then: function () {} };
        function co(e) {
          return "fulfilled" === (e = e.status) || "rejected" === e;
        }
        function uo() {}
        function fo(e, t, n) {
          switch (
            (void 0 === (n = e[n])
              ? e.push(t)
              : n !== t && (t.then(uo, uo), (t = n)),
            t.status)
          ) {
            case "fulfilled":
              return t.value;
            case "rejected":
              if ((e = t.reason) === lo) throw Error(l(483));
              throw e;
            default:
              if ("string" === typeof t.status) t.then(uo, uo);
              else {
                if (null !== (e = tc) && 100 < e.shellSuspendCounter)
                  throw Error(l(482));
                ((e = t).status = "pending"),
                  e.then(
                    function (e) {
                      if ("pending" === t.status) {
                        var n = t;
                        (n.status = "fulfilled"), (n.value = e);
                      }
                    },
                    function (e) {
                      if ("pending" === t.status) {
                        var n = t;
                        (n.status = "rejected"), (n.reason = e);
                      }
                    }
                  );
              }
              switch (t.status) {
                case "fulfilled":
                  return t.value;
                case "rejected":
                  if ((e = t.reason) === lo) throw Error(l(483));
                  throw e;
              }
              throw ((po = t), lo);
          }
        }
        var po = null;
        function mo() {
          if (null === po) throw Error(l(459));
          var e = po;
          return (po = null), e;
        }
        var ho = null,
          vo = 0;
        function yo(e) {
          var t = vo;
          return (vo += 1), null === ho && (ho = []), fo(ho, e, t);
        }
        function go(e, t) {
          (t = t.props.ref), (e.ref = void 0 !== t ? t : null);
        }
        function bo(e, t) {
          if (t.$$typeof === s) throw Error(l(525));
          throw (
            ((e = Object.prototype.toString.call(t)),
            Error(
              l(
                31,
                "[object Object]" === e
                  ? "object with keys {" + Object.keys(t).join(", ") + "}"
                  : e
              )
            ))
          );
        }
        function wo(e) {
          return (0, e._init)(e._payload);
        }
        function xo(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r; ) t(n, r), (r = r.sibling);
            return null;
          }
          function r(e) {
            for (var t = new Map(); null !== e; )
              null !== e.key ? t.set(e.key, e) : t.set(e.index, e),
                (e = e.sibling);
            return t;
          }
          function o(e, t) {
            return ((e = Fs(e, t)).index = 0), (e.sibling = null), e;
          }
          function a(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 33554434), n)
                    : r
                  : ((t.flags |= 33554434), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function i(t) {
            return e && null === t.alternate && (t.flags |= 33554434), t;
          }
          function s(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = Hs(n, e.mode, r)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function f(e, t, n, r) {
            var a = n.type;
            return a === d
              ? m(e, t, n.props.children, r, n.key)
              : null !== t &&
                (t.elementType === a ||
                  ("object" === typeof a &&
                    null !== a &&
                    a.$$typeof === x &&
                    wo(a) === t.type))
              ? (go((t = o(t, n.props)), n), (t.return = e), t)
              : (go((t = Is(n.type, n.key, n.props, null, e.mode, r)), n),
                (t.return = e),
                t);
          }
          function p(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = Bs(n, e.mode, r)).return = e), t)
              : (((t = o(t, n.children || [])).return = e), t);
          }
          function m(e, t, n, r, a) {
            return null === t || 7 !== t.tag
              ? (((t = Vs(n, e.mode, r, a)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function h(e, t, n) {
            if (
              ("string" === typeof t && "" !== t) ||
              "number" === typeof t ||
              "bigint" === typeof t
            )
              return ((t = Hs("" + t, e.mode, n)).return = e), t;
            if ("object" === typeof t && null !== t) {
              switch (t.$$typeof) {
                case c:
                  return (
                    go((n = Is(t.type, t.key, t.props, null, e.mode, n)), t),
                    (n.return = e),
                    n
                  );
                case u:
                  return ((t = Bs(t, e.mode, n)).return = e), t;
                case x:
                  return h(e, (t = (0, t._init)(t._payload)), n);
              }
              if (W(t) || E(t))
                return ((t = Vs(t, e.mode, n, null)).return = e), t;
              if ("function" === typeof t.then) return h(e, yo(t), n);
              if (t.$$typeof === v) return h(e, Ni(e, t), n);
              bo(e, t);
            }
            return null;
          }
          function y(e, t, n, r) {
            var o = null !== t ? t.key : null;
            if (
              ("string" === typeof n && "" !== n) ||
              "number" === typeof n ||
              "bigint" === typeof n
            )
              return null !== o ? null : s(e, t, "" + n, r);
            if ("object" === typeof n && null !== n) {
              switch (n.$$typeof) {
                case c:
                  return n.key === o ? f(e, t, n, r) : null;
                case u:
                  return n.key === o ? p(e, t, n, r) : null;
                case x:
                  return y(e, t, (n = (o = n._init)(n._payload)), r);
              }
              if (W(n) || E(n)) return null !== o ? null : m(e, t, n, r, null);
              if ("function" === typeof n.then) return y(e, t, yo(n), r);
              if (n.$$typeof === v) return y(e, t, Ni(e, n), r);
              bo(e, n);
            }
            return null;
          }
          function g(e, t, n, r, o) {
            if (
              ("string" === typeof r && "" !== r) ||
              "number" === typeof r ||
              "bigint" === typeof r
            )
              return s(t, (e = e.get(n) || null), "" + r, o);
            if ("object" === typeof r && null !== r) {
              switch (r.$$typeof) {
                case c:
                  return f(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case u:
                  return p(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case x:
                  return g(e, t, n, (r = (0, r._init)(r._payload)), o);
              }
              if (W(r) || E(r)) return m(t, (e = e.get(n) || null), r, o, null);
              if ("function" === typeof r.then) return g(e, t, n, yo(r), o);
              if (r.$$typeof === v) return g(e, t, n, Ni(t, r), o);
              bo(t, r);
            }
            return null;
          }
          function b(s, f, p, m) {
            if (
              ("object" === typeof p &&
                null !== p &&
                p.type === d &&
                null === p.key &&
                (p = p.props.children),
              "object" === typeof p && null !== p)
            ) {
              switch (p.$$typeof) {
                case c:
                  e: {
                    for (var w = p.key; null !== f; ) {
                      if (f.key === w) {
                        if ((w = p.type) === d) {
                          if (7 === f.tag) {
                            n(s, f.sibling),
                              ((m = o(f, p.props.children)).return = s),
                              (s = m);
                            break e;
                          }
                        } else if (
                          f.elementType === w ||
                          ("object" === typeof w &&
                            null !== w &&
                            w.$$typeof === x &&
                            wo(w) === f.type)
                        ) {
                          n(s, f.sibling),
                            go((m = o(f, p.props)), p),
                            (m.return = s),
                            (s = m);
                          break e;
                        }
                        n(s, f);
                        break;
                      }
                      t(s, f), (f = f.sibling);
                    }
                    p.type === d
                      ? (((m = Vs(p.props.children, s.mode, m, p.key)).return =
                          s),
                        (s = m))
                      : (go(
                          (m = Is(p.type, p.key, p.props, null, s.mode, m)),
                          p
                        ),
                        (m.return = s),
                        (s = m));
                  }
                  return i(s);
                case u:
                  e: {
                    for (w = p.key; null !== f; ) {
                      if (f.key === w) {
                        if (
                          4 === f.tag &&
                          f.stateNode.containerInfo === p.containerInfo &&
                          f.stateNode.implementation === p.implementation
                        ) {
                          n(s, f.sibling),
                            ((m = o(f, p.children || [])).return = s),
                            (s = m);
                          break e;
                        }
                        n(s, f);
                        break;
                      }
                      t(s, f), (f = f.sibling);
                    }
                    ((m = Bs(p, s.mode, m)).return = s), (s = m);
                  }
                  return i(s);
                case x:
                  return b(s, f, (p = (w = p._init)(p._payload)), m);
              }
              if (W(p))
                return (function (o, l, i, s) {
                  for (
                    var c = null, u = null, d = l, f = (l = 0), p = null;
                    null !== d && f < i.length;
                    f++
                  ) {
                    d.index > f ? ((p = d), (d = null)) : (p = d.sibling);
                    var m = y(o, d, i[f], s);
                    if (null === m) {
                      null === d && (d = p);
                      break;
                    }
                    e && d && null === m.alternate && t(o, d),
                      (l = a(m, l, f)),
                      null === u ? (c = m) : (u.sibling = m),
                      (u = m),
                      (d = p);
                  }
                  if (f === i.length) return n(o, d), Xr && Ur(o, f), c;
                  if (null === d) {
                    for (; f < i.length; f++)
                      null !== (d = h(o, i[f], s)) &&
                        ((l = a(d, l, f)),
                        null === u ? (c = d) : (u.sibling = d),
                        (u = d));
                    return Xr && Ur(o, f), c;
                  }
                  for (d = r(d); f < i.length; f++)
                    null !== (p = g(d, o, f, i[f], s)) &&
                      (e &&
                        null !== p.alternate &&
                        d.delete(null === p.key ? f : p.key),
                      (l = a(p, l, f)),
                      null === u ? (c = p) : (u.sibling = p),
                      (u = p));
                  return (
                    e &&
                      d.forEach(function (e) {
                        return t(o, e);
                      }),
                    Xr && Ur(o, f),
                    c
                  );
                })(s, f, p, m);
              if (E(p)) {
                if ("function" !== typeof (w = E(p))) throw Error(l(150));
                return (function (o, i, s, c) {
                  if (null == s) throw Error(l(151));
                  for (
                    var u = null,
                      d = null,
                      f = i,
                      p = (i = 0),
                      m = null,
                      v = s.next();
                    null !== f && !v.done;
                    p++, v = s.next()
                  ) {
                    f.index > p ? ((m = f), (f = null)) : (m = f.sibling);
                    var b = y(o, f, v.value, c);
                    if (null === b) {
                      null === f && (f = m);
                      break;
                    }
                    e && f && null === b.alternate && t(o, f),
                      (i = a(b, i, p)),
                      null === d ? (u = b) : (d.sibling = b),
                      (d = b),
                      (f = m);
                  }
                  if (v.done) return n(o, f), Xr && Ur(o, p), u;
                  if (null === f) {
                    for (; !v.done; p++, v = s.next())
                      null !== (v = h(o, v.value, c)) &&
                        ((i = a(v, i, p)),
                        null === d ? (u = v) : (d.sibling = v),
                        (d = v));
                    return Xr && Ur(o, p), u;
                  }
                  for (f = r(f); !v.done; p++, v = s.next())
                    null !== (v = g(f, o, p, v.value, c)) &&
                      (e &&
                        null !== v.alternate &&
                        f.delete(null === v.key ? p : v.key),
                      (i = a(v, i, p)),
                      null === d ? (u = v) : (d.sibling = v),
                      (d = v));
                  return (
                    e &&
                      f.forEach(function (e) {
                        return t(o, e);
                      }),
                    Xr && Ur(o, p),
                    u
                  );
                })(s, f, (p = w.call(p)), m);
              }
              if ("function" === typeof p.then) return b(s, f, yo(p), m);
              if (p.$$typeof === v) return b(s, f, Ni(s, p), m);
              bo(s, p);
            }
            return ("string" === typeof p && "" !== p) ||
              "number" === typeof p ||
              "bigint" === typeof p
              ? ((p = "" + p),
                null !== f && 6 === f.tag
                  ? (n(s, f.sibling), ((m = o(f, p)).return = s), (s = m))
                  : (n(s, f), ((m = Hs(p, s.mode, m)).return = s), (s = m)),
                i(s))
              : n(s, f);
          }
          return function (e, t, n, r) {
            try {
              vo = 0;
              var o = b(e, t, n, r);
              return (ho = null), o;
            } catch (l) {
              if (l === lo) throw l;
              var a = Ls(29, l, null, e.mode);
              return (a.lanes = r), (a.return = e), a;
            }
          };
        }
        var So = xo(!0),
          ko = xo(!1),
          Co = q(null),
          Eo = q(0);
        function No(e, t) {
          K(Eo, (e = cc)), K(Co, t), (cc = e | t.baseLanes);
        }
        function Po() {
          K(Eo, cc), K(Co, Co.current);
        }
        function jo() {
          (cc = Eo.current), Y(Co), Y(Eo);
        }
        var zo = q(null),
          To = null;
        function Ro(e) {
          var t = e.alternate;
          K(Lo, 1 & Lo.current),
            K(zo, e),
            null === To &&
              (null === t || null !== Co.current || null !== t.memoizedState) &&
              (To = e);
        }
        function _o(e) {
          if (22 === e.tag) {
            if ((K(Lo, Lo.current), K(zo, e), null === To)) {
              var t = e.alternate;
              null !== t && null !== t.memoizedState && (To = e);
            }
          } else Oo();
        }
        function Oo() {
          K(Lo, Lo.current), K(zo, zo.current);
        }
        function Ao(e) {
          Y(zo), To === e && (To = null), Y(Lo);
        }
        var Lo = q(0);
        function Do(e) {
          for (var t = e; null !== t; ) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (
                null !== n &&
                (null === (n = n.dehydrated) ||
                  "$?" === n.data ||
                  "$!" === n.data)
              )
                return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (0 !== (128 & t.flags)) return t;
            } else if (null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
          return null;
        }
        var Fo =
            "undefined" !== typeof AbortController
              ? AbortController
              : function () {
                  var e = [],
                    t = (this.signal = {
                      aborted: !1,
                      addEventListener: function (t, n) {
                        e.push(n);
                      },
                    });
                  this.abort = function () {
                    (t.aborted = !0),
                      e.forEach(function (e) {
                        return e();
                      });
                  };
                },
          Mo = r.unstable_scheduleCallback,
          Io = r.unstable_NormalPriority,
          Vo = {
            $$typeof: v,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function Wo() {
          return { controller: new Fo(), data: new Map(), refCount: 0 };
        }
        function Ho(e) {
          e.refCount--,
            0 === e.refCount &&
              Mo(Io, function () {
                e.controller.abort();
              });
        }
        var Bo = null,
          Uo = 0,
          $o = 0,
          qo = null;
        function Yo() {
          if (0 === --Uo && null !== Bo) {
            null !== qo && (qo.status = "fulfilled");
            var e = Bo;
            (Bo = null), ($o = 0), (qo = null);
            for (var t = 0; t < e.length; t++) (0, e[t])();
          }
        }
        var Ko = T.S;
        T.S = function (e, t) {
          "object" === typeof t &&
            null !== t &&
            "function" === typeof t.then &&
            (function (e, t) {
              if (null === Bo) {
                var n = (Bo = []);
                (Uo = 0),
                  ($o = xu()),
                  (qo = {
                    status: "pending",
                    value: void 0,
                    then: function (e) {
                      n.push(e);
                    },
                  });
              }
              Uo++, t.then(Yo, Yo);
            })(0, t),
            null !== Ko && Ko(e, t);
        };
        var Qo = q(null);
        function Xo() {
          var e = Qo.current;
          return null !== e ? e : tc.pooledCache;
        }
        function Go(e, t) {
          K(Qo, null === t ? Qo.current : t.pool);
        }
        function Jo() {
          var e = Xo();
          return null === e ? null : { parent: Vo._currentValue, pool: e };
        }
        var Zo = 0,
          ea = null,
          ta = null,
          na = null,
          ra = !1,
          oa = !1,
          aa = !1,
          la = 0,
          ia = 0,
          sa = null,
          ca = 0;
        function ua() {
          throw Error(l(321));
        }
        function da(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++)
            if (!Kn(e[n], t[n])) return !1;
          return !0;
        }
        function fa(e, t, n, r, o, a) {
          return (
            (Zo = a),
            (ea = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (T.H = null === e || null === e.memoizedState ? Nl : Pl),
            (aa = !1),
            (a = n(r, o)),
            (aa = !1),
            oa && (a = ma(t, n, r, o)),
            pa(e),
            a
          );
        }
        function pa(e) {
          T.H = El;
          var t = null !== ta && null !== ta.next;
          if (
            ((Zo = 0),
            (na = ta = ea = null),
            (ra = !1),
            (ia = 0),
            (sa = null),
            t)
          )
            throw Error(l(300));
          null === e ||
            Ul ||
            (null !== (e = e.dependencies) && ki(e) && (Ul = !0));
        }
        function ma(e, t, n, r) {
          ea = e;
          var o = 0;
          do {
            if ((oa && (sa = null), (ia = 0), (oa = !1), 25 <= o))
              throw Error(l(301));
            if (((o += 1), (na = ta = null), null != e.updateQueue)) {
              var a = e.updateQueue;
              (a.lastEffect = null),
                (a.events = null),
                (a.stores = null),
                null != a.memoCache && (a.memoCache.index = 0);
            }
            (T.H = jl), (a = t(n, r));
          } while (oa);
          return a;
        }
        function ha() {
          var e = T.H,
            t = e.useState()[0];
          return (
            (t = "function" === typeof t.then ? xa(t) : t),
            (e = e.useState()[0]),
            (null !== ta ? ta.memoizedState : null) !== e && (ea.flags |= 1024),
            t
          );
        }
        function va() {
          var e = 0 !== la;
          return (la = 0), e;
        }
        function ya(e, t, n) {
          (t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~n);
        }
        function ga(e) {
          if (ra) {
            for (e = e.memoizedState; null !== e; ) {
              var t = e.queue;
              null !== t && (t.pending = null), (e = e.next);
            }
            ra = !1;
          }
          (Zo = 0),
            (na = ta = ea = null),
            (oa = !1),
            (ia = la = 0),
            (sa = null);
        }
        function ba() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === na ? (ea.memoizedState = na = e) : (na = na.next = e), na
          );
        }
        function wa() {
          if (null === ta) {
            var e = ea.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = ta.next;
          var t = null === na ? ea.memoizedState : na.next;
          if (null !== t) (na = t), (ta = e);
          else {
            if (null === e) {
              if (null === ea.alternate) throw Error(l(467));
              throw Error(l(310));
            }
            (e = {
              memoizedState: (ta = e).memoizedState,
              baseState: ta.baseState,
              baseQueue: ta.baseQueue,
              queue: ta.queue,
              next: null,
            }),
              null === na ? (ea.memoizedState = na = e) : (na = na.next = e);
          }
          return na;
        }
        function xa(e) {
          var t = ia;
          return (
            (ia += 1),
            null === sa && (sa = []),
            (e = fo(sa, e, t)),
            (t = ea),
            null === (null === na ? t.memoizedState : na.next) &&
              ((t = t.alternate),
              (T.H = null === t || null === t.memoizedState ? Nl : Pl)),
            e
          );
        }
        function Sa(e) {
          if (null !== e && "object" === typeof e) {
            if ("function" === typeof e.then) return xa(e);
            if (e.$$typeof === v) return Ei(e);
          }
          throw Error(l(438, String(e)));
        }
        function ka(e) {
          var t = null,
            n = ea.updateQueue;
          if ((null !== n && (t = n.memoCache), null == t)) {
            var r = ea.alternate;
            null !== r &&
              null !== (r = r.updateQueue) &&
              null != (r = r.memoCache) &&
              (t = {
                data: r.data.map(function (e) {
                  return e.slice();
                }),
                index: 0,
              });
          }
          if (
            (null == t && (t = { data: [], index: 0 }),
            null === n &&
              ((n = {
                lastEffect: null,
                events: null,
                stores: null,
                memoCache: null,
              }),
              (ea.updateQueue = n)),
            (n.memoCache = t),
            void 0 === (n = t.data[t.index]))
          )
            for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = k;
          return t.index++, n;
        }
        function Ca(e, t) {
          return "function" === typeof t ? t(e) : t;
        }
        function Ea(e) {
          return Na(wa(), ta, e);
        }
        function Na(e, t, n) {
          var r = e.queue;
          if (null === r) throw Error(l(311));
          r.lastRenderedReducer = n;
          var o = e.baseQueue,
            a = r.pending;
          if (null !== a) {
            if (null !== o) {
              var i = o.next;
              (o.next = a.next), (a.next = i);
            }
            (t.baseQueue = o = a), (r.pending = null);
          }
          if (((a = e.baseState), null === o)) e.memoizedState = a;
          else {
            var s = (i = null),
              c = null,
              u = (t = o.next),
              d = !1;
            do {
              var f = -536870913 & u.lane;
              if (f !== u.lane ? (rc & f) === f : (Zo & f) === f) {
                var p = u.revertLane;
                if (0 === p)
                  null !== c &&
                    (c = c.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        action: u.action,
                        hasEagerState: u.hasEagerState,
                        eagerState: u.eagerState,
                        next: null,
                      }),
                    f === $o && (d = !0);
                else {
                  if ((Zo & p) === p) {
                    (u = u.next), p === $o && (d = !0);
                    continue;
                  }
                  (f = {
                    lane: 0,
                    revertLane: u.revertLane,
                    action: u.action,
                    hasEagerState: u.hasEagerState,
                    eagerState: u.eagerState,
                    next: null,
                  }),
                    null === c ? ((s = c = f), (i = a)) : (c = c.next = f),
                    (ea.lanes |= p),
                    (dc |= p);
                }
                (f = u.action),
                  aa && n(a, f),
                  (a = u.hasEagerState ? u.eagerState : n(a, f));
              } else
                (p = {
                  lane: f,
                  revertLane: u.revertLane,
                  action: u.action,
                  hasEagerState: u.hasEagerState,
                  eagerState: u.eagerState,
                  next: null,
                }),
                  null === c ? ((s = c = p), (i = a)) : (c = c.next = p),
                  (ea.lanes |= f),
                  (dc |= f);
              u = u.next;
            } while (null !== u && u !== t);
            if (
              (null === c ? (i = a) : (c.next = s),
              !Kn(a, e.memoizedState) && ((Ul = !0), d && null !== (n = qo)))
            )
              throw n;
            (e.memoizedState = a),
              (e.baseState = i),
              (e.baseQueue = c),
              (r.lastRenderedState = a);
          }
          return null === o && (r.lanes = 0), [e.memoizedState, r.dispatch];
        }
        function Pa(e) {
          var t = wa(),
            n = t.queue;
          if (null === n) throw Error(l(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            o = n.pending,
            a = t.memoizedState;
          if (null !== o) {
            n.pending = null;
            var i = (o = o.next);
            do {
              (a = e(a, i.action)), (i = i.next);
            } while (i !== o);
            Kn(a, t.memoizedState) || (Ul = !0),
              (t.memoizedState = a),
              null === t.baseQueue && (t.baseState = a),
              (n.lastRenderedState = a);
          }
          return [a, r];
        }
        function ja(e, t, n) {
          var r = ea,
            o = wa(),
            a = Xr;
          if (a) {
            if (void 0 === n) throw Error(l(407));
            n = n();
          } else n = t();
          var i = !Kn((ta || o).memoizedState, n);
          if (
            (i && ((o.memoizedState = n), (Ul = !0)),
            (o = o.queue),
            Za(Ra.bind(null, r, o, e), [e]),
            o.getSnapshot !== t ||
              i ||
              (null !== na && 1 & na.memoizedState.tag))
          ) {
            if (
              ((r.flags |= 2048),
              Ka(9, Ta.bind(null, r, o, n, t), { destroy: void 0 }, null),
              null === tc)
            )
              throw Error(l(349));
            a || 0 !== (60 & Zo) || za(r, t, n);
          }
          return n;
        }
        function za(e, t, n) {
          (e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = ea.updateQueue)
              ? ((t = {
                  lastEffect: null,
                  events: null,
                  stores: null,
                  memoCache: null,
                }),
                (ea.updateQueue = t),
                (t.stores = [e]))
              : null === (n = t.stores)
              ? (t.stores = [e])
              : n.push(e);
        }
        function Ta(e, t, n, r) {
          (t.value = n), (t.getSnapshot = r), _a(t) && Oa(e);
        }
        function Ra(e, t, n) {
          return n(function () {
            _a(t) && Oa(e);
          });
        }
        function _a(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !Kn(e, n);
          } catch (r) {
            return !0;
          }
        }
        function Oa(e) {
          var t = zr(e, 2);
          null !== t && _c(t, e, 2);
        }
        function Aa(e) {
          var t = ba();
          if ("function" === typeof e) {
            var n = e;
            if (((e = n()), aa)) {
              be(!0);
              try {
                n();
              } finally {
                be(!1);
              }
            }
          }
          return (
            (t.memoizedState = t.baseState = e),
            (t.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ca,
              lastRenderedState: e,
            }),
            t
          );
        }
        function La(e, t, n, r) {
          return (e.baseState = n), Na(e, ta, "function" === typeof r ? r : Ca);
        }
        function Da(e, t, n, r, o) {
          if (Sl(e)) throw Error(l(485));
          if (null !== (e = t.action)) {
            var a = {
              payload: o,
              action: e,
              next: null,
              isTransition: !0,
              status: "pending",
              value: null,
              reason: null,
              listeners: [],
              then: function (e) {
                a.listeners.push(e);
              },
            };
            null !== T.T ? n(!0) : (a.isTransition = !1),
              r(a),
              null === (n = t.pending)
                ? ((a.next = t.pending = a), Fa(t, a))
                : ((a.next = n.next), (t.pending = n.next = a));
          }
        }
        function Fa(e, t) {
          var n = t.action,
            r = t.payload,
            o = e.state;
          if (t.isTransition) {
            var a = T.T,
              l = {};
            T.T = l;
            try {
              var i = n(o, r),
                s = T.S;
              null !== s && s(l, i), Ma(e, t, i);
            } catch (c) {
              Va(e, t, c);
            } finally {
              T.T = a;
            }
          } else
            try {
              Ma(e, t, (a = n(o, r)));
            } catch (u) {
              Va(e, t, u);
            }
        }
        function Ma(e, t, n) {
          null !== n && "object" === typeof n && "function" === typeof n.then
            ? n.then(
                function (n) {
                  Ia(e, t, n);
                },
                function (n) {
                  return Va(e, t, n);
                }
              )
            : Ia(e, t, n);
        }
        function Ia(e, t, n) {
          (t.status = "fulfilled"),
            (t.value = n),
            Wa(t),
            (e.state = n),
            null !== (t = e.pending) &&
              ((n = t.next) === t
                ? (e.pending = null)
                : ((n = n.next), (t.next = n), Fa(e, n)));
        }
        function Va(e, t, n) {
          var r = e.pending;
          if (((e.pending = null), null !== r)) {
            r = r.next;
            do {
              (t.status = "rejected"), (t.reason = n), Wa(t), (t = t.next);
            } while (t !== r);
          }
          e.action = null;
        }
        function Wa(e) {
          e = e.listeners;
          for (var t = 0; t < e.length; t++) (0, e[t])();
        }
        function Ha(e, t) {
          return t;
        }
        function Ba(e, t) {
          if (Xr) {
            var n = tc.formState;
            if (null !== n) {
              e: {
                var r = ea;
                if (Xr) {
                  if (Qr) {
                    t: {
                      for (var o = Qr, a = Jr; 8 !== o.nodeType; ) {
                        if (!a) {
                          o = null;
                          break t;
                        }
                        if (null === (o = id(o.nextSibling))) {
                          o = null;
                          break t;
                        }
                      }
                      o = "F!" === (a = o.data) || "F" === a ? o : null;
                    }
                    if (o) {
                      (Qr = id(o.nextSibling)), (r = "F!" === o.data);
                      break e;
                    }
                  }
                  eo(r);
                }
                r = !1;
              }
              r && (t = n[0]);
            }
          }
          return (
            ((n = ba()).memoizedState = n.baseState = t),
            (r = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Ha,
              lastRenderedState: t,
            }),
            (n.queue = r),
            (n = bl.bind(null, ea, r)),
            (r.dispatch = n),
            (r = Aa(!1)),
            (a = xl.bind(null, ea, !1, r.queue)),
            (o = { state: t, dispatch: null, action: e, pending: null }),
            ((r = ba()).queue = o),
            (n = Da.bind(null, ea, o, a, n)),
            (o.dispatch = n),
            (r.memoizedState = e),
            [t, n, !1]
          );
        }
        function Ua(e) {
          return $a(wa(), ta, e);
        }
        function $a(e, t, n) {
          (t = Na(e, t, Ha)[0]),
            (e = Ea(Ca)[0]),
            (t =
              "object" === typeof t &&
              null !== t &&
              "function" === typeof t.then
                ? xa(t)
                : t);
          var r = wa(),
            o = r.queue,
            a = o.dispatch;
          return (
            n !== r.memoizedState &&
              ((ea.flags |= 2048),
              Ka(9, qa.bind(null, o, n), { destroy: void 0 }, null)),
            [t, a, e]
          );
        }
        function qa(e, t) {
          e.action = t;
        }
        function Ya(e) {
          var t = wa(),
            n = ta;
          if (null !== n) return $a(t, n, e);
          wa(), (t = t.memoizedState);
          var r = (n = wa()).queue.dispatch;
          return (n.memoizedState = e), [t, r, !1];
        }
        function Ka(e, t, n, r) {
          return (
            (e = { tag: e, create: t, inst: n, deps: r, next: null }),
            null === (t = ea.updateQueue) &&
              ((t = {
                lastEffect: null,
                events: null,
                stores: null,
                memoCache: null,
              }),
              (ea.updateQueue = t)),
            null === (n = t.lastEffect)
              ? (t.lastEffect = e.next = e)
              : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e)),
            e
          );
        }
        function Qa() {
          return wa().memoizedState;
        }
        function Xa(e, t, n, r) {
          var o = ba();
          (ea.flags |= e),
            (o.memoizedState = Ka(
              1 | t,
              n,
              { destroy: void 0 },
              void 0 === r ? null : r
            ));
        }
        function Ga(e, t, n, r) {
          var o = wa();
          r = void 0 === r ? null : r;
          var a = o.memoizedState.inst;
          null !== ta && null !== r && da(r, ta.memoizedState.deps)
            ? (o.memoizedState = Ka(t, n, a, r))
            : ((ea.flags |= e), (o.memoizedState = Ka(1 | t, n, a, r)));
        }
        function Ja(e, t) {
          Xa(8390656, 8, e, t);
        }
        function Za(e, t) {
          Ga(2048, 8, e, t);
        }
        function el(e, t) {
          return Ga(4, 2, e, t);
        }
        function tl(e, t) {
          return Ga(4, 4, e, t);
        }
        function nl(e, t) {
          if ("function" === typeof t) {
            e = e();
            var n = t(e);
            return function () {
              "function" === typeof n ? n() : t(null);
            };
          }
          if (null !== t && void 0 !== t)
            return (
              (e = e()),
              (t.current = e),
              function () {
                t.current = null;
              }
            );
        }
        function rl(e, t, n) {
          (n = null !== n && void 0 !== n ? n.concat([e]) : null),
            Ga(4, 4, nl.bind(null, t, e), n);
        }
        function ol() {}
        function al(e, t) {
          var n = wa();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== t && da(t, r[1])
            ? r[0]
            : ((n.memoizedState = [e, t]), e);
        }
        function ll(e, t) {
          var n = wa();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          if (null !== t && da(t, r[1])) return r[0];
          if (((r = e()), aa)) {
            be(!0);
            try {
              e();
            } finally {
              be(!1);
            }
          }
          return (n.memoizedState = [r, t]), r;
        }
        function il(e, t, n) {
          return void 0 === n || 0 !== (1073741824 & Zo)
            ? (e.memoizedState = t)
            : ((e.memoizedState = n),
              (e = Rc()),
              (ea.lanes |= e),
              (dc |= e),
              n);
        }
        function sl(e, t, n, r) {
          return Kn(n, t)
            ? n
            : null !== Co.current
            ? ((e = il(e, n, r)), Kn(e, t) || (Ul = !0), e)
            : 0 === (42 & Zo)
            ? ((Ul = !0), (e.memoizedState = n))
            : ((e = Rc()), (ea.lanes |= e), (dc |= e), t);
        }
        function cl(e, t, n, r, o) {
          var a = H.p;
          H.p = 0 !== a && 8 > a ? a : 8;
          var l = T.T,
            i = {};
          (T.T = i), xl(e, !1, t, n);
          try {
            var s = o(),
              c = T.S;
            if (
              (null !== c && c(i, s),
              null !== s &&
                "object" === typeof s &&
                "function" === typeof s.then)
            ) {
              var u = (function (e, t) {
                var n = [],
                  r = {
                    status: "pending",
                    value: null,
                    reason: null,
                    then: function (e) {
                      n.push(e);
                    },
                  };
                return (
                  e.then(
                    function () {
                      (r.status = "fulfilled"), (r.value = t);
                      for (var e = 0; e < n.length; e++) (0, n[e])(t);
                    },
                    function (e) {
                      for (
                        r.status = "rejected", r.reason = e, e = 0;
                        e < n.length;
                        e++
                      )
                        (0, n[e])(void 0);
                    }
                  ),
                  r
                );
              })(s, r);
              wl(e, t, u, Tc());
            } else wl(e, t, r, Tc());
          } catch (d) {
            wl(
              e,
              t,
              { then: function () {}, status: "rejected", reason: d },
              Tc()
            );
          } finally {
            (H.p = a), (T.T = l);
          }
        }
        function ul() {}
        function dl(e, t, n, r) {
          if (5 !== e.tag) throw Error(l(476));
          var o = fl(e).queue;
          cl(
            e,
            o,
            t,
            B,
            null === n
              ? ul
              : function () {
                  return pl(e), n(r);
                }
          );
        }
        function fl(e) {
          var t = e.memoizedState;
          if (null !== t) return t;
          var n = {};
          return (
            ((t = {
              memoizedState: B,
              baseState: B,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Ca,
                lastRenderedState: B,
              },
              next: null,
            }).next = {
              memoizedState: n,
              baseState: n,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Ca,
                lastRenderedState: n,
              },
              next: null,
            }),
            (e.memoizedState = t),
            null !== (e = e.alternate) && (e.memoizedState = t),
            t
          );
        }
        function pl(e) {
          wl(e, fl(e).next.queue, {}, Tc());
        }
        function ml() {
          return Ei(Dd);
        }
        function hl() {
          return wa().memoizedState;
        }
        function vl() {
          return wa().memoizedState;
        }
        function yl(e) {
          for (var t = e.return; null !== t; ) {
            switch (t.tag) {
              case 24:
              case 3:
                var n = Tc(),
                  r = _i(t, (e = Ri(n)), n);
                return (
                  null !== r && (_c(r, t, n), Oi(r, t, n)),
                  (t = { cache: Wo() }),
                  void (e.payload = t)
                );
            }
            t = t.return;
          }
        }
        function gl(e, t, n) {
          var r = Tc();
          (n = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            Sl(e)
              ? kl(t, n)
              : null !== (n = jr(e, t, n, r)) && (_c(n, e, r), Cl(n, t, r));
        }
        function bl(e, t, n) {
          wl(e, t, n, Tc());
        }
        function wl(e, t, n, r) {
          var o = {
            lane: r,
            revertLane: 0,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (Sl(e)) kl(t, o);
          else {
            var a = e.alternate;
            if (
              0 === e.lanes &&
              (null === a || 0 === a.lanes) &&
              null !== (a = t.lastRenderedReducer)
            )
              try {
                var l = t.lastRenderedState,
                  i = a(l, n);
                if (((o.hasEagerState = !0), (o.eagerState = i), Kn(i, l)))
                  return Pr(e, t, o, 0), null === tc && Nr(), !1;
              } catch (s) {}
            if (null !== (n = jr(e, t, o, r)))
              return _c(n, e, r), Cl(n, t, r), !0;
          }
          return !1;
        }
        function xl(e, t, n, r) {
          if (
            ((r = {
              lane: 2,
              revertLane: xu(),
              action: r,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            Sl(e))
          ) {
            if (t) throw Error(l(479));
          } else null !== (t = jr(e, n, r, 2)) && _c(t, e, 2);
        }
        function Sl(e) {
          var t = e.alternate;
          return e === ea || (null !== t && t === ea);
        }
        function kl(e, t) {
          oa = ra = !0;
          var n = e.pending;
          null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
            (e.pending = t);
        }
        function Cl(e, t, n) {
          if (0 !== (4194176 & n)) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), Ae(e, n);
          }
        }
        var El = {
          readContext: Ei,
          use: Sa,
          useCallback: ua,
          useContext: ua,
          useEffect: ua,
          useImperativeHandle: ua,
          useLayoutEffect: ua,
          useInsertionEffect: ua,
          useMemo: ua,
          useReducer: ua,
          useRef: ua,
          useState: ua,
          useDebugValue: ua,
          useDeferredValue: ua,
          useTransition: ua,
          useSyncExternalStore: ua,
          useId: ua,
        };
        (El.useCacheRefresh = ua),
          (El.useMemoCache = ua),
          (El.useHostTransitionStatus = ua),
          (El.useFormState = ua),
          (El.useActionState = ua),
          (El.useOptimistic = ua);
        var Nl = {
          readContext: Ei,
          use: Sa,
          useCallback: function (e, t) {
            return (ba().memoizedState = [e, void 0 === t ? null : t]), e;
          },
          useContext: Ei,
          useEffect: Ja,
          useImperativeHandle: function (e, t, n) {
            (n = null !== n && void 0 !== n ? n.concat([e]) : null),
              Xa(4194308, 4, nl.bind(null, t, e), n);
          },
          useLayoutEffect: function (e, t) {
            return Xa(4194308, 4, e, t);
          },
          useInsertionEffect: function (e, t) {
            Xa(4, 2, e, t);
          },
          useMemo: function (e, t) {
            var n = ba();
            t = void 0 === t ? null : t;
            var r = e();
            if (aa) {
              be(!0);
              try {
                e();
              } finally {
                be(!1);
              }
            }
            return (n.memoizedState = [r, t]), r;
          },
          useReducer: function (e, t, n) {
            var r = ba();
            if (void 0 !== n) {
              var o = n(t);
              if (aa) {
                be(!0);
                try {
                  n(t);
                } finally {
                  be(!1);
                }
              }
            } else o = t;
            return (
              (r.memoizedState = r.baseState = o),
              (e = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: e,
                lastRenderedState: o,
              }),
              (r.queue = e),
              (e = e.dispatch = gl.bind(null, ea, e)),
              [r.memoizedState, e]
            );
          },
          useRef: function (e) {
            return (e = { current: e }), (ba().memoizedState = e);
          },
          useState: function (e) {
            var t = (e = Aa(e)).queue,
              n = bl.bind(null, ea, t);
            return (t.dispatch = n), [e.memoizedState, n];
          },
          useDebugValue: ol,
          useDeferredValue: function (e, t) {
            return il(ba(), e, t);
          },
          useTransition: function () {
            var e = Aa(!1);
            return (
              (e = cl.bind(null, ea, e.queue, !0, !1)),
              (ba().memoizedState = e),
              [!1, e]
            );
          },
          useSyncExternalStore: function (e, t, n) {
            var r = ea,
              o = ba();
            if (Xr) {
              if (void 0 === n) throw Error(l(407));
              n = n();
            } else {
              if (((n = t()), null === tc)) throw Error(l(349));
              0 !== (60 & rc) || za(r, t, n);
            }
            o.memoizedState = n;
            var a = { value: n, getSnapshot: t };
            return (
              (o.queue = a),
              Ja(Ra.bind(null, r, a, e), [e]),
              (r.flags |= 2048),
              Ka(9, Ta.bind(null, r, a, n, t), { destroy: void 0 }, null),
              n
            );
          },
          useId: function () {
            var e = ba(),
              t = tc.identifierPrefix;
            if (Xr) {
              var n = Br;
              (t =
                ":" +
                t +
                "R" +
                (n = (Hr & ~(1 << (32 - we(Hr) - 1))).toString(32) + n)),
                0 < (n = la++) && (t += "H" + n.toString(32)),
                (t += ":");
            } else t = ":" + t + "r" + (n = ca++).toString(32) + ":";
            return (e.memoizedState = t);
          },
          useCacheRefresh: function () {
            return (ba().memoizedState = yl.bind(null, ea));
          },
        };
        (Nl.useMemoCache = ka),
          (Nl.useHostTransitionStatus = ml),
          (Nl.useFormState = Ba),
          (Nl.useActionState = Ba),
          (Nl.useOptimistic = function (e) {
            var t = ba();
            t.memoizedState = t.baseState = e;
            var n = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: null,
              lastRenderedState: null,
            };
            return (
              (t.queue = n),
              (t = xl.bind(null, ea, !0, n)),
              (n.dispatch = t),
              [e, t]
            );
          });
        var Pl = {
          readContext: Ei,
          use: Sa,
          useCallback: al,
          useContext: Ei,
          useEffect: Za,
          useImperativeHandle: rl,
          useInsertionEffect: el,
          useLayoutEffect: tl,
          useMemo: ll,
          useReducer: Ea,
          useRef: Qa,
          useState: function () {
            return Ea(Ca);
          },
          useDebugValue: ol,
          useDeferredValue: function (e, t) {
            return sl(wa(), ta.memoizedState, e, t);
          },
          useTransition: function () {
            var e = Ea(Ca)[0],
              t = wa().memoizedState;
            return ["boolean" === typeof e ? e : xa(e), t];
          },
          useSyncExternalStore: ja,
          useId: hl,
        };
        (Pl.useCacheRefresh = vl),
          (Pl.useMemoCache = ka),
          (Pl.useHostTransitionStatus = ml),
          (Pl.useFormState = Ua),
          (Pl.useActionState = Ua),
          (Pl.useOptimistic = function (e, t) {
            return La(wa(), 0, e, t);
          });
        var jl = {
          readContext: Ei,
          use: Sa,
          useCallback: al,
          useContext: Ei,
          useEffect: Za,
          useImperativeHandle: rl,
          useInsertionEffect: el,
          useLayoutEffect: tl,
          useMemo: ll,
          useReducer: Pa,
          useRef: Qa,
          useState: function () {
            return Pa(Ca);
          },
          useDebugValue: ol,
          useDeferredValue: function (e, t) {
            var n = wa();
            return null === ta ? il(n, e, t) : sl(n, ta.memoizedState, e, t);
          },
          useTransition: function () {
            var e = Pa(Ca)[0],
              t = wa().memoizedState;
            return ["boolean" === typeof e ? e : xa(e), t];
          },
          useSyncExternalStore: ja,
          useId: hl,
        };
        function zl(e, t, n, r) {
          (n =
            null === (n = n(r, (t = e.memoizedState))) || void 0 === n
              ? t
              : R({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n);
        }
        (jl.useCacheRefresh = vl),
          (jl.useMemoCache = ka),
          (jl.useHostTransitionStatus = ml),
          (jl.useFormState = Ya),
          (jl.useActionState = Ya),
          (jl.useOptimistic = function (e, t) {
            var n = wa();
            return null !== ta
              ? La(n, 0, e, t)
              : ((n.baseState = e), [e, n.queue.dispatch]);
          });
        var Tl = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && F(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = Tc(),
              o = Ri(r);
            (o.payload = t),
              void 0 !== n && null !== n && (o.callback = n),
              null !== (t = _i(e, o, r)) && (_c(t, e, r), Oi(t, e, r));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = Tc(),
              o = Ri(r);
            (o.tag = 1),
              (o.payload = t),
              void 0 !== n && null !== n && (o.callback = n),
              null !== (t = _i(e, o, r)) && (_c(t, e, r), Oi(t, e, r));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = Tc(),
              r = Ri(n);
            (r.tag = 2),
              void 0 !== t && null !== t && (r.callback = t),
              null !== (t = _i(e, r, n)) && (_c(t, e, n), Oi(t, e, n));
          },
        };
        function Rl(e, t, n, r, o, a, l) {
          return "function" === typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, a, l)
            : !t.prototype ||
                !t.prototype.isPureReactComponent ||
                !Qn(n, r) ||
                !Qn(o, a);
        }
        function _l(e, t, n, r) {
          (e = t.state),
            "function" === typeof t.componentWillReceiveProps &&
              t.componentWillReceiveProps(n, r),
            "function" === typeof t.UNSAFE_componentWillReceiveProps &&
              t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && Tl.enqueueReplaceState(t, t.state, null);
        }
        function Ol(e, t) {
          var n = t;
          if ("ref" in t)
            for (var r in ((n = {}), t)) "ref" !== r && (n[r] = t[r]);
          if ((e = e.defaultProps))
            for (var o in (n === t && (n = R({}, n)), e))
              void 0 === n[o] && (n[o] = e[o]);
          return n;
        }
        var Al =
          "function" === typeof reportError
            ? reportError
            : function (e) {
                if (
                  "object" === typeof window &&
                  "function" === typeof window.ErrorEvent
                ) {
                  var t = new window.ErrorEvent("error", {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      "object" === typeof e &&
                      null !== e &&
                      "string" === typeof e.message
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  "object" === typeof process &&
                  "function" === typeof process.emit
                )
                  return void process.emit("uncaughtException", e);
                console.error(e);
              };
        function Ll(e) {
          Al(e);
        }
        function Dl(e) {
          console.error(e);
        }
        function Fl(e) {
          Al(e);
        }
        function Ml(e, t) {
          try {
            (0, e.onUncaughtError)(t.value, { componentStack: t.stack });
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        function Il(e, t, n) {
          try {
            (0, e.onCaughtError)(n.value, {
              componentStack: n.stack,
              errorBoundary: 1 === t.tag ? t.stateNode : null,
            });
          } catch (r) {
            setTimeout(function () {
              throw r;
            });
          }
        }
        function Vl(e, t, n) {
          return (
            ((n = Ri(n)).tag = 3),
            (n.payload = { element: null }),
            (n.callback = function () {
              Ml(e, t);
            }),
            n
          );
        }
        function Wl(e) {
          return ((e = Ri(e)).tag = 3), e;
        }
        function Hl(e, t, n, r) {
          var o = n.type.getDerivedStateFromError;
          if ("function" === typeof o) {
            var a = r.value;
            (e.payload = function () {
              return o(a);
            }),
              (e.callback = function () {
                Il(t, n, r);
              });
          }
          var l = n.stateNode;
          null !== l &&
            "function" === typeof l.componentDidCatch &&
            (e.callback = function () {
              Il(t, n, r),
                "function" !== typeof o &&
                  (null === Sc ? (Sc = new Set([this])) : Sc.add(this));
              var e = r.stack;
              this.componentDidCatch(r.value, {
                componentStack: null !== e ? e : "",
              });
            });
        }
        var Bl = Error(l(461)),
          Ul = !1;
        function $l(e, t, n, r) {
          t.child = null === e ? ko(t, null, n, r) : So(t, e.child, n, r);
        }
        function ql(e, t, n, r, o) {
          n = n.render;
          var a = t.ref;
          if ("ref" in r) {
            var l = {};
            for (var i in r) "ref" !== i && (l[i] = r[i]);
          } else l = r;
          return (
            Ci(t),
            (r = fa(e, t, n, l, a, o)),
            (i = va()),
            null === e || Ul
              ? (Xr && i && qr(t), (t.flags |= 1), $l(e, t, r, o), t.child)
              : (ya(e, t, o), fi(e, t, o))
          );
        }
        function Yl(e, t, n, r, o) {
          if (null === e) {
            var a = n.type;
            return "function" !== typeof a ||
              Ds(a) ||
              void 0 !== a.defaultProps ||
              null !== n.compare
              ? (((e = Is(n.type, null, r, t, t.mode, o)).ref = t.ref),
                (e.return = t),
                (t.child = e))
              : ((t.tag = 15), (t.type = a), Kl(e, t, a, r, o));
          }
          if (((a = e.child), !pi(e, o))) {
            var l = a.memoizedProps;
            if (
              (n = null !== (n = n.compare) ? n : Qn)(l, r) &&
              e.ref === t.ref
            )
              return fi(e, t, o);
          }
          return (
            (t.flags |= 1),
            ((e = Fs(a, r)).ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function Kl(e, t, n, r, o) {
          if (null !== e) {
            var a = e.memoizedProps;
            if (Qn(a, r) && e.ref === t.ref) {
              if (((Ul = !1), (t.pendingProps = r = a), !pi(e, o)))
                return (t.lanes = e.lanes), fi(e, t, o);
              0 !== (131072 & e.flags) && (Ul = !0);
            }
          }
          return Jl(e, t, n, r, o);
        }
        function Ql(e, t, n) {
          var r = t.pendingProps,
            o = r.children,
            a = 0 !== (2 & t.stateNode._pendingVisibility),
            l = null !== e ? e.memoizedState : null;
          if ((Gl(e, t), "hidden" === r.mode || a)) {
            if (0 !== (128 & t.flags)) {
              if (((r = null !== l ? l.baseLanes | n : n), null !== e)) {
                for (o = t.child = e.child, a = 0; null !== o; )
                  (a = a | o.lanes | o.childLanes), (o = o.sibling);
                t.childLanes = a & ~r;
              } else (t.childLanes = 0), (t.child = null);
              return Xl(e, t, r, n);
            }
            if (0 === (536870912 & n))
              return (
                (t.lanes = t.childLanes = 536870912),
                Xl(e, t, null !== l ? l.baseLanes | n : n, n)
              );
            (t.memoizedState = { baseLanes: 0, cachePool: null }),
              null !== e && Go(0, null !== l ? l.cachePool : null),
              null !== l ? No(t, l) : Po(),
              _o(t);
          } else
            null !== l
              ? (Go(0, l.cachePool), No(t, l), Oo(), (t.memoizedState = null))
              : (null !== e && Go(0, null), Po(), Oo());
          return $l(e, t, o, n), t.child;
        }
        function Xl(e, t, n, r) {
          var o = Xo();
          return (
            (o = null === o ? null : { parent: Vo._currentValue, pool: o }),
            (t.memoizedState = { baseLanes: n, cachePool: o }),
            null !== e && Go(0, null),
            Po(),
            _o(t),
            null !== e && Si(e, t, r, !0),
            null
          );
        }
        function Gl(e, t) {
          var n = t.ref;
          if (null === n) null !== e && null !== e.ref && (t.flags |= 2097664);
          else {
            if ("function" !== typeof n && "object" !== typeof n)
              throw Error(l(284));
            (null !== e && e.ref === n) || (t.flags |= 2097664);
          }
        }
        function Jl(e, t, n, r, o) {
          return (
            Ci(t),
            (n = fa(e, t, n, r, void 0, o)),
            (r = va()),
            null === e || Ul
              ? (Xr && r && qr(t), (t.flags |= 1), $l(e, t, n, o), t.child)
              : (ya(e, t, o), fi(e, t, o))
          );
        }
        function Zl(e, t, n, r, o, a) {
          return (
            Ci(t),
            (t.updateQueue = null),
            (n = ma(t, r, n, o)),
            pa(e),
            (r = va()),
            null === e || Ul
              ? (Xr && r && qr(t), (t.flags |= 1), $l(e, t, n, a), t.child)
              : (ya(e, t, a), fi(e, t, a))
          );
        }
        function ei(e, t, n, r, o) {
          if ((Ci(t), null === t.stateNode)) {
            var a = _r,
              l = n.contextType;
            "object" === typeof l && null !== l && (a = Ei(l)),
              (a = new n(r, a)),
              (t.memoizedState =
                null !== a.state && void 0 !== a.state ? a.state : null),
              (a.updater = Tl),
              (t.stateNode = a),
              (a._reactInternals = t),
              ((a = t.stateNode).props = r),
              (a.state = t.memoizedState),
              (a.refs = {}),
              zi(t),
              (l = n.contextType),
              (a.context = "object" === typeof l && null !== l ? Ei(l) : _r),
              (a.state = t.memoizedState),
              "function" === typeof (l = n.getDerivedStateFromProps) &&
                (zl(t, n, l, r), (a.state = t.memoizedState)),
              "function" === typeof n.getDerivedStateFromProps ||
                "function" === typeof a.getSnapshotBeforeUpdate ||
                ("function" !== typeof a.UNSAFE_componentWillMount &&
                  "function" !== typeof a.componentWillMount) ||
                ((l = a.state),
                "function" === typeof a.componentWillMount &&
                  a.componentWillMount(),
                "function" === typeof a.UNSAFE_componentWillMount &&
                  a.UNSAFE_componentWillMount(),
                l !== a.state && Tl.enqueueReplaceState(a, a.state, null),
                Fi(t, r, a, o),
                Di(),
                (a.state = t.memoizedState)),
              "function" === typeof a.componentDidMount && (t.flags |= 4194308),
              (r = !0);
          } else if (null === e) {
            a = t.stateNode;
            var i = t.memoizedProps,
              s = Ol(n, i);
            a.props = s;
            var c = a.context,
              u = n.contextType;
            (l = _r), "object" === typeof u && null !== u && (l = Ei(u));
            var d = n.getDerivedStateFromProps;
            (u =
              "function" === typeof d ||
              "function" === typeof a.getSnapshotBeforeUpdate),
              (i = t.pendingProps !== i),
              u ||
                ("function" !== typeof a.UNSAFE_componentWillReceiveProps &&
                  "function" !== typeof a.componentWillReceiveProps) ||
                ((i || c !== l) && _l(t, a, r, l)),
              (ji = !1);
            var f = t.memoizedState;
            (a.state = f),
              Fi(t, r, a, o),
              Di(),
              (c = t.memoizedState),
              i || f !== c || ji
                ? ("function" === typeof d &&
                    (zl(t, n, d, r), (c = t.memoizedState)),
                  (s = ji || Rl(t, n, s, r, f, c, l))
                    ? (u ||
                        ("function" !== typeof a.UNSAFE_componentWillMount &&
                          "function" !== typeof a.componentWillMount) ||
                        ("function" === typeof a.componentWillMount &&
                          a.componentWillMount(),
                        "function" === typeof a.UNSAFE_componentWillMount &&
                          a.UNSAFE_componentWillMount()),
                      "function" === typeof a.componentDidMount &&
                        (t.flags |= 4194308))
                    : ("function" === typeof a.componentDidMount &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = c)),
                  (a.props = r),
                  (a.state = c),
                  (a.context = l),
                  (r = s))
                : ("function" === typeof a.componentDidMount &&
                    (t.flags |= 4194308),
                  (r = !1));
          } else {
            (a = t.stateNode),
              Ti(e, t),
              (u = Ol(n, (l = t.memoizedProps))),
              (a.props = u),
              (d = t.pendingProps),
              (f = a.context),
              (c = n.contextType),
              (s = _r),
              "object" === typeof c && null !== c && (s = Ei(c)),
              (c =
                "function" === typeof (i = n.getDerivedStateFromProps) ||
                "function" === typeof a.getSnapshotBeforeUpdate) ||
                ("function" !== typeof a.UNSAFE_componentWillReceiveProps &&
                  "function" !== typeof a.componentWillReceiveProps) ||
                ((l !== d || f !== s) && _l(t, a, r, s)),
              (ji = !1),
              (f = t.memoizedState),
              (a.state = f),
              Fi(t, r, a, o),
              Di();
            var p = t.memoizedState;
            l !== d ||
            f !== p ||
            ji ||
            (null !== e && null !== e.dependencies && ki(e.dependencies))
              ? ("function" === typeof i &&
                  (zl(t, n, i, r), (p = t.memoizedState)),
                (u =
                  ji ||
                  Rl(t, n, u, r, f, p, s) ||
                  (null !== e && null !== e.dependencies && ki(e.dependencies)))
                  ? (c ||
                      ("function" !== typeof a.UNSAFE_componentWillUpdate &&
                        "function" !== typeof a.componentWillUpdate) ||
                      ("function" === typeof a.componentWillUpdate &&
                        a.componentWillUpdate(r, p, s),
                      "function" === typeof a.UNSAFE_componentWillUpdate &&
                        a.UNSAFE_componentWillUpdate(r, p, s)),
                    "function" === typeof a.componentDidUpdate &&
                      (t.flags |= 4),
                    "function" === typeof a.getSnapshotBeforeUpdate &&
                      (t.flags |= 1024))
                  : ("function" !== typeof a.componentDidUpdate ||
                      (l === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 4),
                    "function" !== typeof a.getSnapshotBeforeUpdate ||
                      (l === e.memoizedProps && f === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = p)),
                (a.props = r),
                (a.state = p),
                (a.context = s),
                (r = u))
              : ("function" !== typeof a.componentDidUpdate ||
                  (l === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 4),
                "function" !== typeof a.getSnapshotBeforeUpdate ||
                  (l === e.memoizedProps && f === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return (
            (a = r),
            Gl(e, t),
            (r = 0 !== (128 & t.flags)),
            a || r
              ? ((a = t.stateNode),
                (n =
                  r && "function" !== typeof n.getDerivedStateFromError
                    ? null
                    : a.render()),
                (t.flags |= 1),
                null !== e && r
                  ? ((t.child = So(t, e.child, null, o)),
                    (t.child = So(t, null, n, o)))
                  : $l(e, t, n, o),
                (t.memoizedState = a.state),
                (e = t.child))
              : (e = fi(e, t, o)),
            e
          );
        }
        function ti(e, t, n, r) {
          return oo(), (t.flags |= 256), $l(e, t, n, r), t.child;
        }
        var ni = { dehydrated: null, treeContext: null, retryLane: 0 };
        function ri(e) {
          return { baseLanes: e, cachePool: Jo() };
        }
        function oi(e, t, n) {
          return (e = null !== e ? e.childLanes & ~n : 0), t && (e |= mc), e;
        }
        function ai(e, t, n) {
          var r,
            o = t.pendingProps,
            a = !1,
            i = 0 !== (128 & t.flags);
          if (
            ((r = i) ||
              (r =
                (null === e || null !== e.memoizedState) &&
                0 !== (2 & Lo.current)),
            r && ((a = !0), (t.flags &= -129)),
            (r = 0 !== (32 & t.flags)),
            (t.flags &= -33),
            null === e)
          ) {
            if (Xr) {
              if ((a ? Ro(t) : Oo(), Xr)) {
                var s,
                  c = Qr;
                if ((s = c)) {
                  e: {
                    for (s = c, c = Jr; 8 !== s.nodeType; ) {
                      if (!c) {
                        c = null;
                        break e;
                      }
                      if (null === (s = id(s.nextSibling))) {
                        c = null;
                        break e;
                      }
                    }
                    c = s;
                  }
                  null !== c
                    ? ((t.memoizedState = {
                        dehydrated: c,
                        treeContext:
                          null !== Wr ? { id: Hr, overflow: Br } : null,
                        retryLane: 536870912,
                      }),
                      ((s = Ls(18, null, null, 0)).stateNode = c),
                      (s.return = t),
                      (t.child = s),
                      (Kr = t),
                      (Qr = null),
                      (s = !0))
                    : (s = !1);
                }
                s || eo(t);
              }
              if (null !== (c = t.memoizedState) && null !== (c = c.dehydrated))
                return (
                  "$!" === c.data ? (t.lanes = 16) : (t.lanes = 536870912), null
                );
              Ao(t);
            }
            return (
              (c = o.children),
              (o = o.fallback),
              a
                ? (Oo(),
                  (c = ii({ mode: "hidden", children: c }, (a = t.mode))),
                  (o = Vs(o, a, n, null)),
                  (c.return = t),
                  (o.return = t),
                  (c.sibling = o),
                  (t.child = c),
                  ((a = t.child).memoizedState = ri(n)),
                  (a.childLanes = oi(e, r, n)),
                  (t.memoizedState = ni),
                  o)
                : (Ro(t), li(t, c))
            );
          }
          if (null !== (s = e.memoizedState) && null !== (c = s.dehydrated)) {
            if (i)
              256 & t.flags
                ? (Ro(t), (t.flags &= -257), (t = si(e, t, n)))
                : null !== t.memoizedState
                ? (Oo(), (t.child = e.child), (t.flags |= 128), (t = null))
                : (Oo(),
                  (a = o.fallback),
                  (c = t.mode),
                  (o = ii({ mode: "visible", children: o.children }, c)),
                  ((a = Vs(a, c, n, null)).flags |= 2),
                  (o.return = t),
                  (a.return = t),
                  (o.sibling = a),
                  (t.child = o),
                  So(t, e.child, null, n),
                  ((o = t.child).memoizedState = ri(n)),
                  (o.childLanes = oi(e, r, n)),
                  (t.memoizedState = ni),
                  (t = a));
            else if ((Ro(t), "$!" === c.data)) {
              if ((r = c.nextSibling && c.nextSibling.dataset)) var u = r.dgst;
              (r = u),
                ((o = Error(l(419))).stack = ""),
                (o.digest = r),
                ao({ value: o, source: null, stack: null }),
                (t = si(e, t, n));
            } else if (
              (Ul || Si(e, t, n, !1), (r = 0 !== (n & e.childLanes)), Ul || r)
            ) {
              if (null !== (r = tc)) {
                if (0 !== (42 & (o = n & -n))) o = 1;
                else
                  switch (o) {
                    case 2:
                      o = 1;
                      break;
                    case 8:
                      o = 4;
                      break;
                    case 32:
                      o = 16;
                      break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                      o = 64;
                      break;
                    case 268435456:
                      o = 134217728;
                      break;
                    default:
                      o = 0;
                  }
                if (
                  0 !== (o = 0 !== (o & (r.suspendedLanes | n)) ? 0 : o) &&
                  o !== s.retryLane
                )
                  throw ((s.retryLane = o), zr(e, o), _c(r, e, o), Bl);
              }
              "$?" === c.data || Uc(), (t = si(e, t, n));
            } else
              "$?" === c.data
                ? ((t.flags |= 128),
                  (t.child = e.child),
                  (t = iu.bind(null, e)),
                  (c._reactRetry = t),
                  (t = null))
                : ((e = s.treeContext),
                  (Qr = id(c.nextSibling)),
                  (Kr = t),
                  (Xr = !0),
                  (Gr = null),
                  (Jr = !1),
                  null !== e &&
                    ((Ir[Vr++] = Hr),
                    (Ir[Vr++] = Br),
                    (Ir[Vr++] = Wr),
                    (Hr = e.id),
                    (Br = e.overflow),
                    (Wr = t)),
                  ((t = li(t, o.children)).flags |= 4096));
            return t;
          }
          return a
            ? (Oo(),
              (a = o.fallback),
              (c = t.mode),
              (u = (s = e.child).sibling),
              ((o = Fs(s, {
                mode: "hidden",
                children: o.children,
              })).subtreeFlags = 31457280 & s.subtreeFlags),
              null !== u
                ? (a = Fs(u, a))
                : ((a = Vs(a, c, n, null)).flags |= 2),
              (a.return = t),
              (o.return = t),
              (o.sibling = a),
              (t.child = o),
              (o = a),
              (a = t.child),
              null === (c = e.child.memoizedState)
                ? (c = ri(n))
                : (null !== (s = c.cachePool)
                    ? ((u = Vo._currentValue),
                      (s = s.parent !== u ? { parent: u, pool: u } : s))
                    : (s = Jo()),
                  (c = { baseLanes: c.baseLanes | n, cachePool: s })),
              (a.memoizedState = c),
              (a.childLanes = oi(e, r, n)),
              (t.memoizedState = ni),
              o)
            : (Ro(t),
              (e = (n = e.child).sibling),
              ((n = Fs(n, { mode: "visible", children: o.children })).return =
                t),
              (n.sibling = null),
              null !== e &&
                (null === (r = t.deletions)
                  ? ((t.deletions = [e]), (t.flags |= 16))
                  : r.push(e)),
              (t.child = n),
              (t.memoizedState = null),
              n);
        }
        function li(e, t) {
          return (
            ((t = ii({ mode: "visible", children: t }, e.mode)).return = e),
            (e.child = t)
          );
        }
        function ii(e, t) {
          return Ws(e, t, 0, null);
        }
        function si(e, t, n) {
          return (
            So(t, e.child, null, n),
            ((e = li(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function ci(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          null !== r && (r.lanes |= t), wi(e.return, t, n);
        }
        function ui(e, t, n, r, o) {
          var a = e.memoizedState;
          null === a
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: o,
              })
            : ((a.isBackwards = t),
              (a.rendering = null),
              (a.renderingStartTime = 0),
              (a.last = r),
              (a.tail = n),
              (a.tailMode = o));
        }
        function di(e, t, n) {
          var r = t.pendingProps,
            o = r.revealOrder,
            a = r.tail;
          if (($l(e, t, r.children, n), 0 !== (2 & (r = Lo.current))))
            (r = (1 & r) | 2), (t.flags |= 128);
          else {
            if (null !== e && 0 !== (128 & e.flags))
              e: for (e = t.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && ci(e, n, t);
                else if (19 === e.tag) ci(e, n, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          switch ((K(Lo, r), o)) {
            case "forwards":
              for (n = t.child, o = null; null !== n; )
                null !== (e = n.alternate) && null === Do(e) && (o = n),
                  (n = n.sibling);
              null === (n = o)
                ? ((o = t.child), (t.child = null))
                : ((o = n.sibling), (n.sibling = null)),
                ui(t, !1, o, n, a);
              break;
            case "backwards":
              for (n = null, o = t.child, t.child = null; null !== o; ) {
                if (null !== (e = o.alternate) && null === Do(e)) {
                  t.child = o;
                  break;
                }
                (e = o.sibling), (o.sibling = n), (n = o), (o = e);
              }
              ui(t, !0, n, null, a);
              break;
            case "together":
              ui(t, !1, null, null, void 0);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function fi(e, t, n) {
          if (
            (null !== e && (t.dependencies = e.dependencies),
            (dc |= t.lanes),
            0 === (n & t.childLanes))
          ) {
            if (null === e) return null;
            if ((Si(e, t, n, !1), 0 === (n & t.childLanes))) return null;
          }
          if (null !== e && t.child !== e.child) throw Error(l(153));
          if (null !== t.child) {
            for (
              n = Fs((e = t.child), e.pendingProps), t.child = n, n.return = t;
              null !== e.sibling;

            )
              (e = e.sibling),
                ((n = n.sibling = Fs(e, e.pendingProps)).return = t);
            n.sibling = null;
          }
          return t.child;
        }
        function pi(e, t) {
          return (
            0 !== (e.lanes & t) || !(null === (e = e.dependencies) || !ki(e))
          );
        }
        function mi(e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps) Ul = !0;
            else {
              if (!pi(e, n) && 0 === (128 & t.flags))
                return (
                  (Ul = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        Z(t, t.stateNode.containerInfo),
                          gi(t, Vo, e.memoizedState.cache),
                          oo();
                        break;
                      case 27:
                      case 5:
                        te(t);
                        break;
                      case 4:
                        Z(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        gi(t, t.type, t.memoizedProps.value);
                        break;
                      case 13:
                        var r = t.memoizedState;
                        if (null !== r)
                          return null !== r.dehydrated
                            ? (Ro(t), (t.flags |= 128), null)
                            : 0 !== (n & t.child.childLanes)
                            ? ai(e, t, n)
                            : (Ro(t),
                              null !== (e = fi(e, t, n)) ? e.sibling : null);
                        Ro(t);
                        break;
                      case 19:
                        var o = 0 !== (128 & e.flags);
                        if (
                          ((r = 0 !== (n & t.childLanes)) ||
                            (Si(e, t, n, !1), (r = 0 !== (n & t.childLanes))),
                          o)
                        ) {
                          if (r) return di(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (o = t.memoizedState) &&
                            ((o.rendering = null),
                            (o.tail = null),
                            (o.lastEffect = null)),
                          K(Lo, Lo.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return (t.lanes = 0), Ql(e, t, n);
                      case 24:
                        gi(t, Vo, e.memoizedState.cache);
                    }
                    return fi(e, t, n);
                  })(e, t, n)
                );
              Ul = 0 !== (131072 & e.flags);
            }
          else (Ul = !1), Xr && 0 !== (1048576 & t.flags) && $r(t, Mr, t.index);
          switch (((t.lanes = 0), t.tag)) {
            case 16:
              e: {
                e = t.pendingProps;
                var r = t.elementType,
                  o = r._init;
                if (
                  ((r = o(r._payload)), (t.type = r), "function" !== typeof r)
                ) {
                  if (void 0 !== r && null !== r) {
                    if ((o = r.$$typeof) === y) {
                      (t.tag = 11), (t = ql(null, t, r, e, n));
                      break e;
                    }
                    if (o === w) {
                      (t.tag = 14), (t = Yl(null, t, r, e, n));
                      break e;
                    }
                  }
                  throw ((t = P(r) || r), Error(l(306, t, "")));
                }
                Ds(r)
                  ? ((e = Ol(r, e)), (t.tag = 1), (t = ei(null, t, r, e, n)))
                  : ((t.tag = 0), (t = Jl(null, t, r, e, n)));
              }
              return t;
            case 0:
              return Jl(e, t, t.type, t.pendingProps, n);
            case 1:
              return ei(e, t, (r = t.type), (o = Ol(r, t.pendingProps)), n);
            case 3:
              e: {
                if ((Z(t, t.stateNode.containerInfo), null === e))
                  throw Error(l(387));
                var a = t.pendingProps;
                (r = (o = t.memoizedState).element),
                  Ti(e, t),
                  Fi(t, a, null, n);
                var i = t.memoizedState;
                if (
                  ((a = i.cache),
                  gi(t, Vo, a),
                  a !== o.cache && xi(t, [Vo], n, !0),
                  Di(),
                  (a = i.element),
                  o.isDehydrated)
                ) {
                  if (
                    ((o = { element: a, isDehydrated: !1, cache: i.cache }),
                    (t.updateQueue.baseState = o),
                    (t.memoizedState = o),
                    256 & t.flags)
                  ) {
                    t = ti(e, t, a, n);
                    break e;
                  }
                  if (a !== r) {
                    ao((r = Ar(Error(l(424)), t))), (t = ti(e, t, a, n));
                    break e;
                  }
                  for (
                    Qr = id(t.stateNode.containerInfo.firstChild),
                      Kr = t,
                      Xr = !0,
                      Gr = null,
                      Jr = !0,
                      n = ko(t, null, a, n),
                      t.child = n;
                    n;

                  )
                    (n.flags = (-3 & n.flags) | 4096), (n = n.sibling);
                } else {
                  if ((oo(), a === r)) {
                    t = fi(e, t, n);
                    break e;
                  }
                  $l(e, t, a, n);
                }
                t = t.child;
              }
              return t;
            case 26:
              return (
                Gl(e, t),
                null === e
                  ? (n = vd(t.type, null, t.pendingProps, null))
                    ? (t.memoizedState = n)
                    : Xr ||
                      ((n = t.type),
                      (e = t.pendingProps),
                      ((r = Qu(G.current).createElement(n))[Me] = t),
                      (r[Ie] = e),
                      qu(r, n, e),
                      Ge(r),
                      (t.stateNode = r))
                  : (t.memoizedState = vd(
                      t.type,
                      e.memoizedProps,
                      t.pendingProps,
                      e.memoizedState
                    )),
                null
              );
            case 27:
              return (
                te(t),
                null === e &&
                  Xr &&
                  ((r = t.stateNode = cd(t.type, t.pendingProps, G.current)),
                  (Kr = t),
                  (Jr = !0),
                  (Qr = id(r.firstChild))),
                (r = t.pendingProps.children),
                null !== e || Xr
                  ? $l(e, t, r, n)
                  : (t.child = So(t, null, r, n)),
                Gl(e, t),
                t.child
              );
            case 5:
              return (
                null === e &&
                  Xr &&
                  ((o = r = Qr) &&
                    (null !==
                    (r = (function (e, t, n, r) {
                      for (; 1 === e.nodeType; ) {
                        var o = n;
                        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
                          if (
                            !r &&
                            ("INPUT" !== e.nodeName || "hidden" !== e.type)
                          )
                            break;
                        } else if (r) {
                          if (!e[$e])
                            switch (t) {
                              case "meta":
                                if (!e.hasAttribute("itemprop")) break;
                                return e;
                              case "link":
                                if (
                                  "stylesheet" ===
                                    (a = e.getAttribute("rel")) &&
                                  e.hasAttribute("data-precedence")
                                )
                                  break;
                                if (
                                  a !== o.rel ||
                                  e.getAttribute("href") !==
                                    (null == o.href ? null : o.href) ||
                                  e.getAttribute("crossorigin") !==
                                    (null == o.crossOrigin
                                      ? null
                                      : o.crossOrigin) ||
                                  e.getAttribute("title") !==
                                    (null == o.title ? null : o.title)
                                )
                                  break;
                                return e;
                              case "style":
                                if (e.hasAttribute("data-precedence")) break;
                                return e;
                              case "script":
                                if (
                                  ((a = e.getAttribute("src")) !==
                                    (null == o.src ? null : o.src) ||
                                    e.getAttribute("type") !==
                                      (null == o.type ? null : o.type) ||
                                    e.getAttribute("crossorigin") !==
                                      (null == o.crossOrigin
                                        ? null
                                        : o.crossOrigin)) &&
                                  a &&
                                  e.hasAttribute("async") &&
                                  !e.hasAttribute("itemprop")
                                )
                                  break;
                                return e;
                              default:
                                return e;
                            }
                        } else {
                          if ("input" !== t || "hidden" !== e.type) return e;
                          var a = null == o.name ? null : "" + o.name;
                          if (
                            "hidden" === o.type &&
                            e.getAttribute("name") === a
                          )
                            return e;
                        }
                        if (null === (e = id(e.nextSibling))) break;
                      }
                      return null;
                    })(r, t.type, t.pendingProps, Jr))
                      ? ((t.stateNode = r),
                        (Kr = t),
                        (Qr = id(r.firstChild)),
                        (Jr = !1),
                        (o = !0))
                      : (o = !1)),
                  o || eo(t)),
                te(t),
                (o = t.type),
                (a = t.pendingProps),
                (i = null !== e ? e.memoizedProps : null),
                (r = a.children),
                Ju(o, a)
                  ? (r = null)
                  : null !== i && Ju(o, i) && (t.flags |= 32),
                null !== t.memoizedState &&
                  ((o = fa(e, t, ha, null, null, n)), (Dd._currentValue = o)),
                Gl(e, t),
                $l(e, t, r, n),
                t.child
              );
            case 6:
              return (
                null === e &&
                  Xr &&
                  ((e = n = Qr) &&
                    (null !==
                    (n = (function (e, t, n) {
                      if ("" === t) return null;
                      for (; 3 !== e.nodeType; ) {
                        if (
                          (1 !== e.nodeType ||
                            "INPUT" !== e.nodeName ||
                            "hidden" !== e.type) &&
                          !n
                        )
                          return null;
                        if (null === (e = id(e.nextSibling))) return null;
                      }
                      return e;
                    })(n, t.pendingProps, Jr))
                      ? ((t.stateNode = n), (Kr = t), (Qr = null), (e = !0))
                      : (e = !1)),
                  e || eo(t)),
                null
              );
            case 13:
              return ai(e, t, n);
            case 4:
              return (
                Z(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = So(t, null, r, n)) : $l(e, t, r, n),
                t.child
              );
            case 11:
              return ql(e, t, t.type, t.pendingProps, n);
            case 7:
              return $l(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return $l(e, t, t.pendingProps.children, n), t.child;
            case 10:
              return (
                (r = t.pendingProps),
                gi(t, t.type, r.value),
                $l(e, t, r.children, n),
                t.child
              );
            case 9:
              return (
                (o = t.type._context),
                (r = t.pendingProps.children),
                Ci(t),
                (r = r((o = Ei(o)))),
                (t.flags |= 1),
                $l(e, t, r, n),
                t.child
              );
            case 14:
              return Yl(e, t, t.type, t.pendingProps, n);
            case 15:
              return Kl(e, t, t.type, t.pendingProps, n);
            case 19:
              return di(e, t, n);
            case 22:
              return Ql(e, t, n);
            case 24:
              return (
                Ci(t),
                (r = Ei(Vo)),
                null === e
                  ? (null === (o = Xo()) &&
                      ((o = tc),
                      (a = Wo()),
                      (o.pooledCache = a),
                      a.refCount++,
                      null !== a && (o.pooledCacheLanes |= n),
                      (o = a)),
                    (t.memoizedState = { parent: r, cache: o }),
                    zi(t),
                    gi(t, Vo, o))
                  : (0 !== (e.lanes & n) &&
                      (Ti(e, t), Fi(t, null, null, n), Di()),
                    (o = e.memoizedState),
                    (a = t.memoizedState),
                    o.parent !== r
                      ? ((o = { parent: r, cache: r }),
                        (t.memoizedState = o),
                        0 === t.lanes &&
                          (t.memoizedState = t.updateQueue.baseState = o),
                        gi(t, Vo, r))
                      : ((r = a.cache),
                        gi(t, Vo, r),
                        r !== o.cache && xi(t, [Vo], n, !0))),
                $l(e, t, t.pendingProps.children, n),
                t.child
              );
            case 29:
              throw t.pendingProps;
          }
          throw Error(l(156, t.tag));
        }
        var hi = q(null),
          vi = null,
          yi = null;
        function gi(e, t, n) {
          K(hi, t._currentValue), (t._currentValue = n);
        }
        function bi(e) {
          (e._currentValue = hi.current), Y(hi);
        }
        function wi(e, t, n) {
          for (; null !== e; ) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function xi(e, t, n, r) {
          var o = e.child;
          for (null !== o && (o.return = e); null !== o; ) {
            var a = o.dependencies;
            if (null !== a) {
              var i = o.child;
              a = a.firstContext;
              e: for (; null !== a; ) {
                var s = a;
                a = o;
                for (var c = 0; c < t.length; c++)
                  if (s.context === t[c]) {
                    (a.lanes |= n),
                      null !== (s = a.alternate) && (s.lanes |= n),
                      wi(a.return, n, e),
                      r || (i = null);
                    break e;
                  }
                a = s.next;
              }
            } else if (18 === o.tag) {
              if (null === (i = o.return)) throw Error(l(341));
              (i.lanes |= n),
                null !== (a = i.alternate) && (a.lanes |= n),
                wi(i, n, e),
                (i = null);
            } else i = o.child;
            if (null !== i) i.return = o;
            else
              for (i = o; null !== i; ) {
                if (i === e) {
                  i = null;
                  break;
                }
                if (null !== (o = i.sibling)) {
                  (o.return = i.return), (i = o);
                  break;
                }
                i = i.return;
              }
            o = i;
          }
        }
        function Si(e, t, n, r) {
          e = null;
          for (var o = t, a = !1; null !== o; ) {
            if (!a)
              if (0 !== (524288 & o.flags)) a = !0;
              else if (0 !== (262144 & o.flags)) break;
            if (10 === o.tag) {
              var i = o.alternate;
              if (null === i) throw Error(l(387));
              if (null !== (i = i.memoizedProps)) {
                var s = o.type;
                Kn(o.pendingProps.value, i.value) ||
                  (null !== e ? e.push(s) : (e = [s]));
              }
            } else if (o === J.current) {
              if (null === (i = o.alternate)) throw Error(l(387));
              i.memoizedState.memoizedState !== o.memoizedState.memoizedState &&
                (null !== e ? e.push(Dd) : (e = [Dd]));
            }
            o = o.return;
          }
          null !== e && xi(t, e, n, r), (t.flags |= 262144);
        }
        function ki(e) {
          for (e = e.firstContext; null !== e; ) {
            if (!Kn(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
          }
          return !1;
        }
        function Ci(e) {
          (vi = e),
            (yi = null),
            null !== (e = e.dependencies) && (e.firstContext = null);
        }
        function Ei(e) {
          return Pi(vi, e);
        }
        function Ni(e, t) {
          return null === vi && Ci(e), Pi(e, t);
        }
        function Pi(e, t) {
          var n = t._currentValue;
          if (
            ((t = { context: t, memoizedValue: n, next: null }), null === yi)
          ) {
            if (null === e) throw Error(l(308));
            (yi = t),
              (e.dependencies = { lanes: 0, firstContext: t }),
              (e.flags |= 524288);
          } else yi = yi.next = t;
          return n;
        }
        var ji = !1;
        function zi(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function Ti(e, t) {
          (e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null,
              });
        }
        function Ri(e) {
          return { lane: e, tag: 0, payload: null, callback: null, next: null };
        }
        function _i(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 0 !== (2 & ec))) {
            var o = r.pending;
            return (
              null === o ? (t.next = t) : ((t.next = o.next), (o.next = t)),
              (r.pending = t),
              (t = Rr(e)),
              Tr(e, null, n),
              t
            );
          }
          return Pr(e, r, t, n), Rr(e);
        }
        function Oi(e, t, n) {
          if (
            null !== (t = t.updateQueue) &&
            ((t = t.shared), 0 !== (4194176 & n))
          ) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), Ae(e, n);
          }
        }
        function Ai(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var o = null,
              a = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var l = {
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: null,
                  next: null,
                };
                null === a ? (o = a = l) : (a = a.next = l), (n = n.next);
              } while (null !== n);
              null === a ? (o = a = t) : (a = a.next = t);
            } else o = a = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: o,
                lastBaseUpdate: a,
                shared: r.shared,
                callbacks: r.callbacks,
              }),
              void (e.updateQueue = n)
            );
          }
          null === (e = n.lastBaseUpdate)
            ? (n.firstBaseUpdate = t)
            : (e.next = t),
            (n.lastBaseUpdate = t);
        }
        var Li = !1;
        function Di() {
          if (Li) {
            if (null !== qo) throw qo;
          }
        }
        function Fi(e, t, n, r) {
          Li = !1;
          var o = e.updateQueue;
          ji = !1;
          var a = o.firstBaseUpdate,
            l = o.lastBaseUpdate,
            i = o.shared.pending;
          if (null !== i) {
            o.shared.pending = null;
            var s = i,
              c = s.next;
            (s.next = null), null === l ? (a = c) : (l.next = c), (l = s);
            var u = e.alternate;
            null !== u &&
              (i = (u = u.updateQueue).lastBaseUpdate) !== l &&
              (null === i ? (u.firstBaseUpdate = c) : (i.next = c),
              (u.lastBaseUpdate = s));
          }
          if (null !== a) {
            var d = o.baseState;
            for (l = 0, u = c = s = null, i = a; ; ) {
              var f = -536870913 & i.lane,
                p = f !== i.lane;
              if (p ? (rc & f) === f : (r & f) === f) {
                0 !== f && f === $o && (Li = !0),
                  null !== u &&
                    (u = u.next =
                      {
                        lane: 0,
                        tag: i.tag,
                        payload: i.payload,
                        callback: null,
                        next: null,
                      });
                e: {
                  var m = e,
                    h = i;
                  f = t;
                  var v = n;
                  switch (h.tag) {
                    case 1:
                      if ("function" === typeof (m = h.payload)) {
                        d = m.call(v, d, f);
                        break e;
                      }
                      d = m;
                      break e;
                    case 3:
                      m.flags = (-65537 & m.flags) | 128;
                    case 0:
                      if (
                        null ===
                          (f =
                            "function" === typeof (m = h.payload)
                              ? m.call(v, d, f)
                              : m) ||
                        void 0 === f
                      )
                        break e;
                      d = R({}, d, f);
                      break e;
                    case 2:
                      ji = !0;
                  }
                }
                null !== (f = i.callback) &&
                  ((e.flags |= 64),
                  p && (e.flags |= 8192),
                  null === (p = o.callbacks) ? (o.callbacks = [f]) : p.push(f));
              } else
                (p = {
                  lane: f,
                  tag: i.tag,
                  payload: i.payload,
                  callback: i.callback,
                  next: null,
                }),
                  null === u ? ((c = u = p), (s = d)) : (u = u.next = p),
                  (l |= f);
              if (null === (i = i.next)) {
                if (null === (i = o.shared.pending)) break;
                (i = (p = i).next),
                  (p.next = null),
                  (o.lastBaseUpdate = p),
                  (o.shared.pending = null);
              }
            }
            null === u && (s = d),
              (o.baseState = s),
              (o.firstBaseUpdate = c),
              (o.lastBaseUpdate = u),
              null === a && (o.shared.lanes = 0),
              (dc |= l),
              (e.lanes = l),
              (e.memoizedState = d);
          }
        }
        function Mi(e, t) {
          if ("function" !== typeof e) throw Error(l(191, e));
          e.call(t);
        }
        function Ii(e, t) {
          var n = e.callbacks;
          if (null !== n)
            for (e.callbacks = null, e = 0; e < n.length; e++) Mi(n[e], t);
        }
        function Vi(e, t) {
          try {
            var n = t.updateQueue,
              r = null !== n ? n.lastEffect : null;
            if (null !== r) {
              var o = r.next;
              n = o;
              do {
                if ((n.tag & e) === e) {
                  r = void 0;
                  var a = n.create,
                    l = n.inst;
                  (r = a()), (l.destroy = r);
                }
                n = n.next;
              } while (n !== o);
            }
          } catch (i) {
            ru(t, t.return, i);
          }
        }
        function Wi(e, t, n) {
          try {
            var r = t.updateQueue,
              o = null !== r ? r.lastEffect : null;
            if (null !== o) {
              var a = o.next;
              r = a;
              do {
                if ((r.tag & e) === e) {
                  var l = r.inst,
                    i = l.destroy;
                  if (void 0 !== i) {
                    (l.destroy = void 0), (o = t);
                    var s = n;
                    try {
                      i();
                    } catch (c) {
                      ru(o, s, c);
                    }
                  }
                }
                r = r.next;
              } while (r !== a);
            }
          } catch (c) {
            ru(t, t.return, c);
          }
        }
        function Hi(e) {
          var t = e.updateQueue;
          if (null !== t) {
            var n = e.stateNode;
            try {
              Ii(t, n);
            } catch (r) {
              ru(e, e.return, r);
            }
          }
        }
        function Bi(e, t, n) {
          (n.props = Ol(e.type, e.memoizedProps)), (n.state = e.memoizedState);
          try {
            n.componentWillUnmount();
          } catch (r) {
            ru(e, t, r);
          }
        }
        function Ui(e, t) {
          try {
            var n = e.ref;
            if (null !== n) {
              var r = e.stateNode;
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  var o = r;
                  break;
                default:
                  o = r;
              }
              "function" === typeof n ? (e.refCleanup = n(o)) : (n.current = o);
            }
          } catch (a) {
            ru(e, t, a);
          }
        }
        function $i(e, t) {
          var n = e.ref,
            r = e.refCleanup;
          if (null !== n)
            if ("function" === typeof r)
              try {
                r();
              } catch (o) {
                ru(e, t, o);
              } finally {
                (e.refCleanup = null),
                  null != (e = e.alternate) && (e.refCleanup = null);
              }
            else if ("function" === typeof n)
              try {
                n(null);
              } catch (a) {
                ru(e, t, a);
              }
            else n.current = null;
        }
        function qi(e) {
          var t = e.type,
            n = e.memoizedProps,
            r = e.stateNode;
          try {
            e: switch (t) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                n.autoFocus && r.focus();
                break e;
              case "img":
                n.src ? (r.src = n.src) : n.srcSet && (r.srcset = n.srcSet);
            }
          } catch (o) {
            ru(e, e.return, o);
          }
        }
        function Yi(e, t, n) {
          try {
            var r = e.stateNode;
            !(function (e, t, n, r) {
              switch (t) {
                case "div":
                case "span":
                case "svg":
                case "path":
                case "a":
                case "g":
                case "p":
                case "li":
                  break;
                case "input":
                  var o = null,
                    a = null,
                    i = null,
                    s = null,
                    c = null,
                    u = null,
                    d = null;
                  for (m in n) {
                    var f = n[m];
                    if (n.hasOwnProperty(m) && null != f)
                      switch (m) {
                        case "checked":
                        case "value":
                          break;
                        case "defaultValue":
                          c = f;
                        default:
                          r.hasOwnProperty(m) || Uu(e, t, m, null, r, f);
                      }
                  }
                  for (var p in r) {
                    var m = r[p];
                    if (
                      ((f = n[p]),
                      r.hasOwnProperty(p) && (null != m || null != f))
                    )
                      switch (p) {
                        case "type":
                          a = m;
                          break;
                        case "name":
                          o = m;
                          break;
                        case "checked":
                          u = m;
                          break;
                        case "defaultChecked":
                          d = m;
                          break;
                        case "value":
                          i = m;
                          break;
                        case "defaultValue":
                          s = m;
                          break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                          if (null != m) throw Error(l(137, t));
                          break;
                        default:
                          m !== f && Uu(e, t, p, m, r, f);
                      }
                  }
                  return void vt(e, i, s, c, u, d, a, o);
                case "select":
                  for (a in ((m = i = s = p = null), n))
                    if (((c = n[a]), n.hasOwnProperty(a) && null != c))
                      switch (a) {
                        case "value":
                          break;
                        case "multiple":
                          m = c;
                        default:
                          r.hasOwnProperty(a) || Uu(e, t, a, null, r, c);
                      }
                  for (o in r)
                    if (
                      ((a = r[o]),
                      (c = n[o]),
                      r.hasOwnProperty(o) && (null != a || null != c))
                    )
                      switch (o) {
                        case "value":
                          p = a;
                          break;
                        case "defaultValue":
                          s = a;
                          break;
                        case "multiple":
                          i = a;
                        default:
                          a !== c && Uu(e, t, o, a, r, c);
                      }
                  return (
                    (t = s),
                    (n = i),
                    (r = m),
                    void (null != p
                      ? bt(e, !!n, p, !1)
                      : !!r !== !!n &&
                        (null != t
                          ? bt(e, !!n, t, !0)
                          : bt(e, !!n, n ? [] : "", !1)))
                  );
                case "textarea":
                  for (s in ((m = p = null), n))
                    if (
                      ((o = n[s]),
                      n.hasOwnProperty(s) && null != o && !r.hasOwnProperty(s))
                    )
                      switch (s) {
                        case "value":
                        case "children":
                          break;
                        default:
                          Uu(e, t, s, null, r, o);
                      }
                  for (i in r)
                    if (
                      ((o = r[i]),
                      (a = n[i]),
                      r.hasOwnProperty(i) && (null != o || null != a))
                    )
                      switch (i) {
                        case "value":
                          p = o;
                          break;
                        case "defaultValue":
                          m = o;
                          break;
                        case "children":
                          break;
                        case "dangerouslySetInnerHTML":
                          if (null != o) throw Error(l(91));
                          break;
                        default:
                          o !== a && Uu(e, t, i, o, r, a);
                      }
                  return void wt(e, p, m);
                case "option":
                  for (var h in n)
                    if (
                      ((p = n[h]),
                      n.hasOwnProperty(h) && null != p && !r.hasOwnProperty(h))
                    )
                      if ("selected" === h) e.selected = !1;
                      else Uu(e, t, h, null, r, p);
                  for (c in r)
                    if (
                      ((p = r[c]),
                      (m = n[c]),
                      r.hasOwnProperty(c) &&
                        p !== m &&
                        (null != p || null != m))
                    )
                      if ("selected" === c)
                        e.selected =
                          p && "function" !== typeof p && "symbol" !== typeof p;
                      else Uu(e, t, c, p, r, m);
                  return;
                case "img":
                case "link":
                case "area":
                case "base":
                case "br":
                case "col":
                case "embed":
                case "hr":
                case "keygen":
                case "meta":
                case "param":
                case "source":
                case "track":
                case "wbr":
                case "menuitem":
                  for (var v in n)
                    (p = n[v]),
                      n.hasOwnProperty(v) &&
                        null != p &&
                        !r.hasOwnProperty(v) &&
                        Uu(e, t, v, null, r, p);
                  for (u in r)
                    if (
                      ((p = r[u]),
                      (m = n[u]),
                      r.hasOwnProperty(u) &&
                        p !== m &&
                        (null != p || null != m))
                    )
                      switch (u) {
                        case "children":
                        case "dangerouslySetInnerHTML":
                          if (null != p) throw Error(l(137, t));
                          break;
                        default:
                          Uu(e, t, u, p, r, m);
                      }
                  return;
                default:
                  if (Nt(t)) {
                    for (var y in n)
                      (p = n[y]),
                        n.hasOwnProperty(y) &&
                          void 0 !== p &&
                          !r.hasOwnProperty(y) &&
                          $u(e, t, y, void 0, r, p);
                    for (d in r)
                      (p = r[d]),
                        (m = n[d]),
                        !r.hasOwnProperty(d) ||
                          p === m ||
                          (void 0 === p && void 0 === m) ||
                          $u(e, t, d, p, r, m);
                    return;
                  }
              }
              for (var g in n)
                (p = n[g]),
                  n.hasOwnProperty(g) &&
                    null != p &&
                    !r.hasOwnProperty(g) &&
                    Uu(e, t, g, null, r, p);
              for (f in r)
                (p = r[f]),
                  (m = n[f]),
                  !r.hasOwnProperty(f) ||
                    p === m ||
                    (null == p && null == m) ||
                    Uu(e, t, f, p, r, m);
            })(r, e.type, n, t),
              (r[Ie] = t);
          } catch (o) {
            ru(e, e.return, o);
          }
        }
        function Ki(e) {
          return (
            5 === e.tag ||
            3 === e.tag ||
            26 === e.tag ||
            27 === e.tag ||
            4 === e.tag
          );
        }
        function Qi(e) {
          e: for (;;) {
            for (; null === e.sibling; ) {
              if (null === e.return || Ki(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              5 !== e.tag && 6 !== e.tag && 27 !== e.tag && 18 !== e.tag;

            ) {
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              (e.child.return = e), (e = e.child);
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function Xi(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode),
              t
                ? 8 === n.nodeType
                  ? n.parentNode.insertBefore(e, t)
                  : n.insertBefore(e, t)
                : (8 === n.nodeType
                    ? (t = n.parentNode).insertBefore(e, n)
                    : (t = n).appendChild(e),
                  (null !== (n = n._reactRootContainer) && void 0 !== n) ||
                    null !== t.onclick ||
                    (t.onclick = Bu));
          else if (4 !== r && 27 !== r && null !== (e = e.child))
            for (Xi(e, t, n), e = e.sibling; null !== e; )
              Xi(e, t, n), (e = e.sibling);
        }
        function Gi(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
          else if (4 !== r && 27 !== r && null !== (e = e.child))
            for (Gi(e, t, n), e = e.sibling; null !== e; )
              Gi(e, t, n), (e = e.sibling);
        }
        var Ji = !1,
          Zi = !1,
          es = !1,
          ts = "function" === typeof WeakSet ? WeakSet : Set,
          ns = null,
          rs = !1;
        function os(e, t, n) {
          var r = n.flags;
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
              ys(e, n), 4 & r && Vi(5, n);
              break;
            case 1:
              if ((ys(e, n), 4 & r))
                if (((e = n.stateNode), null === t))
                  try {
                    e.componentDidMount();
                  } catch (i) {
                    ru(n, n.return, i);
                  }
                else {
                  var o = Ol(n.type, t.memoizedProps);
                  t = t.memoizedState;
                  try {
                    e.componentDidUpdate(
                      o,
                      t,
                      e.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (s) {
                    ru(n, n.return, s);
                  }
                }
              64 & r && Hi(n), 512 & r && Ui(n, n.return);
              break;
            case 3:
              if ((ys(e, n), 64 & r && null !== (r = n.updateQueue))) {
                if (((e = null), null !== n.child))
                  switch (n.child.tag) {
                    case 27:
                    case 5:
                    case 1:
                      e = n.child.stateNode;
                  }
                try {
                  Ii(r, e);
                } catch (i) {
                  ru(n, n.return, i);
                }
              }
              break;
            case 26:
              ys(e, n), 512 & r && Ui(n, n.return);
              break;
            case 27:
            case 5:
              ys(e, n),
                null === t && 4 & r && qi(n),
                512 & r && Ui(n, n.return);
              break;
            case 12:
            default:
              ys(e, n);
              break;
            case 13:
              ys(e, n), 4 & r && us(e, n);
              break;
            case 22:
              if (!(o = null !== n.memoizedState || Ji)) {
                t = (null !== t && null !== t.memoizedState) || Zi;
                var a = Ji,
                  l = Zi;
                (Ji = o),
                  (Zi = t) && !l
                    ? bs(e, n, 0 !== (8772 & n.subtreeFlags))
                    : ys(e, n),
                  (Ji = a),
                  (Zi = l);
              }
              512 & r &&
                ("manual" === n.memoizedProps.mode
                  ? Ui(n, n.return)
                  : $i(n, n.return));
          }
        }
        function as(e) {
          var t = e.alternate;
          null !== t && ((e.alternate = null), as(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag && null !== (t = e.stateNode) && qe(t),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null);
        }
        var ls = null,
          is = !1;
        function ss(e, t, n) {
          for (n = n.child; null !== n; ) cs(e, t, n), (n = n.sibling);
        }
        function cs(e, t, n) {
          if (ge && "function" === typeof ge.onCommitFiberUnmount)
            try {
              ge.onCommitFiberUnmount(ye, n);
            } catch (l) {}
          switch (n.tag) {
            case 26:
              Zi || $i(n, t),
                ss(e, t, n),
                n.memoizedState
                  ? n.memoizedState.count--
                  : n.stateNode && (n = n.stateNode).parentNode.removeChild(n);
              break;
            case 27:
              Zi || $i(n, t);
              var r = ls,
                o = is;
              for (
                ls = n.stateNode, ss(e, t, n), t = (n = n.stateNode).attributes;
                t.length;

              )
                n.removeAttributeNode(t[0]);
              qe(n), (ls = r), (is = o);
              break;
            case 5:
              Zi || $i(n, t);
            case 6:
              o = ls;
              var a = is;
              if (((ls = null), ss(e, t, n), (is = a), null !== (ls = o)))
                if (is)
                  try {
                    (e = ls),
                      (r = n.stateNode),
                      8 === e.nodeType
                        ? e.parentNode.removeChild(r)
                        : e.removeChild(r);
                  } catch (i) {
                    ru(n, t, i);
                  }
                else
                  try {
                    ls.removeChild(n.stateNode);
                  } catch (i) {
                    ru(n, t, i);
                  }
              break;
            case 18:
              null !== ls &&
                (is
                  ? ((t = ls),
                    (n = n.stateNode),
                    8 === t.nodeType
                      ? ad(t.parentNode, n)
                      : 1 === t.nodeType && ad(t, n),
                    vf(t))
                  : ad(ls, n.stateNode));
              break;
            case 4:
              (r = ls),
                (o = is),
                (ls = n.stateNode.containerInfo),
                (is = !0),
                ss(e, t, n),
                (ls = r),
                (is = o);
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              Zi || Wi(2, n, t), Zi || Wi(4, n, t), ss(e, t, n);
              break;
            case 1:
              Zi ||
                ($i(n, t),
                "function" === typeof (r = n.stateNode).componentWillUnmount &&
                  Bi(n, t, r)),
                ss(e, t, n);
              break;
            case 21:
              ss(e, t, n);
              break;
            case 22:
              Zi || $i(n, t),
                (Zi = (r = Zi) || null !== n.memoizedState),
                ss(e, t, n),
                (Zi = r);
              break;
            default:
              ss(e, t, n);
          }
        }
        function us(e, t) {
          if (
            null === t.memoizedState &&
            null !== (e = t.alternate) &&
            null !== (e = e.memoizedState) &&
            null !== (e = e.dehydrated)
          )
            try {
              vf(e);
            } catch (n) {
              ru(t, t.return, n);
            }
        }
        function ds(e, t) {
          var n = (function (e) {
            switch (e.tag) {
              case 13:
              case 19:
                var t = e.stateNode;
                return null === t && (t = e.stateNode = new ts()), t;
              case 22:
                return (
                  null === (t = (e = e.stateNode)._retryCache) &&
                    (t = e._retryCache = new ts()),
                  t
                );
              default:
                throw Error(l(435, e.tag));
            }
          })(e);
          t.forEach(function (t) {
            var r = su.bind(null, e, t);
            n.has(t) || (n.add(t), t.then(r, r));
          });
        }
        function fs(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var o = n[r],
                a = e,
                i = t,
                s = i;
              e: for (; null !== s; ) {
                switch (s.tag) {
                  case 27:
                  case 5:
                    (ls = s.stateNode), (is = !1);
                    break e;
                  case 3:
                  case 4:
                    (ls = s.stateNode.containerInfo), (is = !0);
                    break e;
                }
                s = s.return;
              }
              if (null === ls) throw Error(l(160));
              cs(a, i, o),
                (ls = null),
                (is = !1),
                null !== (a = o.alternate) && (a.return = null),
                (o.return = null);
            }
          if (13878 & t.subtreeFlags)
            for (t = t.child; null !== t; ) ms(t, e), (t = t.sibling);
        }
        var ps = null;
        function ms(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              fs(t, e),
                hs(e),
                4 & r && (Wi(3, e, e.return), Vi(3, e), Wi(5, e, e.return));
              break;
            case 1:
              fs(t, e),
                hs(e),
                512 & r && (Zi || null === n || $i(n, n.return)),
                64 & r &&
                  Ji &&
                  null !== (e = e.updateQueue) &&
                  null !== (r = e.callbacks) &&
                  ((n = e.shared.hiddenCallbacks),
                  (e.shared.hiddenCallbacks = null === n ? r : n.concat(r)));
              break;
            case 26:
              var o = ps;
              if (
                (fs(t, e),
                hs(e),
                512 & r && (Zi || null === n || $i(n, n.return)),
                4 & r)
              ) {
                var a = null !== n ? n.memoizedState : null;
                if (((r = e.memoizedState), null === n))
                  if (null === r)
                    if (null === e.stateNode) {
                      e: {
                        (r = e.type),
                          (n = e.memoizedProps),
                          (o = o.ownerDocument || o);
                        t: switch (r) {
                          case "title":
                            (!(a = o.getElementsByTagName("title")[0]) ||
                              a[$e] ||
                              a[Me] ||
                              "http://www.w3.org/2000/svg" === a.namespaceURI ||
                              a.hasAttribute("itemprop")) &&
                              ((a = o.createElement(r)),
                              o.head.insertBefore(
                                a,
                                o.querySelector("head > title")
                              )),
                              qu(a, r, n),
                              (a[Me] = e),
                              Ge(a),
                              (r = a);
                            break e;
                          case "link":
                            var i = Pd("link", "href", o).get(
                              r + (n.href || "")
                            );
                            if (i)
                              for (var s = 0; s < i.length; s++)
                                if (
                                  (a = i[s]).getAttribute("href") ===
                                    (null == n.href ? null : n.href) &&
                                  a.getAttribute("rel") ===
                                    (null == n.rel ? null : n.rel) &&
                                  a.getAttribute("title") ===
                                    (null == n.title ? null : n.title) &&
                                  a.getAttribute("crossorigin") ===
                                    (null == n.crossOrigin
                                      ? null
                                      : n.crossOrigin)
                                ) {
                                  i.splice(s, 1);
                                  break t;
                                }
                            qu((a = o.createElement(r)), r, n),
                              o.head.appendChild(a);
                            break;
                          case "meta":
                            if (
                              (i = Pd("meta", "content", o).get(
                                r + (n.content || "")
                              ))
                            )
                              for (s = 0; s < i.length; s++)
                                if (
                                  (a = i[s]).getAttribute("content") ===
                                    (null == n.content
                                      ? null
                                      : "" + n.content) &&
                                  a.getAttribute("name") ===
                                    (null == n.name ? null : n.name) &&
                                  a.getAttribute("property") ===
                                    (null == n.property ? null : n.property) &&
                                  a.getAttribute("http-equiv") ===
                                    (null == n.httpEquiv
                                      ? null
                                      : n.httpEquiv) &&
                                  a.getAttribute("charset") ===
                                    (null == n.charSet ? null : n.charSet)
                                ) {
                                  i.splice(s, 1);
                                  break t;
                                }
                            qu((a = o.createElement(r)), r, n),
                              o.head.appendChild(a);
                            break;
                          default:
                            throw Error(l(468, r));
                        }
                        (a[Me] = e), Ge(a), (r = a);
                      }
                      e.stateNode = r;
                    } else jd(o, e.type, e.stateNode);
                  else e.stateNode = Sd(o, r, e.memoizedProps);
                else
                  a !== r
                    ? (null === a
                        ? null !== n.stateNode &&
                          (n = n.stateNode).parentNode.removeChild(n)
                        : a.count--,
                      null === r
                        ? jd(o, e.type, e.stateNode)
                        : Sd(o, r, e.memoizedProps))
                    : null === r &&
                      null !== e.stateNode &&
                      Yi(e, e.memoizedProps, n.memoizedProps);
              }
              break;
            case 27:
              if (4 & r && null === e.alternate) {
                (o = e.stateNode), (a = e.memoizedProps);
                try {
                  for (var c = o.firstChild; c; ) {
                    var u = c.nextSibling,
                      d = c.nodeName;
                    c[$e] ||
                      "HEAD" === d ||
                      "BODY" === d ||
                      "SCRIPT" === d ||
                      "STYLE" === d ||
                      ("LINK" === d && "stylesheet" === c.rel.toLowerCase()) ||
                      o.removeChild(c),
                      (c = u);
                  }
                  for (var f = e.type, p = o.attributes; p.length; )
                    o.removeAttributeNode(p[0]);
                  qu(o, f, a), (o[Me] = e), (o[Ie] = a);
                } catch (h) {
                  ru(e, e.return, h);
                }
              }
            case 5:
              if (
                (fs(t, e),
                hs(e),
                512 & r && (Zi || null === n || $i(n, n.return)),
                32 & e.flags)
              ) {
                o = e.stateNode;
                try {
                  St(o, "");
                } catch (h) {
                  ru(e, e.return, h);
                }
              }
              4 & r &&
                null != e.stateNode &&
                Yi(e, (o = e.memoizedProps), null !== n ? n.memoizedProps : o),
                1024 & r && (es = !0);
              break;
            case 6:
              if ((fs(t, e), hs(e), 4 & r)) {
                if (null === e.stateNode) throw Error(l(162));
                (r = e.memoizedProps), (n = e.stateNode);
                try {
                  n.nodeValue = r;
                } catch (h) {
                  ru(e, e.return, h);
                }
              }
              break;
            case 3:
              if (
                ((Nd = null),
                (o = ps),
                (ps = fd(t.containerInfo)),
                fs(t, e),
                (ps = o),
                hs(e),
                4 & r && null !== n && n.memoizedState.isDehydrated)
              )
                try {
                  vf(t.containerInfo);
                } catch (h) {
                  ru(e, e.return, h);
                }
              es && ((es = !1), vs(e));
              break;
            case 4:
              (r = ps),
                (ps = fd(e.stateNode.containerInfo)),
                fs(t, e),
                hs(e),
                (ps = r);
              break;
            case 12:
              fs(t, e), hs(e);
              break;
            case 13:
              fs(t, e),
                hs(e),
                8192 & e.child.flags &&
                  (null !== e.memoizedState) !==
                    (null !== n && null !== n.memoizedState) &&
                  (bc = se()),
                4 & r &&
                  null !== (r = e.updateQueue) &&
                  ((e.updateQueue = null), ds(e, r));
              break;
            case 22:
              if (
                (512 & r && (Zi || null === n || $i(n, n.return)),
                (c = null !== e.memoizedState),
                (u = null !== n && null !== n.memoizedState),
                (Ji = (d = Ji) || c),
                (Zi = (f = Zi) || u),
                fs(t, e),
                (Zi = f),
                (Ji = d),
                hs(e),
                ((t = e.stateNode)._current = e),
                (t._visibility &= -3),
                (t._visibility |= 2 & t._pendingVisibility),
                8192 & r &&
                  ((t._visibility = c ? -2 & t._visibility : 1 | t._visibility),
                  c && ((t = Ji || Zi), null === n || u || t || gs(e)),
                  null === e.memoizedProps ||
                    "manual" !== e.memoizedProps.mode))
              )
                e: for (n = null, t = e; ; ) {
                  if (5 === t.tag || 26 === t.tag || 27 === t.tag) {
                    if (null === n) {
                      u = n = t;
                      try {
                        if (((o = u.stateNode), c))
                          "function" === typeof (a = o.style).setProperty
                            ? a.setProperty("display", "none", "important")
                            : (a.display = "none");
                        else {
                          i = u.stateNode;
                          var m =
                            void 0 !== (s = u.memoizedProps.style) &&
                            null !== s &&
                            s.hasOwnProperty("display")
                              ? s.display
                              : null;
                          i.style.display =
                            null == m || "boolean" === typeof m
                              ? ""
                              : ("" + m).trim();
                        }
                      } catch (h) {
                        ru(u, u.return, h);
                      }
                    }
                  } else if (6 === t.tag) {
                    if (null === n) {
                      u = t;
                      try {
                        u.stateNode.nodeValue = c ? "" : u.memoizedProps;
                      } catch (h) {
                        ru(u, u.return, h);
                      }
                    }
                  } else if (
                    ((22 !== t.tag && 23 !== t.tag) ||
                      null === t.memoizedState ||
                      t === e) &&
                    null !== t.child
                  ) {
                    (t.child.return = t), (t = t.child);
                    continue;
                  }
                  if (t === e) break e;
                  for (; null === t.sibling; ) {
                    if (null === t.return || t.return === e) break e;
                    n === t && (n = null), (t = t.return);
                  }
                  n === t && (n = null),
                    (t.sibling.return = t.return),
                    (t = t.sibling);
                }
              4 & r &&
                null !== (r = e.updateQueue) &&
                null !== (n = r.retryQueue) &&
                ((r.retryQueue = null), ds(e, n));
              break;
            case 19:
              fs(t, e),
                hs(e),
                4 & r &&
                  null !== (r = e.updateQueue) &&
                  ((e.updateQueue = null), ds(e, r));
              break;
            case 21:
              break;
            default:
              fs(t, e), hs(e);
          }
        }
        function hs(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              if (27 !== e.tag) {
                e: {
                  for (var n = e.return; null !== n; ) {
                    if (Ki(n)) {
                      var r = n;
                      break e;
                    }
                    n = n.return;
                  }
                  throw Error(l(160));
                }
                switch (r.tag) {
                  case 27:
                    var o = r.stateNode;
                    Gi(e, Qi(e), o);
                    break;
                  case 5:
                    var a = r.stateNode;
                    32 & r.flags && (St(a, ""), (r.flags &= -33)),
                      Gi(e, Qi(e), a);
                    break;
                  case 3:
                  case 4:
                    var i = r.stateNode.containerInfo;
                    Xi(e, Qi(e), i);
                    break;
                  default:
                    throw Error(l(161));
                }
              }
            } catch (s) {
              ru(e, e.return, s);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function vs(e) {
          if (1024 & e.subtreeFlags)
            for (e = e.child; null !== e; ) {
              var t = e;
              vs(t),
                5 === t.tag && 1024 & t.flags && t.stateNode.reset(),
                (e = e.sibling);
            }
        }
        function ys(e, t) {
          if (8772 & t.subtreeFlags)
            for (t = t.child; null !== t; )
              os(e, t.alternate, t), (t = t.sibling);
        }
        function gs(e) {
          for (e = e.child; null !== e; ) {
            var t = e;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Wi(4, t, t.return), gs(t);
                break;
              case 1:
                $i(t, t.return);
                var n = t.stateNode;
                "function" === typeof n.componentWillUnmount &&
                  Bi(t, t.return, n),
                  gs(t);
                break;
              case 26:
              case 27:
              case 5:
                $i(t, t.return), gs(t);
                break;
              case 22:
                $i(t, t.return), null === t.memoizedState && gs(t);
                break;
              default:
                gs(t);
            }
            e = e.sibling;
          }
        }
        function bs(e, t, n) {
          for (
            n = n && 0 !== (8772 & t.subtreeFlags), t = t.child;
            null !== t;

          ) {
            var r = t.alternate,
              o = e,
              a = t,
              l = a.flags;
            switch (a.tag) {
              case 0:
              case 11:
              case 15:
                bs(o, a, n), Vi(4, a);
                break;
              case 1:
                if (
                  (bs(o, a, n),
                  "function" ===
                    typeof (o = (r = a).stateNode).componentDidMount)
                )
                  try {
                    o.componentDidMount();
                  } catch (c) {
                    ru(r, r.return, c);
                  }
                if (null !== (o = (r = a).updateQueue)) {
                  var i = r.stateNode;
                  try {
                    var s = o.shared.hiddenCallbacks;
                    if (null !== s)
                      for (
                        o.shared.hiddenCallbacks = null, o = 0;
                        o < s.length;
                        o++
                      )
                        Mi(s[o], i);
                  } catch (c) {
                    ru(r, r.return, c);
                  }
                }
                n && 64 & l && Hi(a), Ui(a, a.return);
                break;
              case 26:
              case 27:
              case 5:
                bs(o, a, n), n && null === r && 4 & l && qi(a), Ui(a, a.return);
                break;
              case 12:
              default:
                bs(o, a, n);
                break;
              case 13:
                bs(o, a, n), n && 4 & l && us(o, a);
                break;
              case 22:
                null === a.memoizedState && bs(o, a, n), Ui(a, a.return);
            }
            t = t.sibling;
          }
        }
        function ws(e, t) {
          var n = null;
          null !== e &&
            null !== e.memoizedState &&
            null !== e.memoizedState.cachePool &&
            (n = e.memoizedState.cachePool.pool),
            (e = null),
            null !== t.memoizedState &&
              null !== t.memoizedState.cachePool &&
              (e = t.memoizedState.cachePool.pool),
            e !== n && (null != e && e.refCount++, null != n && Ho(n));
        }
        function xs(e, t) {
          (e = null),
            null !== t.alternate && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache) !== e &&
              (t.refCount++, null != e && Ho(e));
        }
        function Ss(e, t, n, r) {
          if (10256 & t.subtreeFlags)
            for (t = t.child; null !== t; ) ks(e, t, n, r), (t = t.sibling);
        }
        function ks(e, t, n, r) {
          var o = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              Ss(e, t, n, r), 2048 & o && Vi(9, t);
              break;
            case 3:
              Ss(e, t, n, r),
                2048 & o &&
                  ((e = null),
                  null !== t.alternate && (e = t.alternate.memoizedState.cache),
                  (t = t.memoizedState.cache) !== e &&
                    (t.refCount++, null != e && Ho(e)));
              break;
            case 12:
              if (2048 & o) {
                Ss(e, t, n, r), (e = t.stateNode);
                try {
                  var a = t.memoizedProps,
                    l = a.id,
                    i = a.onPostCommit;
                  "function" === typeof i &&
                    i(
                      l,
                      null === t.alternate ? "mount" : "update",
                      e.passiveEffectDuration,
                      -0
                    );
                } catch (s) {
                  ru(t, t.return, s);
                }
              } else Ss(e, t, n, r);
              break;
            case 23:
              break;
            case 22:
              (a = t.stateNode),
                null !== t.memoizedState
                  ? 4 & a._visibility
                    ? Ss(e, t, n, r)
                    : Es(e, t)
                  : 4 & a._visibility
                  ? Ss(e, t, n, r)
                  : ((a._visibility |= 4),
                    Cs(e, t, n, r, 0 !== (10256 & t.subtreeFlags))),
                2048 & o && ws(t.alternate, t);
              break;
            case 24:
              Ss(e, t, n, r), 2048 & o && xs(t.alternate, t);
              break;
            default:
              Ss(e, t, n, r);
          }
        }
        function Cs(e, t, n, r, o) {
          for (
            o = o && 0 !== (10256 & t.subtreeFlags), t = t.child;
            null !== t;

          ) {
            var a = e,
              l = t,
              i = n,
              s = r,
              c = l.flags;
            switch (l.tag) {
              case 0:
              case 11:
              case 15:
                Cs(a, l, i, s, o), Vi(8, l);
                break;
              case 23:
                break;
              case 22:
                var u = l.stateNode;
                null !== l.memoizedState
                  ? 4 & u._visibility
                    ? Cs(a, l, i, s, o)
                    : Es(a, l)
                  : ((u._visibility |= 4), Cs(a, l, i, s, o)),
                  o && 2048 & c && ws(l.alternate, l);
                break;
              case 24:
                Cs(a, l, i, s, o), o && 2048 & c && xs(l.alternate, l);
                break;
              default:
                Cs(a, l, i, s, o);
            }
            t = t.sibling;
          }
        }
        function Es(e, t) {
          if (10256 & t.subtreeFlags)
            for (t = t.child; null !== t; ) {
              var n = e,
                r = t,
                o = r.flags;
              switch (r.tag) {
                case 22:
                  Es(n, r), 2048 & o && ws(r.alternate, r);
                  break;
                case 24:
                  Es(n, r), 2048 & o && xs(r.alternate, r);
                  break;
                default:
                  Es(n, r);
              }
              t = t.sibling;
            }
        }
        var Ns = 8192;
        function Ps(e) {
          if (e.subtreeFlags & Ns)
            for (e = e.child; null !== e; ) js(e), (e = e.sibling);
        }
        function js(e) {
          switch (e.tag) {
            case 26:
              Ps(e),
                e.flags & Ns &&
                  null !== e.memoizedState &&
                  (function (e, t, n) {
                    if (null === Td) throw Error(l(475));
                    var r = Td;
                    if (
                      "stylesheet" === t.type &&
                      ("string" !== typeof n.media ||
                        !1 !== matchMedia(n.media).matches) &&
                      0 === (4 & t.state.loading)
                    ) {
                      if (null === t.instance) {
                        var o = yd(n.href),
                          a = e.querySelector(gd(o));
                        if (a)
                          return (
                            null !== (e = a._p) &&
                              "object" === typeof e &&
                              "function" === typeof e.then &&
                              (r.count++, (r = _d.bind(r)), e.then(r, r)),
                            (t.state.loading |= 4),
                            (t.instance = a),
                            void Ge(a)
                          );
                        (a = e.ownerDocument || e),
                          (n = bd(n)),
                          (o = ud.get(o)) && Cd(n, o),
                          Ge((a = a.createElement("link")));
                        var i = a;
                        (i._p = new Promise(function (e, t) {
                          (i.onload = e), (i.onerror = t);
                        })),
                          qu(a, "link", n),
                          (t.instance = a);
                      }
                      null === r.stylesheets && (r.stylesheets = new Map()),
                        r.stylesheets.set(t, e),
                        (e = t.state.preload) &&
                          0 === (3 & t.state.loading) &&
                          (r.count++,
                          (t = _d.bind(r)),
                          e.addEventListener("load", t),
                          e.addEventListener("error", t));
                    }
                  })(ps, e.memoizedState, e.memoizedProps);
              break;
            case 5:
            default:
              Ps(e);
              break;
            case 3:
            case 4:
              var t = ps;
              (ps = fd(e.stateNode.containerInfo)), Ps(e), (ps = t);
              break;
            case 22:
              null === e.memoizedState &&
                (null !== (t = e.alternate) && null !== t.memoizedState
                  ? ((t = Ns), (Ns = 16777216), Ps(e), (Ns = t))
                  : Ps(e));
          }
        }
        function zs(e) {
          var t = e.alternate;
          if (null !== t && null !== (e = t.child)) {
            t.child = null;
            do {
              (t = e.sibling), (e.sibling = null), (e = t);
            } while (null !== e);
          }
        }
        function Ts(e) {
          var t = e.deletions;
          if (0 !== (16 & e.flags)) {
            if (null !== t)
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                (ns = r), Os(r, e);
              }
            zs(e);
          }
          if (10256 & e.subtreeFlags)
            for (e = e.child; null !== e; ) Rs(e), (e = e.sibling);
        }
        function Rs(e) {
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              Ts(e), 2048 & e.flags && Wi(9, e, e.return);
              break;
            case 3:
            case 12:
            default:
              Ts(e);
              break;
            case 22:
              var t = e.stateNode;
              null !== e.memoizedState &&
              4 & t._visibility &&
              (null === e.return || 13 !== e.return.tag)
                ? ((t._visibility &= -5), _s(e))
                : Ts(e);
          }
        }
        function _s(e) {
          var t = e.deletions;
          if (0 !== (16 & e.flags)) {
            if (null !== t)
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                (ns = r), Os(r, e);
              }
            zs(e);
          }
          for (e = e.child; null !== e; ) {
            switch ((t = e).tag) {
              case 0:
              case 11:
              case 15:
                Wi(8, t, t.return), _s(t);
                break;
              case 22:
                4 & (n = t.stateNode)._visibility &&
                  ((n._visibility &= -5), _s(t));
                break;
              default:
                _s(t);
            }
            e = e.sibling;
          }
        }
        function Os(e, t) {
          for (; null !== ns; ) {
            var n = ns;
            switch (n.tag) {
              case 0:
              case 11:
              case 15:
                Wi(8, n, t);
                break;
              case 23:
              case 22:
                if (
                  null !== n.memoizedState &&
                  null !== n.memoizedState.cachePool
                ) {
                  var r = n.memoizedState.cachePool.pool;
                  null != r && r.refCount++;
                }
                break;
              case 24:
                Ho(n.memoizedState.cache);
            }
            if (null !== (r = n.child)) (r.return = n), (ns = r);
            else
              e: for (n = e; null !== ns; ) {
                var o = (r = ns).sibling,
                  a = r.return;
                if ((as(r), r === n)) {
                  ns = null;
                  break e;
                }
                if (null !== o) {
                  (o.return = a), (ns = o);
                  break e;
                }
                ns = a;
              }
          }
        }
        function As(e, t, n, r) {
          (this.tag = e),
            (this.key = n),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function Ls(e, t, n, r) {
          return new As(e, t, n, r);
        }
        function Ds(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Fs(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = Ls(e.tag, t, e.key, e.mode)).elementType =
                  e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t),
                (n.type = e.type),
                (n.flags = 0),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
            (n.flags = 31457280 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies =
              null === t
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            (n.refCleanup = e.refCleanup),
            n
          );
        }
        function Ms(e, t) {
          e.flags &= 31457282;
          var n = e.alternate;
          return (
            null === n
              ? ((e.childLanes = 0),
                (e.lanes = t),
                (e.child = null),
                (e.subtreeFlags = 0),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.updateQueue = null),
                (e.dependencies = null),
                (e.stateNode = null))
              : ((e.childLanes = n.childLanes),
                (e.lanes = n.lanes),
                (e.child = n.child),
                (e.subtreeFlags = 0),
                (e.deletions = null),
                (e.memoizedProps = n.memoizedProps),
                (e.memoizedState = n.memoizedState),
                (e.updateQueue = n.updateQueue),
                (e.type = n.type),
                (t = n.dependencies),
                (e.dependencies =
                  null === t
                    ? null
                    : { lanes: t.lanes, firstContext: t.firstContext })),
            e
          );
        }
        function Is(e, t, n, r, o, a) {
          var i = 0;
          if (((r = e), "function" === typeof e)) Ds(e) && (i = 1);
          else if ("string" === typeof e)
            i = (function (e, t, n) {
              if (1 === n || null != t.itemProp) return !1;
              switch (e) {
                case "meta":
                case "title":
                  return !0;
                case "style":
                  if (
                    "string" !== typeof t.precedence ||
                    "string" !== typeof t.href ||
                    "" === t.href
                  )
                    break;
                  return !0;
                case "link":
                  if (
                    "string" !== typeof t.rel ||
                    "string" !== typeof t.href ||
                    "" === t.href ||
                    t.onLoad ||
                    t.onError
                  )
                    break;
                  return (
                    "stylesheet" !== t.rel ||
                    ((e = t.disabled),
                    "string" === typeof t.precedence && null == e)
                  );
                case "script":
                  if (
                    t.async &&
                    "function" !== typeof t.async &&
                    "symbol" !== typeof t.async &&
                    !t.onLoad &&
                    !t.onError &&
                    t.src &&
                    "string" === typeof t.src
                  )
                    return !0;
              }
              return !1;
            })(e, n, Q.current)
              ? 26
              : "html" === e || "head" === e || "body" === e
              ? 27
              : 5;
          else
            e: switch (e) {
              case d:
                return Vs(n.children, o, a, t);
              case f:
                (i = 8), (o |= 24);
                break;
              case p:
                return (
                  ((e = Ls(12, n, t, 2 | o)).elementType = p), (e.lanes = a), e
                );
              case g:
                return (
                  ((e = Ls(13, n, t, o)).elementType = g), (e.lanes = a), e
                );
              case b:
                return (
                  ((e = Ls(19, n, t, o)).elementType = b), (e.lanes = a), e
                );
              case S:
                return Ws(n, o, a, t);
              default:
                if ("object" === typeof e && null !== e)
                  switch (e.$$typeof) {
                    case m:
                    case v:
                      i = 10;
                      break e;
                    case h:
                      i = 9;
                      break e;
                    case y:
                      i = 11;
                      break e;
                    case w:
                      i = 14;
                      break e;
                    case x:
                      (i = 16), (r = null);
                      break e;
                  }
                (i = 29),
                  (n = Error(l(130, null === e ? "null" : typeof e, ""))),
                  (r = null);
            }
          return (
            ((t = Ls(i, n, t, o)).elementType = e),
            (t.type = r),
            (t.lanes = a),
            t
          );
        }
        function Vs(e, t, n, r) {
          return ((e = Ls(7, e, r, t)).lanes = n), e;
        }
        function Ws(e, t, n, r) {
          ((e = Ls(22, e, r, t)).elementType = S), (e.lanes = n);
          var o = {
            _visibility: 1,
            _pendingVisibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null,
            _current: null,
            detach: function () {
              var e = o._current;
              if (null === e) throw Error(l(456));
              if (0 === (2 & o._pendingVisibility)) {
                var t = zr(e, 2);
                null !== t && ((o._pendingVisibility |= 2), _c(t, e, 2));
              }
            },
            attach: function () {
              var e = o._current;
              if (null === e) throw Error(l(456));
              if (0 !== (2 & o._pendingVisibility)) {
                var t = zr(e, 2);
                null !== t && ((o._pendingVisibility &= -3), _c(t, e, 2));
              }
            },
          };
          return (e.stateNode = o), e;
        }
        function Hs(e, t, n) {
          return ((e = Ls(6, e, null, t)).lanes = n), e;
        }
        function Bs(e, t, n) {
          return (
            ((t = Ls(
              4,
              null !== e.children ? e.children : [],
              e.key,
              t
            )).lanes = n),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        function Us(e) {
          e.flags |= 4;
        }
        function $s(e, t) {
          if ("stylesheet" !== t.type || 0 !== (4 & t.state.loading))
            e.flags &= -16777217;
          else if (((e.flags |= 16777216), !zd(t))) {
            if (
              null !== (t = zo.current) &&
              ((4194176 & rc) === rc
                ? null !== To
                : ((62914560 & rc) !== rc && 0 === (536870912 & rc)) ||
                  t !== To)
            )
              throw ((po = so), io);
            e.flags |= 8192;
          }
        }
        function qs(e, t) {
          null !== t && (e.flags |= 4),
            16384 & e.flags &&
              ((t = 22 !== e.tag ? Te() : 536870912),
              (e.lanes |= t),
              (hc |= t));
        }
        function Ys(e, t) {
          if (!Xr)
            switch (e.tailMode) {
              case "hidden":
                t = e.tail;
                for (var n = null; null !== t; )
                  null !== t.alternate && (n = t), (t = t.sibling);
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case "collapsed":
                n = e.tail;
                for (var r = null; null !== n; )
                  null !== n.alternate && (r = n), (n = n.sibling);
                null === r
                  ? t || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function Ks(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= 31457280 & o.subtreeFlags),
                (r |= 31457280 & o.flags),
                (o.return = e),
                (o = o.sibling);
          else
            for (o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= o.subtreeFlags),
                (r |= o.flags),
                (o.return = e),
                (o = o.sibling);
          return (e.subtreeFlags |= r), (e.childLanes = n), t;
        }
        function Qs(e, t, n) {
          var r = t.pendingProps;
          switch ((Yr(t), t.tag)) {
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
            case 1:
              return Ks(t), null;
            case 3:
              return (
                (n = t.stateNode),
                (r = null),
                null !== e && (r = e.memoizedState.cache),
                t.memoizedState.cache !== r && (t.flags |= 2048),
                bi(Vo),
                ee(),
                n.pendingContext &&
                  ((n.context = n.pendingContext), (n.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (ro(t)
                    ? Us(t)
                    : null === e ||
                      (e.memoizedState.isDehydrated && 0 === (256 & t.flags)) ||
                      ((t.flags |= 1024),
                      null !== Gr && (Ac(Gr), (Gr = null)))),
                Ks(t),
                null
              );
            case 26:
              return (
                (n = t.memoizedState),
                null === e
                  ? (Us(t),
                    null !== n
                      ? (Ks(t), $s(t, n))
                      : (Ks(t), (t.flags &= -16777217)))
                  : n
                  ? n !== e.memoizedState
                    ? (Us(t), Ks(t), $s(t, n))
                    : (Ks(t), (t.flags &= -16777217))
                  : (e.memoizedProps !== r && Us(t),
                    Ks(t),
                    (t.flags &= -16777217)),
                null
              );
            case 27:
              ne(t), (n = G.current);
              var o = t.type;
              if (null !== e && null != t.stateNode)
                e.memoizedProps !== r && Us(t);
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(l(166));
                  return Ks(t), null;
                }
                (e = Q.current),
                  ro(t) ? to(t) : ((e = cd(o, r, n)), (t.stateNode = e), Us(t));
              }
              return Ks(t), null;
            case 5:
              if ((ne(t), (n = t.type), null !== e && null != t.stateNode))
                e.memoizedProps !== r && Us(t);
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(l(166));
                  return Ks(t), null;
                }
                if (((e = Q.current), ro(t))) to(t);
                else {
                  switch (((o = Qu(G.current)), e)) {
                    case 1:
                      e = o.createElementNS("http://www.w3.org/2000/svg", n);
                      break;
                    case 2:
                      e = o.createElementNS(
                        "http://www.w3.org/1998/Math/MathML",
                        n
                      );
                      break;
                    default:
                      switch (n) {
                        case "svg":
                          e = o.createElementNS(
                            "http://www.w3.org/2000/svg",
                            n
                          );
                          break;
                        case "math":
                          e = o.createElementNS(
                            "http://www.w3.org/1998/Math/MathML",
                            n
                          );
                          break;
                        case "script":
                          ((e = o.createElement("div")).innerHTML =
                            "<script></script>"),
                            (e = e.removeChild(e.firstChild));
                          break;
                        case "select":
                          (e =
                            "string" === typeof r.is
                              ? o.createElement("select", { is: r.is })
                              : o.createElement("select")),
                            r.multiple
                              ? (e.multiple = !0)
                              : r.size && (e.size = r.size);
                          break;
                        default:
                          e =
                            "string" === typeof r.is
                              ? o.createElement(n, { is: r.is })
                              : o.createElement(n);
                      }
                  }
                  (e[Me] = t), (e[Ie] = r);
                  e: for (o = t.child; null !== o; ) {
                    if (5 === o.tag || 6 === o.tag) e.appendChild(o.stateNode);
                    else if (4 !== o.tag && 27 !== o.tag && null !== o.child) {
                      (o.child.return = o), (o = o.child);
                      continue;
                    }
                    if (o === t) break e;
                    for (; null === o.sibling; ) {
                      if (null === o.return || o.return === t) break e;
                      o = o.return;
                    }
                    (o.sibling.return = o.return), (o = o.sibling);
                  }
                  t.stateNode = e;
                  e: switch ((qu(e, n, r), n)) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      e = !!r.autoFocus;
                      break e;
                    case "img":
                      e = !0;
                      break e;
                    default:
                      e = !1;
                  }
                  e && Us(t);
                }
              }
              return Ks(t), (t.flags &= -16777217), null;
            case 6:
              if (e && null != t.stateNode) e.memoizedProps !== r && Us(t);
              else {
                if ("string" !== typeof r && null === t.stateNode)
                  throw Error(l(166));
                if (((e = G.current), ro(t))) {
                  if (
                    ((e = t.stateNode),
                    (n = t.memoizedProps),
                    (r = null),
                    null !== (o = Kr))
                  )
                    switch (o.tag) {
                      case 27:
                      case 5:
                        r = o.memoizedProps;
                    }
                  (e[Me] = t),
                    (e = !!(
                      e.nodeValue === n ||
                      (null !== r && !0 === r.suppressHydrationWarning) ||
                      Hu(e.nodeValue, n)
                    )) || eo(t);
                } else
                  ((e = Qu(e).createTextNode(r))[Me] = t), (t.stateNode = e);
              }
              return Ks(t), null;
            case 13:
              if (
                ((r = t.memoizedState),
                null === e ||
                  (null !== e.memoizedState &&
                    null !== e.memoizedState.dehydrated))
              ) {
                if (((o = ro(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!o) throw Error(l(318));
                    if (
                      !(o =
                        null !== (o = t.memoizedState) ? o.dehydrated : null)
                    )
                      throw Error(l(317));
                    o[Me] = t;
                  } else
                    oo(),
                      0 === (128 & t.flags) && (t.memoizedState = null),
                      (t.flags |= 4);
                  Ks(t), (o = !1);
                } else null !== Gr && (Ac(Gr), (Gr = null)), (o = !0);
                if (!o) return 256 & t.flags ? (Ao(t), t) : (Ao(t), null);
              }
              if ((Ao(t), 0 !== (128 & t.flags))) return (t.lanes = n), t;
              if (
                ((n = null !== r),
                (e = null !== e && null !== e.memoizedState),
                n)
              ) {
                (o = null),
                  null !== (r = t.child).alternate &&
                    null !== r.alternate.memoizedState &&
                    null !== r.alternate.memoizedState.cachePool &&
                    (o = r.alternate.memoizedState.cachePool.pool);
                var a = null;
                null !== r.memoizedState &&
                  null !== r.memoizedState.cachePool &&
                  (a = r.memoizedState.cachePool.pool),
                  a !== o && (r.flags |= 2048);
              }
              return (
                n !== e && n && (t.child.flags |= 8192),
                qs(t, t.updateQueue),
                Ks(t),
                null
              );
            case 4:
              return (
                ee(), null === e && _u(t.stateNode.containerInfo), Ks(t), null
              );
            case 10:
              return bi(t.type), Ks(t), null;
            case 19:
              if ((Y(Lo), null === (o = t.memoizedState))) return Ks(t), null;
              if (((r = 0 !== (128 & t.flags)), null === (a = o.rendering)))
                if (r) Ys(o, !1);
                else {
                  if (0 !== uc || (null !== e && 0 !== (128 & e.flags)))
                    for (e = t.child; null !== e; ) {
                      if (null !== (a = Do(e))) {
                        for (
                          t.flags |= 128,
                            Ys(o, !1),
                            e = a.updateQueue,
                            t.updateQueue = e,
                            qs(t, e),
                            t.subtreeFlags = 0,
                            e = n,
                            n = t.child;
                          null !== n;

                        )
                          Ms(n, e), (n = n.sibling);
                        return K(Lo, (1 & Lo.current) | 2), t.child;
                      }
                      e = e.sibling;
                    }
                  null !== o.tail &&
                    se() > wc &&
                    ((t.flags |= 128),
                    (r = !0),
                    Ys(o, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = Do(a))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      (e = e.updateQueue),
                      (t.updateQueue = e),
                      qs(t, e),
                      Ys(o, !0),
                      null === o.tail &&
                        "hidden" === o.tailMode &&
                        !a.alternate &&
                        !Xr)
                    )
                      return Ks(t), null;
                  } else
                    2 * se() - o.renderingStartTime > wc &&
                      536870912 !== n &&
                      ((t.flags |= 128),
                      (r = !0),
                      Ys(o, !1),
                      (t.lanes = 4194304));
                o.isBackwards
                  ? ((a.sibling = t.child), (t.child = a))
                  : (null !== (e = o.last) ? (e.sibling = a) : (t.child = a),
                    (o.last = a));
              }
              return null !== o.tail
                ? ((t = o.tail),
                  (o.rendering = t),
                  (o.tail = t.sibling),
                  (o.renderingStartTime = se()),
                  (t.sibling = null),
                  (e = Lo.current),
                  K(Lo, r ? (1 & e) | 2 : 1 & e),
                  t)
                : (Ks(t), null);
            case 22:
            case 23:
              return (
                Ao(t),
                jo(),
                (r = null !== t.memoizedState),
                null !== e
                  ? (null !== e.memoizedState) !== r && (t.flags |= 8192)
                  : r && (t.flags |= 8192),
                r
                  ? 0 !== (536870912 & n) &&
                    0 === (128 & t.flags) &&
                    (Ks(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : Ks(t),
                null !== (n = t.updateQueue) && qs(t, n.retryQueue),
                (n = null),
                null !== e &&
                  null !== e.memoizedState &&
                  null !== e.memoizedState.cachePool &&
                  (n = e.memoizedState.cachePool.pool),
                (r = null),
                null !== t.memoizedState &&
                  null !== t.memoizedState.cachePool &&
                  (r = t.memoizedState.cachePool.pool),
                r !== n && (t.flags |= 2048),
                null !== e && Y(Qo),
                null
              );
            case 24:
              return (
                (n = null),
                null !== e && (n = e.memoizedState.cache),
                t.memoizedState.cache !== n && (t.flags |= 2048),
                bi(Vo),
                Ks(t),
                null
              );
            case 25:
              return null;
          }
          throw Error(l(156, t.tag));
        }
        function Xs(e, t) {
          switch ((Yr(t), t.tag)) {
            case 1:
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 3:
              return (
                bi(Vo),
                ee(),
                0 !== (65536 & (e = t.flags)) && 0 === (128 & e)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return ne(t), null;
            case 13:
              if (
                (Ao(t), null !== (e = t.memoizedState) && null !== e.dehydrated)
              ) {
                if (null === t.alternate) throw Error(l(340));
                oo();
              }
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 19:
              return Y(Lo), null;
            case 4:
              return ee(), null;
            case 10:
              return bi(t.type), null;
            case 22:
            case 23:
              return (
                Ao(t),
                jo(),
                null !== e && Y(Qo),
                65536 & (e = t.flags)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 24:
              return bi(Vo), null;
            default:
              return null;
          }
        }
        function Gs(e, t) {
          switch ((Yr(t), t.tag)) {
            case 3:
              bi(Vo), ee();
              break;
            case 26:
            case 27:
            case 5:
              ne(t);
              break;
            case 4:
              ee();
              break;
            case 13:
              Ao(t);
              break;
            case 19:
              Y(Lo);
              break;
            case 10:
              bi(t.type);
              break;
            case 22:
            case 23:
              Ao(t), jo(), null !== e && Y(Qo);
              break;
            case 24:
              bi(Vo);
          }
        }
        var Js = {
            getCacheForType: function (e) {
              var t = Ei(Vo),
                n = t.data.get(e);
              return void 0 === n && ((n = e()), t.data.set(e, n)), n;
            },
          },
          Zs = "function" === typeof WeakMap ? WeakMap : Map,
          ec = 0,
          tc = null,
          nc = null,
          rc = 0,
          oc = 0,
          ac = null,
          lc = !1,
          ic = !1,
          sc = !1,
          cc = 0,
          uc = 0,
          dc = 0,
          fc = 0,
          pc = 0,
          mc = 0,
          hc = 0,
          vc = null,
          yc = null,
          gc = !1,
          bc = 0,
          wc = 1 / 0,
          xc = null,
          Sc = null,
          kc = !1,
          Cc = null,
          Ec = 0,
          Nc = 0,
          Pc = null,
          jc = 0,
          zc = null;
        function Tc() {
          if (0 !== (2 & ec) && 0 !== rc) return rc & -rc;
          if (null !== T.T) {
            return 0 !== $o ? $o : xu();
          }
          return De();
        }
        function Rc() {
          0 === mc && (mc = 0 === (536870912 & rc) || Xr ? ze() : 536870912);
          var e = zo.current;
          return null !== e && (e.flags |= 32), mc;
        }
        function _c(e, t, n) {
          ((e === tc && 2 === oc) || null !== e.cancelPendingCommit) &&
            (Vc(e, 0), Fc(e, rc, mc, !1)),
            _e(e, n),
            (0 !== (2 & ec) && e === tc) ||
              (e === tc &&
                (0 === (2 & ec) && (fc |= n), 4 === uc && Fc(e, rc, mc, !1)),
              hu(e));
        }
        function Oc(e, t, n) {
          if (0 !== (6 & ec)) throw Error(l(327));
          for (
            var r =
                (!n && 0 === (60 & t) && 0 === (t & e.expiredLanes)) ||
                Pe(e, t),
              o = r
                ? (function (e, t) {
                    var n = ec;
                    ec |= 2;
                    var r = Hc(),
                      o = Bc();
                    tc !== e || rc !== t
                      ? ((xc = null), (wc = se() + 500), Vc(e, t))
                      : (ic = Pe(e, t));
                    e: for (;;)
                      try {
                        if (0 !== oc && null !== nc) {
                          t = nc;
                          var a = ac;
                          t: switch (oc) {
                            case 1:
                              (oc = 0), (ac = null), Xc(e, t, a, 1);
                              break;
                            case 2:
                              if (co(a)) {
                                (oc = 0), (ac = null), Qc(t);
                                break;
                              }
                              (t = function () {
                                2 === oc && tc === e && (oc = 7), hu(e);
                              }),
                                a.then(t, t);
                              break e;
                            case 3:
                              oc = 7;
                              break e;
                            case 4:
                              oc = 5;
                              break e;
                            case 7:
                              co(a)
                                ? ((oc = 0), (ac = null), Qc(t))
                                : ((oc = 0), (ac = null), Xc(e, t, a, 7));
                              break;
                            case 5:
                              var i = null;
                              switch (nc.tag) {
                                case 26:
                                  i = nc.memoizedState;
                                case 5:
                                case 27:
                                  var s = nc;
                                  if (!i || zd(i)) {
                                    (oc = 0), (ac = null);
                                    var c = s.sibling;
                                    if (null !== c) nc = c;
                                    else {
                                      var u = s.return;
                                      null !== u
                                        ? ((nc = u), Gc(u))
                                        : (nc = null);
                                    }
                                    break t;
                                  }
                              }
                              (oc = 0), (ac = null), Xc(e, t, a, 5);
                              break;
                            case 6:
                              (oc = 0), (ac = null), Xc(e, t, a, 6);
                              break;
                            case 8:
                              Ic(), (uc = 6);
                              break e;
                            default:
                              throw Error(l(462));
                          }
                        }
                        Yc();
                        break;
                      } catch (d) {
                        Wc(e, d);
                      }
                    return (
                      (yi = vi = null),
                      (T.H = r),
                      (T.A = o),
                      (ec = n),
                      null !== nc ? 0 : ((tc = null), (rc = 0), Nr(), uc)
                    );
                  })(e, t)
                : $c(e, t, !0),
              a = r;
            ;

          ) {
            if (0 === o) {
              ic && !r && Fc(e, t, 0, !1);
              break;
            }
            if (6 === o) Fc(e, t, 0, !lc);
            else {
              if (((n = e.current.alternate), a && !Dc(n))) {
                (o = $c(e, t, !1)), (a = !1);
                continue;
              }
              if (2 === o) {
                if (((a = t), e.errorRecoveryDisabledLanes & a)) var i = 0;
                else
                  i =
                    0 !== (i = -536870913 & e.pendingLanes)
                      ? i
                      : 536870912 & i
                      ? 536870912
                      : 0;
                if (0 !== i) {
                  t = i;
                  e: {
                    var s = e;
                    o = vc;
                    var c = s.current.memoizedState.isDehydrated;
                    if (
                      (c && (Vc(s, i).flags |= 256), 2 !== (i = $c(s, i, !1)))
                    ) {
                      if (sc && !c) {
                        (s.errorRecoveryDisabledLanes |= a), (fc |= a), (o = 4);
                        break e;
                      }
                      (a = yc), (yc = o), null !== a && Ac(a);
                    }
                    o = i;
                  }
                  if (((a = !1), 2 !== o)) continue;
                }
              }
              if (1 === o) {
                Vc(e, 0), Fc(e, t, 0, !0);
                break;
              }
              e: {
                switch (((r = e), o)) {
                  case 0:
                  case 1:
                    throw Error(l(345));
                  case 4:
                    if ((4194176 & t) === t) {
                      Fc(r, t, mc, !lc);
                      break e;
                    }
                    break;
                  case 2:
                    yc = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(l(329));
                }
                if (
                  ((r.finishedWork = n),
                  (r.finishedLanes = t),
                  (62914560 & t) === t && 10 < (a = bc + 300 - se()))
                ) {
                  if ((Fc(r, t, mc, !lc), 0 !== Ne(r, 0))) break e;
                  r.timeoutHandle = ed(
                    Lc.bind(
                      null,
                      r,
                      n,
                      yc,
                      xc,
                      gc,
                      t,
                      mc,
                      fc,
                      hc,
                      lc,
                      2,
                      -0,
                      0
                    ),
                    a
                  );
                } else Lc(r, n, yc, xc, gc, t, mc, fc, hc, lc, 0, -0, 0);
              }
            }
            break;
          }
          hu(e);
        }
        function Ac(e) {
          null === yc ? (yc = e) : yc.push.apply(yc, e);
        }
        function Lc(e, t, n, r, o, a, i, s, c, u, d, f, p) {
          var m = t.subtreeFlags;
          if (
            (8192 & m || 16785408 === (16785408 & m)) &&
            ((Td = { stylesheets: null, count: 0, unsuspend: Rd }),
            js(t),
            null !==
              (t = (function () {
                if (null === Td) throw Error(l(475));
                var e = Td;
                return (
                  e.stylesheets && 0 === e.count && Ad(e, e.stylesheets),
                  0 < e.count
                    ? function (t) {
                        var n = setTimeout(function () {
                          if (
                            (e.stylesheets && Ad(e, e.stylesheets), e.unsuspend)
                          ) {
                            var t = e.unsuspend;
                            (e.unsuspend = null), t();
                          }
                        }, 6e4);
                        return (
                          (e.unsuspend = t),
                          function () {
                            (e.unsuspend = null), clearTimeout(n);
                          }
                        );
                      }
                    : null
                );
              })()))
          )
            return (
              (e.cancelPendingCommit = t(
                Zc.bind(null, e, n, r, o, i, s, c, 1, f, p)
              )),
              void Fc(e, a, i, !u)
            );
          Zc(e, n, r, o, i, s, c, d, f, p);
        }
        function Dc(e) {
          for (var t = e; ; ) {
            var n = t.tag;
            if (
              (0 === n || 11 === n || 15 === n) &&
              16384 & t.flags &&
              null !== (n = t.updateQueue) &&
              null !== (n = n.stores)
            )
              for (var r = 0; r < n.length; r++) {
                var o = n[r],
                  a = o.getSnapshot;
                o = o.value;
                try {
                  if (!Kn(a(), o)) return !1;
                } catch (l) {
                  return !1;
                }
              }
            if (((n = t.child), 16384 & t.subtreeFlags && null !== n))
              (n.return = t), (t = n);
            else {
              if (t === e) break;
              for (; null === t.sibling; ) {
                if (null === t.return || t.return === e) return !0;
                t = t.return;
              }
              (t.sibling.return = t.return), (t = t.sibling);
            }
          }
          return !0;
        }
        function Fc(e, t, n, r) {
          (t &= ~pc),
            (t &= ~fc),
            (e.suspendedLanes |= t),
            (e.pingedLanes &= ~t),
            r && (e.warmLanes |= t),
            (r = e.expirationTimes);
          for (var o = t; 0 < o; ) {
            var a = 31 - we(o),
              l = 1 << a;
            (r[a] = -1), (o &= ~l);
          }
          0 !== n && Oe(e, n, t);
        }
        function Mc() {
          return 0 !== (6 & ec) || (vu(0, !1), !1);
        }
        function Ic() {
          if (null !== nc) {
            if (0 === oc) var e = nc.return;
            else
              (yi = vi = null), ga((e = nc)), (ho = null), (vo = 0), (e = nc);
            for (; null !== e; ) Gs(e.alternate, e), (e = e.return);
            nc = null;
          }
        }
        function Vc(e, t) {
          (e.finishedWork = null), (e.finishedLanes = 0);
          var n = e.timeoutHandle;
          -1 !== n && ((e.timeoutHandle = -1), td(n)),
            null !== (n = e.cancelPendingCommit) &&
              ((e.cancelPendingCommit = null), n()),
            Ic(),
            (tc = e),
            (nc = n = Fs(e.current, null)),
            (rc = t),
            (oc = 0),
            (ac = null),
            (lc = !1),
            (ic = Pe(e, t)),
            (sc = !1),
            (hc = mc = pc = fc = dc = uc = 0),
            (yc = vc = null),
            (gc = !1),
            0 !== (8 & t) && (t |= 32 & t);
          var r = e.entangledLanes;
          if (0 !== r)
            for (e = e.entanglements, r &= t; 0 < r; ) {
              var o = 31 - we(r),
                a = 1 << o;
              (t |= e[o]), (r &= ~a);
            }
          return (cc = t), Nr(), n;
        }
        function Wc(e, t) {
          (ea = null),
            (T.H = El),
            t === lo
              ? ((t = mo()), (oc = 3))
              : t === io
              ? ((t = mo()), (oc = 4))
              : (oc =
                  t === Bl
                    ? 8
                    : null !== t &&
                      "object" === typeof t &&
                      "function" === typeof t.then
                    ? 6
                    : 1),
            (ac = t),
            null === nc && ((uc = 1), Ml(e, Ar(t, e.current)));
        }
        function Hc() {
          var e = T.H;
          return (T.H = El), null === e ? El : e;
        }
        function Bc() {
          var e = T.A;
          return (T.A = Js), e;
        }
        function Uc() {
          (uc = 4),
            lc || ((4194176 & rc) !== rc && null !== zo.current) || (ic = !0),
            (0 === (134217727 & dc) && 0 === (134217727 & fc)) ||
              null === tc ||
              Fc(tc, rc, mc, !1);
        }
        function $c(e, t, n) {
          var r = ec;
          ec |= 2;
          var o = Hc(),
            a = Bc();
          (tc === e && rc === t) || ((xc = null), Vc(e, t)), (t = !1);
          var l = uc;
          e: for (;;)
            try {
              if (0 !== oc && null !== nc) {
                var i = nc,
                  s = ac;
                switch (oc) {
                  case 8:
                    Ic(), (l = 6);
                    break e;
                  case 3:
                  case 2:
                  case 6:
                    null === zo.current && (t = !0);
                    var c = oc;
                    if (((oc = 0), (ac = null), Xc(e, i, s, c), n && ic)) {
                      l = 0;
                      break e;
                    }
                    break;
                  default:
                    (c = oc), (oc = 0), (ac = null), Xc(e, i, s, c);
                }
              }
              qc(), (l = uc);
              break;
            } catch (u) {
              Wc(e, u);
            }
          return (
            t && e.shellSuspendCounter++,
            (yi = vi = null),
            (ec = r),
            (T.H = o),
            (T.A = a),
            null === nc && ((tc = null), (rc = 0), Nr()),
            l
          );
        }
        function qc() {
          for (; null !== nc; ) Kc(nc);
        }
        function Yc() {
          for (; null !== nc && !le(); ) Kc(nc);
        }
        function Kc(e) {
          var t = mi(e.alternate, e, cc);
          (e.memoizedProps = e.pendingProps), null === t ? Gc(e) : (nc = t);
        }
        function Qc(e) {
          var t = e,
            n = t.alternate;
          switch (t.tag) {
            case 15:
            case 0:
              t = Zl(n, t, t.pendingProps, t.type, void 0, rc);
              break;
            case 11:
              t = Zl(n, t, t.pendingProps, t.type.render, t.ref, rc);
              break;
            case 5:
              ga(t);
            default:
              Gs(n, t), (t = mi(n, (t = nc = Ms(t, cc)), cc));
          }
          (e.memoizedProps = e.pendingProps), null === t ? Gc(e) : (nc = t);
        }
        function Xc(e, t, n, r) {
          (yi = vi = null), ga(t), (ho = null), (vo = 0);
          var o = t.return;
          try {
            if (
              (function (e, t, n, r, o) {
                if (
                  ((n.flags |= 32768),
                  null !== r &&
                    "object" === typeof r &&
                    "function" === typeof r.then)
                ) {
                  if (
                    (null !== (t = n.alternate) && Si(t, n, o, !0),
                    null !== (n = zo.current))
                  ) {
                    switch (n.tag) {
                      case 13:
                        return (
                          null === To
                            ? Uc()
                            : null === n.alternate && 0 === uc && (uc = 3),
                          (n.flags &= -257),
                          (n.flags |= 65536),
                          (n.lanes = o),
                          r === so
                            ? (n.flags |= 16384)
                            : (null === (t = n.updateQueue)
                                ? (n.updateQueue = new Set([r]))
                                : t.add(r),
                              ou(e, r, o)),
                          !1
                        );
                      case 22:
                        return (
                          (n.flags |= 65536),
                          r === so
                            ? (n.flags |= 16384)
                            : (null === (t = n.updateQueue)
                                ? ((t = {
                                    transitions: null,
                                    markerInstances: null,
                                    retryQueue: new Set([r]),
                                  }),
                                  (n.updateQueue = t))
                                : null === (n = t.retryQueue)
                                ? (t.retryQueue = new Set([r]))
                                : n.add(r),
                              ou(e, r, o)),
                          !1
                        );
                    }
                    throw Error(l(435, n.tag));
                  }
                  return ou(e, r, o), Uc(), !1;
                }
                if (Xr)
                  return (
                    null !== (t = zo.current)
                      ? (0 === (65536 & t.flags) && (t.flags |= 256),
                        (t.flags |= 65536),
                        (t.lanes = o),
                        r !== Zr &&
                          ao(Ar((e = Error(l(422), { cause: r })), n)))
                      : (r !== Zr &&
                          ao(Ar((t = Error(l(423), { cause: r })), n)),
                        ((e = e.current.alternate).flags |= 65536),
                        (o &= -o),
                        (e.lanes |= o),
                        (r = Ar(r, n)),
                        Ai(e, (o = Vl(e.stateNode, r, o))),
                        4 !== uc && (uc = 2)),
                    !1
                  );
                var a = Error(l(520), { cause: r });
                if (
                  ((a = Ar(a, n)),
                  null === vc ? (vc = [a]) : vc.push(a),
                  4 !== uc && (uc = 2),
                  null === t)
                )
                  return !0;
                (r = Ar(r, n)), (n = t);
                do {
                  switch (n.tag) {
                    case 3:
                      return (
                        (n.flags |= 65536),
                        (e = o & -o),
                        (n.lanes |= e),
                        Ai(n, (e = Vl(n.stateNode, r, e))),
                        !1
                      );
                    case 1:
                      if (
                        ((t = n.type),
                        (a = n.stateNode),
                        0 === (128 & n.flags) &&
                          ("function" === typeof t.getDerivedStateFromError ||
                            (null !== a &&
                              "function" === typeof a.componentDidCatch &&
                              (null === Sc || !Sc.has(a)))))
                      )
                        return (
                          (n.flags |= 65536),
                          (o &= -o),
                          (n.lanes |= o),
                          Hl((o = Wl(o)), e, n, r),
                          Ai(n, o),
                          !1
                        );
                  }
                  n = n.return;
                } while (null !== n);
                return !1;
              })(e, o, t, n, rc)
            )
              return (uc = 1), Ml(e, Ar(n, e.current)), void (nc = null);
          } catch (a) {
            if (null !== o) throw ((nc = o), a);
            return (uc = 1), Ml(e, Ar(n, e.current)), void (nc = null);
          }
          32768 & t.flags
            ? (Xr || 1 === r
                ? (e = !0)
                : ic || 0 !== (536870912 & rc)
                ? (e = !1)
                : ((lc = e = !0),
                  (2 === r || 3 === r || 6 === r) &&
                    null !== (r = zo.current) &&
                    13 === r.tag &&
                    (r.flags |= 16384)),
              Jc(t, e))
            : Gc(t);
        }
        function Gc(e) {
          var t = e;
          do {
            if (0 !== (32768 & t.flags)) return void Jc(t, lc);
            e = t.return;
            var n = Qs(t.alternate, t, cc);
            if (null !== n) return void (nc = n);
            if (null !== (t = t.sibling)) return void (nc = t);
            nc = t = e;
          } while (null !== t);
          0 === uc && (uc = 5);
        }
        function Jc(e, t) {
          do {
            var n = Xs(e.alternate, e);
            if (null !== n) return (n.flags &= 32767), void (nc = n);
            if (
              (null !== (n = e.return) &&
                ((n.flags |= 32768),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
              !t && null !== (e = e.sibling))
            )
              return void (nc = e);
            nc = e = n;
          } while (null !== e);
          (uc = 6), (nc = null);
        }
        function Zc(e, t, n, r, o, a, i, s, c, u) {
          var d = T.T,
            f = H.p;
          try {
            (H.p = 2),
              (T.T = null),
              (function (e, t, n, r, o, a, i, s) {
                do {
                  tu();
                } while (null !== Cc);
                if (0 !== (6 & ec)) throw Error(l(327));
                var c = e.finishedWork;
                if (((r = e.finishedLanes), null === c)) return null;
                if (
                  ((e.finishedWork = null),
                  (e.finishedLanes = 0),
                  c === e.current)
                )
                  throw Error(l(177));
                (e.callbackNode = null),
                  (e.callbackPriority = 0),
                  (e.cancelPendingCommit = null);
                var u = c.lanes | c.childLanes;
                if (
                  ((function (e, t, n, r, o, a) {
                    var l = e.pendingLanes;
                    (e.pendingLanes = n),
                      (e.suspendedLanes = 0),
                      (e.pingedLanes = 0),
                      (e.warmLanes = 0),
                      (e.expiredLanes &= n),
                      (e.entangledLanes &= n),
                      (e.errorRecoveryDisabledLanes &= n),
                      (e.shellSuspendCounter = 0);
                    var i = e.entanglements,
                      s = e.expirationTimes,
                      c = e.hiddenUpdates;
                    for (n = l & ~n; 0 < n; ) {
                      var u = 31 - we(n),
                        d = 1 << u;
                      (i[u] = 0), (s[u] = -1);
                      var f = c[u];
                      if (null !== f)
                        for (c[u] = null, u = 0; u < f.length; u++) {
                          var p = f[u];
                          null !== p && (p.lane &= -536870913);
                        }
                      n &= ~d;
                    }
                    0 !== r && Oe(e, r, 0),
                      0 !== a &&
                        0 === o &&
                        0 !== e.tag &&
                        (e.suspendedLanes |= a & ~(l & ~t));
                  })(e, r, (u |= Er), a, i, s),
                  e === tc && ((nc = tc = null), (rc = 0)),
                  (0 === (10256 & c.subtreeFlags) && 0 === (10256 & c.flags)) ||
                    kc ||
                    ((kc = !0),
                    (Nc = u),
                    (Pc = n),
                    (function (e, t) {
                      oe(e, t);
                    })(fe, function () {
                      return tu(), null;
                    })),
                  (n = 0 !== (15990 & c.flags)),
                  0 !== (15990 & c.subtreeFlags) || n
                    ? ((n = T.T),
                      (T.T = null),
                      (a = H.p),
                      (H.p = 2),
                      (i = ec),
                      (ec |= 4),
                      (function (e, t) {
                        if (
                          ((e = e.containerInfo), (Yu = Ud), er((e = Zn(e))))
                        ) {
                          if ("selectionStart" in e)
                            var n = {
                              start: e.selectionStart,
                              end: e.selectionEnd,
                            };
                          else
                            e: {
                              var r =
                                (n =
                                  ((n = e.ownerDocument) && n.defaultView) ||
                                  window).getSelection && n.getSelection();
                              if (r && 0 !== r.rangeCount) {
                                n = r.anchorNode;
                                var o = r.anchorOffset,
                                  a = r.focusNode;
                                r = r.focusOffset;
                                try {
                                  n.nodeType, a.nodeType;
                                } catch (v) {
                                  n = null;
                                  break e;
                                }
                                var i = 0,
                                  s = -1,
                                  c = -1,
                                  u = 0,
                                  d = 0,
                                  f = e,
                                  p = null;
                                t: for (;;) {
                                  for (
                                    var m;
                                    f !== n ||
                                      (0 !== o && 3 !== f.nodeType) ||
                                      (s = i + o),
                                      f !== a ||
                                        (0 !== r && 3 !== f.nodeType) ||
                                        (c = i + r),
                                      3 === f.nodeType &&
                                        (i += f.nodeValue.length),
                                      null !== (m = f.firstChild);

                                  )
                                    (p = f), (f = m);
                                  for (;;) {
                                    if (f === e) break t;
                                    if (
                                      (p === n && ++u === o && (s = i),
                                      p === a && ++d === r && (c = i),
                                      null !== (m = f.nextSibling))
                                    )
                                      break;
                                    p = (f = p).parentNode;
                                  }
                                  f = m;
                                }
                                n =
                                  -1 === s || -1 === c
                                    ? null
                                    : { start: s, end: c };
                              } else n = null;
                            }
                          n = n || { start: 0, end: 0 };
                        } else n = null;
                        for (
                          Ku = { focusedElem: e, selectionRange: n },
                            Ud = !1,
                            ns = t;
                          null !== ns;

                        )
                          if (
                            ((e = (t = ns).child),
                            0 !== (1028 & t.subtreeFlags) && null !== e)
                          )
                            (e.return = t), (ns = e);
                          else
                            for (; null !== ns; ) {
                              switch (
                                ((a = (t = ns).alternate), (e = t.flags), t.tag)
                              ) {
                                case 0:
                                case 11:
                                case 15:
                                case 5:
                                case 26:
                                case 27:
                                case 6:
                                case 4:
                                case 17:
                                  break;
                                case 1:
                                  if (0 !== (1024 & e) && null !== a) {
                                    (e = void 0),
                                      (n = t),
                                      (o = a.memoizedProps),
                                      (a = a.memoizedState),
                                      (r = n.stateNode);
                                    try {
                                      var h = Ol(
                                        n.type,
                                        o,
                                        (n.elementType, n.type)
                                      );
                                      (e = r.getSnapshotBeforeUpdate(h, a)),
                                        (r.__reactInternalSnapshotBeforeUpdate =
                                          e);
                                    } catch (y) {
                                      ru(n, n.return, y);
                                    }
                                  }
                                  break;
                                case 3:
                                  if (0 !== (1024 & e))
                                    if (
                                      9 ===
                                      (n = (e = t.stateNode.containerInfo)
                                        .nodeType)
                                    )
                                      ld(e);
                                    else if (1 === n)
                                      switch (e.nodeName) {
                                        case "HEAD":
                                        case "HTML":
                                        case "BODY":
                                          ld(e);
                                          break;
                                        default:
                                          e.textContent = "";
                                      }
                                  break;
                                default:
                                  if (0 !== (1024 & e)) throw Error(l(163));
                              }
                              if (null !== (e = t.sibling)) {
                                (e.return = t.return), (ns = e);
                                break;
                              }
                              ns = t.return;
                            }
                        (h = rs), (rs = !1);
                      })(e, c),
                      ms(c, e),
                      tr(Ku, e.containerInfo),
                      (Ud = !!Yu),
                      (Ku = Yu = null),
                      (e.current = c),
                      os(e, c.alternate, c),
                      ie(),
                      (ec = i),
                      (H.p = a),
                      (T.T = n))
                    : (e.current = c),
                  kc ? ((kc = !1), (Cc = e), (Ec = r)) : eu(e, u),
                  (u = e.pendingLanes),
                  0 === u && (Sc = null),
                  (function (e) {
                    if (ge && "function" === typeof ge.onCommitFiberRoot)
                      try {
                        ge.onCommitFiberRoot(
                          ye,
                          e,
                          void 0,
                          128 === (128 & e.current.flags)
                        );
                      } catch (t) {}
                  })(c.stateNode),
                  hu(e),
                  null !== t)
                )
                  for (o = e.onRecoverableError, c = 0; c < t.length; c++)
                    (u = t[c]), o(u.value, { componentStack: u.stack });
                0 !== (3 & Ec) && tu(),
                  (u = e.pendingLanes),
                  0 !== (4194218 & r) && 0 !== (42 & u)
                    ? e === zc
                      ? jc++
                      : ((jc = 0), (zc = e))
                    : (jc = 0),
                  vu(0, !1);
              })(e, t, n, r, f, o, a, i);
          } finally {
            (T.T = d), (H.p = f);
          }
        }
        function eu(e, t) {
          0 === (e.pooledCacheLanes &= t) &&
            null != (t = e.pooledCache) &&
            ((e.pooledCache = null), Ho(t));
        }
        function tu() {
          if (null !== Cc) {
            var e = Cc,
              t = Nc;
            Nc = 0;
            var n = Le(Ec),
              r = T.T,
              o = H.p;
            try {
              if (((H.p = 32 > n ? 32 : n), (T.T = null), null === Cc))
                var a = !1;
              else {
                (n = Pc), (Pc = null);
                var i = Cc,
                  s = Ec;
                if (((Cc = null), (Ec = 0), 0 !== (6 & ec)))
                  throw Error(l(331));
                var c = ec;
                if (
                  ((ec |= 4),
                  Rs(i.current),
                  ks(i, i.current, s, n),
                  (ec = c),
                  vu(0, !1),
                  ge && "function" === typeof ge.onPostCommitFiberRoot)
                )
                  try {
                    ge.onPostCommitFiberRoot(ye, i);
                  } catch (u) {}
                a = !0;
              }
              return a;
            } finally {
              (H.p = o), (T.T = r), eu(e, t);
            }
          }
          return !1;
        }
        function nu(e, t, n) {
          (t = Ar(n, t)),
            null !== (e = _i(e, (t = Vl(e.stateNode, t, 2)), 2)) &&
              (_e(e, 2), hu(e));
        }
        function ru(e, t, n) {
          if (3 === e.tag) nu(e, e, n);
          else
            for (; null !== t; ) {
              if (3 === t.tag) {
                nu(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" === typeof t.type.getDerivedStateFromError ||
                  ("function" === typeof r.componentDidCatch &&
                    (null === Sc || !Sc.has(r)))
                ) {
                  (e = Ar(n, e)),
                    null !== (r = _i(t, (n = Wl(2)), 2)) &&
                      (Hl(n, r, t, e), _e(r, 2), hu(r));
                  break;
                }
              }
              t = t.return;
            }
        }
        function ou(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new Zs();
            var o = new Set();
            r.set(t, o);
          } else void 0 === (o = r.get(t)) && ((o = new Set()), r.set(t, o));
          o.has(n) ||
            ((sc = !0), o.add(n), (e = au.bind(null, e, t, n)), t.then(e, e));
        }
        function au(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t),
            (e.pingedLanes |= e.suspendedLanes & n),
            (e.warmLanes &= ~n),
            tc === e &&
              (rc & n) === n &&
              (4 === uc ||
              (3 === uc && (62914560 & rc) === rc && 300 > se() - bc)
                ? 0 === (2 & ec) && Vc(e, 0)
                : (pc |= n),
              hc === rc && (hc = 0)),
            hu(e);
        }
        function lu(e, t) {
          0 === t && (t = Te()), null !== (e = zr(e, t)) && (_e(e, t), hu(e));
        }
        function iu(e) {
          var t = e.memoizedState,
            n = 0;
          null !== t && (n = t.retryLane), lu(e, n);
        }
        function su(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                o = e.memoizedState;
              null !== o && (n = o.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            case 22:
              r = e.stateNode._retryCache;
              break;
            default:
              throw Error(l(314));
          }
          null !== r && r.delete(t), lu(e, n);
        }
        var cu = null,
          uu = null,
          du = !1,
          fu = !1,
          pu = !1,
          mu = 0;
        function hu(e) {
          var t;
          e !== uu &&
            null === e.next &&
            (null === uu ? (cu = uu = e) : (uu = uu.next = e)),
            (fu = !0),
            du ||
              ((du = !0),
              (t = yu),
              rd(function () {
                0 !== (6 & ec) ? oe(ue, t) : t();
              }));
        }
        function vu(e, t) {
          if (!pu && fu) {
            pu = !0;
            do {
              for (var n = !1, r = cu; null !== r; ) {
                if (!t)
                  if (0 !== e) {
                    var o = r.pendingLanes;
                    if (0 === o) var a = 0;
                    else {
                      var l = r.suspendedLanes,
                        i = r.pingedLanes;
                      (a = (1 << (31 - we(42 | e) + 1)) - 1),
                        (a =
                          201326677 & (a &= o & ~(l & ~i))
                            ? (201326677 & a) | 1
                            : a
                            ? 2 | a
                            : 0);
                    }
                    0 !== a && ((n = !0), wu(r, a));
                  } else
                    (a = rc),
                      0 === (3 & (a = Ne(r, r === tc ? a : 0))) ||
                        Pe(r, a) ||
                        ((n = !0), wu(r, a));
                r = r.next;
              }
            } while (n);
            pu = !1;
          }
        }
        function yu() {
          fu = du = !1;
          var e = 0;
          0 !== mu &&
            ((function () {
              var e = window.event;
              if (e && "popstate" === e.type) return e !== Zu && ((Zu = e), !0);
              return (Zu = null), !1;
            })() && (e = mu),
            (mu = 0));
          for (var t = se(), n = null, r = cu; null !== r; ) {
            var o = r.next,
              a = gu(r, t);
            0 === a
              ? ((r.next = null),
                null === n ? (cu = o) : (n.next = o),
                null === o && (uu = n))
              : ((n = r), (0 !== e || 0 !== (3 & a)) && (fu = !0)),
              (r = o);
          }
          vu(e, !1);
        }
        function gu(e, t) {
          for (
            var n = e.suspendedLanes,
              r = e.pingedLanes,
              o = e.expirationTimes,
              a = -62914561 & e.pendingLanes;
            0 < a;

          ) {
            var l = 31 - we(a),
              i = 1 << l,
              s = o[l];
            -1 === s
              ? (0 !== (i & n) && 0 === (i & r)) || (o[l] = je(i, t))
              : s <= t && (e.expiredLanes |= i),
              (a &= ~i);
          }
          if (
            ((n = rc),
            (n = Ne(e, e === (t = tc) ? n : 0)),
            (r = e.callbackNode),
            0 === n || (e === t && 2 === oc) || null !== e.cancelPendingCommit)
          )
            return (
              null !== r && null !== r && ae(r),
              (e.callbackNode = null),
              (e.callbackPriority = 0)
            );
          if (0 === (3 & n) || Pe(e, n)) {
            if ((t = n & -n) === e.callbackPriority) return t;
            switch ((null !== r && ae(r), Le(n))) {
              case 2:
              case 8:
                n = de;
                break;
              case 32:
              default:
                n = fe;
                break;
              case 268435456:
                n = me;
            }
            return (
              (r = bu.bind(null, e)),
              (n = oe(n, r)),
              (e.callbackPriority = t),
              (e.callbackNode = n),
              t
            );
          }
          return (
            null !== r && null !== r && ae(r),
            (e.callbackPriority = 2),
            (e.callbackNode = null),
            2
          );
        }
        function bu(e, t) {
          var n = e.callbackNode;
          if (tu() && e.callbackNode !== n) return null;
          var r = rc;
          return 0 === (r = Ne(e, e === tc ? r : 0))
            ? null
            : (Oc(e, r, t),
              gu(e, se()),
              null != e.callbackNode && e.callbackNode === n
                ? bu.bind(null, e)
                : null);
        }
        function wu(e, t) {
          if (tu()) return null;
          Oc(e, t, !0);
        }
        function xu() {
          return 0 === mu && (mu = ze()), mu;
        }
        function Su(e) {
          return null == e || "symbol" === typeof e || "boolean" === typeof e
            ? null
            : "function" === typeof e
            ? e
            : zt("" + e);
        }
        function ku(e, t) {
          var n = t.ownerDocument.createElement("input");
          return (
            (n.name = t.name),
            (n.value = t.value),
            e.id && n.setAttribute("form", e.id),
            t.parentNode.insertBefore(n, t),
            (e = new FormData(e)),
            n.parentNode.removeChild(n),
            e
          );
        }
        for (var Cu = 0; Cu < xr.length; Cu++) {
          var Eu = xr[Cu];
          Sr(Eu.toLowerCase(), "on" + (Eu[0].toUpperCase() + Eu.slice(1)));
        }
        Sr(pr, "onAnimationEnd"),
          Sr(mr, "onAnimationIteration"),
          Sr(hr, "onAnimationStart"),
          Sr("dblclick", "onDoubleClick"),
          Sr("focusin", "onFocus"),
          Sr("focusout", "onBlur"),
          Sr(vr, "onTransitionRun"),
          Sr(yr, "onTransitionStart"),
          Sr(gr, "onTransitionCancel"),
          Sr(br, "onTransitionEnd"),
          tt("onMouseEnter", ["mouseout", "mouseover"]),
          tt("onMouseLeave", ["mouseout", "mouseover"]),
          tt("onPointerEnter", ["pointerout", "pointerover"]),
          tt("onPointerLeave", ["pointerout", "pointerover"]),
          et(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " "
            )
          ),
          et(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " "
            )
          ),
          et("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          et(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          et(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          et(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " "
            )
          );
        var Nu =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " "
            ),
          Pu = new Set(
            "beforetoggle cancel close invalid load scroll scrollend toggle"
              .split(" ")
              .concat(Nu)
          );
        function ju(e, t) {
          t = 0 !== (4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              o = r.event;
            r = r.listeners;
            e: {
              var a = void 0;
              if (t)
                for (var l = r.length - 1; 0 <= l; l--) {
                  var i = r[l],
                    s = i.instance,
                    c = i.currentTarget;
                  if (((i = i.listener), s !== a && o.isPropagationStopped()))
                    break e;
                  (a = i), (o.currentTarget = c);
                  try {
                    a(o);
                  } catch (u) {
                    Al(u);
                  }
                  (o.currentTarget = null), (a = s);
                }
              else
                for (l = 0; l < r.length; l++) {
                  if (
                    ((s = (i = r[l]).instance),
                    (c = i.currentTarget),
                    (i = i.listener),
                    s !== a && o.isPropagationStopped())
                  )
                    break e;
                  (a = i), (o.currentTarget = c);
                  try {
                    a(o);
                  } catch (u) {
                    Al(u);
                  }
                  (o.currentTarget = null), (a = s);
                }
            }
          }
        }
        function zu(e, t) {
          var n = t[We];
          void 0 === n && (n = t[We] = new Set());
          var r = e + "__bubble";
          n.has(r) || (Ou(t, e, 2, !1), n.add(r));
        }
        function Tu(e, t, n) {
          var r = 0;
          t && (r |= 4), Ou(n, e, r, t);
        }
        var Ru = "_reactListening" + Math.random().toString(36).slice(2);
        function _u(e) {
          if (!e[Ru]) {
            (e[Ru] = !0),
              Je.forEach(function (t) {
                "selectionchange" !== t &&
                  (Pu.has(t) || Tu(t, !1, e), Tu(t, !0, e));
              });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Ru] || ((t[Ru] = !0), Tu("selectionchange", !1, t));
          }
        }
        function Ou(e, t, n, r) {
          switch (Gd(t)) {
            case 2:
              var o = $d;
              break;
            case 8:
              o = qd;
              break;
            default:
              o = Yd;
          }
          (n = o.bind(null, t, n, e)),
            (o = void 0),
            !Mt ||
              ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
              (o = !0),
            r
              ? void 0 !== o
                ? e.addEventListener(t, n, { capture: !0, passive: o })
                : e.addEventListener(t, n, !0)
              : void 0 !== o
              ? e.addEventListener(t, n, { passive: o })
              : e.addEventListener(t, n, !1);
        }
        function Au(e, t, n, r, o) {
          var a = r;
          if (0 === (1 & t) && 0 === (2 & t) && null !== r)
            e: for (;;) {
              if (null === r) return;
              var l = r.tag;
              if (3 === l || 4 === l) {
                var i = r.stateNode.containerInfo;
                if (i === o || (8 === i.nodeType && i.parentNode === o)) break;
                if (4 === l)
                  for (l = r.return; null !== l; ) {
                    var s = l.tag;
                    if (
                      (3 === s || 4 === s) &&
                      ((s = l.stateNode.containerInfo) === o ||
                        (8 === s.nodeType && s.parentNode === o))
                    )
                      return;
                    l = l.return;
                  }
                for (; null !== i; ) {
                  if (null === (l = Ye(i))) return;
                  if (5 === (s = l.tag) || 6 === s || 26 === s || 27 === s) {
                    r = a = l;
                    continue e;
                  }
                  i = i.parentNode;
                }
              }
              r = r.return;
            }
          Dt(function () {
            var r = a,
              o = Rt(n),
              l = [];
            e: {
              var i = wr.get(e);
              if (void 0 !== i) {
                var s = Jt,
                  c = e;
                switch (e) {
                  case "keypress":
                    if (0 === Ut(n)) break e;
                  case "keydown":
                  case "keyup":
                    s = mn;
                    break;
                  case "focusin":
                    (c = "focus"), (s = on);
                    break;
                  case "focusout":
                    (c = "blur"), (s = on);
                    break;
                  case "beforeblur":
                  case "afterblur":
                    s = on;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    s = nn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    s = rn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    s = vn;
                    break;
                  case pr:
                  case mr:
                  case hr:
                    s = an;
                    break;
                  case br:
                    s = yn;
                    break;
                  case "scroll":
                  case "scrollend":
                    s = en;
                    break;
                  case "wheel":
                    s = gn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    s = ln;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    s = hn;
                    break;
                  case "toggle":
                  case "beforetoggle":
                    s = bn;
                }
                var u = 0 !== (4 & t),
                  d = !u && ("scroll" === e || "scrollend" === e),
                  f = u ? (null !== i ? i + "Capture" : null) : i;
                u = [];
                for (var p, m = r; null !== m; ) {
                  var h = m;
                  if (
                    ((p = h.stateNode),
                    (5 !== (h = h.tag) && 26 !== h && 27 !== h) ||
                      null === p ||
                      null === f ||
                      (null != (h = Ft(m, f)) && u.push(Lu(m, h, p))),
                    d)
                  )
                    break;
                  m = m.return;
                }
                0 < u.length &&
                  ((i = new s(i, c, null, n, o)),
                  l.push({ event: i, listeners: u }));
              }
            }
            if (0 === (7 & t)) {
              if (
                ((s = "mouseout" === e || "pointerout" === e),
                (!(i = "mouseover" === e || "pointerover" === e) ||
                  n === Tt ||
                  !(c = n.relatedTarget || n.fromElement) ||
                  (!Ye(c) && !c[Ve])) &&
                  (s || i) &&
                  ((i =
                    o.window === o
                      ? o
                      : (i = o.ownerDocument)
                      ? i.defaultView || i.parentWindow
                      : window),
                  s
                    ? ((s = r),
                      null !==
                        (c = (c = n.relatedTarget || n.toElement)
                          ? Ye(c)
                          : null) &&
                        ((d = F(c)),
                        (u = c.tag),
                        c !== d || (5 !== u && 27 !== u && 6 !== u)) &&
                        (c = null))
                    : ((s = null), (c = r)),
                  s !== c))
              ) {
                if (
                  ((u = nn),
                  (h = "onMouseLeave"),
                  (f = "onMouseEnter"),
                  (m = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((u = hn),
                    (h = "onPointerLeave"),
                    (f = "onPointerEnter"),
                    (m = "pointer")),
                  (d = null == s ? i : Qe(s)),
                  (p = null == c ? i : Qe(c)),
                  ((i = new u(h, m + "leave", s, n, o)).target = d),
                  (i.relatedTarget = p),
                  (h = null),
                  Ye(o) === r &&
                    (((u = new u(f, m + "enter", c, n, o)).target = p),
                    (u.relatedTarget = d),
                    (h = u)),
                  (d = h),
                  s && c)
                )
                  e: {
                    for (f = c, m = 0, p = u = s; p; p = Fu(p)) m++;
                    for (p = 0, h = f; h; h = Fu(h)) p++;
                    for (; 0 < m - p; ) (u = Fu(u)), m--;
                    for (; 0 < p - m; ) (f = Fu(f)), p--;
                    for (; m--; ) {
                      if (u === f || (null !== f && u === f.alternate)) break e;
                      (u = Fu(u)), (f = Fu(f));
                    }
                    u = null;
                  }
                else u = null;
                null !== s && Mu(l, i, s, u, !1),
                  null !== c && null !== d && Mu(l, d, c, u, !0);
              }
              if (
                "select" ===
                  (s =
                    (i = r ? Qe(r) : window).nodeName &&
                    i.nodeName.toLowerCase()) ||
                ("input" === s && "file" === i.type)
              )
                var v = Fn;
              else if (Rn(i))
                if (Mn) v = Yn;
                else {
                  v = $n;
                  var y = Un;
                }
              else
                !(s = i.nodeName) ||
                "input" !== s.toLowerCase() ||
                ("checkbox" !== i.type && "radio" !== i.type)
                  ? r && Nt(r.elementType) && (v = Fn)
                  : (v = qn);
              switch (
                (v && (v = v(e, r))
                  ? _n(l, v, n, o)
                  : (y && y(e, i, r),
                    "focusout" === e &&
                      r &&
                      "number" === i.type &&
                      null != r.memoizedProps.value &&
                      gt(i, "number", i.value)),
                (y = r ? Qe(r) : window),
                e)
              ) {
                case "focusin":
                  (Rn(y) || "true" === y.contentEditable) &&
                    ((rr = y), (or = r), (ar = null));
                  break;
                case "focusout":
                  ar = or = rr = null;
                  break;
                case "mousedown":
                  lr = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  (lr = !1), ir(l, n, o);
                  break;
                case "selectionchange":
                  if (nr) break;
                case "keydown":
                case "keyup":
                  ir(l, n, o);
              }
              var g;
              if (xn)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var b = "onCompositionStart";
                      break e;
                    case "compositionend":
                      b = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      b = "onCompositionUpdate";
                      break e;
                  }
                  b = void 0;
                }
              else
                zn
                  ? Pn(e, n) && (b = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (b = "onCompositionStart");
              b &&
                (Cn &&
                  "ko" !== n.locale &&
                  (zn || "onCompositionStart" !== b
                    ? "onCompositionEnd" === b && zn && (g = Bt())
                    : ((Wt = "value" in (Vt = o) ? Vt.value : Vt.textContent),
                      (zn = !0))),
                0 < (y = Du(r, b)).length &&
                  ((b = new sn(b, e, null, n, o)),
                  l.push({ event: b, listeners: y }),
                  g ? (b.data = g) : null !== (g = jn(n)) && (b.data = g))),
                (g = kn
                  ? (function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return jn(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((Nn = !0), En);
                        case "textInput":
                          return (e = t.data) === En && Nn ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (zn)
                        return "compositionend" === e || (!xn && Pn(e, t))
                          ? ((e = Bt()), (Ht = Wt = Vt = null), (zn = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return Cn && "ko" !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (b = Du(r, "onBeforeInput")).length &&
                  ((y = new sn("onBeforeInput", "beforeinput", null, n, o)),
                  l.push({ event: y, listeners: b }),
                  (y.data = g)),
                (function (e, t, n, r, o) {
                  if ("submit" === t && n && n.stateNode === o) {
                    var a = Su((o[Ie] || null).action),
                      l = r.submitter;
                    l &&
                      null !==
                        (t = (t = l[Ie] || null)
                          ? Su(t.formAction)
                          : l.getAttribute("formAction")) &&
                      ((a = t), (l = null));
                    var i = new Jt("action", "action", null, r, o);
                    e.push({
                      event: i,
                      listeners: [
                        {
                          instance: null,
                          listener: function () {
                            if (r.defaultPrevented) {
                              if (0 !== mu) {
                                var e = l ? ku(o, l) : new FormData(o);
                                dl(
                                  n,
                                  {
                                    pending: !0,
                                    data: e,
                                    method: o.method,
                                    action: a,
                                  },
                                  null,
                                  e
                                );
                              }
                            } else
                              "function" === typeof a &&
                                (i.preventDefault(),
                                (e = l ? ku(o, l) : new FormData(o)),
                                dl(
                                  n,
                                  {
                                    pending: !0,
                                    data: e,
                                    method: o.method,
                                    action: a,
                                  },
                                  a,
                                  e
                                ));
                          },
                          currentTarget: o,
                        },
                      ],
                    });
                  }
                })(l, e, r, n, o);
            }
            ju(l, t);
          });
        }
        function Lu(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function Du(e, t) {
          for (var n = t + "Capture", r = []; null !== e; ) {
            var o = e,
              a = o.stateNode;
            (5 !== (o = o.tag) && 26 !== o && 27 !== o) ||
              null === a ||
              (null != (o = Ft(e, n)) && r.unshift(Lu(e, o, a)),
              null != (o = Ft(e, t)) && r.push(Lu(e, o, a))),
              (e = e.return);
          }
          return r;
        }
        function Fu(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag && 27 !== e.tag);
          return e || null;
        }
        function Mu(e, t, n, r, o) {
          for (var a = t._reactName, l = []; null !== n && n !== r; ) {
            var i = n,
              s = i.alternate,
              c = i.stateNode;
            if (((i = i.tag), null !== s && s === r)) break;
            (5 !== i && 26 !== i && 27 !== i) ||
              null === c ||
              ((s = c),
              o
                ? null != (c = Ft(n, a)) && l.unshift(Lu(n, c, s))
                : o || (null != (c = Ft(n, a)) && l.push(Lu(n, c, s)))),
              (n = n.return);
          }
          0 !== l.length && e.push({ event: t, listeners: l });
        }
        var Iu = /\r\n?/g,
          Vu = /\u0000|\uFFFD/g;
        function Wu(e) {
          return ("string" === typeof e ? e : "" + e)
            .replace(Iu, "\n")
            .replace(Vu, "");
        }
        function Hu(e, t) {
          return (t = Wu(t)), Wu(e) === t;
        }
        function Bu() {}
        function Uu(e, t, n, r, o, a) {
          switch (n) {
            case "children":
              "string" === typeof r
                ? "body" === t || ("textarea" === t && "" === r) || St(e, r)
                : ("number" === typeof r || "bigint" === typeof r) &&
                  "body" !== t &&
                  St(e, "" + r);
              break;
            case "className":
              it(e, "class", r);
              break;
            case "tabIndex":
              it(e, "tabindex", r);
              break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
              it(e, n, r);
              break;
            case "style":
              Et(e, r, a);
              break;
            case "data":
              if ("object" !== t) {
                it(e, "data", r);
                break;
              }
            case "src":
            case "href":
              if ("" === r && ("a" !== t || "href" !== n)) {
                e.removeAttribute(n);
                break;
              }
              if (
                null == r ||
                "function" === typeof r ||
                "symbol" === typeof r ||
                "boolean" === typeof r
              ) {
                e.removeAttribute(n);
                break;
              }
              (r = zt("" + r)), e.setAttribute(n, r);
              break;
            case "action":
            case "formAction":
              if ("function" === typeof r) {
                e.setAttribute(
                  n,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              }
              if (
                ("function" === typeof a &&
                  ("formAction" === n
                    ? ("input" !== t && Uu(e, t, "name", o.name, o, null),
                      Uu(e, t, "formEncType", o.formEncType, o, null),
                      Uu(e, t, "formMethod", o.formMethod, o, null),
                      Uu(e, t, "formTarget", o.formTarget, o, null))
                    : (Uu(e, t, "encType", o.encType, o, null),
                      Uu(e, t, "method", o.method, o, null),
                      Uu(e, t, "target", o.target, o, null))),
                null == r || "symbol" === typeof r || "boolean" === typeof r)
              ) {
                e.removeAttribute(n);
                break;
              }
              (r = zt("" + r)), e.setAttribute(n, r);
              break;
            case "onClick":
              null != r && (e.onclick = Bu);
              break;
            case "onScroll":
              null != r && zu("scroll", e);
              break;
            case "onScrollEnd":
              null != r && zu("scrollend", e);
              break;
            case "dangerouslySetInnerHTML":
              if (null != r) {
                if ("object" !== typeof r || !("__html" in r))
                  throw Error(l(61));
                if (null != (n = r.__html)) {
                  if (null != o.children) throw Error(l(60));
                  e.innerHTML = n;
                }
              }
              break;
            case "multiple":
              e.multiple =
                r && "function" !== typeof r && "symbol" !== typeof r;
              break;
            case "muted":
              e.muted = r && "function" !== typeof r && "symbol" !== typeof r;
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
            case "autoFocus":
              break;
            case "xlinkHref":
              if (
                null == r ||
                "function" === typeof r ||
                "boolean" === typeof r ||
                "symbol" === typeof r
              ) {
                e.removeAttribute("xlink:href");
                break;
              }
              (n = zt("" + r)),
                e.setAttributeNS(
                  "http://www.w3.org/1999/xlink",
                  "xlink:href",
                  n
                );
              break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
              null != r && "function" !== typeof r && "symbol" !== typeof r
                ? e.setAttribute(n, "" + r)
                : e.removeAttribute(n);
              break;
            case "inert":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
              r && "function" !== typeof r && "symbol" !== typeof r
                ? e.setAttribute(n, "")
                : e.removeAttribute(n);
              break;
            case "capture":
            case "download":
              !0 === r
                ? e.setAttribute(n, "")
                : !1 !== r &&
                  null != r &&
                  "function" !== typeof r &&
                  "symbol" !== typeof r
                ? e.setAttribute(n, r)
                : e.removeAttribute(n);
              break;
            case "cols":
            case "rows":
            case "size":
            case "span":
              null != r &&
              "function" !== typeof r &&
              "symbol" !== typeof r &&
              !isNaN(r) &&
              1 <= r
                ? e.setAttribute(n, r)
                : e.removeAttribute(n);
              break;
            case "rowSpan":
            case "start":
              null == r ||
              "function" === typeof r ||
              "symbol" === typeof r ||
              isNaN(r)
                ? e.removeAttribute(n)
                : e.setAttribute(n, r);
              break;
            case "popover":
              zu("beforetoggle", e), zu("toggle", e), lt(e, "popover", r);
              break;
            case "xlinkActuate":
              st(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
              break;
            case "xlinkArcrole":
              st(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
              break;
            case "xlinkRole":
              st(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
              break;
            case "xlinkShow":
              st(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
              break;
            case "xlinkTitle":
              st(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
              break;
            case "xlinkType":
              st(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
              break;
            case "xmlBase":
              st(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
              break;
            case "xmlLang":
              st(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
              break;
            case "xmlSpace":
              st(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
              break;
            case "is":
              lt(e, "is", r);
              break;
            case "innerText":
            case "textContent":
              break;
            default:
              (!(2 < n.length) ||
                ("o" !== n[0] && "O" !== n[0]) ||
                ("n" !== n[1] && "N" !== n[1])) &&
                lt(e, (n = Pt.get(n) || n), r);
          }
        }
        function $u(e, t, n, r, o, a) {
          switch (n) {
            case "style":
              Et(e, r, a);
              break;
            case "dangerouslySetInnerHTML":
              if (null != r) {
                if ("object" !== typeof r || !("__html" in r))
                  throw Error(l(61));
                if (null != (n = r.__html)) {
                  if (null != o.children) throw Error(l(60));
                  e.innerHTML = n;
                }
              }
              break;
            case "children":
              "string" === typeof r
                ? St(e, r)
                : ("number" === typeof r || "bigint" === typeof r) &&
                  St(e, "" + r);
              break;
            case "onScroll":
              null != r && zu("scroll", e);
              break;
            case "onScrollEnd":
              null != r && zu("scrollend", e);
              break;
            case "onClick":
              null != r && (e.onclick = Bu);
              break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
            case "innerText":
            case "textContent":
              break;
            default:
              Ze.hasOwnProperty(n) ||
                ("o" !== n[0] ||
                "n" !== n[1] ||
                ((o = n.endsWith("Capture")),
                (t = n.slice(2, o ? n.length - 7 : void 0)),
                "function" ===
                  typeof (a = null != (a = e[Ie] || null) ? a[n] : null) &&
                  e.removeEventListener(t, a, o),
                "function" !== typeof r)
                  ? n in e
                    ? (e[n] = r)
                    : !0 === r
                    ? e.setAttribute(n, "")
                    : lt(e, n, r)
                  : ("function" !== typeof a &&
                      null !== a &&
                      (n in e
                        ? (e[n] = null)
                        : e.hasAttribute(n) && e.removeAttribute(n)),
                    e.addEventListener(t, r, o)));
          }
        }
        function qu(e, t, n) {
          switch (t) {
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
              break;
            case "img":
              zu("error", e), zu("load", e);
              var r,
                o = !1,
                a = !1;
              for (r in n)
                if (n.hasOwnProperty(r)) {
                  var i = n[r];
                  if (null != i)
                    switch (r) {
                      case "src":
                        o = !0;
                        break;
                      case "srcSet":
                        a = !0;
                        break;
                      case "children":
                      case "dangerouslySetInnerHTML":
                        throw Error(l(137, t));
                      default:
                        Uu(e, t, r, i, n, null);
                    }
                }
              return (
                a && Uu(e, t, "srcSet", n.srcSet, n, null),
                void (o && Uu(e, t, "src", n.src, n, null))
              );
            case "input":
              zu("invalid", e);
              var s = (r = i = a = null),
                c = null,
                u = null;
              for (o in n)
                if (n.hasOwnProperty(o)) {
                  var d = n[o];
                  if (null != d)
                    switch (o) {
                      case "name":
                        a = d;
                        break;
                      case "type":
                        i = d;
                        break;
                      case "checked":
                        c = d;
                        break;
                      case "defaultChecked":
                        u = d;
                        break;
                      case "value":
                        r = d;
                        break;
                      case "defaultValue":
                        s = d;
                        break;
                      case "children":
                      case "dangerouslySetInnerHTML":
                        if (null != d) throw Error(l(137, t));
                        break;
                      default:
                        Uu(e, t, o, d, n, null);
                    }
                }
              return yt(e, r, s, c, u, i, a, !1), void dt(e);
            case "select":
              for (a in (zu("invalid", e), (o = i = r = null), n))
                if (n.hasOwnProperty(a) && null != (s = n[a]))
                  switch (a) {
                    case "value":
                      r = s;
                      break;
                    case "defaultValue":
                      i = s;
                      break;
                    case "multiple":
                      o = s;
                    default:
                      Uu(e, t, a, s, n, null);
                  }
              return (
                (t = r),
                (n = i),
                (e.multiple = !!o),
                void (null != t
                  ? bt(e, !!o, t, !1)
                  : null != n && bt(e, !!o, n, !0))
              );
            case "textarea":
              for (i in (zu("invalid", e), (r = a = o = null), n))
                if (n.hasOwnProperty(i) && null != (s = n[i]))
                  switch (i) {
                    case "value":
                      o = s;
                      break;
                    case "defaultValue":
                      a = s;
                      break;
                    case "children":
                      r = s;
                      break;
                    case "dangerouslySetInnerHTML":
                      if (null != s) throw Error(l(91));
                      break;
                    default:
                      Uu(e, t, i, s, n, null);
                  }
              return xt(e, o, a, r), void dt(e);
            case "option":
              for (c in n)
                if (n.hasOwnProperty(c) && null != (o = n[c]))
                  if ("selected" === c)
                    e.selected =
                      o && "function" !== typeof o && "symbol" !== typeof o;
                  else Uu(e, t, c, o, n, null);
              return;
            case "dialog":
              zu("cancel", e), zu("close", e);
              break;
            case "iframe":
            case "object":
              zu("load", e);
              break;
            case "video":
            case "audio":
              for (o = 0; o < Nu.length; o++) zu(Nu[o], e);
              break;
            case "image":
              zu("error", e), zu("load", e);
              break;
            case "details":
              zu("toggle", e);
              break;
            case "embed":
            case "source":
            case "link":
              zu("error", e), zu("load", e);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
              for (u in n)
                if (n.hasOwnProperty(u) && null != (o = n[u]))
                  switch (u) {
                    case "children":
                    case "dangerouslySetInnerHTML":
                      throw Error(l(137, t));
                    default:
                      Uu(e, t, u, o, n, null);
                  }
              return;
            default:
              if (Nt(t)) {
                for (d in n)
                  n.hasOwnProperty(d) &&
                    void 0 !== (o = n[d]) &&
                    $u(e, t, d, o, n, void 0);
                return;
              }
          }
          for (s in n)
            n.hasOwnProperty(s) &&
              null != (o = n[s]) &&
              Uu(e, t, s, o, n, null);
        }
        var Yu = null,
          Ku = null;
        function Qu(e) {
          return 9 === e.nodeType ? e : e.ownerDocument;
        }
        function Xu(e) {
          switch (e) {
            case "http://www.w3.org/2000/svg":
              return 1;
            case "http://www.w3.org/1998/Math/MathML":
              return 2;
            default:
              return 0;
          }
        }
        function Gu(e, t) {
          if (0 === e)
            switch (t) {
              case "svg":
                return 1;
              case "math":
                return 2;
              default:
                return 0;
            }
          return 1 === e && "foreignObject" === t ? 0 : e;
        }
        function Ju(e, t) {
          return (
            "textarea" === e ||
            "noscript" === e ||
            "string" === typeof t.children ||
            "number" === typeof t.children ||
            "bigint" === typeof t.children ||
            ("object" === typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var Zu = null;
        var ed = "function" === typeof setTimeout ? setTimeout : void 0,
          td = "function" === typeof clearTimeout ? clearTimeout : void 0,
          nd = "function" === typeof Promise ? Promise : void 0,
          rd =
            "function" === typeof queueMicrotask
              ? queueMicrotask
              : "undefined" !== typeof nd
              ? function (e) {
                  return nd.resolve(null).then(e).catch(od);
                }
              : ed;
        function od(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function ad(e, t) {
          var n = t,
            r = 0;
          do {
            var o = n.nextSibling;
            if ((e.removeChild(n), o && 8 === o.nodeType))
              if ("/$" === (n = o.data)) {
                if (0 === r) return e.removeChild(o), void vf(t);
                r--;
              } else ("$" !== n && "$?" !== n && "$!" !== n) || r++;
            n = o;
          } while (n);
          vf(t);
        }
        function ld(e) {
          var t = e.firstChild;
          for (t && 10 === t.nodeType && (t = t.nextSibling); t; ) {
            var n = t;
            switch (((t = t.nextSibling), n.nodeName)) {
              case "HTML":
              case "HEAD":
              case "BODY":
                ld(n), qe(n);
                continue;
              case "SCRIPT":
              case "STYLE":
                continue;
              case "LINK":
                if ("stylesheet" === n.rel.toLowerCase()) continue;
            }
            e.removeChild(n);
          }
        }
        function id(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if (
                "$" === (t = e.data) ||
                "$!" === t ||
                "$?" === t ||
                "F!" === t ||
                "F" === t
              )
                break;
              if ("/$" === t) return null;
            }
          }
          return e;
        }
        function sd(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        function cd(e, t, n) {
          switch (((t = Qu(n)), e)) {
            case "html":
              if (!(e = t.documentElement)) throw Error(l(452));
              return e;
            case "head":
              if (!(e = t.head)) throw Error(l(453));
              return e;
            case "body":
              if (!(e = t.body)) throw Error(l(454));
              return e;
            default:
              throw Error(l(451));
          }
        }
        var ud = new Map(),
          dd = new Set();
        function fd(e) {
          return "function" === typeof e.getRootNode
            ? e.getRootNode()
            : e.ownerDocument;
        }
        var pd = H.d;
        H.d = {
          f: function () {
            var e = pd.f(),
              t = Mc();
            return e || t;
          },
          r: function (e) {
            var t = Ke(e);
            null !== t && 5 === t.tag && "form" === t.type ? pl(t) : pd.r(e);
          },
          D: function (e) {
            pd.D(e), hd("dns-prefetch", e, null);
          },
          C: function (e, t) {
            pd.C(e, t), hd("preconnect", e, t);
          },
          L: function (e, t, n) {
            pd.L(e, t, n);
            var r = md;
            if (r && e && t) {
              var o = 'link[rel="preload"][as="' + ht(t) + '"]';
              "image" === t && n && n.imageSrcSet
                ? ((o += '[imagesrcset="' + ht(n.imageSrcSet) + '"]'),
                  "string" === typeof n.imageSizes &&
                    (o += '[imagesizes="' + ht(n.imageSizes) + '"]'))
                : (o += '[href="' + ht(e) + '"]');
              var a = o;
              switch (t) {
                case "style":
                  a = yd(e);
                  break;
                case "script":
                  a = wd(e);
              }
              ud.has(a) ||
                ((e = R(
                  {
                    rel: "preload",
                    href: "image" === t && n && n.imageSrcSet ? void 0 : e,
                    as: t,
                  },
                  n
                )),
                ud.set(a, e),
                null !== r.querySelector(o) ||
                  ("style" === t && r.querySelector(gd(a))) ||
                  ("script" === t && r.querySelector(xd(a))) ||
                  (qu((t = r.createElement("link")), "link", e),
                  Ge(t),
                  r.head.appendChild(t)));
            }
          },
          m: function (e, t) {
            pd.m(e, t);
            var n = md;
            if (n && e) {
              var r = t && "string" === typeof t.as ? t.as : "script",
                o =
                  'link[rel="modulepreload"][as="' +
                  ht(r) +
                  '"][href="' +
                  ht(e) +
                  '"]',
                a = o;
              switch (r) {
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                  a = wd(e);
              }
              if (
                !ud.has(a) &&
                ((e = R({ rel: "modulepreload", href: e }, t)),
                ud.set(a, e),
                null === n.querySelector(o))
              ) {
                switch (r) {
                  case "audioworklet":
                  case "paintworklet":
                  case "serviceworker":
                  case "sharedworker":
                  case "worker":
                  case "script":
                    if (n.querySelector(xd(a))) return;
                }
                qu((r = n.createElement("link")), "link", e),
                  Ge(r),
                  n.head.appendChild(r);
              }
            }
          },
          X: function (e, t) {
            pd.X(e, t);
            var n = md;
            if (n && e) {
              var r = Xe(n).hoistableScripts,
                o = wd(e),
                a = r.get(o);
              a ||
                ((a = n.querySelector(xd(o))) ||
                  ((e = R({ src: e, async: !0 }, t)),
                  (t = ud.get(o)) && Ed(e, t),
                  Ge((a = n.createElement("script"))),
                  qu(a, "link", e),
                  n.head.appendChild(a)),
                (a = { type: "script", instance: a, count: 1, state: null }),
                r.set(o, a));
            }
          },
          S: function (e, t, n) {
            pd.S(e, t, n);
            var r = md;
            if (r && e) {
              var o = Xe(r).hoistableStyles,
                a = yd(e);
              t = t || "default";
              var l = o.get(a);
              if (!l) {
                var i = { loading: 0, preload: null };
                if ((l = r.querySelector(gd(a)))) i.loading = 5;
                else {
                  (e = R(
                    { rel: "stylesheet", href: e, "data-precedence": t },
                    n
                  )),
                    (n = ud.get(a)) && Cd(e, n);
                  var s = (l = r.createElement("link"));
                  Ge(s),
                    qu(s, "link", e),
                    (s._p = new Promise(function (e, t) {
                      (s.onload = e), (s.onerror = t);
                    })),
                    s.addEventListener("load", function () {
                      i.loading |= 1;
                    }),
                    s.addEventListener("error", function () {
                      i.loading |= 2;
                    }),
                    (i.loading |= 4),
                    kd(l, t, r);
                }
                (l = { type: "stylesheet", instance: l, count: 1, state: i }),
                  o.set(a, l);
              }
            }
          },
          M: function (e, t) {
            pd.M(e, t);
            var n = md;
            if (n && e) {
              var r = Xe(n).hoistableScripts,
                o = wd(e),
                a = r.get(o);
              a ||
                ((a = n.querySelector(xd(o))) ||
                  ((e = R({ src: e, async: !0, type: "module" }, t)),
                  (t = ud.get(o)) && Ed(e, t),
                  Ge((a = n.createElement("script"))),
                  qu(a, "link", e),
                  n.head.appendChild(a)),
                (a = { type: "script", instance: a, count: 1, state: null }),
                r.set(o, a));
            }
          },
        };
        var md = "undefined" === typeof document ? null : document;
        function hd(e, t, n) {
          var r = md;
          if (r && "string" === typeof t && t) {
            var o = ht(t);
            (o = 'link[rel="' + e + '"][href="' + o + '"]'),
              "string" === typeof n && (o += '[crossorigin="' + n + '"]'),
              dd.has(o) ||
                (dd.add(o),
                (e = { rel: e, crossOrigin: n, href: t }),
                null === r.querySelector(o) &&
                  (qu((t = r.createElement("link")), "link", e),
                  Ge(t),
                  r.head.appendChild(t)));
          }
        }
        function vd(e, t, n, r) {
          var o,
            a,
            i,
            s,
            c = (c = G.current) ? fd(c) : null;
          if (!c) throw Error(l(446));
          switch (e) {
            case "meta":
            case "title":
              return null;
            case "style":
              return "string" === typeof n.precedence &&
                "string" === typeof n.href
                ? ((t = yd(n.href)),
                  (r = (n = Xe(c).hoistableStyles).get(t)) ||
                    ((r = {
                      type: "style",
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    n.set(t, r)),
                  r)
                : { type: "void", instance: null, count: 0, state: null };
            case "link":
              if (
                "stylesheet" === n.rel &&
                "string" === typeof n.href &&
                "string" === typeof n.precedence
              ) {
                e = yd(n.href);
                var u = Xe(c).hoistableStyles,
                  d = u.get(e);
                if (
                  (d ||
                    ((c = c.ownerDocument || c),
                    (d = {
                      type: "stylesheet",
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    u.set(e, d),
                    (u = c.querySelector(gd(e))) &&
                      !u._p &&
                      ((d.instance = u), (d.state.loading = 5)),
                    ud.has(e) ||
                      ((n = {
                        rel: "preload",
                        as: "style",
                        href: n.href,
                        crossOrigin: n.crossOrigin,
                        integrity: n.integrity,
                        media: n.media,
                        hrefLang: n.hrefLang,
                        referrerPolicy: n.referrerPolicy,
                      }),
                      ud.set(e, n),
                      u ||
                        ((o = c),
                        (a = e),
                        (i = n),
                        (s = d.state),
                        o.querySelector(
                          'link[rel="preload"][as="style"][' + a + "]"
                        )
                          ? (s.loading = 1)
                          : ((a = o.createElement("link")),
                            (s.preload = a),
                            a.addEventListener("load", function () {
                              return (s.loading |= 1);
                            }),
                            a.addEventListener("error", function () {
                              return (s.loading |= 2);
                            }),
                            qu(a, "link", i),
                            Ge(a),
                            o.head.appendChild(a))))),
                  t && null === r)
                )
                  throw Error(l(528, ""));
                return d;
              }
              if (t && null !== r) throw Error(l(529, ""));
              return null;
            case "script":
              return (
                (t = n.async),
                "string" === typeof (n = n.src) &&
                t &&
                "function" !== typeof t &&
                "symbol" !== typeof t
                  ? ((t = wd(n)),
                    (r = (n = Xe(c).hoistableScripts).get(t)) ||
                      ((r = {
                        type: "script",
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      n.set(t, r)),
                    r)
                  : { type: "void", instance: null, count: 0, state: null }
              );
            default:
              throw Error(l(444, e));
          }
        }
        function yd(e) {
          return 'href="' + ht(e) + '"';
        }
        function gd(e) {
          return 'link[rel="stylesheet"][' + e + "]";
        }
        function bd(e) {
          return R({}, e, {
            "data-precedence": e.precedence,
            precedence: null,
          });
        }
        function wd(e) {
          return '[src="' + ht(e) + '"]';
        }
        function xd(e) {
          return "script[async]" + e;
        }
        function Sd(e, t, n) {
          if ((t.count++, null === t.instance))
            switch (t.type) {
              case "style":
                var r = e.querySelector(
                  'style[data-href~="' + ht(n.href) + '"]'
                );
                if (r) return (t.instance = r), Ge(r), r;
                var o = R({}, n, {
                  "data-href": n.href,
                  "data-precedence": n.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  Ge((r = (e.ownerDocument || e).createElement("style"))),
                  qu(r, "style", o),
                  kd(r, n.precedence, e),
                  (t.instance = r)
                );
              case "stylesheet":
                o = yd(n.href);
                var a = e.querySelector(gd(o));
                if (a)
                  return (t.state.loading |= 4), (t.instance = a), Ge(a), a;
                (r = bd(n)),
                  (o = ud.get(o)) && Cd(r, o),
                  Ge((a = (e.ownerDocument || e).createElement("link")));
                var i = a;
                return (
                  (i._p = new Promise(function (e, t) {
                    (i.onload = e), (i.onerror = t);
                  })),
                  qu(a, "link", r),
                  (t.state.loading |= 4),
                  kd(a, n.precedence, e),
                  (t.instance = a)
                );
              case "script":
                return (
                  (a = wd(n.src)),
                  (o = e.querySelector(xd(a)))
                    ? ((t.instance = o), Ge(o), o)
                    : ((r = n),
                      (o = ud.get(a)) && Ed((r = R({}, n)), o),
                      Ge(
                        (o = (e = e.ownerDocument || e).createElement("script"))
                      ),
                      qu(o, "link", r),
                      e.head.appendChild(o),
                      (t.instance = o))
                );
              case "void":
                return null;
              default:
                throw Error(l(443, t.type));
            }
          else
            "stylesheet" === t.type &&
              0 === (4 & t.state.loading) &&
              ((r = t.instance),
              (t.state.loading |= 4),
              kd(r, n.precedence, e));
          return t.instance;
        }
        function kd(e, t, n) {
          for (
            var r = n.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              o = r.length ? r[r.length - 1] : null,
              a = o,
              l = 0;
            l < r.length;
            l++
          ) {
            var i = r[l];
            if (i.dataset.precedence === t) a = i;
            else if (a !== o) break;
          }
          a
            ? a.parentNode.insertBefore(e, a.nextSibling)
            : (t = 9 === n.nodeType ? n.head : n).insertBefore(e, t.firstChild);
        }
        function Cd(e, t) {
          null == e.crossOrigin && (e.crossOrigin = t.crossOrigin),
            null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy),
            null == e.title && (e.title = t.title);
        }
        function Ed(e, t) {
          null == e.crossOrigin && (e.crossOrigin = t.crossOrigin),
            null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy),
            null == e.integrity && (e.integrity = t.integrity);
        }
        var Nd = null;
        function Pd(e, t, n) {
          if (null === Nd) {
            var r = new Map(),
              o = (Nd = new Map());
            o.set(n, r);
          } else (r = (o = Nd).get(n)) || ((r = new Map()), o.set(n, r));
          if (r.has(e)) return r;
          for (
            r.set(e, null), n = n.getElementsByTagName(e), o = 0;
            o < n.length;
            o++
          ) {
            var a = n[o];
            if (
              !(
                a[$e] ||
                a[Me] ||
                ("link" === e && "stylesheet" === a.getAttribute("rel"))
              ) &&
              "http://www.w3.org/2000/svg" !== a.namespaceURI
            ) {
              var l = a.getAttribute(t) || "";
              l = e + l;
              var i = r.get(l);
              i ? i.push(a) : r.set(l, [a]);
            }
          }
          return r;
        }
        function jd(e, t, n) {
          (e = e.ownerDocument || e).head.insertBefore(
            n,
            "title" === t ? e.querySelector("head > title") : null
          );
        }
        function zd(e) {
          return "stylesheet" !== e.type || 0 !== (3 & e.state.loading);
        }
        var Td = null;
        function Rd() {}
        function _d() {
          if ((this.count--, 0 === this.count))
            if (this.stylesheets) Ad(this, this.stylesheets);
            else if (this.unsuspend) {
              var e = this.unsuspend;
              (this.unsuspend = null), e();
            }
        }
        var Od = null;
        function Ad(e, t) {
          (e.stylesheets = null),
            null !== e.unsuspend &&
              (e.count++,
              (Od = new Map()),
              t.forEach(Ld, e),
              (Od = null),
              _d.call(e));
        }
        function Ld(e, t) {
          if (!(4 & t.state.loading)) {
            var n = Od.get(e);
            if (n) var r = n.get(null);
            else {
              (n = new Map()), Od.set(e, n);
              for (
                var o = e.querySelectorAll(
                    "link[data-precedence],style[data-precedence]"
                  ),
                  a = 0;
                a < o.length;
                a++
              ) {
                var l = o[a];
                ("LINK" !== l.nodeName &&
                  "not all" === l.getAttribute("media")) ||
                  (n.set(l.dataset.precedence, l), (r = l));
              }
              r && n.set(null, r);
            }
            (l = (o = t.instance).getAttribute("data-precedence")),
              (a = n.get(l) || r) === r && n.set(null, o),
              n.set(l, o),
              this.count++,
              (r = _d.bind(this)),
              o.addEventListener("load", r),
              o.addEventListener("error", r),
              a
                ? a.parentNode.insertBefore(o, a.nextSibling)
                : (e = 9 === e.nodeType ? e.head : e).insertBefore(
                    o,
                    e.firstChild
                  ),
              (t.state.loading |= 4);
          }
        }
        var Dd = {
          $$typeof: v,
          Provider: null,
          Consumer: null,
          _currentValue: B,
          _currentValue2: B,
          _threadCount: 0,
        };
        function Fd(e, t, n, r, o, a, l, i) {
          (this.tag = 1),
            (this.containerInfo = e),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = Re(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.finishedLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = Re(0)),
            (this.hiddenUpdates = Re(null)),
            (this.identifierPrefix = r),
            (this.onUncaughtError = o),
            (this.onCaughtError = a),
            (this.onRecoverableError = l),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = i),
            (this.incompleteTransitions = new Map());
        }
        function Md(e, t, n, r, o, a, l, i, s, c, u, d) {
          return (
            (e = new Fd(e, t, n, l, i, s, c, d)),
            (t = 1),
            !0 === a && (t |= 24),
            (a = Ls(3, null, null, t)),
            (e.current = a),
            (a.stateNode = e),
            (t = Wo()).refCount++,
            (e.pooledCache = t),
            t.refCount++,
            (a.memoizedState = { element: r, isDehydrated: n, cache: t }),
            zi(a),
            e
          );
        }
        function Id(e) {
          return e ? (e = _r) : _r;
        }
        function Vd(e, t, n, r, o, a) {
          (o = Id(o)),
            null === r.context ? (r.context = o) : (r.pendingContext = o),
            ((r = Ri(t)).payload = { element: n }),
            null !== (a = void 0 === a ? null : a) && (r.callback = a),
            null !== (n = _i(e, r, t)) && (_c(n, 0, t), Oi(n, e, t));
        }
        function Wd(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function Hd(e, t) {
          Wd(e, t), (e = e.alternate) && Wd(e, t);
        }
        function Bd(e) {
          if (13 === e.tag) {
            var t = zr(e, 67108864);
            null !== t && _c(t, 0, 67108864), Hd(e, 67108864);
          }
        }
        var Ud = !0;
        function $d(e, t, n, r) {
          var o = T.T;
          T.T = null;
          var a = H.p;
          try {
            (H.p = 2), Yd(e, t, n, r);
          } finally {
            (H.p = a), (T.T = o);
          }
        }
        function qd(e, t, n, r) {
          var o = T.T;
          T.T = null;
          var a = H.p;
          try {
            (H.p = 8), Yd(e, t, n, r);
          } finally {
            (H.p = a), (T.T = o);
          }
        }
        function Yd(e, t, n, r) {
          if (Ud) {
            var o = Kd(r);
            if (null === o) Au(e, t, r, Qd, n), lf(e, r);
            else if (
              (function (e, t, n, r, o) {
                switch (t) {
                  case "focusin":
                    return (Zd = sf(Zd, e, t, n, r, o)), !0;
                  case "dragenter":
                    return (ef = sf(ef, e, t, n, r, o)), !0;
                  case "mouseover":
                    return (tf = sf(tf, e, t, n, r, o)), !0;
                  case "pointerover":
                    var a = o.pointerId;
                    return nf.set(a, sf(nf.get(a) || null, e, t, n, r, o)), !0;
                  case "gotpointercapture":
                    return (
                      (a = o.pointerId),
                      rf.set(a, sf(rf.get(a) || null, e, t, n, r, o)),
                      !0
                    );
                }
                return !1;
              })(o, e, t, n, r)
            )
              r.stopPropagation();
            else if ((lf(e, r), 4 & t && -1 < af.indexOf(e))) {
              for (; null !== o; ) {
                var a = Ke(o);
                if (null !== a)
                  switch (a.tag) {
                    case 3:
                      if (
                        (a = a.stateNode).current.memoizedState.isDehydrated
                      ) {
                        var l = Ee(a.pendingLanes);
                        if (0 !== l) {
                          var i = a;
                          for (
                            i.pendingLanes |= 2, i.entangledLanes |= 2;
                            l;

                          ) {
                            var s = 1 << (31 - we(l));
                            (i.entanglements[1] |= s), (l &= ~s);
                          }
                          hu(a),
                            0 === (6 & ec) && ((wc = se() + 500), vu(0, !1));
                        }
                      }
                      break;
                    case 13:
                      null !== (i = zr(a, 2)) && _c(i, 0, 2), Mc(), Hd(a, 2);
                  }
                if ((null === (a = Kd(r)) && Au(e, t, r, Qd, n), a === o))
                  break;
                o = a;
              }
              null !== o && r.stopPropagation();
            } else Au(e, t, r, null, n);
          }
        }
        function Kd(e) {
          return Xd((e = Rt(e)));
        }
        var Qd = null;
        function Xd(e) {
          if (((Qd = null), null !== (e = Ye(e)))) {
            var t = F(e);
            if (null === t) e = null;
            else {
              var n = t.tag;
              if (13 === n) {
                if (null !== (e = M(t))) return e;
                e = null;
              } else if (3 === n) {
                if (t.stateNode.current.memoizedState.isDehydrated)
                  return 3 === t.tag ? t.stateNode.containerInfo : null;
                e = null;
              } else t !== e && (e = null);
            }
          }
          return (Qd = e), null;
        }
        function Gd(e) {
          switch (e) {
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 2;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 8;
            case "message":
              switch (ce()) {
                case ue:
                  return 2;
                case de:
                  return 8;
                case fe:
                case pe:
                  return 32;
                case me:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var Jd = !1,
          Zd = null,
          ef = null,
          tf = null,
          nf = new Map(),
          rf = new Map(),
          of = [],
          af =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
              " "
            );
        function lf(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              Zd = null;
              break;
            case "dragenter":
            case "dragleave":
              ef = null;
              break;
            case "mouseover":
            case "mouseout":
              tf = null;
              break;
            case "pointerover":
            case "pointerout":
              nf.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              rf.delete(t.pointerId);
          }
        }
        function sf(e, t, n, r, o, a) {
          return null === e || e.nativeEvent !== a
            ? ((e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: a,
                targetContainers: [o],
              }),
              null !== t && null !== (t = Ke(t)) && Bd(t),
              e)
            : ((e.eventSystemFlags |= r),
              (t = e.targetContainers),
              null !== o && -1 === t.indexOf(o) && t.push(o),
              e);
        }
        function cf(e) {
          var t = Ye(e.target);
          if (null !== t) {
            var n = F(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = M(n)))
                  return (
                    (e.blockedOn = t),
                    void (function (e, t) {
                      var n = H.p;
                      try {
                        return (H.p = e), t();
                      } finally {
                        H.p = n;
                      }
                    })(e.priority, function () {
                      if (13 === n.tag) {
                        var e = Tc(),
                          t = zr(n, e);
                        null !== t && _c(t, 0, e), Hd(n, e);
                      }
                    })
                  );
              } else if (
                3 === t &&
                n.stateNode.current.memoizedState.isDehydrated
              )
                return void (e.blockedOn =
                  3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function uf(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var n = Kd(e.nativeEvent);
            if (null !== n)
              return null !== (t = Ke(n)) && Bd(t), (e.blockedOn = n), !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            (Tt = r), n.target.dispatchEvent(r), (Tt = null), t.shift();
          }
          return !0;
        }
        function df(e, t, n) {
          uf(e) && n.delete(t);
        }
        function ff() {
          (Jd = !1),
            null !== Zd && uf(Zd) && (Zd = null),
            null !== ef && uf(ef) && (ef = null),
            null !== tf && uf(tf) && (tf = null),
            nf.forEach(df),
            rf.forEach(df);
        }
        function pf(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            Jd ||
              ((Jd = !0),
              r.unstable_scheduleCallback(r.unstable_NormalPriority, ff)));
        }
        var mf = null;
        function hf(e) {
          mf !== e &&
            ((mf = e),
            r.unstable_scheduleCallback(r.unstable_NormalPriority, function () {
              mf === e && (mf = null);
              for (var t = 0; t < e.length; t += 3) {
                var n = e[t],
                  r = e[t + 1],
                  o = e[t + 2];
                if ("function" !== typeof r) {
                  if (null === Xd(r || n)) continue;
                  break;
                }
                var a = Ke(n);
                null !== a &&
                  (e.splice(t, 3),
                  (t -= 3),
                  dl(
                    a,
                    { pending: !0, data: o, method: n.method, action: r },
                    r,
                    o
                  ));
              }
            }));
        }
        function vf(e) {
          function t(t) {
            return pf(t, e);
          }
          null !== Zd && pf(Zd, e),
            null !== ef && pf(ef, e),
            null !== tf && pf(tf, e),
            nf.forEach(t),
            rf.forEach(t);
          for (var n = 0; n < of.length; n++) {
            var r = of[n];
            r.blockedOn === e && (r.blockedOn = null);
          }
          for (; 0 < of.length && null === (n = of[0]).blockedOn; )
            cf(n), null === n.blockedOn && of.shift();
          if (null != (n = (e.ownerDocument || e).$$reactFormReplay))
            for (r = 0; r < n.length; r += 3) {
              var o = n[r],
                a = n[r + 1],
                l = o[Ie] || null;
              if ("function" === typeof a) l || hf(n);
              else if (l) {
                var i = null;
                if (a && a.hasAttribute("formAction")) {
                  if (((o = a), (l = a[Ie] || null))) i = l.formAction;
                  else if (null !== Xd(o)) continue;
                } else i = l.action;
                "function" === typeof i
                  ? (n[r + 1] = i)
                  : (n.splice(r, 3), (r -= 3)),
                  hf(n);
              }
            }
        }
        function yf(e) {
          this._internalRoot = e;
        }
        function gf(e) {
          this._internalRoot = e;
        }
        (gf.prototype.render = yf.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(l(409));
            Vd(t.current, Tc(), e, t, null, null);
          }),
          (gf.prototype.unmount = yf.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                0 === e.tag && tu(),
                  Vd(e.current, 2, null, e, null, null),
                  Mc(),
                  (t[Ve] = null);
              }
            }),
          (gf.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = De();
              e = { blockedOn: null, target: e, priority: t };
              for (
                var n = 0;
                n < of.length && 0 !== t && t < of[n].priority;
                n++
              );
              of.splice(n, 0, e), 0 === n && cf(e);
            }
          });
        var bf = o.version;
        if ("19.0.0" !== bf) throw Error(l(527, bf, "19.0.0"));
        H.findDOMNode = function (e) {
          var t = e._reactInternals;
          if (void 0 === t) {
            if ("function" === typeof e.render) throw Error(l(188));
            throw ((e = Object.keys(e).join(",")), Error(l(268, e)));
          }
          return (
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = F(e))) throw Error(l(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ; ) {
                var o = n.return;
                if (null === o) break;
                var a = o.alternate;
                if (null === a) {
                  if (null !== (r = o.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (o.child === a.child) {
                  for (a = o.child; a; ) {
                    if (a === n) return I(o), e;
                    if (a === r) return I(o), t;
                    a = a.sibling;
                  }
                  throw Error(l(188));
                }
                if (n.return !== r.return) (n = o), (r = a);
                else {
                  for (var i = !1, s = o.child; s; ) {
                    if (s === n) {
                      (i = !0), (n = o), (r = a);
                      break;
                    }
                    if (s === r) {
                      (i = !0), (r = o), (n = a);
                      break;
                    }
                    s = s.sibling;
                  }
                  if (!i) {
                    for (s = a.child; s; ) {
                      if (s === n) {
                        (i = !0), (n = a), (r = o);
                        break;
                      }
                      if (s === r) {
                        (i = !0), (r = a), (n = o);
                        break;
                      }
                      s = s.sibling;
                    }
                    if (!i) throw Error(l(189));
                  }
                }
                if (n.alternate !== r) throw Error(l(190));
              }
              if (3 !== n.tag) throw Error(l(188));
              return n.stateNode.current === n ? e : t;
            })(t)),
            (e = null === (e = null !== e ? V(e) : null) ? null : e.stateNode)
          );
        };
        var wf = {
          bundleType: 0,
          version: "19.0.0",
          rendererPackageName: "react-dom",
          currentDispatcherRef: T,
          findFiberByHostInstance: Ye,
          reconcilerVersion: "19.0.0",
        };
        if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var xf = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!xf.isDisabled && xf.supportsFiber)
            try {
              (ye = xf.inject(wf)), (ge = xf);
            } catch (kf) {}
        }
        (t.createRoot = function (e, t) {
          if (!i(e)) throw Error(l(299));
          var n = !1,
            r = "",
            o = Ll,
            a = Dl,
            s = Fl;
          return (
            null !== t &&
              void 0 !== t &&
              (!0 === t.unstable_strictMode && (n = !0),
              void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
              void 0 !== t.onUncaughtError && (o = t.onUncaughtError),
              void 0 !== t.onCaughtError && (a = t.onCaughtError),
              void 0 !== t.onRecoverableError && (s = t.onRecoverableError),
              void 0 !== t.unstable_transitionCallbacks &&
                t.unstable_transitionCallbacks),
            (t = Md(e, 1, !1, null, 0, n, r, o, a, s, 0, null)),
            (e[Ve] = t.current),
            _u(8 === e.nodeType ? e.parentNode : e),
            new yf(t)
          );
        }),
          (t.hydrateRoot = function (e, t, n) {
            if (!i(e)) throw Error(l(299));
            var r = !1,
              o = "",
              a = Ll,
              s = Dl,
              c = Fl,
              u = null;
            return (
              null !== n &&
                void 0 !== n &&
                (!0 === n.unstable_strictMode && (r = !0),
                void 0 !== n.identifierPrefix && (o = n.identifierPrefix),
                void 0 !== n.onUncaughtError && (a = n.onUncaughtError),
                void 0 !== n.onCaughtError && (s = n.onCaughtError),
                void 0 !== n.onRecoverableError && (c = n.onRecoverableError),
                void 0 !== n.unstable_transitionCallbacks &&
                  n.unstable_transitionCallbacks,
                void 0 !== n.formState && (u = n.formState)),
              ((t = Md(e, 1, !0, t, 0, r, o, a, s, c, 0, u)).context =
                Id(null)),
              (n = t.current),
              ((o = Ri((r = Tc()))).callback = null),
              _i(n, o, r),
              (t.current.lanes = r),
              _e(t, r),
              hu(t),
              (e[Ve] = t.current),
              _u(e),
              new gf(t)
            );
          }),
          (t.version = "19.0.0");
      },
      672: (e, t, n) => {
        var r = n(43);
        function o(e) {
          var t = "https://react.dev/errors/" + e;
          if (1 < arguments.length) {
            t += "?args[]=" + encodeURIComponent(arguments[1]);
            for (var n = 2; n < arguments.length; n++)
              t += "&args[]=" + encodeURIComponent(arguments[n]);
          }
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        function a() {}
        var l = {
            d: {
              f: a,
              r: function () {
                throw Error(o(522));
              },
              D: a,
              C: a,
              L: a,
              m: a,
              X: a,
              S: a,
              M: a,
            },
            p: 0,
            findDOMNode: null,
          },
          i = Symbol.for("react.portal");
        var s =
          r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function c(e, t) {
          return "font" === e
            ? ""
            : "string" === typeof t
            ? "use-credentials" === t
              ? t
              : ""
            : void 0;
        }
        (t.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = l),
          (t.createPortal = function (e, t) {
            var n =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            if (
              !t ||
              (1 !== t.nodeType && 9 !== t.nodeType && 11 !== t.nodeType)
            )
              throw Error(o(299));
            return (function (e, t, n) {
              var r =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return {
                $$typeof: i,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n,
              };
            })(e, t, null, n);
          }),
          (t.flushSync = function (e) {
            var t = s.T,
              n = l.p;
            try {
              if (((s.T = null), (l.p = 2), e)) return e();
            } finally {
              (s.T = t), (l.p = n), l.d.f();
            }
          }),
          (t.preconnect = function (e, t) {
            "string" === typeof e &&
              (t
                ? (t =
                    "string" === typeof (t = t.crossOrigin)
                      ? "use-credentials" === t
                        ? t
                        : ""
                      : void 0)
                : (t = null),
              l.d.C(e, t));
          }),
          (t.prefetchDNS = function (e) {
            "string" === typeof e && l.d.D(e);
          }),
          (t.preinit = function (e, t) {
            if ("string" === typeof e && t && "string" === typeof t.as) {
              var n = t.as,
                r = c(n, t.crossOrigin),
                o = "string" === typeof t.integrity ? t.integrity : void 0,
                a =
                  "string" === typeof t.fetchPriority
                    ? t.fetchPriority
                    : void 0;
              "style" === n
                ? l.d.S(
                    e,
                    "string" === typeof t.precedence ? t.precedence : void 0,
                    { crossOrigin: r, integrity: o, fetchPriority: a }
                  )
                : "script" === n &&
                  l.d.X(e, {
                    crossOrigin: r,
                    integrity: o,
                    fetchPriority: a,
                    nonce: "string" === typeof t.nonce ? t.nonce : void 0,
                  });
            }
          }),
          (t.preinitModule = function (e, t) {
            if ("string" === typeof e)
              if ("object" === typeof t && null !== t) {
                if (null == t.as || "script" === t.as) {
                  var n = c(t.as, t.crossOrigin);
                  l.d.M(e, {
                    crossOrigin: n,
                    integrity:
                      "string" === typeof t.integrity ? t.integrity : void 0,
                    nonce: "string" === typeof t.nonce ? t.nonce : void 0,
                  });
                }
              } else null == t && l.d.M(e);
          }),
          (t.preload = function (e, t) {
            if (
              "string" === typeof e &&
              "object" === typeof t &&
              null !== t &&
              "string" === typeof t.as
            ) {
              var n = t.as,
                r = c(n, t.crossOrigin);
              l.d.L(e, n, {
                crossOrigin: r,
                integrity:
                  "string" === typeof t.integrity ? t.integrity : void 0,
                nonce: "string" === typeof t.nonce ? t.nonce : void 0,
                type: "string" === typeof t.type ? t.type : void 0,
                fetchPriority:
                  "string" === typeof t.fetchPriority
                    ? t.fetchPriority
                    : void 0,
                referrerPolicy:
                  "string" === typeof t.referrerPolicy
                    ? t.referrerPolicy
                    : void 0,
                imageSrcSet:
                  "string" === typeof t.imageSrcSet ? t.imageSrcSet : void 0,
                imageSizes:
                  "string" === typeof t.imageSizes ? t.imageSizes : void 0,
                media: "string" === typeof t.media ? t.media : void 0,
              });
            }
          }),
          (t.preloadModule = function (e, t) {
            if ("string" === typeof e)
              if (t) {
                var n = c(t.as, t.crossOrigin);
                l.d.m(e, {
                  as:
                    "string" === typeof t.as && "script" !== t.as
                      ? t.as
                      : void 0,
                  crossOrigin: n,
                  integrity:
                    "string" === typeof t.integrity ? t.integrity : void 0,
                });
              } else l.d.m(e);
          }),
          (t.requestFormReset = function (e) {
            l.d.r(e);
          }),
          (t.unstable_batchedUpdates = function (e, t) {
            return e(t);
          }),
          (t.useFormState = function (e, t, n) {
            return s.H.useFormState(e, t, n);
          }),
          (t.useFormStatus = function () {
            return s.H.useHostTransitionStatus();
          }),
          (t.version = "19.0.0");
      },
      391: (e, t, n) => {
        !(function e() {
          if (
            "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (t) {
              console.error(t);
            }
        })(),
          (e.exports = n(4));
      },
      950: (e, t, n) => {
        !(function e() {
          if (
            "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (t) {
              console.error(t);
            }
        })(),
          (e.exports = n(672));
      },
      799: (e, t) => {
        var n = Symbol.for("react.transitional.element"),
          r = Symbol.for("react.fragment");
        function o(e, t, r) {
          var o = null;
          if (
            (void 0 !== r && (o = "" + r),
            void 0 !== t.key && (o = "" + t.key),
            "key" in t)
          )
            for (var a in ((r = {}), t)) "key" !== a && (r[a] = t[a]);
          else r = t;
          return (
            (t = r.ref),
            {
              $$typeof: n,
              type: e,
              key: o,
              ref: void 0 !== t ? t : null,
              props: r,
            }
          );
        }
        (t.Fragment = r), (t.jsx = o), (t.jsxs = o);
      },
      288: (e, t) => {
        var n = Symbol.for("react.transitional.element"),
          r = Symbol.for("react.portal"),
          o = Symbol.for("react.fragment"),
          a = Symbol.for("react.strict_mode"),
          l = Symbol.for("react.profiler"),
          i = Symbol.for("react.consumer"),
          s = Symbol.for("react.context"),
          c = Symbol.for("react.forward_ref"),
          u = Symbol.for("react.suspense"),
          d = Symbol.for("react.memo"),
          f = Symbol.for("react.lazy"),
          p = Symbol.iterator;
        var m = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          h = Object.assign,
          v = {};
        function y(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = v),
            (this.updater = n || m);
        }
        function g() {}
        function b(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = v),
            (this.updater = n || m);
        }
        (y.prototype.isReactComponent = {}),
          (y.prototype.setState = function (e, t) {
            if ("object" !== typeof e && "function" !== typeof e && null != e)
              throw Error(
                "takes an object of state variables to update or a function which returns an object of state variables."
              );
            this.updater.enqueueSetState(this, e, t, "setState");
          }),
          (y.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, "forceUpdate");
          }),
          (g.prototype = y.prototype);
        var w = (b.prototype = new g());
        (w.constructor = b), h(w, y.prototype), (w.isPureReactComponent = !0);
        var x = Array.isArray,
          S = { H: null, A: null, T: null, S: null },
          k = Object.prototype.hasOwnProperty;
        function C(e, t, r, o, a, l) {
          return (
            (r = l.ref),
            {
              $$typeof: n,
              type: e,
              key: t,
              ref: void 0 !== r ? r : null,
              props: l,
            }
          );
        }
        function E(e) {
          return "object" === typeof e && null !== e && e.$$typeof === n;
        }
        var N = /\/+/g;
        function P(e, t) {
          return "object" === typeof e && null !== e && null != e.key
            ? (function (e) {
                var t = { "=": "=0", ":": "=2" };
                return (
                  "$" +
                  e.replace(/[=:]/g, function (e) {
                    return t[e];
                  })
                );
              })("" + e.key)
            : t.toString(36);
        }
        function j() {}
        function z(e, t, o, a, l) {
          var i = typeof e;
          ("undefined" !== i && "boolean" !== i) || (e = null);
          var s,
            c,
            u = !1;
          if (null === e) u = !0;
          else
            switch (i) {
              case "bigint":
              case "string":
              case "number":
                u = !0;
                break;
              case "object":
                switch (e.$$typeof) {
                  case n:
                  case r:
                    u = !0;
                    break;
                  case f:
                    return z((u = e._init)(e._payload), t, o, a, l);
                }
            }
          if (u)
            return (
              (l = l(e)),
              (u = "" === a ? "." + P(e, 0) : a),
              x(l)
                ? ((o = ""),
                  null != u && (o = u.replace(N, "$&/") + "/"),
                  z(l, t, o, "", function (e) {
                    return e;
                  }))
                : null != l &&
                  (E(l) &&
                    ((s = l),
                    (c =
                      o +
                      (null == l.key || (e && e.key === l.key)
                        ? ""
                        : ("" + l.key).replace(N, "$&/") + "/") +
                      u),
                    (l = C(s.type, c, void 0, 0, 0, s.props))),
                  t.push(l)),
              1
            );
          u = 0;
          var d,
            m = "" === a ? "." : a + ":";
          if (x(e))
            for (var h = 0; h < e.length; h++)
              u += z((a = e[h]), t, o, (i = m + P(a, h)), l);
          else if (
            "function" ===
            typeof (h =
              null === (d = e) || "object" !== typeof d
                ? null
                : "function" === typeof (d = (p && d[p]) || d["@@iterator"])
                ? d
                : null)
          )
            for (e = h.call(e), h = 0; !(a = e.next()).done; )
              u += z((a = a.value), t, o, (i = m + P(a, h++)), l);
          else if ("object" === i) {
            if ("function" === typeof e.then)
              return z(
                (function (e) {
                  switch (e.status) {
                    case "fulfilled":
                      return e.value;
                    case "rejected":
                      throw e.reason;
                    default:
                      switch (
                        ("string" === typeof e.status
                          ? e.then(j, j)
                          : ((e.status = "pending"),
                            e.then(
                              function (t) {
                                "pending" === e.status &&
                                  ((e.status = "fulfilled"), (e.value = t));
                              },
                              function (t) {
                                "pending" === e.status &&
                                  ((e.status = "rejected"), (e.reason = t));
                              }
                            )),
                        e.status)
                      ) {
                        case "fulfilled":
                          return e.value;
                        case "rejected":
                          throw e.reason;
                      }
                  }
                  throw e;
                })(e),
                t,
                o,
                a,
                l
              );
            throw (
              ((t = String(e)),
              Error(
                "Objects are not valid as a React child (found: " +
                  ("[object Object]" === t
                    ? "object with keys {" + Object.keys(e).join(", ") + "}"
                    : t) +
                  "). If you meant to render a collection of children, use an array instead."
              ))
            );
          }
          return u;
        }
        function T(e, t, n) {
          if (null == e) return e;
          var r = [],
            o = 0;
          return (
            z(e, r, "", "", function (e) {
              return t.call(n, e, o++);
            }),
            r
          );
        }
        function R(e) {
          if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 2), (e._result = t));
              }
            ),
              -1 === e._status && ((e._status = 0), (e._result = t));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var _ =
          "function" === typeof reportError
            ? reportError
            : function (e) {
                if (
                  "object" === typeof window &&
                  "function" === typeof window.ErrorEvent
                ) {
                  var t = new window.ErrorEvent("error", {
                    bubbles: !0,
                    cancelable: !0,
                    message:
                      "object" === typeof e &&
                      null !== e &&
                      "string" === typeof e.message
                        ? String(e.message)
                        : String(e),
                    error: e,
                  });
                  if (!window.dispatchEvent(t)) return;
                } else if (
                  "object" === typeof process &&
                  "function" === typeof process.emit
                )
                  return void process.emit("uncaughtException", e);
                console.error(e);
              };
        function O() {}
        (t.Children = {
          map: T,
          forEach: function (e, t, n) {
            T(
              e,
              function () {
                t.apply(this, arguments);
              },
              n
            );
          },
          count: function (e) {
            var t = 0;
            return (
              T(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              T(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!E(e))
              throw Error(
                "React.Children.only expected to receive a single React element child."
              );
            return e;
          },
        }),
          (t.Component = y),
          (t.Fragment = o),
          (t.Profiler = l),
          (t.PureComponent = b),
          (t.StrictMode = a),
          (t.Suspense = u),
          (t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            S),
          (t.act = function () {
            throw Error(
              "act(...) is not supported in production builds of React."
            );
          }),
          (t.cache = function (e) {
            return function () {
              return e.apply(null, arguments);
            };
          }),
          (t.cloneElement = function (e, t, n) {
            if (null === e || void 0 === e)
              throw Error(
                "The argument must be a React element, but you passed " +
                  e +
                  "."
              );
            var r = h({}, e.props),
              o = e.key;
            if (null != t)
              for (a in (void 0 !== t.ref && void 0,
              void 0 !== t.key && (o = "" + t.key),
              t))
                !k.call(t, a) ||
                  "key" === a ||
                  "__self" === a ||
                  "__source" === a ||
                  ("ref" === a && void 0 === t.ref) ||
                  (r[a] = t[a]);
            var a = arguments.length - 2;
            if (1 === a) r.children = n;
            else if (1 < a) {
              for (var l = Array(a), i = 0; i < a; i++) l[i] = arguments[i + 2];
              r.children = l;
            }
            return C(e.type, o, void 0, 0, 0, r);
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: s,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }).Provider = e),
              (e.Consumer = { $$typeof: i, _context: e }),
              e
            );
          }),
          (t.createElement = function (e, t, n) {
            var r,
              o = {},
              a = null;
            if (null != t)
              for (r in (void 0 !== t.key && (a = "" + t.key), t))
                k.call(t, r) &&
                  "key" !== r &&
                  "__self" !== r &&
                  "__source" !== r &&
                  (o[r] = t[r]);
            var l = arguments.length - 2;
            if (1 === l) o.children = n;
            else if (1 < l) {
              for (var i = Array(l), s = 0; s < l; s++) i[s] = arguments[s + 2];
              o.children = i;
            }
            if (e && e.defaultProps)
              for (r in (l = e.defaultProps)) void 0 === o[r] && (o[r] = l[r]);
            return C(e, a, void 0, 0, 0, o);
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: c, render: e };
          }),
          (t.isValidElement = E),
          (t.lazy = function (e) {
            return {
              $$typeof: f,
              _payload: { _status: -1, _result: e },
              _init: R,
            };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: d, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = S.T,
              n = {};
            S.T = n;
            try {
              var r = e(),
                o = S.S;
              null !== o && o(n, r),
                "object" === typeof r &&
                  null !== r &&
                  "function" === typeof r.then &&
                  r.then(O, _);
            } catch (a) {
              _(a);
            } finally {
              S.T = t;
            }
          }),
          (t.unstable_useCacheRefresh = function () {
            return S.H.useCacheRefresh();
          }),
          (t.use = function (e) {
            return S.H.use(e);
          }),
          (t.useActionState = function (e, t, n) {
            return S.H.useActionState(e, t, n);
          }),
          (t.useCallback = function (e, t) {
            return S.H.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return S.H.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e, t) {
            return S.H.useDeferredValue(e, t);
          }),
          (t.useEffect = function (e, t) {
            return S.H.useEffect(e, t);
          }),
          (t.useId = function () {
            return S.H.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return S.H.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return S.H.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return S.H.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return S.H.useMemo(e, t);
          }),
          (t.useOptimistic = function (e, t) {
            return S.H.useOptimistic(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return S.H.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return S.H.useRef(e);
          }),
          (t.useState = function (e) {
            return S.H.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return S.H.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return S.H.useTransition();
          }),
          (t.version = "19.0.0");
      },
      43: (e, t, n) => {
        e.exports = n(288);
      },
      579: (e, t, n) => {
        e.exports = n(799);
      },
      896: (e, t) => {
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n; ) {
            var r = (n - 1) >>> 1,
              o = e[r];
            if (!(0 < a(o, t))) break e;
            (e[r] = t), (e[n] = o), (n = r);
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function o(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, o = e.length, l = o >>> 1; r < l; ) {
              var i = 2 * (r + 1) - 1,
                s = e[i],
                c = i + 1,
                u = e[c];
              if (0 > a(s, n))
                c < o && 0 > a(u, s)
                  ? ((e[r] = u), (e[c] = n), (r = c))
                  : ((e[r] = s), (e[i] = n), (r = i));
              else {
                if (!(c < o && 0 > a(u, n))) break e;
                (e[r] = u), (e[c] = n), (r = c);
              }
            }
          }
          return t;
        }
        function a(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if (
          ((t.unstable_now = void 0),
          "object" === typeof performance &&
            "function" === typeof performance.now)
        ) {
          var l = performance;
          t.unstable_now = function () {
            return l.now();
          };
        } else {
          var i = Date,
            s = i.now();
          t.unstable_now = function () {
            return i.now() - s;
          };
        }
        var c = [],
          u = [],
          d = 1,
          f = null,
          p = 3,
          m = !1,
          h = !1,
          v = !1,
          y = "function" === typeof setTimeout ? setTimeout : null,
          g = "function" === typeof clearTimeout ? clearTimeout : null,
          b = "undefined" !== typeof setImmediate ? setImmediate : null;
        function w(e) {
          for (var t = r(u); null !== t; ) {
            if (null === t.callback) o(u);
            else {
              if (!(t.startTime <= e)) break;
              o(u), (t.sortIndex = t.expirationTime), n(c, t);
            }
            t = r(u);
          }
        }
        function x(e) {
          if (((v = !1), w(e), !h))
            if (null !== r(c)) (h = !0), R();
            else {
              var t = r(u);
              null !== t && _(x, t.startTime - e);
            }
        }
        var S,
          k = !1,
          C = -1,
          E = 5,
          N = -1;
        function P() {
          return !(t.unstable_now() - N < E);
        }
        function j() {
          if (k) {
            var e = t.unstable_now();
            N = e;
            var n = !0;
            try {
              e: {
                (h = !1), v && ((v = !1), g(C), (C = -1)), (m = !0);
                var a = p;
                try {
                  t: {
                    for (
                      w(e), f = r(c);
                      null !== f && !(f.expirationTime > e && P());

                    ) {
                      var l = f.callback;
                      if ("function" === typeof l) {
                        (f.callback = null), (p = f.priorityLevel);
                        var i = l(f.expirationTime <= e);
                        if (((e = t.unstable_now()), "function" === typeof i)) {
                          (f.callback = i), w(e), (n = !0);
                          break t;
                        }
                        f === r(c) && o(c), w(e);
                      } else o(c);
                      f = r(c);
                    }
                    if (null !== f) n = !0;
                    else {
                      var s = r(u);
                      null !== s && _(x, s.startTime - e), (n = !1);
                    }
                  }
                  break e;
                } finally {
                  (f = null), (p = a), (m = !1);
                }
                n = void 0;
              }
            } finally {
              n ? S() : (k = !1);
            }
          }
        }
        if ("function" === typeof b)
          S = function () {
            b(j);
          };
        else if ("undefined" !== typeof MessageChannel) {
          var z = new MessageChannel(),
            T = z.port2;
          (z.port1.onmessage = j),
            (S = function () {
              T.postMessage(null);
            });
        } else
          S = function () {
            y(j, 0);
          };
        function R() {
          k || ((k = !0), S());
        }
        function _(e, n) {
          C = y(function () {
            e(t.unstable_now());
          }, n);
        }
        (t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_continueExecution = function () {
            h || m || ((h = !0), R());
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                )
              : (E = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return p;
          }),
          (t.unstable_getFirstCallbackNode = function () {
            return r(c);
          }),
          (t.unstable_next = function (e) {
            switch (p) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = p;
            }
            var n = p;
            p = t;
            try {
              return e();
            } finally {
              p = n;
            }
          }),
          (t.unstable_pauseExecution = function () {}),
          (t.unstable_requestPaint = function () {}),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = p;
            p = e;
            try {
              return t();
            } finally {
              p = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, o, a) {
            var l = t.unstable_now();
            switch (
              ("object" === typeof a && null !== a
                ? (a = "number" === typeof (a = a.delay) && 0 < a ? l + a : l)
                : (a = l),
              e)
            ) {
              case 1:
                var i = -1;
                break;
              case 2:
                i = 250;
                break;
              case 5:
                i = 1073741823;
                break;
              case 4:
                i = 1e4;
                break;
              default:
                i = 5e3;
            }
            return (
              (e = {
                id: d++,
                callback: o,
                priorityLevel: e,
                startTime: a,
                expirationTime: (i = a + i),
                sortIndex: -1,
              }),
              a > l
                ? ((e.sortIndex = a),
                  n(u, e),
                  null === r(c) &&
                    e === r(u) &&
                    (v ? (g(C), (C = -1)) : (v = !0), _(x, a - l)))
                : ((e.sortIndex = i), n(c, e), h || m || ((h = !0), R())),
              e
            );
          }),
          (t.unstable_shouldYield = P),
          (t.unstable_wrapCallback = function (e) {
            var t = p;
            return function () {
              var n = p;
              p = t;
              try {
                return e.apply(this, arguments);
              } finally {
                p = n;
              }
            };
          });
      },
      853: (e, t, n) => {
        e.exports = n(896);
      },
    },
    t = {};
  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var a = (t[r] = { exports: {} });
    return e[r](a, a.exports, n), a.exports;
  }
  (() => {
    var e,
      t = Object.getPrototypeOf
        ? (e) => Object.getPrototypeOf(e)
        : (e) => e.__proto__;
    n.t = function (r, o) {
      if ((1 & o && (r = this(r)), 8 & o)) return r;
      if ("object" === typeof r && r) {
        if (4 & o && r.__esModule) return r;
        if (16 & o && "function" === typeof r.then) return r;
      }
      var a = Object.create(null);
      n.r(a);
      var l = {};
      e = e || [null, t({}), t([]), t(t)];
      for (var i = 2 & o && r; "object" == typeof i && !~e.indexOf(i); i = t(i))
        Object.getOwnPropertyNames(i).forEach((e) => (l[e] = () => r[e]));
      return (l.default = () => r), n.d(a, l), a;
    };
  })(),
    (n.d = (e, t) => {
      for (var r in t)
        n.o(t, r) &&
          !n.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (n.r = (e) => {
      "undefined" !== typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (n.nc = void 0);
  var r = n(43),
    o = n.t(r, 2),
    a = n(391);
  function l(e, t) {
    if (null == e) return {};
    var n = {};
    for (var r in e)
      if ({}.hasOwnProperty.call(e, r)) {
        if (t.includes(r)) continue;
        n[r] = e[r];
      }
    return n;
  }
  function i(e, t) {
    if (null == e) return {};
    var n,
      r,
      o = l(e, t);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (r = 0; r < a.length; r++)
        (n = a[r]),
          t.includes(n) ||
            ({}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]));
    }
    return o;
  }
  function s(e) {
    return (
      (s =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (e) {
              return typeof e;
            }
          : function (e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            }),
      s(e)
    );
  }
  function c(e) {
    var t = (function (e, t) {
      if ("object" != s(e) || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" != s(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    })(e, "string");
    return "symbol" == s(t) ? t : t + "";
  }
  function u(e, t, n) {
    return (
      (t = c(t)) in e
        ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (e[t] = n),
      e
    );
  }
  function d(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t &&
        (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })),
        n.push.apply(n, r);
    }
    return n;
  }
  function f(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2
        ? d(Object(n), !0).forEach(function (t) {
            u(e, t, n[t]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : d(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
    }
    return e;
  }
  n(175);
  const p = ["page"],
    m = ["page", "matches"],
    h = [
      "onClick",
      "discover",
      "prefetch",
      "relative",
      "reloadDocument",
      "replace",
      "state",
      "target",
      "to",
      "preventScrollReset",
      "viewTransition",
    ],
    v = [
      "aria-current",
      "caseSensitive",
      "className",
      "end",
      "style",
      "to",
      "viewTransition",
      "children",
    ],
    y = [
      "discover",
      "fetcherKey",
      "navigate",
      "reloadDocument",
      "replace",
      "state",
      "method",
      "action",
      "onSubmit",
      "relative",
      "preventScrollReset",
      "viewTransition",
    ];
  var g = "popstate";
  function b() {
    return N(
      function (e, t) {
        let { pathname: n, search: r, hash: o } = e.location;
        return k(
          "",
          { pathname: n, search: r, hash: o },
          (t.state && t.state.usr) || null,
          (t.state && t.state.key) || "default"
        );
      },
      function (e, t) {
        return "string" === typeof t ? t : C(t);
      },
      null,
      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
    );
  }
  function w(e, t) {
    if (!1 === e || null === e || "undefined" === typeof e) throw new Error(t);
  }
  function x(e, t) {
    if (!e) {
      "undefined" !== typeof console && console.warn(t);
      try {
        throw new Error(t);
      } catch (n) {}
    }
  }
  function S(e, t) {
    return { usr: e.state, key: e.key, idx: t };
  }
  function k(e, t) {
    let n =
        arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
      r = arguments.length > 3 ? arguments[3] : void 0;
    return f(
      f(
        {
          pathname: "string" === typeof e ? e : e.pathname,
          search: "",
          hash: "",
        },
        "string" === typeof t ? E(t) : t
      ),
      {},
      {
        state: n,
        key: (t && t.key) || r || Math.random().toString(36).substring(2, 10),
      }
    );
  }
  function C(e) {
    let { pathname: t = "/", search: n = "", hash: r = "" } = e;
    return (
      n && "?" !== n && (t += "?" === n.charAt(0) ? n : "?" + n),
      r && "#" !== r && (t += "#" === r.charAt(0) ? r : "#" + r),
      t
    );
  }
  function E(e) {
    let t = {};
    if (e) {
      let n = e.indexOf("#");
      n >= 0 && ((t.hash = e.substring(n)), (e = e.substring(0, n)));
      let r = e.indexOf("?");
      r >= 0 && ((t.search = e.substring(r)), (e = e.substring(0, r))),
        e && (t.pathname = e);
    }
    return t;
  }
  function N(e, t, n) {
    let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
      { window: o = document.defaultView, v5Compat: a = !1 } = r,
      l = o.history,
      i = "POP",
      s = null,
      c = u();
    function u() {
      return (l.state || { idx: null }).idx;
    }
    function d() {
      i = "POP";
      let e = u(),
        t = null == e ? null : e - c;
      (c = e), s && s({ action: i, location: m.location, delta: t });
    }
    function p(e) {
      let t =
          "null" !== o.location.origin ? o.location.origin : o.location.href,
        n = "string" === typeof e ? e : C(e);
      return (
        (n = n.replace(/ $/, "%20")),
        w(
          t,
          "No window.location.(origin|href) available to create URL for href: ".concat(
            n
          )
        ),
        new URL(n, t)
      );
    }
    null == c &&
      ((c = 0), l.replaceState(f(f({}, l.state), {}, { idx: c }), ""));
    let m = {
      get action() {
        return i;
      },
      get location() {
        return e(o, l);
      },
      listen(e) {
        if (s) throw new Error("A history only accepts one active listener");
        return (
          o.addEventListener(g, d),
          (s = e),
          () => {
            o.removeEventListener(g, d), (s = null);
          }
        );
      },
      createHref: (e) => t(o, e),
      createURL: p,
      encodeLocation(e) {
        let t = p(e);
        return { pathname: t.pathname, search: t.search, hash: t.hash };
      },
      push: function (e, t) {
        i = "PUSH";
        let r = k(m.location, e, t);
        n && n(r, e), (c = u() + 1);
        let d = S(r, c),
          f = m.createHref(r);
        try {
          l.pushState(d, "", f);
        } catch (p) {
          if (p instanceof DOMException && "DataCloneError" === p.name) throw p;
          o.location.assign(f);
        }
        a && s && s({ action: i, location: m.location, delta: 1 });
      },
      replace: function (e, t) {
        i = "REPLACE";
        let r = k(m.location, e, t);
        n && n(r, e), (c = u());
        let o = S(r, c),
          d = m.createHref(r);
        l.replaceState(o, "", d),
          a && s && s({ action: i, location: m.location, delta: 0 });
      },
      go: (e) => l.go(e),
    };
    return m;
  }
  function P(e, t) {
    return j(
      e,
      t,
      arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "/",
      !1
    );
  }
  function j(e, t, n, r) {
    let o = H(("string" === typeof t ? E(t) : t).pathname || "/", n);
    if (null == o) return null;
    let a = z(e);
    !(function (e) {
      e.sort((e, t) =>
        e.score !== t.score
          ? t.score - e.score
          : (function (e, t) {
              let n =
                e.length === t.length &&
                e.slice(0, -1).every((e, n) => e === t[n]);
              return n ? e[e.length - 1] - t[t.length - 1] : 0;
            })(
              e.routesMeta.map((e) => e.childrenIndex),
              t.routesMeta.map((e) => e.childrenIndex)
            )
      );
    })(a);
    let l = null;
    for (let i = 0; null == l && i < a.length; ++i) {
      let e = W(o);
      l = I(a[i], e, r);
    }
    return l;
  }
  function z(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "",
      o = (e, o, a) => {
        let l = {
          relativePath: void 0 === a ? e.path || "" : a,
          caseSensitive: !0 === e.caseSensitive,
          childrenIndex: o,
          route: e,
        };
        l.relativePath.startsWith("/") &&
          (w(
            l.relativePath.startsWith(r),
            'Absolute route path "'
              .concat(l.relativePath, '" nested under path "')
              .concat(
                r,
                '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'
              )
          ),
          (l.relativePath = l.relativePath.slice(r.length)));
        let i = Y([r, l.relativePath]),
          s = n.concat(l);
        e.children &&
          e.children.length > 0 &&
          (w(
            !0 !== e.index,
            'Index routes must not have child routes. Please remove all child routes from route path "'.concat(
              i,
              '".'
            )
          ),
          z(e.children, t, s, i)),
          (null != e.path || e.index) &&
            t.push({ path: i, score: M(i, e.index), routesMeta: s });
      };
    return (
      e.forEach((e, t) => {
        var n;
        if (
          "" !== e.path &&
          null !== (n = e.path) &&
          void 0 !== n &&
          n.includes("?")
        )
          for (let r of T(e.path)) o(e, t, r);
        else o(e, t);
      }),
      t
    );
  }
  function T(e) {
    let t = e.split("/");
    if (0 === t.length) return [];
    let [n, ...r] = t,
      o = n.endsWith("?"),
      a = n.replace(/\?$/, "");
    if (0 === r.length) return o ? [a, ""] : [a];
    let l = T(r.join("/")),
      i = [];
    return (
      i.push(...l.map((e) => ("" === e ? a : [a, e].join("/")))),
      o && i.push(...l),
      i.map((t) => (e.startsWith("/") && "" === t ? "/" : t))
    );
  }
  var R = /^:[\w-]+$/,
    _ = 3,
    O = 2,
    A = 1,
    L = 10,
    D = -2,
    F = (e) => "*" === e;
  function M(e, t) {
    let n = e.split("/"),
      r = n.length;
    return (
      n.some(F) && (r += D),
      t && (r += O),
      n
        .filter((e) => !F(e))
        .reduce((e, t) => e + (R.test(t) ? _ : "" === t ? A : L), r)
    );
  }
  function I(e, t) {
    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      { routesMeta: r } = e,
      o = {},
      a = "/",
      l = [];
    for (let i = 0; i < r.length; ++i) {
      let e = r[i],
        s = i === r.length - 1,
        c = "/" === a ? t : t.slice(a.length) || "/",
        u = V(
          { path: e.relativePath, caseSensitive: e.caseSensitive, end: s },
          c
        ),
        d = e.route;
      if (
        (!u &&
          s &&
          n &&
          !r[r.length - 1].route.index &&
          (u = V(
            { path: e.relativePath, caseSensitive: e.caseSensitive, end: !1 },
            c
          )),
        !u)
      )
        return null;
      Object.assign(o, u.params),
        l.push({
          params: o,
          pathname: Y([a, u.pathname]),
          pathnameBase: K(Y([a, u.pathnameBase])),
          route: d,
        }),
        "/" !== u.pathnameBase && (a = Y([a, u.pathnameBase]));
    }
    return l;
  }
  function V(e, t) {
    "string" === typeof e && (e = { path: e, caseSensitive: !1, end: !0 });
    let [n, r] = (function (e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n =
            !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
        x(
          "*" === e || !e.endsWith("*") || e.endsWith("/*"),
          'Route path "'
            .concat(e, '" will be treated as if it were "')
            .concat(
              e.replace(/\*$/, "/*"),
              '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "'
            )
            .concat(e.replace(/\*$/, "/*"), '".')
        );
        let r = [],
          o =
            "^" +
            e
              .replace(/\/*\*?$/, "")
              .replace(/^\/*/, "/")
              .replace(/[\\.*+^${}|()[\]]/g, "\\$&")
              .replace(
                /\/:([\w-]+)(\?)?/g,
                (e, t, n) => (
                  r.push({ paramName: t, isOptional: null != n }),
                  n ? "/?([^\\/]+)?" : "/([^\\/]+)"
                )
              );
        e.endsWith("*")
          ? (r.push({ paramName: "*" }),
            (o += "*" === e || "/*" === e ? "(.*)$" : "(?:\\/(.+)|\\/*)$"))
          : n
          ? (o += "\\/*$")
          : "" !== e && "/" !== e && (o += "(?:(?=\\/|$))");
        let a = new RegExp(o, t ? void 0 : "i");
        return [a, r];
      })(e.path, e.caseSensitive, e.end),
      o = t.match(n);
    if (!o) return null;
    let a = o[0],
      l = a.replace(/(.)\/+$/, "$1"),
      i = o.slice(1),
      s = r.reduce((e, t, n) => {
        let { paramName: r, isOptional: o } = t;
        if ("*" === r) {
          let e = i[n] || "";
          l = a.slice(0, a.length - e.length).replace(/(.)\/+$/, "$1");
        }
        const s = i[n];
        return (e[r] = o && !s ? void 0 : (s || "").replace(/%2F/g, "/")), e;
      }, {});
    return { params: s, pathname: a, pathnameBase: l, pattern: e };
  }
  function W(e) {
    try {
      return e
        .split("/")
        .map((e) => decodeURIComponent(e).replace(/\//g, "%2F"))
        .join("/");
    } catch (t) {
      return (
        x(
          !1,
          'The URL path "'
            .concat(
              e,
              '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent encoding ('
            )
            .concat(t, ").")
        ),
        e
      );
    }
  }
  function H(e, t) {
    if ("/" === t) return e;
    if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
    let n = t.endsWith("/") ? t.length - 1 : t.length,
      r = e.charAt(n);
    return r && "/" !== r ? null : e.slice(n) || "/";
  }
  function B(e, t, n, r) {
    return "Cannot include a '"
      .concat(e, "' character in a manually specified `to.")
      .concat(t, "` field [")
      .concat(JSON.stringify(r), "].  Please separate it out to the `to.")
      .concat(
        n,
        '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.'
      );
  }
  function U(e) {
    return e.filter(
      (e, t) => 0 === t || (e.route.path && e.route.path.length > 0)
    );
  }
  function $(e) {
    let t = U(e);
    return t.map((e, n) => (n === t.length - 1 ? e.pathname : e.pathnameBase));
  }
  function q(e, t, n) {
    let r,
      o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    "string" === typeof e
      ? (r = E(e))
      : ((r = f({}, e)),
        w(
          !r.pathname || !r.pathname.includes("?"),
          B("?", "pathname", "search", r)
        ),
        w(
          !r.pathname || !r.pathname.includes("#"),
          B("#", "pathname", "hash", r)
        ),
        w(!r.search || !r.search.includes("#"), B("#", "search", "hash", r)));
    let a,
      l = "" === e || "" === r.pathname,
      i = l ? "/" : r.pathname;
    if (null == i) a = n;
    else {
      let e = t.length - 1;
      if (!o && i.startsWith("..")) {
        let t = i.split("/");
        for (; ".." === t[0]; ) t.shift(), (e -= 1);
        r.pathname = t.join("/");
      }
      a = e >= 0 ? t[e] : "/";
    }
    let s = (function (e) {
        let t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "/",
          {
            pathname: n,
            search: r = "",
            hash: o = "",
          } = "string" === typeof e ? E(e) : e,
          a = n
            ? n.startsWith("/")
              ? n
              : (function (e, t) {
                  let n = t.replace(/\/+$/, "").split("/");
                  return (
                    e.split("/").forEach((e) => {
                      ".." === e
                        ? n.length > 1 && n.pop()
                        : "." !== e && n.push(e);
                    }),
                    n.length > 1 ? n.join("/") : "/"
                  );
                })(n, t)
            : t;
        return { pathname: a, search: Q(r), hash: X(o) };
      })(r, a),
      c = i && "/" !== i && i.endsWith("/"),
      u = (l || "." === i) && n.endsWith("/");
    return s.pathname.endsWith("/") || (!c && !u) || (s.pathname += "/"), s;
  }
  var Y = (e) => e.join("/").replace(/\/\/+/g, "/"),
    K = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"),
    Q = (e) => (e && "?" !== e ? (e.startsWith("?") ? e : "?" + e) : ""),
    X = (e) => (e && "#" !== e ? (e.startsWith("#") ? e : "#" + e) : "");
  function G(e) {
    return (
      null != e &&
      "number" === typeof e.status &&
      "string" === typeof e.statusText &&
      "boolean" === typeof e.internal &&
      "data" in e
    );
  }
  var J = ["POST", "PUT", "PATCH", "DELETE"],
    Z = (new Set(J), ["GET", ...J]);
  new Set(Z), Symbol("ResetLoaderData");
  var ee = r.createContext(null);
  ee.displayName = "DataRouter";
  var te = r.createContext(null);
  te.displayName = "DataRouterState";
  var ne = r.createContext({ isTransitioning: !1 });
  ne.displayName = "ViewTransition";
  var re = r.createContext(new Map());
  re.displayName = "Fetchers";
  var oe = r.createContext(null);
  oe.displayName = "Await";
  var ae = r.createContext(null);
  ae.displayName = "Navigation";
  var le = r.createContext(null);
  le.displayName = "Location";
  var ie = r.createContext({ outlet: null, matches: [], isDataRoute: !1 });
  ie.displayName = "Route";
  var se = r.createContext(null);
  se.displayName = "RouteError";
  function ce() {
    return null != r.useContext(le);
  }
  function ue() {
    return (
      w(
        ce(),
        "useLocation() may be used only in the context of a <Router> component."
      ),
      r.useContext(le).location
    );
  }
  var de =
    "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
  function fe(e) {
    r.useContext(ae).static || r.useLayoutEffect(e);
  }
  function pe() {
    let { isDataRoute: e } = r.useContext(ie);
    return e
      ? (function () {
          let { router: e } = Se("useNavigate"),
            t = Ce("useNavigate"),
            n = r.useRef(!1);
          fe(() => {
            n.current = !0;
          });
          let o = r.useCallback(
            async function (r) {
              let o =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              x(n.current, de),
                n.current &&
                  ("number" === typeof r
                    ? e.navigate(r)
                    : await e.navigate(r, f({ fromRouteId: t }, o)));
            },
            [e, t]
          );
          return o;
        })()
      : (function () {
          w(
            ce(),
            "useNavigate() may be used only in the context of a <Router> component."
          );
          let e = r.useContext(ee),
            { basename: t, navigator: n } = r.useContext(ae),
            { matches: o } = r.useContext(ie),
            { pathname: a } = ue(),
            l = JSON.stringify($(o)),
            i = r.useRef(!1);
          fe(() => {
            i.current = !0;
          });
          let s = r.useCallback(
            function (r) {
              let o =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              if ((x(i.current, de), !i.current)) return;
              if ("number" === typeof r) return void n.go(r);
              let s = q(r, JSON.parse(l), a, "path" === o.relative);
              null == e &&
                "/" !== t &&
                (s.pathname = "/" === s.pathname ? t : Y([t, s.pathname])),
                (o.replace ? n.replace : n.push)(s, o.state, o);
            },
            [t, n, l, a, e]
          );
          return s;
        })();
  }
  r.createContext(null);
  function me(e) {
    let { relative: t } =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      { matches: n } = r.useContext(ie),
      { pathname: o } = ue(),
      a = JSON.stringify($(n));
    return r.useMemo(() => q(e, JSON.parse(a), o, "path" === t), [e, a, o, t]);
  }
  function he(e, t, n, o) {
    w(
      ce(),
      "useRoutes() may be used only in the context of a <Router> component."
    );
    let { navigator: a } = r.useContext(ae),
      { matches: l } = r.useContext(ie),
      i = l[l.length - 1],
      s = i ? i.params : {},
      c = i ? i.pathname : "/",
      u = i ? i.pathnameBase : "/",
      d = i && i.route;
    {
      let e = (d && d.path) || "";
      Pe(
        c,
        !d || e.endsWith("*") || e.endsWith("*?"),
        'You rendered descendant <Routes> (or called `useRoutes()`) at "'
          .concat(c, '" (under <Route path="')
          .concat(
            e,
            '">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won\'t match anymore and therefore the child routes will never render.\n\nPlease change the parent <Route path="'
          )
          .concat(e, '"> to <Route path="')
          .concat("/" === e ? "*" : "".concat(e, "/*"), '">.')
      );
    }
    let p,
      m = ue();
    if (t) {
      var h;
      let e = "string" === typeof t ? E(t) : t;
      w(
        "/" === u ||
          (null === (h = e.pathname) || void 0 === h
            ? void 0
            : h.startsWith(u)),
        'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'
          .concat(u, '" but pathname "')
          .concat(e.pathname, '" was given in the `location` prop.')
      ),
        (p = e);
    } else p = m;
    let v = p.pathname || "/",
      y = v;
    if ("/" !== u) {
      let e = u.replace(/^\//, "").split("/");
      y = "/" + v.replace(/^\//, "").split("/").slice(e.length).join("/");
    }
    let g = P(e, { pathname: y });
    x(
      d || null != g,
      'No routes matched location "'
        .concat(p.pathname)
        .concat(p.search)
        .concat(p.hash, '" ')
    ),
      x(
        null == g ||
          void 0 !== g[g.length - 1].route.element ||
          void 0 !== g[g.length - 1].route.Component ||
          void 0 !== g[g.length - 1].route.lazy,
        'Matched leaf route at location "'
          .concat(p.pathname)
          .concat(p.search)
          .concat(
            p.hash,
            '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'
          )
      );
    let b = we(
      g &&
        g.map((e) =>
          Object.assign({}, e, {
            params: Object.assign({}, s, e.params),
            pathname: Y([
              u,
              a.encodeLocation
                ? a.encodeLocation(e.pathname).pathname
                : e.pathname,
            ]),
            pathnameBase:
              "/" === e.pathnameBase
                ? u
                : Y([
                    u,
                    a.encodeLocation
                      ? a.encodeLocation(e.pathnameBase).pathname
                      : e.pathnameBase,
                  ]),
          })
        ),
      l,
      n,
      o
    );
    return t && b
      ? r.createElement(
          le.Provider,
          {
            value: {
              location: f(
                {
                  pathname: "/",
                  search: "",
                  hash: "",
                  state: null,
                  key: "default",
                },
                p
              ),
              navigationType: "POP",
            },
          },
          b
        )
      : b;
  }
  function ve() {
    let e = Ee(),
      t = G(e)
        ? "".concat(e.status, " ").concat(e.statusText)
        : e instanceof Error
        ? e.message
        : JSON.stringify(e),
      n = e instanceof Error ? e.stack : null,
      o = "rgba(200,200,200, 0.5)",
      a = { padding: "0.5rem", backgroundColor: o },
      l = { padding: "2px 4px", backgroundColor: o },
      i = null;
    return (
      console.error("Error handled by React Router default ErrorBoundary:", e),
      (i = r.createElement(
        r.Fragment,
        null,
        r.createElement("p", null, "\ud83d\udcbf Hey developer \ud83d\udc4b"),
        r.createElement(
          "p",
          null,
          "You can provide a way better UX than this when your app throws errors by providing your own ",
          r.createElement("code", { style: l }, "ErrorBoundary"),
          " or",
          " ",
          r.createElement("code", { style: l }, "errorElement"),
          " prop on your route."
        )
      )),
      r.createElement(
        r.Fragment,
        null,
        r.createElement("h2", null, "Unexpected Application Error!"),
        r.createElement("h3", { style: { fontStyle: "italic" } }, t),
        n ? r.createElement("pre", { style: a }, n) : null,
        i
      )
    );
  }
  var ye = r.createElement(ve, null),
    ge = class extends r.Component {
      constructor(e) {
        super(e),
          (this.state = {
            location: e.location,
            revalidation: e.revalidation,
            error: e.error,
          });
      }
      static getDerivedStateFromError(e) {
        return { error: e };
      }
      static getDerivedStateFromProps(e, t) {
        return t.location !== e.location ||
          ("idle" !== t.revalidation && "idle" === e.revalidation)
          ? {
              error: e.error,
              location: e.location,
              revalidation: e.revalidation,
            }
          : {
              error: void 0 !== e.error ? e.error : t.error,
              location: t.location,
              revalidation: e.revalidation || t.revalidation,
            };
      }
      componentDidCatch(e, t) {
        console.error(
          "React Router caught the following error during render",
          e,
          t
        );
      }
      render() {
        return void 0 !== this.state.error
          ? r.createElement(
              ie.Provider,
              { value: this.props.routeContext },
              r.createElement(se.Provider, {
                value: this.state.error,
                children: this.props.component,
              })
            )
          : this.props.children;
      }
    };
  function be(e) {
    let { routeContext: t, match: n, children: o } = e,
      a = r.useContext(ee);
    return (
      a &&
        a.static &&
        a.staticContext &&
        (n.route.errorElement || n.route.ErrorBoundary) &&
        (a.staticContext._deepestRenderedBoundaryId = n.route.id),
      r.createElement(ie.Provider, { value: t }, o)
    );
  }
  function we(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
    if (null == e) {
      if (!n) return null;
      if (n.errors) e = n.matches;
      else {
        if (0 !== t.length || n.initialized || !(n.matches.length > 0))
          return null;
        e = n.matches;
      }
    }
    let o = e,
      a = null === n || void 0 === n ? void 0 : n.errors;
    if (null != a) {
      let e = o.findIndex(
        (e) =>
          e.route.id &&
          void 0 !== (null === a || void 0 === a ? void 0 : a[e.route.id])
      );
      w(
        e >= 0,
        "Could not find a matching route for errors on route IDs: ".concat(
          Object.keys(a).join(",")
        )
      ),
        (o = o.slice(0, Math.min(o.length, e + 1)));
    }
    let l = !1,
      i = -1;
    if (n)
      for (let r = 0; r < o.length; r++) {
        let e = o[r];
        if (
          ((e.route.HydrateFallback || e.route.hydrateFallbackElement) &&
            (i = r),
          e.route.id)
        ) {
          let { loaderData: t, errors: r } = n,
            a =
              e.route.loader &&
              !t.hasOwnProperty(e.route.id) &&
              (!r || void 0 === r[e.route.id]);
          if (e.route.lazy || a) {
            (l = !0), (o = i >= 0 ? o.slice(0, i + 1) : [o[0]]);
            break;
          }
        }
      }
    return o.reduceRight((e, s, c) => {
      let u,
        d = !1,
        f = null,
        p = null;
      n &&
        ((u = a && s.route.id ? a[s.route.id] : void 0),
        (f = s.route.errorElement || ye),
        l &&
          (i < 0 && 0 === c
            ? (Pe(
                "route-fallback",
                !1,
                "No `HydrateFallback` element provided to render during initial hydration"
              ),
              (d = !0),
              (p = null))
            : i === c &&
              ((d = !0), (p = s.route.hydrateFallbackElement || null))));
      let m = t.concat(o.slice(0, c + 1)),
        h = () => {
          let t;
          return (
            (t = u
              ? f
              : d
              ? p
              : s.route.Component
              ? r.createElement(s.route.Component, null)
              : s.route.element
              ? s.route.element
              : e),
            r.createElement(be, {
              match: s,
              routeContext: { outlet: e, matches: m, isDataRoute: null != n },
              children: t,
            })
          );
        };
      return n && (s.route.ErrorBoundary || s.route.errorElement || 0 === c)
        ? r.createElement(ge, {
            location: n.location,
            revalidation: n.revalidation,
            component: f,
            error: u,
            children: h(),
            routeContext: { outlet: null, matches: m, isDataRoute: !0 },
          })
        : h();
    }, null);
  }
  function xe(e) {
    return "".concat(
      e,
      " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router."
    );
  }
  function Se(e) {
    let t = r.useContext(ee);
    return w(t, xe(e)), t;
  }
  function ke(e) {
    let t = r.useContext(te);
    return w(t, xe(e)), t;
  }
  function Ce(e) {
    let t = (function (e) {
        let t = r.useContext(ie);
        return w(t, xe(e)), t;
      })(e),
      n = t.matches[t.matches.length - 1];
    return (
      w(
        n.route.id,
        "".concat(e, ' can only be used on routes that contain a unique "id"')
      ),
      n.route.id
    );
  }
  function Ee() {
    var e;
    let t = r.useContext(se),
      n = ke("useRouteError"),
      o = Ce("useRouteError");
    return void 0 !== t
      ? t
      : null === (e = n.errors) || void 0 === e
      ? void 0
      : e[o];
  }
  var Ne = {};
  function Pe(e, t, n) {
    t || Ne[e] || ((Ne[e] = !0), x(!1, n));
  }
  r.memo(function (e) {
    let { routes: t, future: n, state: r } = e;
    return he(t, void 0, r, n);
  });
  function je(e) {
    let {
      basename: t = "/",
      children: n = null,
      location: o,
      navigationType: a = "POP",
      navigator: l,
      static: i = !1,
    } = e;
    w(
      !ce(),
      "You cannot render a <Router> inside another <Router>. You should never have more than one in your app."
    );
    let s = t.replace(/^\/*/, "/"),
      c = r.useMemo(
        () => ({ basename: s, navigator: l, static: i, future: {} }),
        [s, l, i]
      );
    "string" === typeof o && (o = E(o));
    let {
        pathname: u = "/",
        search: d = "",
        hash: f = "",
        state: p = null,
        key: m = "default",
      } = o,
      h = r.useMemo(() => {
        let e = H(u, s);
        return null == e
          ? null
          : {
              location: { pathname: e, search: d, hash: f, state: p, key: m },
              navigationType: a,
            };
      }, [s, u, d, f, p, m, a]);
    return (
      x(
        null != h,
        '<Router basename="'
          .concat(s, '"> is not able to match the URL "')
          .concat(u)
          .concat(d)
          .concat(
            f,
            "\" because it does not start with the basename, so the <Router> won't render anything."
          )
      ),
      null == h
        ? null
        : r.createElement(
            ae.Provider,
            { value: c },
            r.createElement(le.Provider, { children: n, value: h })
          )
    );
  }
  r.Component;
  var ze = "get",
    Te = "application/x-www-form-urlencoded";
  function Re(e) {
    return null != e && "string" === typeof e.tagName;
  }
  var _e = null;
  var Oe = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain",
  ]);
  function Ae(e) {
    return null == e || Oe.has(e)
      ? e
      : (x(
          !1,
          '"'
            .concat(
              e,
              '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "'
            )
            .concat(Te, '"')
        ),
        null);
  }
  function Le(e, t) {
    let n, r, o, a, l;
    if (Re((i = e)) && "form" === i.tagName.toLowerCase()) {
      let l = e.getAttribute("action");
      (r = l ? H(l, t) : null),
        (n = e.getAttribute("method") || ze),
        (o = Ae(e.getAttribute("enctype")) || Te),
        (a = new FormData(e));
    } else if (
      (function (e) {
        return Re(e) && "button" === e.tagName.toLowerCase();
      })(e) ||
      ((function (e) {
        return Re(e) && "input" === e.tagName.toLowerCase();
      })(e) &&
        ("submit" === e.type || "image" === e.type))
    ) {
      let l = e.form;
      if (null == l)
        throw new Error(
          'Cannot submit a <button> or <input type="submit"> without a <form>'
        );
      let i = e.getAttribute("formaction") || l.getAttribute("action");
      if (
        ((r = i ? H(i, t) : null),
        (n = e.getAttribute("formmethod") || l.getAttribute("method") || ze),
        (o =
          Ae(e.getAttribute("formenctype")) ||
          Ae(l.getAttribute("enctype")) ||
          Te),
        (a = new FormData(l, e)),
        !(function () {
          if (null === _e)
            try {
              new FormData(document.createElement("form"), 0), (_e = !1);
            } catch (e) {
              _e = !0;
            }
          return _e;
        })())
      ) {
        let { name: t, type: n, value: r } = e;
        if ("image" === n) {
          let e = t ? "".concat(t, ".") : "";
          a.append("".concat(e, "x"), "0"), a.append("".concat(e, "y"), "0");
        } else t && a.append(t, r);
      }
    } else {
      if (Re(e))
        throw new Error(
          'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
        );
      (n = ze), (r = null), (o = Te), (l = e);
    }
    var i;
    return (
      a && "text/plain" === o && ((l = a), (a = void 0)),
      { action: r, method: n.toLowerCase(), encType: o, formData: a, body: l }
    );
  }
  function De(e, t) {
    if (!1 === e || null === e || "undefined" === typeof e) throw new Error(t);
  }
  async function Fe(e, t) {
    if (e.id in t) return t[e.id];
    try {
      let n = await import(e.module);
      return (t[e.id] = n), n;
    } catch (n) {
      return (
        console.error(
          "Error loading route module `".concat(
            e.module,
            "`, reloading page..."
          )
        ),
        console.error(n),
        window.__reactRouterContext && window.__reactRouterContext.isSpaMode,
        window.location.reload(),
        new Promise(() => {})
      );
    }
  }
  function Me(e) {
    return null != e && "string" === typeof e.page;
  }
  function Ie(e) {
    return (
      null != e &&
      (null == e.href
        ? "preload" === e.rel &&
          "string" === typeof e.imageSrcSet &&
          "string" === typeof e.imageSizes
        : "string" === typeof e.rel && "string" === typeof e.href)
    );
  }
  function Ve(e, t, n, r, o, a) {
    let l = (e, t) => !n[t] || e.route.id !== n[t].route.id,
      i = (e, t) => {
        var r;
        return (
          n[t].pathname !== e.pathname ||
          ((null === (r = n[t].route.path) || void 0 === r
            ? void 0
            : r.endsWith("*")) &&
            n[t].params["*"] !== e.params["*"])
        );
      };
    return "assets" === a
      ? t.filter((e, t) => l(e, t) || i(e, t))
      : "data" === a
      ? t.filter((t, a) => {
          let s = r.routes[t.route.id];
          if (!s || !s.hasLoader) return !1;
          if (l(t, a) || i(t, a)) return !0;
          if (t.route.shouldRevalidate) {
            var c;
            let r = t.route.shouldRevalidate({
              currentUrl: new URL(
                o.pathname + o.search + o.hash,
                window.origin
              ),
              currentParams:
                (null === (c = n[0]) || void 0 === c ? void 0 : c.params) || {},
              nextUrl: new URL(e, window.origin),
              nextParams: t.params,
              defaultShouldRevalidate: !0,
            });
            if ("boolean" === typeof r) return r;
          }
          return !0;
        })
      : [];
  }
  function We(e) {
    return [...new Set(e)];
  }
  function He(e, t) {
    let n = new Set(),
      r = new Set(t);
    return e.reduce((e, o) => {
      if (t && !Me(o) && "script" === o.as && o.href && r.has(o.href)) return e;
      let a = JSON.stringify(
        (function (e) {
          let t = {},
            n = Object.keys(e).sort();
          for (let r of n) t[r] = e[r];
          return t;
        })(o)
      );
      return n.has(a) || (n.add(a), e.push({ key: a, link: o })), e;
    }, []);
  }
  function Be(e) {
    return { __html: e };
  }
  Symbol("SingleFetchRedirect");
  function Ue(e) {
    let t =
      "string" === typeof e
        ? new URL(
            e,
            "undefined" === typeof window
              ? "server://singlefetch/"
              : window.location.origin
          )
        : e;
    return (
      "/" === t.pathname
        ? (t.pathname = "_root.data")
        : (t.pathname = "".concat(t.pathname.replace(/\/$/, ""), ".data")),
      t
    );
  }
  r.Component;
  function $e(e) {
    let { error: t, isOutsideRemixApp: n } = e;
    console.error(t);
    let o,
      a = r.createElement("script", {
        dangerouslySetInnerHTML: {
          __html:
            '\n        console.log(\n          "\ud83d\udcbf Hey developer \ud83d\udc4b. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."\n        );\n      ',
        },
      });
    if (G(t))
      return r.createElement(
        qe,
        { title: "Unhandled Thrown Response!" },
        r.createElement(
          "h1",
          { style: { fontSize: "24px" } },
          t.status,
          " ",
          t.statusText
        ),
        a
      );
    if (t instanceof Error) o = t;
    else {
      let e =
        null == t
          ? "Unknown Error"
          : "object" === typeof t && "toString" in t
          ? t.toString()
          : JSON.stringify(t);
      o = new Error(e);
    }
    return r.createElement(
      qe,
      { title: "Application Error!", isOutsideRemixApp: n },
      r.createElement(
        "h1",
        { style: { fontSize: "24px" } },
        "Application Error"
      ),
      r.createElement(
        "pre",
        {
          style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto",
          },
        },
        o.stack
      ),
      a
    );
  }
  function qe(e) {
    var t;
    let { title: n, renderScripts: o, isOutsideRemixApp: a, children: l } = e,
      { routeModules: i } = Ge();
    return null !== (t = i.root) && void 0 !== t && t.Layout && !a
      ? l
      : r.createElement(
          "html",
          { lang: "en" },
          r.createElement(
            "head",
            null,
            r.createElement("meta", { charSet: "utf-8" }),
            r.createElement("meta", {
              name: "viewport",
              content: "width=device-width,initial-scale=1,viewport-fit=cover",
            }),
            r.createElement("title", null, n)
          ),
          r.createElement(
            "body",
            null,
            r.createElement(
              "main",
              {
                style: { fontFamily: "system-ui, sans-serif", padding: "2rem" },
              },
              l,
              o ? r.createElement(ot, null) : null
            )
          )
        );
  }
  function Ye(e) {
    return !e;
  }
  function Ke() {
    let e = r.useContext(ee);
    return (
      De(
        e,
        "You must render this element inside a <DataRouterContext.Provider> element"
      ),
      e
    );
  }
  function Qe() {
    let e = r.useContext(te);
    return (
      De(
        e,
        "You must render this element inside a <DataRouterStateContext.Provider> element"
      ),
      e
    );
  }
  var Xe = r.createContext(void 0);
  function Ge() {
    let e = r.useContext(Xe);
    return (
      De(e, "You must render this element inside a <HydratedRouter> element"), e
    );
  }
  function Je(e, t) {
    return (n) => {
      e && e(n), n.defaultPrevented || t(n);
    };
  }
  function Ze(e, t, n) {
    if (n && !rt) return [e[0]];
    if (t) {
      let n = e.findIndex((e) => void 0 !== t[e.route.id]);
      return e.slice(0, n + 1);
    }
    return e;
  }
  function et(e) {
    let { page: t } = e,
      n = i(e, p),
      { router: o } = Ke(),
      a = r.useMemo(
        () => P(o.routes, t, o.basename),
        [o.routes, t, o.basename]
      );
    return a ? r.createElement(nt, f({ page: t, matches: a }, n)) : null;
  }
  function tt(e) {
    let { manifest: t, routeModules: n } = Ge(),
      [o, a] = r.useState([]);
    return (
      r.useEffect(() => {
        let r = !1;
        return (
          (async function (e, t, n) {
            return He(
              (
                await Promise.all(
                  e.map(async (e) => {
                    let r = t.routes[e.route.id];
                    if (r) {
                      let e = await Fe(r, n);
                      return e.links ? e.links() : [];
                    }
                    return [];
                  })
                )
              )
                .flat(1)
                .filter(Ie)
                .filter((e) => "stylesheet" === e.rel || "preload" === e.rel)
                .map((e) =>
                  "stylesheet" === e.rel
                    ? f(f({}, e), {}, { rel: "prefetch", as: "style" })
                    : f(f({}, e), {}, { rel: "prefetch" })
                )
            );
          })(e, t, n).then((e) => {
            r || a(e);
          }),
          () => {
            r = !0;
          }
        );
      }, [e, t, n]),
      o
    );
  }
  function nt(e) {
    let { page: t, matches: n } = e,
      o = i(e, m),
      a = ue(),
      { manifest: l, routeModules: s } = Ge(),
      { loaderData: c, matches: u } = Qe(),
      d = r.useMemo(() => Ve(t, n, u, l, a, "data"), [t, n, u, l, a]),
      p = r.useMemo(() => Ve(t, n, u, l, a, "assets"), [t, n, u, l, a]),
      h = r.useMemo(() => {
        if (t === a.pathname + a.search + a.hash) return [];
        let e = new Set(),
          r = !1;
        if (
          (n.forEach((t) => {
            var n;
            let o = l.routes[t.route.id];
            o &&
              o.hasLoader &&
              ((!d.some((e) => e.route.id === t.route.id) &&
                t.route.id in c &&
                null !== (n = s[t.route.id]) &&
                void 0 !== n &&
                n.shouldRevalidate) ||
              o.hasClientLoader
                ? (r = !0)
                : e.add(t.route.id));
          }),
          0 === e.size)
        )
          return [];
        let o = Ue(t);
        return (
          r &&
            e.size > 0 &&
            o.searchParams.set(
              "_routes",
              n
                .filter((t) => e.has(t.route.id))
                .map((e) => e.route.id)
                .join(",")
            ),
          [o.pathname + o.search]
        );
      }, [c, a, l, d, n, t, s]),
      v = r.useMemo(
        () =>
          (function (e, t) {
            return We(
              e
                .map((e) => {
                  let n = t.routes[e.route.id];
                  if (!n) return [];
                  let r = [n.module];
                  return n.imports && (r = r.concat(n.imports)), r;
                })
                .flat(1)
            );
          })(p, l),
        [p, l]
      ),
      y = tt(p);
    return r.createElement(
      r.Fragment,
      null,
      h.map((e) =>
        r.createElement(
          "link",
          f({ key: e, rel: "prefetch", as: "fetch", href: e }, o)
        )
      ),
      v.map((e) =>
        r.createElement("link", f({ key: e, rel: "modulepreload", href: e }, o))
      ),
      y.map((e) => {
        let { key: t, link: n } = e;
        return r.createElement("link", f({ key: t }, n));
      })
    );
  }
  Xe.displayName = "FrameworkContext";
  var rt = !1;
  function ot(e) {
    let {
        manifest: t,
        serverHandoffString: n,
        isSpaMode: o,
        renderMeta: a,
      } = Ge(),
      { router: l, static: i, staticContext: s } = Ke(),
      { matches: c } = Qe(),
      u = Ye(o);
    a && (a.didRenderScripts = !0);
    let d = Ze(c, null, o);
    r.useEffect(() => {
      rt = !0;
    }, []);
    let p = r.useMemo(() => {
        var o;
        let a = s
            ? "window.__reactRouterContext = "
                .concat(n, ";")
                .concat(
                  "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());"
                )
            : " ",
          c = i
            ? ""
                .concat(
                  null !== (o = t.hmr) && void 0 !== o && o.runtime
                    ? "import ".concat(JSON.stringify(t.hmr.runtime), ";")
                    : ""
                )
                .concat(u ? "" : "import ".concat(JSON.stringify(t.url)), ";\n")
                .concat(
                  d
                    .map((e, n) =>
                      "import * as route"
                        .concat(n, " from ")
                        .concat(
                          JSON.stringify(t.routes[e.route.id].module),
                          ";"
                        )
                    )
                    .join("\n"),
                  "\n  "
                )
                .concat(
                  u
                    ? "window.__reactRouterManifest = ".concat(
                        JSON.stringify(
                          (function (e, t) {
                            let n = new Set(
                                t.state.matches.map((e) => e.route.id)
                              ),
                              r = t.state.location.pathname
                                .split("/")
                                .filter(Boolean),
                              o = ["/"];
                            for (r.pop(); r.length > 0; )
                              o.push("/".concat(r.join("/"))), r.pop();
                            o.forEach((e) => {
                              let r = P(t.routes, e, t.basename);
                              r && r.forEach((e) => n.add(e.route.id));
                            });
                            let a = [...n].reduce(
                              (t, n) => Object.assign(t, { [n]: e.routes[n] }),
                              {}
                            );
                            return f(f({}, e), {}, { routes: a });
                          })(t, l),
                          null,
                          2
                        ),
                        ";"
                      )
                    : "",
                  "\n  window.__reactRouterRouteModules = {"
                )
                .concat(
                  d
                    .map((e, t) =>
                      "".concat(JSON.stringify(e.route.id), ":route").concat(t)
                    )
                    .join(","),
                  "};\n\nimport("
                )
                .concat(JSON.stringify(t.entry.module), ");")
            : " ";
        return r.createElement(
          r.Fragment,
          null,
          r.createElement(
            "script",
            f(
              f({}, e),
              {},
              {
                suppressHydrationWarning: !0,
                dangerouslySetInnerHTML: Be(a),
                type: void 0,
              }
            )
          ),
          r.createElement(
            "script",
            f(
              f({}, e),
              {},
              {
                suppressHydrationWarning: !0,
                dangerouslySetInnerHTML: Be(c),
                type: "module",
                async: !0,
              }
            )
          )
        );
      }, []),
      m = d
        .map((e) => {
          let n = t.routes[e.route.id];
          return n ? (n.imports || []).concat([n.module]) : [];
        })
        .flat(1),
      h = rt ? [] : t.entry.imports.concat(m);
    return rt
      ? null
      : r.createElement(
          r.Fragment,
          null,
          u
            ? null
            : r.createElement("link", {
                rel: "modulepreload",
                href: t.url,
                crossOrigin: e.crossOrigin,
              }),
          r.createElement("link", {
            rel: "modulepreload",
            href: t.entry.module,
            crossOrigin: e.crossOrigin,
          }),
          ((v = h), [...new Set(v)]).map((t) =>
            r.createElement("link", {
              key: t,
              rel: "modulepreload",
              href: t,
              crossOrigin: e.crossOrigin,
            })
          ),
          p
        );
    var v;
  }
  function at() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return (e) => {
      t.forEach((t) => {
        "function" === typeof t ? t(e) : null != t && (t.current = e);
      });
    };
  }
  var lt =
    "undefined" !== typeof window &&
    "undefined" !== typeof window.document &&
    "undefined" !== typeof window.document.createElement;
  try {
    lt && (window.__reactRouterVersion = "7.1.1");
  } catch (ap) {}
  function it(e) {
    let { basename: t, children: n, window: o } = e,
      a = r.useRef();
    null == a.current && (a.current = b({ window: o, v5Compat: !0 }));
    let l = a.current,
      [i, s] = r.useState({ action: l.action, location: l.location }),
      c = r.useCallback(
        (e) => {
          r.startTransition(() => s(e));
        },
        [s]
      );
    return (
      r.useLayoutEffect(() => l.listen(c), [l, c]),
      r.createElement(je, {
        basename: t,
        children: n,
        location: i.location,
        navigationType: i.action,
        navigator: l,
      })
    );
  }
  var st = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i,
    ct = r.forwardRef(function (e, t) {
      let n,
        {
          onClick: o,
          discover: a = "render",
          prefetch: l = "none",
          relative: s,
          reloadDocument: c,
          replace: u,
          state: d,
          target: p,
          to: m,
          preventScrollReset: v,
          viewTransition: y,
        } = e,
        g = i(e, h),
        { basename: b } = r.useContext(ae),
        S = "string" === typeof m && st.test(m),
        k = !1;
      if ("string" === typeof m && S && ((n = m), lt))
        try {
          let e = new URL(window.location.href),
            t = m.startsWith("//") ? new URL(e.protocol + m) : new URL(m),
            n = H(t.pathname, b);
          t.origin === e.origin && null != n
            ? (m = n + t.search + t.hash)
            : (k = !0);
        } catch (ap) {
          x(
            !1,
            '<Link to="'.concat(
              m,
              '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'
            )
          );
        }
      let E = (function (e) {
          let { relative: t } =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          w(
            ce(),
            "useHref() may be used only in the context of a <Router> component."
          );
          let { basename: n, navigator: o } = r.useContext(ae),
            { hash: a, pathname: l, search: i } = me(e, { relative: t }),
            s = l;
          return (
            "/" !== n && (s = "/" === l ? n : Y([n, l])),
            o.createHref({ pathname: s, search: i, hash: a })
          );
        })(m, { relative: s }),
        [N, P, j] = (function (e, t) {
          let n = r.useContext(Xe),
            [o, a] = r.useState(!1),
            [l, i] = r.useState(!1),
            {
              onFocus: s,
              onBlur: c,
              onMouseEnter: u,
              onMouseLeave: d,
              onTouchStart: f,
            } = t,
            p = r.useRef(null);
          r.useEffect(() => {
            if (("render" === e && i(!0), "viewport" === e)) {
              let e = new IntersectionObserver(
                (e) => {
                  e.forEach((e) => {
                    i(e.isIntersecting);
                  });
                },
                { threshold: 0.5 }
              );
              return (
                p.current && e.observe(p.current),
                () => {
                  e.disconnect();
                }
              );
            }
          }, [e]),
            r.useEffect(() => {
              if (o) {
                let e = setTimeout(() => {
                  i(!0);
                }, 100);
                return () => {
                  clearTimeout(e);
                };
              }
            }, [o]);
          let m = () => {
              a(!0);
            },
            h = () => {
              a(!1), i(!1);
            };
          return n
            ? "intent" !== e
              ? [l, p, {}]
              : [
                  l,
                  p,
                  {
                    onFocus: Je(s, m),
                    onBlur: Je(c, h),
                    onMouseEnter: Je(u, m),
                    onMouseLeave: Je(d, h),
                    onTouchStart: Je(f, m),
                  },
                ]
            : [!1, p, {}];
        })(l, g),
        z = (function (e) {
          let {
              target: t,
              replace: n,
              state: o,
              preventScrollReset: a,
              relative: l,
              viewTransition: i,
            } = arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : {},
            s = pe(),
            c = ue(),
            u = me(e, { relative: l });
          return r.useCallback(
            (r) => {
              if (
                (function (e, t) {
                  return (
                    0 === e.button &&
                    (!t || "_self" === t) &&
                    !(function (e) {
                      return !!(
                        e.metaKey ||
                        e.altKey ||
                        e.ctrlKey ||
                        e.shiftKey
                      );
                    })(e)
                  );
                })(r, t)
              ) {
                r.preventDefault();
                let t = void 0 !== n ? n : C(c) === C(u);
                s(e, {
                  replace: t,
                  state: o,
                  preventScrollReset: a,
                  relative: l,
                  viewTransition: i,
                });
              }
            },
            [c, s, u, n, o, t, e, a, l, i]
          );
        })(m, {
          replace: u,
          state: d,
          target: p,
          preventScrollReset: v,
          relative: s,
          viewTransition: y,
        });
      let T = r.createElement(
        "a",
        f(
          f(f({}, g), j),
          {},
          {
            href: n || E,
            onClick:
              k || c
                ? o
                : function (e) {
                    o && o(e), e.defaultPrevented || z(e);
                  },
            ref: at(t, P),
            target: p,
            "data-discover": S || "render" !== a ? void 0 : "true",
          }
        )
      );
      return N && !S
        ? r.createElement(r.Fragment, null, T, r.createElement(et, { page: E }))
        : T;
    });
  (ct.displayName = "Link"),
    (r.forwardRef(function (e, t) {
      let {
          "aria-current": n = "page",
          caseSensitive: o = !1,
          className: a = "",
          end: l = !1,
          style: s,
          to: c,
          viewTransition: u,
          children: d,
        } = e,
        p = i(e, v),
        m = me(c, { relative: p.relative }),
        h = ue(),
        y = r.useContext(te),
        { navigator: g, basename: b } = r.useContext(ae),
        x =
          null != y &&
          (function (e) {
            let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              n = r.useContext(ne);
            w(
              null != n,
              "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
            );
            let { basename: o } = ft("useViewTransitionState"),
              a = me(e, { relative: t.relative });
            if (!n.isTransitioning) return !1;
            let l =
                H(n.currentLocation.pathname, o) || n.currentLocation.pathname,
              i = H(n.nextLocation.pathname, o) || n.nextLocation.pathname;
            return null != V(a.pathname, i) || null != V(a.pathname, l);
          })(m) &&
          !0 === u,
        S = g.encodeLocation ? g.encodeLocation(m).pathname : m.pathname,
        k = h.pathname,
        C =
          y && y.navigation && y.navigation.location
            ? y.navigation.location.pathname
            : null;
      o ||
        ((k = k.toLowerCase()),
        (C = C ? C.toLowerCase() : null),
        (S = S.toLowerCase())),
        C && b && (C = H(C, b) || C);
      const E = "/" !== S && S.endsWith("/") ? S.length - 1 : S.length;
      let N,
        P = k === S || (!l && k.startsWith(S) && "/" === k.charAt(E)),
        j =
          null != C &&
          (C === S || (!l && C.startsWith(S) && "/" === C.charAt(S.length))),
        z = { isActive: P, isPending: j, isTransitioning: x },
        T = P ? n : void 0;
      N =
        "function" === typeof a
          ? a(z)
          : [
              a,
              P ? "active" : null,
              j ? "pending" : null,
              x ? "transitioning" : null,
            ]
              .filter(Boolean)
              .join(" ");
      let R = "function" === typeof s ? s(z) : s;
      return r.createElement(
        ct,
        f(
          f({}, p),
          {},
          {
            "aria-current": T,
            className: N,
            ref: t,
            style: R,
            to: c,
            viewTransition: u,
          }
        ),
        "function" === typeof d ? d(z) : d
      );
    }).displayName = "NavLink");
  var ut = r.forwardRef((e, t) => {
    let {
        discover: n = "render",
        fetcherKey: o,
        navigate: a,
        reloadDocument: l,
        replace: s,
        state: c,
        method: u = ze,
        action: d,
        onSubmit: p,
        relative: m,
        preventScrollReset: h,
        viewTransition: v,
      } = e,
      g = i(e, y),
      b = ht(),
      x = (function (e) {
        let { relative: t } =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          { basename: n } = r.useContext(ae),
          o = r.useContext(ie);
        w(o, "useFormAction must be used inside a RouteContext");
        let [a] = o.matches.slice(-1),
          l = f({}, me(e || ".", { relative: t })),
          i = ue();
        if (null == e) {
          l.search = i.search;
          let e = new URLSearchParams(l.search),
            t = e.getAll("index");
          if (t.some((e) => "" === e)) {
            e.delete("index"),
              t.filter((e) => e).forEach((t) => e.append("index", t));
            let n = e.toString();
            l.search = n ? "?".concat(n) : "";
          }
        }
        (e && "." !== e) ||
          !a.route.index ||
          (l.search = l.search ? l.search.replace(/^\?/, "?index&") : "?index");
        "/" !== n && (l.pathname = "/" === l.pathname ? n : Y([n, l.pathname]));
        return C(l);
      })(d, { relative: m }),
      S = "get" === u.toLowerCase() ? "get" : "post",
      k = "string" === typeof d && st.test(d);
    return r.createElement(
      "form",
      f(
        f(
          {
            ref: t,
            method: S,
            action: x,
            onSubmit: l
              ? p
              : (e) => {
                  if ((p && p(e), e.defaultPrevented)) return;
                  e.preventDefault();
                  let t = e.nativeEvent.submitter,
                    n =
                      (null === t || void 0 === t
                        ? void 0
                        : t.getAttribute("formmethod")) || u;
                  b(t || e.currentTarget, {
                    fetcherKey: o,
                    method: n,
                    navigate: a,
                    replace: s,
                    state: c,
                    relative: m,
                    preventScrollReset: h,
                    viewTransition: v,
                  });
                },
          },
          g
        ),
        {},
        { "data-discover": k || "render" !== n ? void 0 : "true" }
      )
    );
  });
  function dt(e) {
    return "".concat(
      e,
      " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router."
    );
  }
  function ft(e) {
    let t = r.useContext(ee);
    return w(t, dt(e)), t;
  }
  ut.displayName = "Form";
  var pt = 0,
    mt = () => "__".concat(String(++pt), "__");
  function ht() {
    let { router: e } = ft("useSubmit"),
      { basename: t } = r.useContext(ae),
      n = Ce("useRouteId");
    return r.useCallback(
      async function (r) {
        let o =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          { action: a, method: l, encType: i, formData: s, body: c } = Le(r, t);
        if (!1 === o.navigate) {
          let t = o.fetcherKey || mt();
          await e.fetch(t, n, o.action || a, {
            preventScrollReset: o.preventScrollReset,
            formData: s,
            body: c,
            formMethod: o.method || l,
            formEncType: o.encType || i,
            flushSync: o.flushSync,
          });
        } else
          await e.navigate(o.action || a, {
            preventScrollReset: o.preventScrollReset,
            formData: s,
            body: c,
            formMethod: o.method || l,
            formEncType: o.encType || i,
            replace: o.replace,
            state: o.state,
            fromRouteId: n,
            flushSync: o.flushSync,
            viewTransition: o.viewTransition,
          });
      },
      [e, t, n]
    );
  }
  new TextEncoder();
  var vt = n(579);
  const yt = "undefined" !== typeof document ? r.useLayoutEffect : r.useEffect;
  function gt() {
    return ""
      .concat(
        arguments.length > 0 && void 0 !== arguments[0]
          ? arguments[0]
          : "mantine-"
      )
      .concat(Math.random().toString(36).slice(2, 11));
  }
  const bt = r["useId".toString()] || (() => {});
  function wt(e) {
    const t = (function () {
        const e = bt();
        return e ? "mantine-".concat(e.replace(/:/g, "")) : "";
      })(),
      [n, o] = (0, r.useState)(t);
    return (
      yt(() => {
        o(gt());
      }, []),
      "string" === typeof e ? e : "undefined" === typeof window ? t : n
    );
  }
  function xt(e) {
    if ("number" === typeof e) return !0;
    if ("string" === typeof e) {
      if (
        e.startsWith("calc(") ||
        e.startsWith("var(") ||
        (e.includes(" ") && "" !== e.trim())
      )
        return !0;
      const t =
        /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
      return e
        .trim()
        .split(/\s+/)
        .every((e) => t.test(e));
    }
    return !1;
  }
  function St(e) {
    return "0rem" === e
      ? "0rem"
      : "calc(".concat(e, " * var(--mantine-scale))");
  }
  function kt(e) {
    let { shouldScale: t = !1 } =
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return function n(r) {
      if (0 === r || "0" === r) return "0".concat(e);
      if ("number" === typeof r) {
        const n = "".concat(r / 16).concat(e);
        return t ? St(n) : n;
      }
      if ("string" === typeof r) {
        if ("" === r) return r;
        if (
          r.startsWith("calc(") ||
          r.startsWith("clamp(") ||
          r.includes("rgba(")
        )
          return r;
        if (r.includes(","))
          return r
            .split(",")
            .map((e) => n(e))
            .join(",");
        if (r.includes(" "))
          return r
            .split(" ")
            .map((e) => n(e))
            .join(" ");
        if (r.includes(e)) return t ? St(r) : r;
        const o = r.replace("px", "");
        if (!Number.isNaN(Number(o))) {
          const n = "".concat(Number(o) / 16).concat(e);
          return t ? St(n) : n;
        }
      }
      return r;
    };
  }
  const Ct = kt("rem", { shouldScale: !0 }),
    Et = kt("em");
  function Nt(e) {
    let t =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "size",
      n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
    if (void 0 !== e)
      return xt(e) ? (n ? Ct(e) : e) : "var(--".concat(t, "-").concat(e, ")");
  }
  function Pt(e) {
    return Nt(e, "mantine-spacing");
  }
  function jt(e) {
    return void 0 === e
      ? "var(--mantine-radius-default)"
      : Nt(e, "mantine-radius");
  }
  function zt(e) {
    return Nt(e, "mantine-font-size");
  }
  function Tt(e) {
    if (e) return Nt(e, "mantine-shadow", !1);
  }
  function Rt(e, t) {
    return "number" === typeof e.primaryShade
      ? e.primaryShade
      : "dark" === t
      ? e.primaryShade.dark
      : e.primaryShade.light;
  }
  function _t(e) {
    return (function (e) {
      return /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(e);
    })(e)
      ? (function (e) {
          let t = e.replace("#", "");
          if (3 === t.length) {
            const e = t.split("");
            t = [e[0], e[0], e[1], e[1], e[2], e[2]].join("");
          }
          if (8 === t.length) {
            const e = parseInt(t.slice(6, 8), 16) / 255;
            return {
              r: parseInt(t.slice(0, 2), 16),
              g: parseInt(t.slice(2, 4), 16),
              b: parseInt(t.slice(4, 6), 16),
              a: e,
            };
          }
          const n = parseInt(t, 16);
          return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: 255 & n, a: 1 };
        })(e)
      : e.startsWith("rgb")
      ? (function (e) {
          const [t, n, r, o] = e
            .replace(/[^0-9,./]/g, "")
            .split(/[/,]/)
            .map(Number);
          return { r: t, g: n, b: r, a: o || 1 };
        })(e)
      : e.startsWith("hsl")
      ? (function (e) {
          const t = e.match(
            /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i
          );
          if (!t) return { r: 0, g: 0, b: 0, a: 1 };
          const n = parseInt(t[1], 10),
            r = parseInt(t[2], 10) / 100,
            o = parseInt(t[3], 10) / 100,
            a = t[5] ? parseFloat(t[5]) : void 0,
            l = (1 - Math.abs(2 * o - 1)) * r,
            i = n / 60,
            s = l * (1 - Math.abs((i % 2) - 1)),
            c = o - l / 2;
          let u, d, f;
          return (
            i >= 0 && i < 1
              ? ((u = l), (d = s), (f = 0))
              : i >= 1 && i < 2
              ? ((u = s), (d = l), (f = 0))
              : i >= 2 && i < 3
              ? ((u = 0), (d = l), (f = s))
              : i >= 3 && i < 4
              ? ((u = 0), (d = s), (f = l))
              : i >= 4 && i < 5
              ? ((u = s), (d = 0), (f = l))
              : ((u = l), (d = 0), (f = s)),
            {
              r: Math.round(255 * (u + c)),
              g: Math.round(255 * (d + c)),
              b: Math.round(255 * (f + c)),
              a: a || 1,
            }
          );
        })(e)
      : { r: 0, g: 0, b: 0, a: 1 };
  }
  function Ot(e) {
    return e <= 0.03928 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
  }
  function At(e) {
    if (e.startsWith("oklch("))
      return (
        ((function (e) {
          const t = e.match(/oklch\((.*?)%\s/);
          return t ? parseFloat(t[1]) : null;
        })(e) || 0) / 100
      );
    const { r: t, g: n, b: r } = _t(e),
      o = n / 255,
      a = r / 255;
    return 0.2126 * Ot(t / 255) + 0.7152 * Ot(o) + 0.0722 * Ot(a);
  }
  function Lt(e) {
    let t =
      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0.179;
    return !e.startsWith("var(") && At(e) > t;
  }
  function Dt(e) {
    let { color: t, theme: n, colorScheme: r } = e;
    if ("string" !== typeof t)
      throw new Error(
        "[@mantine/core] Failed to parse color. Expected color to be a string, instead got ".concat(
          typeof t
        )
      );
    if ("bright" === t)
      return {
        color: t,
        value: "dark" === r ? n.white : n.black,
        shade: void 0,
        isThemeColor: !1,
        isLight: Lt("dark" === r ? n.white : n.black, n.luminanceThreshold),
        variable: "--mantine-color-bright",
      };
    if ("dimmed" === t)
      return {
        color: t,
        value: "dark" === r ? n.colors.dark[2] : n.colors.gray[7],
        shade: void 0,
        isThemeColor: !1,
        isLight: Lt(
          "dark" === r ? n.colors.dark[2] : n.colors.gray[6],
          n.luminanceThreshold
        ),
        variable: "--mantine-color-dimmed",
      };
    if ("white" === t || "black" === t)
      return {
        color: t,
        value: "white" === t ? n.white : n.black,
        shade: void 0,
        isThemeColor: !1,
        isLight: Lt("white" === t ? n.white : n.black, n.luminanceThreshold),
        variable: "--mantine-color-".concat(t),
      };
    const [o, a] = t.split("."),
      l = a ? Number(a) : void 0,
      i = o in n.colors;
    if (i) {
      const e =
        void 0 !== l ? n.colors[o][l] : n.colors[o][Rt(n, r || "light")];
      return {
        color: o,
        value: e,
        shade: l,
        isThemeColor: i,
        isLight: Lt(e, n.luminanceThreshold),
        variable: a
          ? "--mantine-color-".concat(o, "-").concat(l)
          : "--mantine-color-".concat(o, "-filled"),
      };
    }
    return {
      color: t,
      value: t,
      isThemeColor: i,
      isLight: Lt(t, n.luminanceThreshold),
      shade: l,
      variable: void 0,
    };
  }
  function Ft(e, t) {
    const n = Dt({ color: e || t.primaryColor, theme: t });
    return n.variable ? "var(".concat(n.variable, ")") : e;
  }
  function Mt(e) {
    let { color: t, theme: n, autoContrast: r } = e;
    if (!("boolean" === typeof r ? r : n.autoContrast))
      return "var(--mantine-color-white)";
    return Dt({ color: t || n.primaryColor, theme: n }).isLight
      ? "var(--mantine-color-black)"
      : "var(--mantine-color-white)";
  }
  function It(e, t) {
    return Mt({
      color: e.colors[e.primaryColor][Rt(e, t)],
      theme: e,
      autoContrast: null,
    });
  }
  function Vt(e, t) {
    return "boolean" === typeof e ? e : t.autoContrast;
  }
  function Wt(e) {
    return Object.keys(e).reduce(
      (t, n) => (void 0 !== e[n] && (t[n] = e[n]), t),
      {}
    );
  }
  function Ht(e, t) {
    if (e.startsWith("var("))
      return "color-mix(in srgb, ".concat(e, ", black ").concat(100 * t, "%)");
    const { r: n, g: r, b: o, a: a } = _t(e),
      l = 1 - t,
      i = (e) => Math.round(e * l);
    return "rgba("
      .concat(i(n), ", ")
      .concat(i(r), ", ")
      .concat(i(o), ", ")
      .concat(a, ")");
  }
  function Bt(e, t) {
    const n = {
        from:
          (null === e || void 0 === e ? void 0 : e.from) ||
          t.defaultGradient.from,
        to:
          (null === e || void 0 === e ? void 0 : e.to) || t.defaultGradient.to,
        deg:
          (null === e || void 0 === e ? void 0 : e.deg) ||
          t.defaultGradient.deg ||
          0,
      },
      r = Ft(n.from, t),
      o = Ft(n.to, t);
    return "linear-gradient("
      .concat(n.deg, "deg, ")
      .concat(r, " 0%, ")
      .concat(o, " 100%)");
  }
  function Ut(e, t) {
    if ("string" !== typeof e || t > 1 || t < 0) return "rgba(0, 0, 0, 1)";
    if (e.startsWith("var(")) {
      const n = 100 * (1 - t);
      return "color-mix(in srgb, ".concat(e, ", transparent ").concat(n, "%)");
    }
    if (e.startsWith("oklch"))
      return e.includes("/")
        ? e.replace(/\/\s*[\d.]+\s*\)/, "/ ".concat(t, ")"))
        : e.replace(")", " / ".concat(t, ")"));
    const { r: n, g: r, b: o } = _t(e);
    return "rgba("
      .concat(n, ", ")
      .concat(r, ", ")
      .concat(o, ", ")
      .concat(t, ")");
  }
  const $t = Ut,
    qt =
      "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    Yt = {
      scale: 1,
      fontSmoothing: !0,
      focusRing: "auto",
      white: "#fff",
      black: "#000",
      colors: {
        dark: [
          "#C9C9C9",
          "#b8b8b8",
          "#828282",
          "#696969",
          "#424242",
          "#3b3b3b",
          "#2e2e2e",
          "#242424",
          "#1f1f1f",
          "#141414",
        ],
        gray: [
          "#f8f9fa",
          "#f1f3f5",
          "#e9ecef",
          "#dee2e6",
          "#ced4da",
          "#adb5bd",
          "#868e96",
          "#495057",
          "#343a40",
          "#212529",
        ],
        red: [
          "#fff5f5",
          "#ffe3e3",
          "#ffc9c9",
          "#ffa8a8",
          "#ff8787",
          "#ff6b6b",
          "#fa5252",
          "#f03e3e",
          "#e03131",
          "#c92a2a",
        ],
        pink: [
          "#fff0f6",
          "#ffdeeb",
          "#fcc2d7",
          "#faa2c1",
          "#f783ac",
          "#f06595",
          "#e64980",
          "#d6336c",
          "#c2255c",
          "#a61e4d",
        ],
        grape: [
          "#f8f0fc",
          "#f3d9fa",
          "#eebefa",
          "#e599f7",
          "#da77f2",
          "#cc5de8",
          "#be4bdb",
          "#ae3ec9",
          "#9c36b5",
          "#862e9c",
        ],
        violet: [
          "#f3f0ff",
          "#e5dbff",
          "#d0bfff",
          "#b197fc",
          "#9775fa",
          "#845ef7",
          "#7950f2",
          "#7048e8",
          "#6741d9",
          "#5f3dc4",
        ],
        indigo: [
          "#edf2ff",
          "#dbe4ff",
          "#bac8ff",
          "#91a7ff",
          "#748ffc",
          "#5c7cfa",
          "#4c6ef5",
          "#4263eb",
          "#3b5bdb",
          "#364fc7",
        ],
        blue: [
          "#e7f5ff",
          "#d0ebff",
          "#a5d8ff",
          "#74c0fc",
          "#4dabf7",
          "#339af0",
          "#228be6",
          "#1c7ed6",
          "#1971c2",
          "#1864ab",
        ],
        cyan: [
          "#e3fafc",
          "#c5f6fa",
          "#99e9f2",
          "#66d9e8",
          "#3bc9db",
          "#22b8cf",
          "#15aabf",
          "#1098ad",
          "#0c8599",
          "#0b7285",
        ],
        teal: [
          "#e6fcf5",
          "#c3fae8",
          "#96f2d7",
          "#63e6be",
          "#38d9a9",
          "#20c997",
          "#12b886",
          "#0ca678",
          "#099268",
          "#087f5b",
        ],
        green: [
          "#ebfbee",
          "#d3f9d8",
          "#b2f2bb",
          "#8ce99a",
          "#69db7c",
          "#51cf66",
          "#40c057",
          "#37b24d",
          "#2f9e44",
          "#2b8a3e",
        ],
        lime: [
          "#f4fce3",
          "#e9fac8",
          "#d8f5a2",
          "#c0eb75",
          "#a9e34b",
          "#94d82d",
          "#82c91e",
          "#74b816",
          "#66a80f",
          "#5c940d",
        ],
        yellow: [
          "#fff9db",
          "#fff3bf",
          "#ffec99",
          "#ffe066",
          "#ffd43b",
          "#fcc419",
          "#fab005",
          "#f59f00",
          "#f08c00",
          "#e67700",
        ],
        orange: [
          "#fff4e6",
          "#ffe8cc",
          "#ffd8a8",
          "#ffc078",
          "#ffa94d",
          "#ff922b",
          "#fd7e14",
          "#f76707",
          "#e8590c",
          "#d9480f",
        ],
      },
      primaryShade: { light: 6, dark: 8 },
      primaryColor: "blue",
      variantColorResolver: (e) => {
        let {
          color: t,
          theme: n,
          variant: r,
          gradient: o,
          autoContrast: a,
        } = e;
        const l = Dt({ color: t, theme: n }),
          i = "boolean" === typeof a ? a : n.autoContrast;
        if ("filled" === r) {
          const e =
            i && l.isLight
              ? "var(--mantine-color-black)"
              : "var(--mantine-color-white)";
          return l.isThemeColor
            ? void 0 === l.shade
              ? {
                  background: "var(--mantine-color-".concat(t, "-filled)"),
                  hover: "var(--mantine-color-".concat(t, "-filled-hover)"),
                  color: e,
                  border: "".concat(Ct(1), " solid transparent"),
                }
              : {
                  background: "var(--mantine-color-"
                    .concat(l.color, "-")
                    .concat(l.shade, ")"),
                  hover: "var(--mantine-color-"
                    .concat(l.color, "-")
                    .concat(9 === l.shade ? 8 : l.shade + 1, ")"),
                  color: e,
                  border: "".concat(Ct(1), " solid transparent"),
                }
            : {
                background: t,
                hover: Ht(t, 0.1),
                color: e,
                border: "".concat(Ct(1), " solid transparent"),
              };
        }
        if ("light" === r) {
          if (l.isThemeColor) {
            if (void 0 === l.shade)
              return {
                background: "var(--mantine-color-".concat(t, "-light)"),
                hover: "var(--mantine-color-".concat(t, "-light-hover)"),
                color: "var(--mantine-color-".concat(t, "-light-color)"),
                border: "".concat(Ct(1), " solid transparent"),
              };
            const e = n.colors[l.color][l.shade];
            return {
              background: Ut(e, 0.1),
              hover: Ut(e, 0.12),
              color: "var(--mantine-color-"
                .concat(l.color, "-")
                .concat(Math.min(l.shade, 6), ")"),
              border: "".concat(Ct(1), " solid transparent"),
            };
          }
          return {
            background: Ut(t, 0.1),
            hover: Ut(t, 0.12),
            color: t,
            border: "".concat(Ct(1), " solid transparent"),
          };
        }
        if ("outline" === r)
          return l.isThemeColor
            ? void 0 === l.shade
              ? {
                  background: "transparent",
                  hover: "var(--mantine-color-".concat(t, "-outline-hover)"),
                  color: "var(--mantine-color-".concat(t, "-outline)"),
                  border: ""
                    .concat(Ct(1), " solid var(--mantine-color-")
                    .concat(t, "-outline)"),
                }
              : {
                  background: "transparent",
                  hover: Ut(n.colors[l.color][l.shade], 0.05),
                  color: "var(--mantine-color-"
                    .concat(l.color, "-")
                    .concat(l.shade, ")"),
                  border: ""
                    .concat(Ct(1), " solid var(--mantine-color-")
                    .concat(l.color, "-")
                    .concat(l.shade, ")"),
                }
            : {
                background: "transparent",
                hover: Ut(t, 0.05),
                color: t,
                border: "".concat(Ct(1), " solid ").concat(t),
              };
        if ("subtle" === r) {
          if (l.isThemeColor) {
            if (void 0 === l.shade)
              return {
                background: "transparent",
                hover: "var(--mantine-color-".concat(t, "-light-hover)"),
                color: "var(--mantine-color-".concat(t, "-light-color)"),
                border: "".concat(Ct(1), " solid transparent"),
              };
            return {
              background: "transparent",
              hover: Ut(n.colors[l.color][l.shade], 0.12),
              color: "var(--mantine-color-"
                .concat(l.color, "-")
                .concat(Math.min(l.shade, 6), ")"),
              border: "".concat(Ct(1), " solid transparent"),
            };
          }
          return {
            background: "transparent",
            hover: Ut(t, 0.12),
            color: t,
            border: "".concat(Ct(1), " solid transparent"),
          };
        }
        return "transparent" === r
          ? l.isThemeColor
            ? void 0 === l.shade
              ? {
                  background: "transparent",
                  hover: "transparent",
                  color: "var(--mantine-color-".concat(t, "-light-color)"),
                  border: "".concat(Ct(1), " solid transparent"),
                }
              : {
                  background: "transparent",
                  hover: "transparent",
                  color: "var(--mantine-color-"
                    .concat(l.color, "-")
                    .concat(Math.min(l.shade, 6), ")"),
                  border: "".concat(Ct(1), " solid transparent"),
                }
            : {
                background: "transparent",
                hover: "transparent",
                color: t,
                border: "".concat(Ct(1), " solid transparent"),
              }
          : "white" === r
          ? l.isThemeColor
            ? void 0 === l.shade
              ? {
                  background: "var(--mantine-color-white)",
                  hover: Ht(n.white, 0.01),
                  color: "var(--mantine-color-".concat(t, "-filled)"),
                  border: "".concat(Ct(1), " solid transparent"),
                }
              : {
                  background: "var(--mantine-color-white)",
                  hover: Ht(n.white, 0.01),
                  color: "var(--mantine-color-"
                    .concat(l.color, "-")
                    .concat(l.shade, ")"),
                  border: "".concat(Ct(1), " solid transparent"),
                }
            : {
                background: "var(--mantine-color-white)",
                hover: Ht(n.white, 0.01),
                color: t,
                border: "".concat(Ct(1), " solid transparent"),
              }
          : "gradient" === r
          ? {
              background: Bt(o, n),
              hover: Bt(o, n),
              color: "var(--mantine-color-white)",
              border: "none",
            }
          : "default" === r
          ? {
              background: "var(--mantine-color-default)",
              hover: "var(--mantine-color-default-hover)",
              color: "var(--mantine-color-default-color)",
              border: "".concat(
                Ct(1),
                " solid var(--mantine-color-default-border)"
              ),
            }
          : {};
      },
      autoContrast: !1,
      luminanceThreshold: 0.3,
      fontFamily: qt,
      fontFamilyMonospace:
        "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
      respectReducedMotion: !1,
      cursorType: "default",
      defaultGradient: { from: "blue", to: "cyan", deg: 45 },
      defaultRadius: "sm",
      activeClassName: "mantine-active",
      focusClassName: "",
      headings: {
        fontFamily: qt,
        fontWeight: "700",
        textWrap: "wrap",
        sizes: {
          h1: { fontSize: Ct(34), lineHeight: "1.3" },
          h2: { fontSize: Ct(26), lineHeight: "1.35" },
          h3: { fontSize: Ct(22), lineHeight: "1.4" },
          h4: { fontSize: Ct(18), lineHeight: "1.45" },
          h5: { fontSize: Ct(16), lineHeight: "1.5" },
          h6: { fontSize: Ct(14), lineHeight: "1.5" },
        },
      },
      fontSizes: { xs: Ct(12), sm: Ct(14), md: Ct(16), lg: Ct(18), xl: Ct(20) },
      lineHeights: { xs: "1.4", sm: "1.45", md: "1.55", lg: "1.6", xl: "1.65" },
      radius: { xs: Ct(2), sm: Ct(4), md: Ct(8), lg: Ct(16), xl: Ct(32) },
      spacing: { xs: Ct(10), sm: Ct(12), md: Ct(16), lg: Ct(20), xl: Ct(32) },
      breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em",
      },
      shadows: {
        xs: "0 "
          .concat(Ct(1), " ")
          .concat(Ct(3), " rgba(0, 0, 0, 0.05), 0 ")
          .concat(Ct(1), " ")
          .concat(Ct(2), " rgba(0, 0, 0, 0.1)"),
        sm: "0 "
          .concat(Ct(1), " ")
          .concat(Ct(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Ct(10), " ")
          .concat(Ct(15), " ")
          .concat(Ct(-5), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Ct(7), " ")
          .concat(Ct(7), " ")
          .concat(Ct(-5)),
        md: "0 "
          .concat(Ct(1), " ")
          .concat(Ct(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Ct(20), " ")
          .concat(Ct(25), " ")
          .concat(Ct(-5), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Ct(10), " ")
          .concat(Ct(10), " ")
          .concat(Ct(-5)),
        lg: "0 "
          .concat(Ct(1), " ")
          .concat(Ct(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Ct(28), " ")
          .concat(Ct(23), " ")
          .concat(Ct(-7), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Ct(12), " ")
          .concat(Ct(12), " ")
          .concat(Ct(-7)),
        xl: "0 "
          .concat(Ct(1), " ")
          .concat(Ct(3), " rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ")
          .concat(Ct(36), " ")
          .concat(Ct(28), " ")
          .concat(Ct(-7), ", rgba(0, 0, 0, 0.04) 0 ")
          .concat(Ct(17), " ")
          .concat(Ct(17), " ")
          .concat(Ct(-7)),
      },
      other: {},
      components: {},
    };
  function Kt(e) {
    return e && "object" === typeof e && !Array.isArray(e);
  }
  function Qt(e, t) {
    const n = f({}, e),
      r = t;
    return (
      Kt(e) &&
        Kt(t) &&
        Object.keys(t).forEach((t) => {
          Kt(r[t]) ? (n[t] = t in e ? Qt(n[t], r[t]) : r[t]) : (n[t] = r[t]);
        }),
      n
    );
  }
  const Xt =
    "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
  function Gt(e) {
    return !(e < 0 || e > 9) && parseInt(e.toString(), 10) === e;
  }
  function Jt(e) {
    if (!(e.primaryColor in e.colors))
      throw new Error(
        "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color"
      );
    if (
      "object" === typeof e.primaryShade &&
      (!Gt(e.primaryShade.dark) || !Gt(e.primaryShade.light))
    )
      throw new Error(Xt);
    if ("number" === typeof e.primaryShade && !Gt(e.primaryShade))
      throw new Error(Xt);
  }
  const Zt = (0, r.createContext)(null);
  function en() {
    const e = (0, r.useContext)(Zt);
    if (!e)
      throw new Error(
        "@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app"
      );
    return e;
  }
  function tn(e) {
    let { theme: t, children: n, inherit: o = !0 } = e;
    const a = (0, r.useContext)(Zt) || Yt,
      l = (0, r.useMemo)(
        () =>
          (function (e, t) {
            var n;
            if (!t) return Jt(e), e;
            const r = Qt(e, t);
            return (
              !t.fontFamily ||
                (null !== (n = t.headings) && void 0 !== n && n.fontFamily) ||
                (r.headings.fontFamily = t.fontFamily),
              Jt(r),
              r
            );
          })(o ? a : Yt, t),
        [t, a, o]
      );
    return (0, vt.jsx)(Zt.Provider, { value: l, children: n });
  }
  function nn(e, t, n) {
    var r;
    const o = en(),
      a =
        null === (r = o.components[e]) || void 0 === r
          ? void 0
          : r.defaultProps,
      l = "function" === typeof a ? a(o) : a;
    return f(f(f({}, t), l), Wt(n));
  }
  tn.displayName = "@mantine/core/MantineThemeProvider";
  const rn = (0, r.createContext)(null);
  function on() {
    const e = (0, r.useContext)(rn);
    if (!e)
      throw new Error("[@mantine/core] MantineProvider was not found in tree");
    return e;
  }
  function an() {
    return on().getStyleNonce;
  }
  function ln(e) {
    var t,
      n,
      r = "";
    if ("string" == typeof e || "number" == typeof e) r += e;
    else if ("object" == typeof e)
      if (Array.isArray(e)) {
        var o = e.length;
        for (t = 0; t < o; t++)
          e[t] && (n = ln(e[t])) && (r && (r += " "), (r += n));
      } else for (n in e) e[n] && (r && (r += " "), (r += n));
    return r;
  }
  const sn = function () {
      for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
        (e = arguments[n]) && (t = ln(e)) && (r && (r += " "), (r += t));
      return r;
    },
    cn = {
      always: "mantine-focus-always",
      auto: "mantine-focus-auto",
      never: "mantine-focus-never",
    };
  const un = {};
  function dn(e) {
    let { theme: t, classNames: n, props: r, stylesCtx: o } = e;
    return (function (e) {
      const t = {};
      return (
        e.forEach((e) => {
          Object.entries(e).forEach((e) => {
            let [n, r] = e;
            t[n] ? (t[n] = sn(t[n], r)) : (t[n] = r);
          });
        }),
        t
      );
    })(
      (Array.isArray(n) ? n : [n]).map((e) =>
        "function" === typeof e ? e(t, r, o) : e || un
      )
    );
  }
  function fn(e) {
    let { selector: t, stylesCtx: n, theme: r, classNames: o, props: a } = e;
    return dn({ theme: r, classNames: o, props: a, stylesCtx: n })[t];
  }
  function pn(e) {
    let {
      theme: t,
      options: n,
      themeName: r,
      selector: o,
      classNamesPrefix: a,
      classNames: l,
      classes: i,
      unstyled: s,
      className: c,
      rootSelector: u,
      props: d,
      stylesCtx: f,
      withStaticClasses: p,
      headless: m,
      transformedStyles: h,
    } = e;
    return sn(
      (function (e) {
        let { theme: t, options: n, unstyled: r } = e;
        return sn(
          (null === n || void 0 === n ? void 0 : n.focusable) &&
            !r &&
            (t.focusClassName || cn[t.focusRing]),
          (null === n || void 0 === n ? void 0 : n.active) &&
            !r &&
            t.activeClassName
        );
      })({ theme: t, options: n, unstyled: s || m }),
      (function (e) {
        let { themeName: t, theme: n, selector: r, props: o, stylesCtx: a } = e;
        return t.map((e) => {
          var t, l;
          return null ===
            (t = dn({
              theme: n,
              classNames:
                null === (l = n.components[e]) || void 0 === l
                  ? void 0
                  : l.classNames,
              props: o,
              stylesCtx: a,
            })) || void 0 === t
            ? void 0
            : t[r];
        });
      })({ theme: t, themeName: r, selector: o, props: d, stylesCtx: f }),
      (function (e) {
        let { options: t, classes: n, selector: r, unstyled: o } = e;
        return null !== t && void 0 !== t && t.variant && !o
          ? n["".concat(r, "--").concat(t.variant)]
          : void 0;
      })({ options: n, classes: i, selector: o, unstyled: s }),
      fn({ selector: o, stylesCtx: f, theme: t, classNames: l, props: d }),
      fn({ selector: o, stylesCtx: f, theme: t, classNames: h, props: d }),
      (function (e) {
        let { selector: t, stylesCtx: n, options: r, props: o, theme: a } = e;
        return dn({
          theme: a,
          classNames: null === r || void 0 === r ? void 0 : r.classNames,
          props: (null === r || void 0 === r ? void 0 : r.props) || o,
          stylesCtx: n,
        })[t];
      })({ selector: o, stylesCtx: f, options: n, props: d, theme: t }),
      (function (e) {
        let { rootSelector: t, selector: n, className: r } = e;
        return t === n ? r : void 0;
      })({ rootSelector: u, selector: o, className: c }),
      (function (e) {
        let { selector: t, classes: n, unstyled: r } = e;
        return r ? void 0 : n[t];
      })({ selector: o, classes: i, unstyled: s || m }),
      p &&
        !m &&
        (function (e) {
          let {
            themeName: t,
            classNamesPrefix: n,
            selector: r,
            withStaticClass: o,
          } = e;
          return !1 === o
            ? []
            : t.map((e) => "".concat(n, "-").concat(e, "-").concat(r));
        })({
          themeName: r,
          classNamesPrefix: a,
          selector: o,
          withStaticClass:
            null === n || void 0 === n ? void 0 : n.withStaticClass,
        }),
      null === n || void 0 === n ? void 0 : n.className
    );
  }
  function mn(e) {
    let { theme: t, styles: n, props: r, stylesCtx: o } = e;
    return (Array.isArray(n) ? n : [n]).reduce(
      (e, n) => f(f({}, e), "function" === typeof n ? n(t, r, o) : n),
      {}
    );
  }
  function hn(e) {
    let { style: t, theme: n } = e;
    return Array.isArray(t)
      ? [...t].reduce((e, t) => f(f({}, e), hn({ style: t, theme: n })), {})
      : "function" === typeof t
      ? t(n)
      : null == t
      ? {}
      : t;
  }
  function vn(e) {
    var t;
    let {
      vars: n,
      varsResolver: r,
      theme: o,
      props: a,
      stylesCtx: l,
      selector: i,
      themeName: s,
      headless: c,
    } = e;
    return null ===
      (t = (function (e) {
        return e.reduce(
          (e, t) => (
            t &&
              Object.keys(t).forEach((n) => {
                e[n] = f(f({}, e[n]), Wt(t[n]));
              }),
            e
          ),
          {}
        );
      })([
        c ? {} : null === r || void 0 === r ? void 0 : r(o, a, l),
        ...s.map((e) => {
          var t, n;
          return null === (t = o.components) ||
            void 0 === t ||
            null === (t = t[e]) ||
            void 0 === t ||
            null === (n = t.vars) ||
            void 0 === n
            ? void 0
            : n.call(t, o, a, l);
        }),
        null === n || void 0 === n ? void 0 : n(o, a, l),
      ])) || void 0 === t
      ? void 0
      : t[i];
  }
  function yn(e) {
    let {
      theme: t,
      themeName: n,
      selector: r,
      options: o,
      props: a,
      stylesCtx: l,
      rootSelector: i,
      styles: s,
      style: c,
      vars: u,
      varsResolver: d,
      headless: p,
      withStylesTransform: m,
    } = e;
    return f(
      f(
        f(
          f(
            f(
              f(
                {},
                !m &&
                  (function (e) {
                    let {
                      theme: t,
                      themeName: n,
                      props: r,
                      stylesCtx: o,
                      selector: a,
                    } = e;
                    return n
                      .map((e) => {
                        var n;
                        return mn({
                          theme: t,
                          styles:
                            null === (n = t.components[e]) || void 0 === n
                              ? void 0
                              : n.styles,
                          props: r,
                          stylesCtx: o,
                        })[a];
                      })
                      .reduce((e, t) => f(f({}, e), t), {});
                  })({
                    theme: t,
                    themeName: n,
                    props: a,
                    stylesCtx: l,
                    selector: r,
                  })
              ),
              !m && mn({ theme: t, styles: s, props: a, stylesCtx: l })[r]
            ),
            !m &&
              mn({
                theme: t,
                styles: null === o || void 0 === o ? void 0 : o.styles,
                props: (null === o || void 0 === o ? void 0 : o.props) || a,
                stylesCtx: l,
              })[r]
          ),
          vn({
            theme: t,
            props: a,
            stylesCtx: l,
            vars: u,
            varsResolver: d,
            selector: r,
            themeName: n,
            headless: p,
          })
        ),
        i === r ? hn({ style: c, theme: t }) : null
      ),
      hn({ style: null === o || void 0 === o ? void 0 : o.style, theme: t })
    );
  }
  function gn(e) {
    var t;
    let { props: n, stylesCtx: r, themeName: o } = e;
    const a = en(),
      l =
        null ===
          (t = (function () {
            var e;
            return null === (e = on().stylesTransform) || void 0 === e
              ? void 0
              : e.styles;
          })()) || void 0 === t
          ? void 0
          : t();
    return {
      getTransformedStyles: (e) => {
        if (!l) return [];
        return [
          ...e.map((e) => l(e, { props: n, theme: a, ctx: r })),
          ...o.map((e) => {
            var t;
            return l(
              null === (t = a.components[e]) || void 0 === t
                ? void 0
                : t.styles,
              { props: n, theme: a, ctx: r }
            );
          }),
        ].filter(Boolean);
      },
      withStylesTransform: !!l,
    };
  }
  function bn(e) {
    let {
      name: t,
      classes: n,
      props: r,
      stylesCtx: o,
      className: a,
      style: l,
      rootSelector: i = "root",
      unstyled: s,
      classNames: c,
      styles: u,
      vars: d,
      varsResolver: f,
    } = e;
    const p = en(),
      m = on().classNamesPrefix,
      h = on().withStaticClasses,
      v = on().headless,
      y = (Array.isArray(t) ? t : [t]).filter((e) => e),
      { withStylesTransform: g, getTransformedStyles: b } = gn({
        props: r,
        stylesCtx: o,
        themeName: y,
      });
    return (e, t) => ({
      className: pn({
        theme: p,
        options: t,
        themeName: y,
        selector: e,
        classNamesPrefix: m,
        classNames: c,
        classes: n,
        unstyled: s,
        className: a,
        rootSelector: i,
        props: r,
        stylesCtx: o,
        withStaticClasses: h,
        headless: v,
        transformedStyles: b([
          null === t || void 0 === t ? void 0 : t.styles,
          u,
        ]),
      }),
      style: yn({
        theme: p,
        themeName: y,
        selector: e,
        options: t,
        props: r,
        stylesCtx: o,
        rootSelector: i,
        styles: u,
        style: l,
        vars: d,
        varsResolver: f,
        headless: v,
        withStylesTransform: g,
      }),
    });
  }
  const wn = [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "me",
    "ms",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "pe",
    "ps",
    "bd",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display",
    "flex",
    "hiddenFrom",
    "visibleFrom",
    "lightHidden",
    "darkHidden",
    "sx",
  ];
  function xn(e) {
    const {
        m: t,
        mx: n,
        my: r,
        mt: o,
        mb: a,
        ml: l,
        mr: s,
        me: c,
        ms: u,
        p: d,
        px: f,
        py: p,
        pt: m,
        pb: h,
        pl: v,
        pr: y,
        pe: g,
        ps: b,
        bd: w,
        bg: x,
        c: S,
        opacity: k,
        ff: C,
        fz: E,
        fw: N,
        lts: P,
        ta: j,
        lh: z,
        fs: T,
        tt: R,
        td: _,
        w: O,
        miw: A,
        maw: L,
        h: D,
        mih: F,
        mah: M,
        bgsz: I,
        bgp: V,
        bgr: W,
        bga: H,
        pos: B,
        top: U,
        left: $,
        bottom: q,
        right: Y,
        inset: K,
        display: Q,
        flex: X,
        hiddenFrom: G,
        visibleFrom: J,
        lightHidden: Z,
        darkHidden: ee,
        sx: te,
      } = e,
      ne = i(e, wn);
    return {
      styleProps: Wt({
        m: t,
        mx: n,
        my: r,
        mt: o,
        mb: a,
        ml: l,
        mr: s,
        me: c,
        ms: u,
        p: d,
        px: f,
        py: p,
        pt: m,
        pb: h,
        pl: v,
        pr: y,
        pe: g,
        ps: b,
        bd: w,
        bg: x,
        c: S,
        opacity: k,
        ff: C,
        fz: E,
        fw: N,
        lts: P,
        ta: j,
        lh: z,
        fs: T,
        tt: R,
        td: _,
        w: O,
        miw: A,
        maw: L,
        h: D,
        mih: F,
        mah: M,
        bgsz: I,
        bgp: V,
        bgr: W,
        bga: H,
        pos: B,
        top: U,
        left: $,
        bottom: q,
        right: Y,
        inset: K,
        display: Q,
        flex: X,
        hiddenFrom: G,
        visibleFrom: J,
        lightHidden: Z,
        darkHidden: ee,
        sx: te,
      }),
      rest: ne,
    };
  }
  function Sn(e) {
    return Object.keys(e);
  }
  function kn(e) {
    return Sn(e)
      .reduce((t, n) => {
        return void 0 !== e[n]
          ? ""
              .concat(t)
              .concat(
                ((r = n),
                r.replace(/[A-Z]/g, (e) => "-".concat(e.toLowerCase()))),
                ":"
              )
              .concat(e[n], ";")
          : t;
        var r;
      }, "")
      .trim();
  }
  function Cn(e) {
    let { selector: t, styles: n, media: r, container: o } = e;
    const a = n ? kn(n) : "",
      l = Array.isArray(r)
        ? r.map((e) =>
            "@media"
              .concat(e.query, "{")
              .concat(t, "{")
              .concat(kn(e.styles), "}}")
          )
        : [],
      i = Array.isArray(o)
        ? o.map((e) =>
            "@container "
              .concat(e.query, "{")
              .concat(t, "{")
              .concat(kn(e.styles), "}}")
          )
        : [];
    return ""
      .concat(a ? "".concat(t, "{").concat(a, "}") : "")
      .concat(l.join(""))
      .concat(i.join(""))
      .trim();
  }
  function En(e) {
    const t = an();
    return (0, vt.jsx)("style", {
      "data-mantine-styles": "inline",
      nonce: null === t || void 0 === t ? void 0 : t(),
      dangerouslySetInnerHTML: { __html: Cn(e) },
    });
  }
  function Nn(e) {
    return e.startsWith("data-") ? e : "data-".concat(e);
  }
  function Pn(e) {
    return e
      ? "string" === typeof e
        ? { [Nn(e)]: !0 }
        : Array.isArray(e)
        ? [...e].reduce((e, t) => f(f({}, e), Pn(t)), {})
        : ((t = e),
          Object.keys(t).reduce((e, n) => {
            const r = t[n];
            return (
              void 0 === r ||
                "" === r ||
                !1 === r ||
                null === r ||
                (e[Nn(n)] = t[n]),
              e
            );
          }, {}))
      : null;
    var t;
  }
  function jn(e, t) {
    return Array.isArray(e)
      ? [...e].reduce((e, n) => f(f({}, e), jn(n, t)), {})
      : "function" === typeof e
      ? e(t)
      : null == e
      ? {}
      : e;
  }
  function zn(e) {
    let { theme: t, style: n, vars: r, styleProps: o } = e;
    const a = jn(n, t),
      l = jn(r, t);
    return f(f(f({}, a), l), o);
  }
  const Tn = {
    m: { type: "spacing", property: "margin" },
    mt: { type: "spacing", property: "marginTop" },
    mb: { type: "spacing", property: "marginBottom" },
    ml: { type: "spacing", property: "marginLeft" },
    mr: { type: "spacing", property: "marginRight" },
    ms: { type: "spacing", property: "marginInlineStart" },
    me: { type: "spacing", property: "marginInlineEnd" },
    mx: { type: "spacing", property: "marginInline" },
    my: { type: "spacing", property: "marginBlock" },
    p: { type: "spacing", property: "padding" },
    pt: { type: "spacing", property: "paddingTop" },
    pb: { type: "spacing", property: "paddingBottom" },
    pl: { type: "spacing", property: "paddingLeft" },
    pr: { type: "spacing", property: "paddingRight" },
    ps: { type: "spacing", property: "paddingInlineStart" },
    pe: { type: "spacing", property: "paddingInlineEnd" },
    px: { type: "spacing", property: "paddingInline" },
    py: { type: "spacing", property: "paddingBlock" },
    bd: { type: "border", property: "border" },
    bg: { type: "color", property: "background" },
    c: { type: "textColor", property: "color" },
    opacity: { type: "identity", property: "opacity" },
    ff: { type: "fontFamily", property: "fontFamily" },
    fz: { type: "fontSize", property: "fontSize" },
    fw: { type: "identity", property: "fontWeight" },
    lts: { type: "size", property: "letterSpacing" },
    ta: { type: "identity", property: "textAlign" },
    lh: { type: "lineHeight", property: "lineHeight" },
    fs: { type: "identity", property: "fontStyle" },
    tt: { type: "identity", property: "textTransform" },
    td: { type: "identity", property: "textDecoration" },
    w: { type: "spacing", property: "width" },
    miw: { type: "spacing", property: "minWidth" },
    maw: { type: "spacing", property: "maxWidth" },
    h: { type: "spacing", property: "height" },
    mih: { type: "spacing", property: "minHeight" },
    mah: { type: "spacing", property: "maxHeight" },
    bgsz: { type: "size", property: "backgroundSize" },
    bgp: { type: "identity", property: "backgroundPosition" },
    bgr: { type: "identity", property: "backgroundRepeat" },
    bga: { type: "identity", property: "backgroundAttachment" },
    pos: { type: "identity", property: "position" },
    top: { type: "size", property: "top" },
    left: { type: "size", property: "left" },
    bottom: { type: "size", property: "bottom" },
    right: { type: "size", property: "right" },
    inset: { type: "size", property: "inset" },
    display: { type: "identity", property: "display" },
    flex: { type: "identity", property: "flex" },
  };
  function Rn(e, t) {
    const n = Dt({ color: e, theme: t });
    return "dimmed" === n.color
      ? "var(--mantine-color-dimmed)"
      : "bright" === n.color
      ? "var(--mantine-color-bright)"
      : n.variable
      ? "var(".concat(n.variable, ")")
      : n.color;
  }
  const _n = {
    text: "var(--mantine-font-family)",
    mono: "var(--mantine-font-family-monospace)",
    monospace: "var(--mantine-font-family-monospace)",
    heading: "var(--mantine-font-family-headings)",
    headings: "var(--mantine-font-family-headings)",
  };
  const On = ["h1", "h2", "h3", "h4", "h5", "h6"];
  const An = ["h1", "h2", "h3", "h4", "h5", "h6"];
  const Ln = {
      color: Rn,
      textColor: function (e, t) {
        const n = Dt({ color: e, theme: t });
        return n.isThemeColor && void 0 === n.shade
          ? "var(--mantine-color-".concat(n.color, "-text)")
          : Rn(e, t);
      },
      fontSize: function (e, t) {
        return "string" === typeof e && e in t.fontSizes
          ? "var(--mantine-font-size-".concat(e, ")")
          : "string" === typeof e && On.includes(e)
          ? "var(--mantine-".concat(e, "-font-size)")
          : "number" === typeof e || "string" === typeof e
          ? Ct(e)
          : e;
      },
      spacing: function (e, t) {
        if ("number" === typeof e) return Ct(e);
        if ("string" === typeof e) {
          const n = e.replace("-", "");
          if (!(n in t.spacing)) return Ct(e);
          const r = "--mantine-spacing-".concat(n);
          return e.startsWith("-")
            ? "calc(var(".concat(r, ") * -1)")
            : "var(".concat(r, ")");
        }
        return e;
      },
      identity: function (e) {
        return e;
      },
      size: function (e) {
        return "number" === typeof e ? Ct(e) : e;
      },
      lineHeight: function (e, t) {
        return "string" === typeof e && e in t.lineHeights
          ? "var(--mantine-line-height-".concat(e, ")")
          : "string" === typeof e && An.includes(e)
          ? "var(--mantine-".concat(e, "-line-height)")
          : e;
      },
      fontFamily: function (e) {
        return "string" === typeof e && e in _n ? _n[e] : e;
      },
      border: function (e, t) {
        if ("number" === typeof e) return Ct(e);
        if ("string" === typeof e) {
          const [n, r, ...o] = e.split(" ").filter((e) => "" !== e.trim());
          let a = "".concat(Ct(n));
          return (
            r && (a += " ".concat(r)),
            o.length > 0 && (a += " ".concat(Rn(o.join(" "), t))),
            a.trim()
          );
        }
        return e;
      },
    },
    Dn = ["media"];
  function Fn(e) {
    return e.replace("(min-width: ", "").replace("em)", "");
  }
  function Mn(e, t) {
    return "object" === typeof e && null !== e && t in e ? e[t] : e;
  }
  function In(e) {
    let { styleProps: t, data: n, theme: r } = e;
    return (function (e) {
      let { media: t } = e,
        n = i(e, Dn);
      const r = Object.keys(t)
        .sort((e, t) => Number(Fn(e)) - Number(Fn(t)))
        .map((e) => ({ query: e, styles: t[e] }));
      return f(f({}, n), {}, { media: r });
    })(
      Sn(t).reduce(
        (e, o) => {
          if ("hiddenFrom" === o || "visibleFrom" === o || "sx" === o) return e;
          const a = n[o],
            l = Array.isArray(a.property) ? a.property : [a.property],
            i =
              "object" === typeof (s = t[o]) && null !== s
                ? "base" in s
                  ? s.base
                  : void 0
                : s;
          var s;
          if (
            !(function (e) {
              if ("object" !== typeof e || null === e) return !1;
              const t = Object.keys(e);
              return 1 !== t.length || "base" !== t[0];
            })(t[o])
          )
            return (
              l.forEach((t) => {
                e.inlineStyles[t] = Ln[a.type](i, r);
              }),
              e
            );
          e.hasResponsiveStyles = !0;
          const c = (function (e) {
            return "object" === typeof e && null !== e
              ? Sn(e).filter((e) => "base" !== e)
              : [];
          })(t[o]);
          return (
            l.forEach((n) => {
              i && (e.styles[n] = Ln[a.type](i, r)),
                c.forEach((l) => {
                  const i = "(min-width: ".concat(r.breakpoints[l], ")");
                  e.media[i] = f(
                    f({}, e.media[i]),
                    {},
                    { [n]: Ln[a.type](Mn(t[o], l), r) }
                  );
                });
            }),
            e
          );
        },
        { hasResponsiveStyles: !1, styles: {}, inlineStyles: {}, media: {} }
      )
    );
  }
  function Vn() {
    const e = (0, r.useId)().replace(/:/g, "");
    return "__m__-".concat(e);
  }
  const Wn = [
      "component",
      "style",
      "__vars",
      "className",
      "variant",
      "mod",
      "size",
      "hiddenFrom",
      "visibleFrom",
      "lightHidden",
      "darkHidden",
      "renderRoot",
      "__size",
    ],
    Hn = (0, r.forwardRef)((e, t) => {
      var n;
      let {
          component: r,
          style: o,
          __vars: a,
          className: l,
          variant: s,
          mod: c,
          size: u,
          hiddenFrom: d,
          visibleFrom: p,
          lightHidden: m,
          darkHidden: h,
          renderRoot: v,
          __size: y,
        } = e,
        g = i(e, Wn);
      const b = en(),
        w = r || "div",
        { styleProps: x, rest: S } = xn(g),
        k = (function () {
          var e;
          return null === (e = on().stylesTransform) || void 0 === e
            ? void 0
            : e.sx;
        })(),
        C =
          null === k || void 0 === k || null === (n = k()) || void 0 === n
            ? void 0
            : n(x.sx),
        E = Vn(),
        N = In({ styleProps: x, theme: b, data: Tn }),
        P = f(
          f(
            {
              ref: t,
              style: zn({
                theme: b,
                style: o,
                vars: a,
                styleProps: N.inlineStyles,
              }),
              className: sn(l, C, {
                [E]: N.hasResponsiveStyles,
                "mantine-light-hidden": m,
                "mantine-dark-hidden": h,
                ["mantine-hidden-from-".concat(d)]: d,
                ["mantine-visible-from-".concat(p)]: p,
              }),
              "data-variant": s,
              "data-size": xt(u) ? void 0 : u || void 0,
              size: y,
            },
            Pn(c)
          ),
          S
        );
      return (0, vt.jsxs)(vt.Fragment, {
        children: [
          N.hasResponsiveStyles &&
            (0, vt.jsx)(En, {
              selector: ".".concat(E),
              styles: N.styles,
              media: N.media,
            }),
          "function" === typeof v ? v(P) : (0, vt.jsx)(w, f({}, P)),
        ],
      });
    });
  Hn.displayName = "@mantine/core/Box";
  const Bn = Hn;
  function Un(e) {
    return e;
  }
  function $n(e) {
    const t = (0, r.forwardRef)(e);
    return (
      (t.extend = Un),
      (t.withProps = (e) => {
        const n = (0, r.forwardRef)((n, r) =>
          (0, vt.jsx)(t, f(f(f({}, e), n), {}, { ref: r }))
        );
        return (
          (n.extend = t.extend),
          (n.displayName = "WithProps(".concat(t.displayName, ")")),
          n
        );
      }),
      t
    );
  }
  function qn(e) {
    const t = (0, r.forwardRef)(e);
    return (
      (t.withProps = (e) => {
        const n = (0, r.forwardRef)((n, r) =>
          (0, vt.jsx)(t, f(f(f({}, e), n), {}, { ref: r }))
        );
        return (
          (n.extend = t.extend),
          (n.displayName = "WithProps(".concat(t.displayName, ")")),
          n
        );
      }),
      (t.extend = Un),
      t
    );
  }
  function Yn() {
    let e =
      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
    const t = (0, r.createContext)(e);
    return [
      (e) => {
        let { children: n, value: r } = e;
        return (0, vt.jsx)(t.Provider, { value: r, children: n });
      },
      () => (0, r.useContext)(t),
    ];
  }
  const [Kn, Qn] = Yn({
    offsetBottom: !1,
    offsetTop: !1,
    describedBy: void 0,
    getStyles: null,
    inputId: void 0,
    labelId: void 0,
  });
  var Xn = {
    wrapper: "m_6c018570",
    input: "m_8fb7ebe7",
    section: "m_82577fc2",
    placeholder: "m_88bacfd0",
    root: "m_46b77525",
    label: "m_8fdc1311",
    required: "m_78a94662",
    error: "m_8f816625",
    description: "m_fe47ce59",
  };
  const Gn = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "size",
      "__staticSelector",
      "__inheritStyles",
      "variant",
    ],
    Jn = {},
    Zn = (e, t) => {
      let { size: n } = t;
      return {
        description: {
          "--input-description-size":
            void 0 === n
              ? void 0
              : "calc(".concat(zt(n), " - ").concat(Ct(2), ")"),
        },
      };
    },
    er = $n((e, t) => {
      const n = nn("InputDescription", Jn, e),
        r = nn("InputDescription", Jn, n),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          vars: u,
          size: d,
          __staticSelector: p,
          __inheritStyles: m = !0,
          variant: h,
        } = r,
        v = i(r, Gn),
        y = Qn(),
        g = bn({
          name: ["InputWrapper", p],
          props: n,
          classes: Xn,
          className: a,
          style: l,
          classNames: o,
          styles: s,
          unstyled: c,
          rootSelector: "description",
          vars: u,
          varsResolver: Zn,
        }),
        b = (m && (null === y || void 0 === y ? void 0 : y.getStyles)) || g;
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            { component: "p", ref: t, variant: h, size: d },
            b(
              "description",
              null !== y && void 0 !== y && y.getStyles
                ? { className: a, style: l }
                : void 0
            )
          ),
          v
        )
      );
    });
  (er.classes = Xn), (er.displayName = "@mantine/core/InputDescription");
  const tr = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "size",
      "__staticSelector",
      "__inheritStyles",
      "variant",
    ],
    nr = {},
    rr = (e, t) => {
      let { size: n } = t;
      return {
        error: {
          "--input-error-size":
            void 0 === n
              ? void 0
              : "calc(".concat(zt(n), " - ").concat(Ct(2), ")"),
        },
      };
    },
    or = $n((e, t) => {
      const n = nn("InputError", nr, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
          size: u,
          __staticSelector: d,
          __inheritStyles: p = !0,
          variant: m,
        } = n,
        h = i(n, tr),
        v = bn({
          name: ["InputWrapper", d],
          props: n,
          classes: Xn,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          rootSelector: "error",
          vars: c,
          varsResolver: rr,
        }),
        y = Qn(),
        g = (p && (null === y || void 0 === y ? void 0 : y.getStyles)) || v;
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            { component: "p", ref: t, variant: m, size: u },
            g(
              "error",
              null !== y && void 0 !== y && y.getStyles
                ? { className: o, style: a }
                : void 0
            )
          ),
          h
        )
      );
    });
  (or.classes = Xn), (or.displayName = "@mantine/core/InputError");
  const ar = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "labelElement",
      "size",
      "required",
      "htmlFor",
      "onMouseDown",
      "children",
      "__staticSelector",
      "variant",
      "mod",
    ],
    lr = { labelElement: "label" },
    ir = (e, t) => {
      let { size: n } = t;
      return {
        label: {
          "--input-label-size": zt(n),
          "--input-asterisk-color": void 0,
        },
      };
    },
    sr = $n((e, t) => {
      const n = nn("InputLabel", lr, e),
        r = nn("InputLabel", lr, n),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          vars: u,
          labelElement: d,
          size: p,
          required: m,
          htmlFor: h,
          onMouseDown: v,
          children: y,
          __staticSelector: g,
          variant: b,
          mod: w,
        } = r,
        x = i(r, ar),
        S = bn({
          name: ["InputWrapper", g],
          props: n,
          classes: Xn,
          className: a,
          style: l,
          classNames: o,
          styles: s,
          unstyled: c,
          rootSelector: "label",
          vars: u,
          varsResolver: ir,
        }),
        k = Qn(),
        C = (null === k || void 0 === k ? void 0 : k.getStyles) || S;
      return (0, vt.jsxs)(
        Bn,
        f(
          f(
            f(
              {},
              C(
                "label",
                null !== k && void 0 !== k && k.getStyles
                  ? { className: a, style: l }
                  : void 0
              )
            ),
            {},
            {
              component: d,
              variant: b,
              size: p,
              ref: t,
              htmlFor: "label" === d ? h : void 0,
              mod: [{ required: m }, w],
              onMouseDown: (e) => {
                null === v || void 0 === v || v(e),
                  !e.defaultPrevented && e.detail > 1 && e.preventDefault();
              },
            },
            x
          ),
          {},
          {
            children: [
              y,
              m &&
                (0, vt.jsx)(
                  "span",
                  f(
                    f({}, C("required")),
                    {},
                    { "aria-hidden": !0, children: " *" }
                  )
                ),
            ],
          }
        )
      );
    });
  (sr.classes = Xn), (sr.displayName = "@mantine/core/InputLabel");
  const cr = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "__staticSelector",
      "variant",
      "error",
      "mod",
    ],
    ur = {},
    dr = $n((e, t) => {
      const n = nn("InputPlaceholder", ur, e),
        r = nn("InputPlaceholder", ur, n),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          vars: u,
          __staticSelector: d,
          variant: p,
          error: m,
          mod: h,
        } = r,
        v = i(r, cr),
        y = bn({
          name: ["InputPlaceholder", d],
          props: n,
          classes: Xn,
          className: a,
          style: l,
          classNames: o,
          styles: s,
          unstyled: c,
          rootSelector: "placeholder",
        });
      return (0, vt.jsx)(
        Bn,
        f(
          f({}, y("placeholder")),
          {},
          { mod: [{ error: !!m }, h], component: "span", variant: p, ref: t },
          v
        )
      );
    });
  function fr(e, t) {
    let { hasDescription: n, hasError: r } = t;
    const o = e.findIndex((e) => "input" === e),
      a = e.slice(0, o),
      l = e.slice(o + 1),
      i = (n && a.includes("description")) || (r && a.includes("error"));
    return {
      offsetBottom:
        (n && l.includes("description")) || (r && l.includes("error")),
      offsetTop: i,
    };
  }
  (dr.classes = Xn), (dr.displayName = "@mantine/core/InputPlaceholder");
  const pr = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "size",
      "variant",
      "__staticSelector",
      "inputContainer",
      "inputWrapperOrder",
      "label",
      "error",
      "description",
      "labelProps",
      "descriptionProps",
      "errorProps",
      "labelElement",
      "children",
      "withAsterisk",
      "id",
      "required",
      "__stylesApiProps",
      "mod",
    ],
    mr = {
      labelElement: "label",
      inputContainer: (e) => e,
      inputWrapperOrder: ["label", "description", "input", "error"],
    },
    hr = (e, t) => {
      let { size: n } = t;
      return {
        label: {
          "--input-label-size": zt(n),
          "--input-asterisk-color": void 0,
        },
        error: {
          "--input-error-size":
            void 0 === n
              ? void 0
              : "calc(".concat(zt(n), " - ").concat(Ct(2), ")"),
        },
        description: {
          "--input-description-size":
            void 0 === n
              ? void 0
              : "calc(".concat(zt(n), " - ").concat(Ct(2), ")"),
        },
      };
    },
    vr = $n((e, t) => {
      const n = nn("InputWrapper", mr, e),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          vars: u,
          size: d,
          variant: p,
          __staticSelector: m,
          inputContainer: h,
          inputWrapperOrder: v,
          label: y,
          error: g,
          description: b,
          labelProps: w,
          descriptionProps: x,
          errorProps: S,
          labelElement: k,
          children: C,
          withAsterisk: E,
          id: N,
          required: P,
          __stylesApiProps: j,
          mod: z,
        } = n,
        T = i(n, pr),
        R = bn({
          name: ["InputWrapper", m],
          props: j || n,
          classes: Xn,
          className: a,
          style: l,
          classNames: o,
          styles: s,
          unstyled: c,
          vars: u,
          varsResolver: hr,
        }),
        _ = { size: d, variant: p, __staticSelector: m },
        O = wt(N),
        A = "boolean" === typeof E ? E : P,
        L =
          (null === S || void 0 === S ? void 0 : S.id) ||
          "".concat(O, "-error"),
        D =
          (null === x || void 0 === x ? void 0 : x.id) ||
          "".concat(O, "-description"),
        F = O,
        M = !!g && "boolean" !== typeof g,
        I = !!b,
        V = "".concat(M ? L : "", " ").concat(I ? D : ""),
        W = V.trim().length > 0 ? V.trim() : void 0,
        H =
          (null === w || void 0 === w ? void 0 : w.id) ||
          "".concat(O, "-label"),
        B =
          y &&
          (0, vt.jsx)(
            sr,
            f(
              f(f({ labelElement: k, id: H, htmlFor: F, required: A }, _), w),
              {},
              { children: y }
            ),
            "label"
          ),
        U =
          I &&
          (0, vt.jsx)(
            er,
            f(
              f(f({}, x), _),
              {},
              {
                size: (null === x || void 0 === x ? void 0 : x.size) || _.size,
                id: (null === x || void 0 === x ? void 0 : x.id) || D,
                children: b,
              }
            ),
            "description"
          ),
        $ = (0, vt.jsx)(r.Fragment, { children: h(C) }, "input"),
        q =
          M &&
          (0, r.createElement)(
            or,
            f(
              f(f({}, S), _),
              {},
              {
                size: (null === S || void 0 === S ? void 0 : S.size) || _.size,
                key: "error",
                id: (null === S || void 0 === S ? void 0 : S.id) || L,
              }
            ),
            g
          ),
        Y = v.map((e) => {
          switch (e) {
            case "label":
              return B;
            case "input":
              return $;
            case "description":
              return U;
            case "error":
              return q;
            default:
              return null;
          }
        });
      return (0, vt.jsx)(Kn, {
        value: f(
          { getStyles: R, describedBy: W, inputId: F, labelId: H },
          fr(v, { hasDescription: I, hasError: M })
        ),
        children: (0, vt.jsx)(
          Bn,
          f(
            f(
              f(
                { ref: t, variant: p, size: d, mod: [{ error: !!g }, z] },
                R("root")
              ),
              T
            ),
            {},
            { children: Y }
          )
        ),
      });
    });
  (vr.classes = Xn), (vr.displayName = "@mantine/core/InputWrapper");
  const yr = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "required",
      "__staticSelector",
      "__stylesApiProps",
      "size",
      "wrapperProps",
      "error",
      "disabled",
      "leftSection",
      "leftSectionProps",
      "leftSectionWidth",
      "rightSection",
      "rightSectionProps",
      "rightSectionWidth",
      "rightSectionPointerEvents",
      "leftSectionPointerEvents",
      "variant",
      "vars",
      "pointer",
      "multiline",
      "radius",
      "id",
      "withAria",
      "withErrorStyles",
      "mod",
      "inputSize",
    ],
    gr = {
      variant: "default",
      leftSectionPointerEvents: "none",
      rightSectionPointerEvents: "none",
      withAria: !0,
      withErrorStyles: !0,
    },
    br = (e, t, n) => ({
      wrapper: {
        "--input-margin-top": n.offsetTop
          ? "calc(var(--mantine-spacing-xs) / 2)"
          : void 0,
        "--input-margin-bottom": n.offsetBottom
          ? "calc(var(--mantine-spacing-xs) / 2)"
          : void 0,
        "--input-height": Nt(t.size, "input-height"),
        "--input-fz": zt(t.size),
        "--input-radius": void 0 === t.radius ? void 0 : jt(t.radius),
        "--input-left-section-width":
          void 0 !== t.leftSectionWidth ? Ct(t.leftSectionWidth) : void 0,
        "--input-right-section-width":
          void 0 !== t.rightSectionWidth ? Ct(t.rightSectionWidth) : void 0,
        "--input-padding-y": t.multiline
          ? Nt(t.size, "input-padding-y")
          : void 0,
        "--input-left-section-pointer-events": t.leftSectionPointerEvents,
        "--input-right-section-pointer-events": t.rightSectionPointerEvents,
      },
    }),
    wr = qn((e, t) => {
      const n = nn("Input", gr, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          required: c,
          __staticSelector: u,
          __stylesApiProps: d,
          size: p,
          wrapperProps: m,
          error: h,
          disabled: v,
          leftSection: y,
          leftSectionProps: g,
          leftSectionWidth: b,
          rightSection: w,
          rightSectionProps: x,
          rightSectionWidth: S,
          rightSectionPointerEvents: k,
          leftSectionPointerEvents: C,
          variant: E,
          vars: N,
          pointer: P,
          multiline: j,
          radius: z,
          id: T,
          withAria: R,
          withErrorStyles: _,
          mod: O,
          inputSize: A,
        } = n,
        L = i(n, yr),
        { styleProps: D, rest: F } = xn(L),
        M = Qn(),
        I = {
          offsetBottom: null === M || void 0 === M ? void 0 : M.offsetBottom,
          offsetTop: null === M || void 0 === M ? void 0 : M.offsetTop,
        },
        V = bn({
          name: ["Input", u],
          props: d || n,
          classes: Xn,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          stylesCtx: I,
          rootSelector: "wrapper",
          vars: N,
          varsResolver: br,
        }),
        W = R
          ? {
              required: c,
              disabled: v,
              "aria-invalid": !!h,
              "aria-describedby":
                null === M || void 0 === M ? void 0 : M.describedBy,
              id: (null === M || void 0 === M ? void 0 : M.inputId) || T,
            }
          : {};
      return (0, vt.jsxs)(
        Bn,
        f(
          f(f(f({}, V("wrapper")), D), m),
          {},
          {
            mod: [
              {
                error: !!h && _,
                pointer: P,
                disabled: v,
                multiline: j,
                "data-with-right-section": !!w,
                "data-with-left-section": !!y,
              },
              O,
            ],
            variant: E,
            size: p,
            children: [
              y &&
                (0, vt.jsx)(
                  "div",
                  f(
                    f(
                      f({}, g),
                      {},
                      { "data-position": "left" },
                      V("section", {
                        className:
                          null === g || void 0 === g ? void 0 : g.className,
                        style: null === g || void 0 === g ? void 0 : g.style,
                      })
                    ),
                    {},
                    { children: y }
                  )
                ),
              (0, vt.jsx)(
                Bn,
                f(
                  f(f({ component: "input" }, F), W),
                  {},
                  {
                    ref: t,
                    required: c,
                    mod: { disabled: v, error: !!h && _ },
                    variant: E,
                    __size: A,
                  },
                  V("input")
                )
              ),
              w &&
                (0, vt.jsx)(
                  "div",
                  f(
                    f(
                      f({}, x),
                      {},
                      { "data-position": "right" },
                      V("section", {
                        className:
                          null === x || void 0 === x ? void 0 : x.className,
                        style: null === x || void 0 === x ? void 0 : x.style,
                      })
                    ),
                    {},
                    { children: w }
                  )
                ),
            ],
          }
        )
      );
    });
  (wr.classes = Xn),
    (wr.Wrapper = vr),
    (wr.Label = sr),
    (wr.Error = or),
    (wr.Description = er),
    (wr.Placeholder = dr),
    (wr.displayName = "@mantine/core/Input");
  var xr = {
    root: "m_5f75b09e",
    body: "m_5f6e695e",
    labelWrapper: "m_d3ea56bb",
    label: "m_8ee546b8",
    description: "m_328f68c0",
    error: "m_8e8a99cc",
  };
  const Sr = [
      "__staticSelector",
      "__stylesApiProps",
      "className",
      "classNames",
      "styles",
      "unstyled",
      "children",
      "label",
      "description",
      "id",
      "disabled",
      "error",
      "size",
      "labelPosition",
      "bodyElement",
      "labelElement",
      "variant",
      "style",
      "vars",
      "mod",
    ],
    kr = xr,
    Cr = (0, r.forwardRef)((e, t) => {
      let {
          __staticSelector: n,
          __stylesApiProps: r,
          className: o,
          classNames: a,
          styles: l,
          unstyled: s,
          children: c,
          label: u,
          description: d,
          id: p,
          disabled: m,
          error: h,
          size: v,
          labelPosition: y = "left",
          bodyElement: g = "div",
          labelElement: b = "label",
          variant: w,
          style: x,
          vars: S,
          mod: k,
        } = e,
        C = i(e, Sr);
      const E = bn({
        name: n,
        props: r,
        className: o,
        style: x,
        classes: xr,
        classNames: a,
        styles: l,
        unstyled: s,
      });
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            f({}, E("root")),
            {},
            {
              ref: t,
              __vars: { "--label-fz": zt(v), "--label-lh": Nt(v, "label-lh") },
              mod: [{ "label-position": y }, k],
              variant: w,
              size: v,
            },
            C
          ),
          {},
          {
            children: (0, vt.jsxs)(
              Bn,
              f(
                f(
                  { component: g, htmlFor: "label" === g ? p : void 0 },
                  E("body")
                ),
                {},
                {
                  children: [
                    c,
                    (0, vt.jsxs)(
                      "div",
                      f(
                        f({}, E("labelWrapper")),
                        {},
                        {
                          "data-disabled": m || void 0,
                          children: [
                            u &&
                              (0, vt.jsx)(
                                Bn,
                                f(
                                  f(
                                    {
                                      component: b,
                                      htmlFor: "label" === b ? p : void 0,
                                    },
                                    E("label")
                                  ),
                                  {},
                                  { "data-disabled": m || void 0, children: u }
                                )
                              ),
                            d &&
                              (0, vt.jsx)(
                                wr.Description,
                                f(
                                  f(
                                    { size: v, __inheritStyles: !1 },
                                    E("description")
                                  ),
                                  {},
                                  { children: d }
                                )
                              ),
                            h &&
                              "boolean" !== typeof h &&
                              (0, vt.jsx)(
                                wr.Error,
                                f(
                                  f(
                                    { size: v, __inheritStyles: !1 },
                                    E("error")
                                  ),
                                  {},
                                  { children: h }
                                )
                              ),
                          ],
                        }
                      )
                    ),
                  ],
                }
              )
            ),
          }
        )
      );
    });
  Cr.displayName = "@mantine/core/InlineInput";
  const Er = (0, r.createContext)({
    dir: "ltr",
    toggleDirection: () => {},
    setDirection: () => {},
  });
  function Nr() {
    return (0, r.useContext)(Er);
  }
  var Pr = { root: "m_87cf2631" };
  const jr = [
      "className",
      "component",
      "__staticSelector",
      "unstyled",
      "classNames",
      "styles",
      "style",
    ],
    zr = { __staticSelector: "UnstyledButton" },
    Tr = qn((e, t) => {
      const n = nn("UnstyledButton", zr, e),
        {
          className: r,
          component: o = "button",
          __staticSelector: a,
          unstyled: l,
          classNames: s,
          styles: c,
          style: u,
        } = n,
        d = i(n, jr),
        p = bn({
          name: a,
          props: n,
          classes: Pr,
          className: r,
          style: u,
          classNames: s,
          styles: c,
          unstyled: l,
        });
      return (0, vt.jsx)(
        Bn,
        f(
          f({}, p("root", { focusable: !0 })),
          {},
          { component: o, ref: t, type: "button" === o ? "button" : void 0 },
          d
        )
      );
    });
  (Tr.classes = Pr), (Tr.displayName = "@mantine/core/UnstyledButton");
  const [Rr, _r] = Yn(),
    [Or, Ar] = Yn();
  var Lr = { card: "m_9dc8ae12" };
  const Dr = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "checked",
      "mod",
      "withBorder",
      "value",
      "onClick",
      "name",
      "onKeyDown",
    ],
    Fr = { withBorder: !0 },
    Mr = (e, t) => {
      let { radius: n } = t;
      return { card: { "--card-radius": jt(n) } };
    },
    Ir = $n((e, t) => {
      const n = nn("RadioCard", Fr, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
          checked: u,
          mod: d,
          withBorder: p,
          value: m,
          onClick: h,
          name: v,
          onKeyDown: y,
        } = n,
        g = i(n, Dr),
        b = bn({
          name: "RadioCard",
          classes: Lr,
          props: n,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          vars: c,
          varsResolver: Mr,
          rootSelector: "card",
        }),
        { dir: w } = Nr(),
        x = _r(),
        S =
          "boolean" === typeof u
            ? u
            : (null === x || void 0 === x ? void 0 : x.value) === m || !1,
        k = v || (null === x || void 0 === x ? void 0 : x.name);
      return (0, vt.jsx)(Or, {
        value: { checked: S },
        children: (0, vt.jsx)(
          Tr,
          f(
            f(
              f(
                { ref: t, mod: [{ "with-border": p, checked: S }, d] },
                b("card")
              ),
              g
            ),
            {},
            {
              role: "radio",
              "aria-checked": S,
              name: k,
              onClick: (e) => {
                null === h || void 0 === h || h(e),
                  null === x || void 0 === x || x.onChange(m || "");
              },
              onKeyDown: (e) => {
                if (
                  (null === y || void 0 === y || y(e),
                  ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(
                    e.nativeEvent.code
                  ))
                ) {
                  e.preventDefault();
                  const t = Array.from(
                      document.querySelectorAll(
                        '[role="radio"][name="'.concat(k || "__mantine", '"]')
                      )
                    ),
                    n = t.findIndex((t) => t === e.target),
                    r = n + 1 >= t.length ? 0 : n + 1,
                    o = n - 1 < 0 ? t.length - 1 : n - 1;
                  "ArrowDown" === e.nativeEvent.code &&
                    (t[r].focus(), t[r].click()),
                    "ArrowUp" === e.nativeEvent.code &&
                      (t[o].focus(), t[o].click()),
                    "ArrowLeft" === e.nativeEvent.code &&
                      (t["ltr" === w ? o : r].focus(),
                      t["ltr" === w ? o : r].click()),
                    "ArrowRight" === e.nativeEvent.code &&
                      (t["ltr" === w ? r : o].focus(),
                      t["ltr" === w ? r : o].click());
                }
              },
            }
          )
        ),
      });
    });
  function Vr(e) {
    let {
      value: t,
      defaultValue: n,
      finalValue: o,
      onChange: a = () => {},
    } = e;
    const [l, i] = (0, r.useState)(void 0 !== n ? n : o);
    return void 0 !== t
      ? [t, a, !0]
      : [
          l,
          function (e) {
            i(e);
            for (
              var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1;
              r < t;
              r++
            )
              n[r - 1] = arguments[r];
            null === a || void 0 === a || a(e, ...n);
          },
          !1,
        ];
  }
  function Wr(e) {
    let { children: t, role: n } = e;
    const r = Qn();
    return r
      ? (0, vt.jsx)("div", {
          role: n,
          "aria-labelledby": r.labelId,
          "aria-describedby": r.describedBy,
          children: t,
        })
      : (0, vt.jsx)(vt.Fragment, { children: t });
  }
  (Ir.displayName = "@mantine/core/RadioCard"), (Ir.classes = Lr);
  const Hr = [
      "value",
      "defaultValue",
      "onChange",
      "size",
      "wrapperProps",
      "children",
      "name",
      "readOnly",
    ],
    Br = {},
    Ur = $n((e, t) => {
      const n = nn("RadioGroup", Br, e),
        {
          value: r,
          defaultValue: o,
          onChange: a,
          size: l,
          wrapperProps: s,
          children: c,
          name: u,
          readOnly: d,
        } = n,
        p = i(n, Hr),
        m = wt(u),
        [h, v] = Vr({ value: r, defaultValue: o, finalValue: "", onChange: a });
      return (0, vt.jsx)(Rr, {
        value: {
          value: h,
          onChange: (e) =>
            !d && v("string" === typeof e ? e : e.currentTarget.value),
          size: l,
          name: m,
        },
        children: (0, vt.jsx)(
          wr.Wrapper,
          f(
            f(f({ size: l, ref: t }, s), p),
            {},
            {
              labelElement: "div",
              __staticSelector: "RadioGroup",
              children: (0, vt.jsx)(Wr, { role: "radiogroup", children: c }),
            }
          )
        ),
      });
    });
  (Ur.classes = wr.Wrapper.classes),
    (Ur.displayName = "@mantine/core/RadioGroup");
  const $r = ["size", "style"];
  function qr(e) {
    let { size: t, style: n } = e,
      r = i(e, $r);
    return (0, vt.jsx)(
      "svg",
      f(
        f(
          {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 5 5",
            style: f({ width: Ct(t), height: Ct(t) }, n),
            "aria-hidden": !0,
          },
          r
        ),
        {},
        {
          children: (0, vt.jsx)("circle", {
            cx: "2.5",
            cy: "2.5",
            r: "2.5",
            fill: "currentColor",
          }),
        }
      )
    );
  }
  var Yr = {
    indicator: "m_717d7ff6",
    icon: "m_3e4da632",
    "indicator--outline": "m_2980836c",
  };
  const Kr = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "icon",
      "radius",
      "color",
      "iconColor",
      "autoContrast",
      "checked",
      "mod",
      "variant",
      "disabled",
    ],
    Qr = { icon: qr },
    Xr = (e, t) => {
      let {
        radius: n,
        color: r,
        size: o,
        iconColor: a,
        variant: l,
        autoContrast: i,
      } = t;
      const s = Dt({ color: r || e.primaryColor, theme: e }),
        c =
          s.isThemeColor && void 0 === s.shade
            ? "var(--mantine-color-".concat(s.color, "-outline)")
            : s.color;
      return {
        indicator: {
          "--radio-size": Nt(o, "radio-size"),
          "--radio-radius": void 0 === n ? void 0 : jt(n),
          "--radio-color": "outline" === l ? c : Ft(r, e),
          "--radio-icon-size": Nt(o, "radio-icon-size"),
          "--radio-icon-color": a
            ? Ft(a, e)
            : Vt(i, e)
            ? Mt({ color: r, theme: e, autoContrast: i })
            : void 0,
        },
      };
    },
    Gr = $n((e, t) => {
      const n = nn("RadioIndicator", Qr, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
          icon: u,
          radius: d,
          color: p,
          iconColor: m,
          autoContrast: h,
          checked: v,
          mod: y,
          variant: g,
          disabled: b,
        } = n,
        w = i(n, Kr),
        x = u,
        S = bn({
          name: "RadioIndicator",
          classes: Yr,
          props: n,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          vars: c,
          varsResolver: Xr,
          rootSelector: "indicator",
        }),
        k = Ar(),
        C =
          "boolean" === typeof v
            ? v
            : (null === k || void 0 === k ? void 0 : k.checked) || !1;
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            f({ ref: t }, S("indicator", { variant: g })),
            {},
            { variant: g, mod: [{ checked: C, disabled: b }, y] },
            w
          ),
          {},
          { children: (0, vt.jsx)(x, f({}, S("icon"))) }
        )
      );
    });
  (Gr.displayName = "@mantine/core/RadioIndicator"), (Gr.classes = Yr);
  var Jr = {
    root: "m_f3f1af94",
    inner: "m_89c4f5e4",
    icon: "m_f3ed6b2b",
    radio: "m_8a3dbb89",
    "radio--outline": "m_1bfe9d39",
  };
  const Zr = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "id",
      "size",
      "label",
      "labelPosition",
      "description",
      "error",
      "radius",
      "color",
      "variant",
      "disabled",
      "wrapperProps",
      "icon",
      "rootRef",
      "iconColor",
      "onChange",
      "mod",
    ],
    eo = { labelPosition: "right" },
    to = (e, t) => {
      let {
        size: n,
        radius: r,
        color: o,
        iconColor: a,
        variant: l,
        autoContrast: i,
      } = t;
      const s = Dt({ color: o || e.primaryColor, theme: e }),
        c =
          s.isThemeColor && void 0 === s.shade
            ? "var(--mantine-color-".concat(s.color, "-outline)")
            : s.color;
      return {
        root: {
          "--radio-size": Nt(n, "radio-size"),
          "--radio-radius": void 0 === r ? void 0 : jt(r),
          "--radio-color": "outline" === l ? c : Ft(o, e),
          "--radio-icon-color": a
            ? Ft(a, e)
            : Vt(i, e)
            ? Mt({ color: o, theme: e, autoContrast: i })
            : void 0,
          "--radio-icon-size": Nt(n, "radio-icon-size"),
        },
      };
    },
    no = $n((e, t) => {
      var n, r;
      const o = nn("Radio", eo, e),
        {
          classNames: a,
          className: l,
          style: s,
          styles: c,
          unstyled: u,
          vars: d,
          id: p,
          size: m,
          label: h,
          labelPosition: v,
          description: y,
          error: g,
          radius: b,
          color: w,
          variant: x,
          disabled: S,
          wrapperProps: k,
          icon: C = qr,
          rootRef: E,
          iconColor: N,
          onChange: P,
          mod: j,
        } = o,
        z = i(o, Zr),
        T = bn({
          name: "Radio",
          classes: Jr,
          props: o,
          className: l,
          style: s,
          classNames: a,
          styles: c,
          unstyled: u,
          vars: d,
          varsResolver: to,
        }),
        R = _r(),
        _ =
          null !== (n = null === R || void 0 === R ? void 0 : R.size) &&
          void 0 !== n
            ? n
            : m,
        O = o.size ? m : _,
        { styleProps: A, rest: L } = xn(z),
        D = wt(p),
        F = R
          ? {
              checked: R.value === L.value,
              name: null !== (r = L.name) && void 0 !== r ? r : R.name,
              onChange: (e) => {
                R.onChange(e), null === P || void 0 === P || P(e);
              },
            }
          : {};
      return (0, vt.jsx)(
        Cr,
        f(
          f(
            f(
              f({}, T("root")),
              {},
              {
                __staticSelector: "Radio",
                __stylesApiProps: o,
                id: D,
                size: O,
                labelPosition: v,
                label: h,
                description: y,
                error: g,
                disabled: S,
                classNames: a,
                styles: c,
                unstyled: u,
                "data-checked": F.checked || void 0,
                variant: x,
                ref: E,
                mod: j,
              },
              A
            ),
            k
          ),
          {},
          {
            children: (0, vt.jsxs)(
              Bn,
              f(
                f({}, T("inner")),
                {},
                {
                  mod: { "label-position": v },
                  children: [
                    (0, vt.jsx)(
                      Bn,
                      f(
                        f(
                          f(
                            f({}, T("radio", { focusable: !0, variant: x })),
                            {},
                            { onChange: P },
                            L
                          ),
                          F
                        ),
                        {},
                        {
                          component: "input",
                          mod: { error: !!g },
                          ref: t,
                          id: D,
                          disabled: S,
                          type: "radio",
                        }
                      )
                    ),
                    (0, vt.jsx)(
                      C,
                      f(f({}, T("icon")), {}, { "aria-hidden": !0 })
                    ),
                  ],
                }
              )
            ),
          }
        )
      );
    });
  (no.classes = Jr),
    (no.displayName = "@mantine/core/Radio"),
    (no.Group = Ur),
    (no.Card = Ir),
    (no.Indicator = Gr);
  var ro = { root: "m_4081bf90" };
  const oo = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "children",
      "gap",
      "align",
      "justify",
      "wrap",
      "grow",
      "preventGrowOverflow",
      "vars",
      "variant",
      "__size",
      "mod",
    ],
    ao = {
      preventGrowOverflow: !0,
      gap: "md",
      align: "center",
      justify: "flex-start",
      wrap: "wrap",
    },
    lo = (e, t, n) => {
      let {
          grow: r,
          preventGrowOverflow: o,
          gap: a,
          align: l,
          justify: i,
          wrap: s,
        } = t,
        { childWidth: c } = n;
      return {
        root: {
          "--group-child-width": r && o ? c : void 0,
          "--group-gap": Pt(a),
          "--group-align": l,
          "--group-justify": i,
          "--group-wrap": s,
        },
      };
    },
    io = $n((e, t) => {
      const n = nn("Group", ao, e),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          children: u,
          gap: d,
          align: p,
          justify: m,
          wrap: h,
          grow: v,
          preventGrowOverflow: y,
          vars: g,
          variant: b,
          __size: w,
          mod: x,
        } = n,
        S = i(n, oo),
        k = (function (e) {
          return r.Children.toArray(e).filter(Boolean);
        })(u),
        C = k.length,
        E = Pt(null !== d && void 0 !== d ? d : "md"),
        N = bn({
          name: "Group",
          props: n,
          stylesCtx: {
            childWidth: "calc("
              .concat(100 / C, "% - (")
              .concat(E, " - ")
              .concat(E, " / ")
              .concat(C, "))"),
          },
          className: a,
          style: l,
          classes: ro,
          classNames: o,
          styles: s,
          unstyled: c,
          vars: g,
          varsResolver: lo,
        });
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            f({}, N("root")),
            {},
            { ref: t, variant: b, mod: [{ grow: v }, x], size: w },
            S
          ),
          {},
          { children: k }
        )
      );
    });
  (io.classes = ro), (io.displayName = "@mantine/core/Group");
  const so = (0, r.createContext)(null),
    co = so.Provider,
    uo = () => (0, r.useContext)(so),
    [fo, po] = Yn();
  var mo = { card: "m_26775b0a" };
  const ho = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "checked",
      "mod",
      "withBorder",
      "value",
      "onClick",
      "defaultChecked",
      "onChange",
    ],
    vo = { withBorder: !0 },
    yo = (e, t) => {
      let { radius: n } = t;
      return { card: { "--card-radius": jt(n) } };
    },
    go = $n((e, t) => {
      const n = nn("CheckboxCard", vo, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
          checked: u,
          mod: d,
          withBorder: p,
          value: m,
          onClick: h,
          defaultChecked: v,
          onChange: y,
        } = n,
        g = i(n, ho),
        b = bn({
          name: "CheckboxCard",
          classes: mo,
          props: n,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          vars: c,
          varsResolver: yo,
          rootSelector: "card",
        }),
        w = uo(),
        x = "boolean" === typeof u ? u : w ? w.value.includes(m || "") : void 0,
        [S, k] = Vr({ value: x, defaultValue: v, finalValue: !1, onChange: y });
      return (0, vt.jsx)(fo, {
        value: { checked: S },
        children: (0, vt.jsx)(
          Tr,
          f(
            f(
              f(
                { ref: t, mod: [{ "with-border": p, checked: S }, d] },
                b("card")
              ),
              g
            ),
            {},
            {
              role: "checkbox",
              "aria-checked": S,
              onClick: (e) => {
                null === h || void 0 === h || h(e),
                  null === w || void 0 === w || w.onChange(m || ""),
                  k(!S);
              },
            }
          )
        ),
      });
    });
  (go.displayName = "@mantine/core/CheckboxCard"), (go.classes = mo);
  const bo = [
      "value",
      "defaultValue",
      "onChange",
      "size",
      "wrapperProps",
      "children",
      "readOnly",
    ],
    wo = {},
    xo = $n((e, t) => {
      const n = nn("CheckboxGroup", wo, e),
        {
          value: r,
          defaultValue: o,
          onChange: a,
          size: l,
          wrapperProps: s,
          children: c,
          readOnly: u,
        } = n,
        d = i(n, bo),
        [p, m] = Vr({ value: r, defaultValue: o, finalValue: [], onChange: a });
      return (0, vt.jsx)(co, {
        value: {
          value: p,
          onChange: (e) => {
            const t = "string" === typeof e ? e : e.currentTarget.value;
            !u && m(p.includes(t) ? p.filter((e) => e !== t) : [...p, t]);
          },
          size: l,
        },
        children: (0, vt.jsx)(
          wr.Wrapper,
          f(
            f(f({ size: l, ref: t }, s), d),
            {},
            {
              labelElement: "div",
              __staticSelector: "CheckboxGroup",
              children: (0, vt.jsx)(Wr, { role: "group", children: c }),
            }
          )
        ),
      });
    });
  (xo.classes = wr.Wrapper.classes),
    (xo.displayName = "@mantine/core/CheckboxGroup");
  const So = ["size", "style"],
    ko = ["indeterminate"];
  function Co(e) {
    let { size: t, style: n } = e,
      r = i(e, So);
    const o = void 0 !== t ? f({ width: Ct(t), height: Ct(t) }, n) : n;
    return (0, vt.jsx)(
      "svg",
      f(
        f(
          {
            viewBox: "0 0 10 7",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: o,
            "aria-hidden": !0,
          },
          r
        ),
        {},
        {
          children: (0, vt.jsx)("path", {
            d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
          }),
        }
      )
    );
  }
  function Eo(e) {
    let { indeterminate: t } = e,
      n = i(e, ko);
    return t
      ? (0, vt.jsx)(
          "svg",
          f(
            f(
              {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 32 6",
                "aria-hidden": !0,
              },
              n
            ),
            {},
            {
              children: (0, vt.jsx)("rect", {
                width: "32",
                height: "6",
                fill: "currentColor",
                rx: "3",
              }),
            }
          )
        )
      : (0, vt.jsx)(Co, f({}, n));
  }
  var No = {
    indicator: "m_5e5256ee",
    icon: "m_1b1c543a",
    "indicator--outline": "m_76e20374",
  };
  const Po = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "icon",
      "indeterminate",
      "radius",
      "color",
      "iconColor",
      "autoContrast",
      "checked",
      "mod",
      "variant",
      "disabled",
    ],
    jo = { icon: Eo },
    zo = (e, t) => {
      let {
        radius: n,
        color: r,
        size: o,
        iconColor: a,
        variant: l,
        autoContrast: i,
      } = t;
      const s = Dt({ color: r || e.primaryColor, theme: e }),
        c =
          s.isThemeColor && void 0 === s.shade
            ? "var(--mantine-color-".concat(s.color, "-outline)")
            : s.color;
      return {
        indicator: {
          "--checkbox-size": Nt(o, "checkbox-size"),
          "--checkbox-radius": void 0 === n ? void 0 : jt(n),
          "--checkbox-color": "outline" === l ? c : Ft(r, e),
          "--checkbox-icon-color": a
            ? Ft(a, e)
            : Vt(i, e)
            ? Mt({ color: r, theme: e, autoContrast: i })
            : void 0,
        },
      };
    },
    To = $n((e, t) => {
      const n = nn("CheckboxIndicator", jo, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
          icon: u,
          indeterminate: d,
          radius: p,
          color: m,
          iconColor: h,
          autoContrast: v,
          checked: y,
          mod: g,
          variant: b,
          disabled: w,
        } = n,
        x = i(n, Po),
        S = u,
        k = bn({
          name: "CheckboxIndicator",
          classes: No,
          props: n,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          vars: c,
          varsResolver: zo,
          rootSelector: "indicator",
        }),
        C = po(),
        E =
          "boolean" === typeof y || "boolean" === typeof d
            ? y || d
            : (null === C || void 0 === C ? void 0 : C.checked) || !1;
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            f({ ref: t }, k("indicator", { variant: b })),
            {},
            { variant: b, mod: [{ checked: E, disabled: w }, g] },
            x
          ),
          {},
          { children: (0, vt.jsx)(S, f({ indeterminate: d }, k("icon"))) }
        )
      );
    });
  (To.displayName = "@mantine/core/CheckboxIndicator"), (To.classes = No);
  var Ro = {
    root: "m_bf2d988c",
    inner: "m_26062bec",
    input: "m_26063560",
    icon: "m_bf295423",
    "input--outline": "m_215c4542",
  };
  const _o = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "color",
      "label",
      "id",
      "size",
      "radius",
      "wrapperProps",
      "checked",
      "labelPosition",
      "description",
      "error",
      "disabled",
      "variant",
      "indeterminate",
      "icon",
      "rootRef",
      "iconColor",
      "onChange",
      "autoContrast",
      "mod",
    ],
    Oo = { labelPosition: "right", icon: Eo },
    Ao = (e, t) => {
      let {
        radius: n,
        color: r,
        size: o,
        iconColor: a,
        variant: l,
        autoContrast: i,
      } = t;
      const s = Dt({ color: r || e.primaryColor, theme: e }),
        c =
          s.isThemeColor && void 0 === s.shade
            ? "var(--mantine-color-".concat(s.color, "-outline)")
            : s.color;
      return {
        root: {
          "--checkbox-size": Nt(o, "checkbox-size"),
          "--checkbox-radius": void 0 === n ? void 0 : jt(n),
          "--checkbox-color": "outline" === l ? c : Ft(r, e),
          "--checkbox-icon-color": a
            ? Ft(a, e)
            : Vt(i, e)
            ? Mt({ color: r, theme: e, autoContrast: i })
            : void 0,
        },
      };
    },
    Lo = $n((e, t) => {
      const n = nn("Checkbox", Oo, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
          color: u,
          label: d,
          id: p,
          size: m,
          radius: h,
          wrapperProps: v,
          checked: y,
          labelPosition: g,
          description: b,
          error: w,
          disabled: x,
          variant: S,
          indeterminate: k,
          icon: C,
          rootRef: E,
          iconColor: N,
          onChange: P,
          autoContrast: j,
          mod: z,
        } = n,
        T = i(n, _o),
        R = uo(),
        _ = m || (null === R || void 0 === R ? void 0 : R.size),
        O = C,
        A = bn({
          name: "Checkbox",
          props: n,
          classes: Ro,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          vars: c,
          varsResolver: Ao,
        }),
        { styleProps: L, rest: D } = xn(T),
        F = wt(p),
        M = R
          ? {
              checked: R.value.includes(D.value),
              onChange: (e) => {
                R.onChange(e), null === P || void 0 === P || P(e);
              },
            }
          : {};
      return (0, vt.jsx)(
        Cr,
        f(
          f(
            f(
              f({}, A("root")),
              {},
              {
                __staticSelector: "Checkbox",
                __stylesApiProps: n,
                id: F,
                size: _,
                labelPosition: g,
                label: d,
                description: b,
                error: w,
                disabled: x,
                classNames: r,
                styles: l,
                unstyled: s,
                "data-checked": M.checked || y || void 0,
                variant: S,
                ref: E,
                mod: z,
              },
              L
            ),
            v
          ),
          {},
          {
            children: (0, vt.jsxs)(
              Bn,
              f(
                f({}, A("inner")),
                {},
                {
                  mod: { "data-label-position": g },
                  children: [
                    (0, vt.jsx)(
                      Bn,
                      f(
                        f(
                          f(
                            f(
                              {
                                component: "input",
                                id: F,
                                ref: t,
                                checked: y,
                                disabled: x,
                                mod: { error: !!w, indeterminate: k },
                              },
                              A("input", { focusable: !0, variant: S })
                            ),
                            {},
                            { onChange: P },
                            D
                          ),
                          M
                        ),
                        {},
                        { type: "checkbox" }
                      )
                    ),
                    (0, vt.jsx)(O, f({ indeterminate: k }, A("icon"))),
                  ],
                }
              )
            ),
          }
        )
      );
    });
  function Do(e) {
    let { classNames: t, styles: n, props: r, stylesCtx: o } = e;
    const a = en();
    return {
      resolvedClassNames: dn({
        theme: a,
        classNames: t,
        props: r,
        stylesCtx: o || void 0,
      }),
      resolvedStyles: mn({
        theme: a,
        styles: n,
        props: r,
        stylesCtx: o || void 0,
      }),
    };
  }
  function Fo(e) {
    return "string" === typeof e
      ? { value: e, label: e }
      : "value" in e && !("label" in e)
      ? { value: e.value, label: e.value, disabled: e.disabled }
      : "number" === typeof e
      ? { value: e.toString(), label: e.toString() }
      : "group" in e
      ? { group: e.group, items: e.items.map((e) => Fo(e)) }
      : e;
  }
  function Mo(e) {
    return e ? e.map((e) => Fo(e)) : [];
  }
  function Io(e) {
    return e.reduce(
      (e, t) =>
        "group" in t ? f(f({}, e), Io(t.items)) : ((e[t.value] = t), e),
      {}
    );
  }
  (Lo.classes = f(f({}, Ro), kr)),
    (Lo.displayName = "@mantine/core/Checkbox"),
    (Lo.Group = xo),
    (Lo.Indicator = To),
    (Lo.Card = go);
  const Vo = ["mousedown", "touchstart"];
  const Wo = { app: 100, modal: 200, popover: 300, overlay: 400, max: 9999 };
  function Ho(e) {
    return Wo[e];
  }
  function Bo(e, t) {
    if ("rtl" === e && (t.includes("right") || t.includes("left"))) {
      const [e, n] = t.split("-"),
        r = "right" === e ? "left" : "right";
      return void 0 === n ? r : "".concat(r, "-").concat(n);
    }
    return t;
  }
  function Uo(e) {
    const t = (0, r.createContext)(null);
    return [
      (e) => {
        let { children: n, value: r } = e;
        return (0, vt.jsx)(t.Provider, { value: r, children: n });
      },
      () => {
        const n = (0, r.useContext)(t);
        if (null === n) throw new Error(e);
        return n;
      },
    ];
  }
  const [$o, qo] = Uo("Popover component was not found in the tree");
  function Yo(e, t) {
    const n = (0, r.useRef)(!1);
    (0, r.useEffect)(
      () => () => {
        n.current = !1;
      },
      []
    ),
      (0, r.useEffect)(() => {
        if (n.current) return e();
        n.current = !0;
      }, t);
  }
  function Ko(e, t) {
    "function" === typeof e
      ? e(t)
      : "object" === typeof e &&
        null !== e &&
        "current" in e &&
        (e.current = t);
  }
  function Qo() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return (0, r.useCallback)(
      (function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        return (e) => {
          t.forEach((t) => Ko(t, e));
        };
      })(...t),
      t
    );
  }
  const Xo = () => {};
  function Go(e) {
    let t =
      arguments.length > 1 && void 0 !== arguments[1]
        ? arguments[1]
        : { active: !0 };
    return "function" === typeof e && t.active
      ? (n) => {
          var r;
          "Escape" === n.key &&
            (e(n), null === (r = t.onTrigger) || void 0 === r || r.call(t));
        }
      : t.onKeyDown || Xo;
  }
  function Jo(e, t, n, r) {
    return "center" === e || "center" === r
      ? { top: t }
      : "end" === e
      ? { bottom: n }
      : "start" === e
      ? { top: n }
      : {};
  }
  function Zo(e, t, n, r, o) {
    return "center" === e || "center" === r
      ? { left: t }
      : "end" === e
      ? { ["ltr" === o ? "right" : "left"]: n }
      : "start" === e
      ? { ["ltr" === o ? "left" : "right"]: n }
      : {};
  }
  const ea = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius",
  };
  function ta(e) {
    let {
      position: t,
      arrowSize: n,
      arrowOffset: r,
      arrowRadius: o,
      arrowPosition: a,
      arrowX: l,
      arrowY: i,
      dir: s,
    } = e;
    const [c, u = "center"] = t.split("-"),
      d = {
        width: n,
        height: n,
        transform: "rotate(45deg)",
        position: "absolute",
        [ea[c]]: o,
      },
      p = -n / 2;
    return "left" === c
      ? f(
          f(f({}, d), Jo(u, i, r, a)),
          {},
          {
            right: p,
            borderLeftColor: "transparent",
            borderBottomColor: "transparent",
            clipPath: "polygon(100% 0, 0 0, 100% 100%)",
          }
        )
      : "right" === c
      ? f(
          f(f({}, d), Jo(u, i, r, a)),
          {},
          {
            left: p,
            borderRightColor: "transparent",
            borderTopColor: "transparent",
            clipPath: "polygon(0 100%, 0 0, 100% 100%)",
          }
        )
      : "top" === c
      ? f(
          f(f({}, d), Zo(u, l, r, a, s)),
          {},
          {
            bottom: p,
            borderTopColor: "transparent",
            borderLeftColor: "transparent",
            clipPath: "polygon(0 100%, 100% 100%, 100% 0)",
          }
        )
      : "bottom" === c
      ? f(
          f(f({}, d), Zo(u, l, r, a, s)),
          {},
          {
            top: p,
            borderBottomColor: "transparent",
            borderRightColor: "transparent",
            clipPath: "polygon(0 100%, 0 0, 100% 0)",
          }
        )
      : {};
  }
  const na = [
      "position",
      "arrowSize",
      "arrowOffset",
      "arrowRadius",
      "arrowPosition",
      "visible",
      "arrowX",
      "arrowY",
      "style",
    ],
    ra = (0, r.forwardRef)((e, t) => {
      let {
          position: n,
          arrowSize: r,
          arrowOffset: o,
          arrowRadius: a,
          arrowPosition: l,
          visible: s,
          arrowX: c,
          arrowY: u,
          style: d,
        } = e,
        p = i(e, na);
      const { dir: m } = Nr();
      return s
        ? (0, vt.jsx)(
            "div",
            f(
              f({}, p),
              {},
              {
                ref: t,
                style: f(
                  f({}, d),
                  ta({
                    position: n,
                    arrowSize: r,
                    arrowOffset: o,
                    arrowRadius: a,
                    arrowPosition: l,
                    dir: m,
                    arrowX: c,
                    arrowY: u,
                  })
                ),
              }
            )
          )
        : null;
    });
  ra.displayName = "@mantine/core/FloatingArrow";
  const oa = /input|select|textarea|button|object/,
    aa = "a, input, select, textarea, button, object, [tabindex]";
  function la(e) {
    return "none" === e.style.display;
  }
  function ia(e) {
    let t = e.getAttribute("tabindex");
    return null === t && (t = void 0), parseInt(t, 10);
  }
  function sa(e) {
    const t = e.nodeName.toLowerCase(),
      n = !Number.isNaN(ia(e));
    return (
      ((oa.test(t) && !e.disabled) ||
        (e instanceof HTMLAnchorElement && e.href) ||
        n) &&
      (function (e) {
        if (
          e.getAttribute("aria-hidden") ||
          e.getAttribute("hidden") ||
          "hidden" === e.getAttribute("type")
        )
          return !1;
        let t = e;
        for (; t && t !== document.body && 11 !== t.nodeType; ) {
          if (la(t)) return !1;
          t = t.parentNode;
        }
        return !0;
      })(e)
    );
  }
  function ca(e) {
    const t = ia(e);
    return (Number.isNaN(t) || t >= 0) && sa(e);
  }
  function ua(e, t) {
    const n = ((r = e), Array.from(r.querySelectorAll(aa)).filter(ca));
    var r;
    if (!n.length) return void t.preventDefault();
    const o = n[t.shiftKey ? 0 : n.length - 1],
      a = e.getRootNode();
    let l = o === a.activeElement || e === a.activeElement;
    const i = a.activeElement;
    if ("INPUT" === i.tagName && "radio" === i.getAttribute("type")) {
      const e = n.filter(
        (e) =>
          "radio" === e.getAttribute("type") &&
          e.getAttribute("name") === i.getAttribute("name")
      );
      l = e.includes(o);
    }
    if (!l) return;
    t.preventDefault();
    const s = n[t.shiftKey ? n.length - 1 : 0];
    s && s.focus();
  }
  function da(e) {
    return (
      !Array.isArray(e) &&
      null !== e &&
      "object" === typeof e &&
      e.type !== r.Fragment
    );
  }
  var fa = { root: "m_515a97f8" };
  const pa = ["classNames", "className", "style", "styles", "unstyled", "vars"],
    ma = {},
    ha = $n((e, t) => {
      const n = nn("VisuallyHidden", ma, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
        } = n,
        u = i(n, pa),
        d = bn({
          name: "VisuallyHidden",
          classes: fa,
          props: n,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
        });
      return (0, vt.jsx)(Bn, f(f({ component: "span", ref: t }, d("root")), u));
    });
  function va(e) {
    let { children: t, active: n = !0, refProp: o = "ref", innerRef: a } = e;
    const l = (function () {
        let e =
          !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        const t = (0, r.useRef)(null),
          n = (e) => {
            let t = e.querySelector("[data-autofocus]");
            if (!t) {
              const n = Array.from(e.querySelectorAll(aa));
              (t = n.find(ca) || n.find(sa) || null), !t && sa(e) && (t = e);
            }
            t && t.focus({ preventScroll: !0 });
          },
          o = (0, r.useCallback)(
            (r) => {
              e &&
                null !== r &&
                t.current !== r &&
                (r
                  ? (setTimeout(() => {
                      r.getRootNode() && n(r);
                    }),
                    (t.current = r))
                  : (t.current = null));
            },
            [e]
          );
        return (
          (0, r.useEffect)(() => {
            if (!e) return;
            t.current && setTimeout(() => n(t.current));
            const r = (e) => {
              "Tab" === e.key && t.current && ua(t.current, e);
            };
            return (
              document.addEventListener("keydown", r),
              () => document.removeEventListener("keydown", r)
            );
          }, [e]),
          o
        );
      })(n),
      i = Qo(l, a);
    return da(t) ? (0, r.cloneElement)(t, { [o]: i }) : t;
  }
  function ya(e) {
    return (0, vt.jsx)(ha, f({ tabIndex: -1, "data-autofocus": !0 }, e));
  }
  (ha.classes = fa),
    (ha.displayName = "@mantine/core/VisuallyHidden"),
    (va.displayName = "@mantine/core/FocusTrap"),
    (ya.displayName = "@mantine/core/FocusTrapInitialFocus"),
    (va.InitialFocus = ya);
  var ga = n(950);
  const ba = ["children", "target"];
  const wa = {},
    xa = (0, r.forwardRef)((e, t) => {
      const n = nn("Portal", wa, e),
        { children: o, target: a } = n,
        l = i(n, ba),
        [s, c] = (0, r.useState)(!1),
        u = (0, r.useRef)(null);
      return (
        yt(
          () => (
            c(!0),
            (u.current = a
              ? "string" === typeof a
                ? document.querySelector(a)
                : a
              : (function (e) {
                  const t = document.createElement("div");
                  return (
                    t.setAttribute("data-portal", "true"),
                    "string" === typeof e.className &&
                      t.classList.add(
                        ...e.className.split(" ").filter(Boolean)
                      ),
                    "object" === typeof e.style &&
                      Object.assign(t.style, e.style),
                    "string" === typeof e.id && t.setAttribute("id", e.id),
                    t
                  );
                })(l)),
            Ko(t, u.current),
            !a && u.current && document.body.appendChild(u.current),
            () => {
              !a && u.current && document.body.removeChild(u.current);
            }
          ),
          [a]
        ),
        s && u.current
          ? (0, ga.createPortal)(
              (0, vt.jsx)(vt.Fragment, { children: o }),
              u.current
            )
          : null
      );
    });
  xa.displayName = "@mantine/core/Portal";
  const Sa = ["withinPortal", "children"];
  function ka(e) {
    let { withinPortal: t = !0, children: n } = e,
      r = i(e, Sa);
    return t
      ? (0, vt.jsx)(xa, f(f({}, r), {}, { children: n }))
      : (0, vt.jsx)(vt.Fragment, { children: n });
  }
  ka.displayName = "@mantine/core/OptionalPortal";
  const Ca = (e) => ({
      in: { opacity: 1, transform: "scale(1)" },
      out: {
        opacity: 0,
        transform: "scale(.9) translateY(".concat(
          Ct("bottom" === e ? 10 : -10),
          ")"
        ),
      },
      transitionProperty: "transform, opacity",
    }),
    Ea = {
      fade: {
        in: { opacity: 1 },
        out: { opacity: 0 },
        transitionProperty: "opacity",
      },
      "fade-up": {
        in: { opacity: 1, transform: "translateY(0)" },
        out: { opacity: 0, transform: "translateY(".concat(Ct(30)) },
        transitionProperty: "opacity, transform",
      },
      "fade-down": {
        in: { opacity: 1, transform: "translateY(0)" },
        out: { opacity: 0, transform: "translateY(".concat(Ct(-30)) },
        transitionProperty: "opacity, transform",
      },
      "fade-left": {
        in: { opacity: 1, transform: "translateX(0)" },
        out: { opacity: 0, transform: "translateX(".concat(Ct(30)) },
        transitionProperty: "opacity, transform",
      },
      "fade-right": {
        in: { opacity: 1, transform: "translateX(0)" },
        out: { opacity: 0, transform: "translateX(".concat(Ct(-30)) },
        transitionProperty: "opacity, transform",
      },
      scale: {
        in: { opacity: 1, transform: "scale(1)" },
        out: { opacity: 0, transform: "scale(0)" },
        common: { transformOrigin: "top" },
        transitionProperty: "transform, opacity",
      },
      "scale-y": {
        in: { opacity: 1, transform: "scaleY(1)" },
        out: { opacity: 0, transform: "scaleY(0)" },
        common: { transformOrigin: "top" },
        transitionProperty: "transform, opacity",
      },
      "scale-x": {
        in: { opacity: 1, transform: "scaleX(1)" },
        out: { opacity: 0, transform: "scaleX(0)" },
        common: { transformOrigin: "left" },
        transitionProperty: "transform, opacity",
      },
      "skew-up": {
        in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
        out: {
          opacity: 0,
          transform: "translateY(".concat(Ct(-20), ") skew(-10deg, -5deg)"),
        },
        common: { transformOrigin: "top" },
        transitionProperty: "transform, opacity",
      },
      "skew-down": {
        in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
        out: {
          opacity: 0,
          transform: "translateY(".concat(Ct(20), ") skew(-10deg, -5deg)"),
        },
        common: { transformOrigin: "bottom" },
        transitionProperty: "transform, opacity",
      },
      "rotate-left": {
        in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
        out: {
          opacity: 0,
          transform: "translateY(".concat(Ct(20), ") rotate(-5deg)"),
        },
        common: { transformOrigin: "bottom" },
        transitionProperty: "transform, opacity",
      },
      "rotate-right": {
        in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
        out: {
          opacity: 0,
          transform: "translateY(".concat(Ct(20), ") rotate(5deg)"),
        },
        common: { transformOrigin: "top" },
        transitionProperty: "transform, opacity",
      },
      "slide-down": {
        in: { opacity: 1, transform: "translateY(0)" },
        out: { opacity: 0, transform: "translateY(-100%)" },
        common: { transformOrigin: "top" },
        transitionProperty: "transform, opacity",
      },
      "slide-up": {
        in: { opacity: 1, transform: "translateY(0)" },
        out: { opacity: 0, transform: "translateY(100%)" },
        common: { transformOrigin: "bottom" },
        transitionProperty: "transform, opacity",
      },
      "slide-left": {
        in: { opacity: 1, transform: "translateX(0)" },
        out: { opacity: 0, transform: "translateX(100%)" },
        common: { transformOrigin: "left" },
        transitionProperty: "transform, opacity",
      },
      "slide-right": {
        in: { opacity: 1, transform: "translateX(0)" },
        out: { opacity: 0, transform: "translateX(-100%)" },
        common: { transformOrigin: "right" },
        transitionProperty: "transform, opacity",
      },
      pop: f(
        f({}, Ca("bottom")),
        {},
        { common: { transformOrigin: "center center" } }
      ),
      "pop-bottom-left": f(
        f({}, Ca("bottom")),
        {},
        { common: { transformOrigin: "bottom left" } }
      ),
      "pop-bottom-right": f(
        f({}, Ca("bottom")),
        {},
        { common: { transformOrigin: "bottom right" } }
      ),
      "pop-top-left": f(
        f({}, Ca("top")),
        {},
        { common: { transformOrigin: "top left" } }
      ),
      "pop-top-right": f(
        f({}, Ca("top")),
        {},
        { common: { transformOrigin: "top right" } }
      ),
    },
    Na = {
      entering: "in",
      entered: "in",
      exiting: "out",
      exited: "out",
      "pre-exiting": "out",
      "pre-entering": "out",
    };
  function Pa(e) {
    let { transition: t, state: n, duration: r, timingFunction: o } = e;
    const a = {
      transitionDuration: "".concat(r, "ms"),
      transitionTimingFunction: o,
    };
    return "string" === typeof t
      ? t in Ea
        ? f(
            f(
              f({ transitionProperty: Ea[t].transitionProperty }, a),
              Ea[t].common
            ),
            Ea[t][Na[n]]
          )
        : {}
      : f(
          f(f({ transitionProperty: t.transitionProperty }, a), t.common),
          t[Na[n]]
        );
  }
  function ja(e, t) {
    let { getInitialValueInEffect: n } =
      arguments.length > 2 && void 0 !== arguments[2]
        ? arguments[2]
        : { getInitialValueInEffect: !0 };
    const [o, a] = (0, r.useState)(
        n
          ? t
          : (function (e) {
              return (
                "undefined" !== typeof window &&
                "matchMedia" in window &&
                window.matchMedia(e).matches
              );
            })(e)
      ),
      l = (0, r.useRef)(null);
    return (
      (0, r.useEffect)(() => {
        if ("matchMedia" in window)
          return (
            (l.current = window.matchMedia(e)),
            a(l.current.matches),
            (function (e, t) {
              try {
                return (
                  e.addEventListener("change", t),
                  () => e.removeEventListener("change", t)
                );
              } catch (ap) {
                return e.addListener(t), () => e.removeListener(t);
              }
            })(l.current, (e) => a(e.matches))
          );
      }, [e]),
      o
    );
  }
  function za(e, t) {
    return ja("(prefers-reduced-motion: reduce)", e, t);
  }
  function Ta(e) {
    let {
      duration: t,
      exitDuration: n,
      timingFunction: o,
      mounted: a,
      onEnter: l,
      onExit: i,
      onEntered: s,
      onExited: c,
      enterDelay: u,
      exitDelay: d,
    } = e;
    const f = en(),
      p = za(),
      m = !!f.respectReducedMotion && p,
      [h, v] = (0, r.useState)(m ? 0 : t),
      [y, g] = (0, r.useState)(a ? "entered" : "exited"),
      b = (0, r.useRef)(-1),
      w = (0, r.useRef)(-1),
      x = (0, r.useRef)(-1),
      S = (e) => {
        const r = e ? l : i,
          o = e ? s : c;
        window.clearTimeout(b.current);
        const a = m ? 0 : e ? t : n;
        v(a),
          0 === a
            ? ("function" === typeof r && r(),
              "function" === typeof o && o(),
              g(e ? "entered" : "exited"))
            : (x.current = requestAnimationFrame(() => {
                ga.flushSync(() => {
                  g(e ? "pre-entering" : "pre-exiting");
                }),
                  (x.current = requestAnimationFrame(() => {
                    "function" === typeof r && r(),
                      g(e ? "entering" : "exiting"),
                      (b.current = window.setTimeout(() => {
                        "function" === typeof o && o(),
                          g(e ? "entered" : "exited");
                      }, a));
                  }));
              }));
      };
    return (
      Yo(() => {
        var e;
        (e = a),
          window.clearTimeout(w.current),
          "number" === typeof (e ? u : d)
            ? (w.current = window.setTimeout(
                () => {
                  S(e);
                },
                e ? u : d
              ))
            : S(e);
      }, [a]),
      (0, r.useEffect)(
        () => () => {
          window.clearTimeout(b.current), cancelAnimationFrame(x.current);
        },
        []
      ),
      {
        transitionDuration: h,
        transitionStatus: y,
        transitionTimingFunction: o || "ease",
      }
    );
  }
  function Ra(e) {
    let {
      keepMounted: t,
      transition: n = "fade",
      duration: r = 250,
      exitDuration: o = r,
      mounted: a,
      children: l,
      timingFunction: i = "ease",
      onExit: s,
      onEntered: c,
      onEnter: u,
      onExited: d,
      enterDelay: f,
      exitDelay: p,
    } = e;
    const {
      transitionDuration: m,
      transitionStatus: h,
      transitionTimingFunction: v,
    } = Ta({
      mounted: a,
      exitDuration: o,
      duration: r,
      timingFunction: i,
      onExit: s,
      onEntered: c,
      onEnter: u,
      onExited: d,
      enterDelay: f,
      exitDelay: p,
    });
    return 0 === m
      ? a
        ? (0, vt.jsx)(vt.Fragment, { children: l({}) })
        : t
        ? l({ display: "none" })
        : null
      : "exited" === h
      ? t
        ? l({ display: "none" })
        : null
      : (0, vt.jsx)(vt.Fragment, {
          children: l(
            Pa({ transition: n, duration: m, state: h, timingFunction: v })
          ),
        });
  }
  Ra.displayName = "@mantine/core/Transition";
  var _a = { dropdown: "m_38a85659", arrow: "m_a31dc6c1" };
  const Oa = [
      "className",
      "style",
      "vars",
      "children",
      "onKeyDownCapture",
      "variant",
      "classNames",
      "styles",
    ],
    Aa = {},
    La = $n((e, t) => {
      var n, o, a, l, s;
      const c = nn("PopoverDropdown", Aa, e),
        {
          className: u,
          style: d,
          vars: p,
          children: m,
          onKeyDownCapture: h,
          variant: v,
          classNames: y,
          styles: g,
        } = c,
        b = i(c, Oa),
        w = qo(),
        x = (function (e) {
          let { opened: t, shouldReturnFocus: n = !0 } = e;
          const o = (0, r.useRef)(null),
            a = () => {
              var e;
              o.current &&
                "focus" in o.current &&
                "function" === typeof o.current.focus &&
                (null === (e = o.current) ||
                  void 0 === e ||
                  e.focus({ preventScroll: !0 }));
            };
          return (
            Yo(() => {
              let e = -1;
              const r = (t) => {
                "Tab" === t.key && window.clearTimeout(e);
              };
              return (
                document.addEventListener("keydown", r),
                t
                  ? (o.current = document.activeElement)
                  : n && (e = window.setTimeout(a, 10)),
                () => {
                  window.clearTimeout(e),
                    document.removeEventListener("keydown", r);
                }
              );
            }, [t, n]),
            a
          );
        })({ opened: w.opened, shouldReturnFocus: w.returnFocus }),
        S = w.withRoles
          ? {
              "aria-labelledby": w.getTargetId(),
              id: w.getDropdownId(),
              role: "dialog",
              tabIndex: -1,
            }
          : {},
        k = Qo(t, w.floating);
      return w.disabled
        ? null
        : (0, vt.jsx)(
            ka,
            f(
              f({}, w.portalProps),
              {},
              {
                withinPortal: w.withinPortal,
                children: (0, vt.jsx)(
                  Ra,
                  f(
                    f({ mounted: w.opened }, w.transitionProps),
                    {},
                    {
                      transition:
                        (null === (n = w.transitionProps) || void 0 === n
                          ? void 0
                          : n.transition) || "fade",
                      duration:
                        null !==
                          (o =
                            null === (a = w.transitionProps) || void 0 === a
                              ? void 0
                              : a.duration) && void 0 !== o
                          ? o
                          : 150,
                      keepMounted: w.keepMounted,
                      exitDuration:
                        "number" ===
                        typeof (null === (l = w.transitionProps) || void 0 === l
                          ? void 0
                          : l.exitDuration)
                          ? w.transitionProps.exitDuration
                          : null === (s = w.transitionProps) || void 0 === s
                          ? void 0
                          : s.duration,
                      children: (e) => {
                        var t, n;
                        return (0, vt.jsx)(va, {
                          active: w.trapFocus && w.opened,
                          innerRef: k,
                          children: (0, vt.jsxs)(
                            Bn,
                            f(
                              f(
                                f(f({}, S), b),
                                {},
                                {
                                  variant: v,
                                  onKeyDownCapture: Go(w.onClose, {
                                    active: w.closeOnEscape,
                                    onTrigger: x,
                                    onKeyDown: h,
                                  }),
                                  "data-position": w.placement,
                                  "data-fixed":
                                    "fixed" === w.floatingStrategy || void 0,
                                },
                                w.getStyles("dropdown", {
                                  className: u,
                                  props: c,
                                  classNames: y,
                                  styles: g,
                                  style: [
                                    f(
                                      f({}, e),
                                      {},
                                      {
                                        zIndex: w.zIndex,
                                        top:
                                          null !== (t = w.y) && void 0 !== t
                                            ? t
                                            : 0,
                                        left:
                                          null !== (n = w.x) && void 0 !== n
                                            ? n
                                            : 0,
                                        width:
                                          "target" === w.width
                                            ? void 0
                                            : Ct(w.width),
                                      }
                                    ),
                                    w.resolvedStyles.dropdown,
                                    null === g || void 0 === g
                                      ? void 0
                                      : g.dropdown,
                                    d,
                                  ],
                                })
                              ),
                              {},
                              {
                                children: [
                                  m,
                                  (0, vt.jsx)(
                                    ra,
                                    f(
                                      {
                                        ref: w.arrowRef,
                                        arrowX: w.arrowX,
                                        arrowY: w.arrowY,
                                        visible: w.withArrow,
                                        position: w.placement,
                                        arrowSize: w.arrowSize,
                                        arrowRadius: w.arrowRadius,
                                        arrowOffset: w.arrowOffset,
                                        arrowPosition: w.arrowPosition,
                                      },
                                      w.getStyles("arrow", {
                                        props: c,
                                        classNames: y,
                                        styles: g,
                                      })
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        });
                      },
                    }
                  )
                ),
              }
            )
          );
    });
  function Da(e) {
    var t;
    const n = r.version;
    return "string" !== typeof r.version || n.startsWith("18.")
      ? null === e || void 0 === e
        ? void 0
        : e.ref
      : null === e || void 0 === e || null === (t = e.props) || void 0 === t
      ? void 0
      : t.ref;
  }
  (La.classes = _a), (La.displayName = "@mantine/core/PopoverDropdown");
  const Fa = ["children", "refProp", "popupType"],
    Ma = { refProp: "ref", popupType: "dialog" },
    Ia = $n((e, t) => {
      const n = nn("PopoverTarget", Ma, e),
        { children: o, refProp: a, popupType: l } = n,
        s = i(n, Fa);
      if (!da(o))
        throw new Error(
          "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
        );
      const c = s,
        u = qo(),
        d = Qo(u.reference, Da(o), t),
        p = u.withRoles
          ? {
              "aria-haspopup": l,
              "aria-expanded": u.opened,
              "aria-controls": u.getDropdownId(),
              id: u.getTargetId(),
            }
          : {};
      return (0, r.cloneElement)(
        o,
        f(
          f(f(f({}, c), p), u.targetProps),
          {},
          {
            className: sn(
              u.targetProps.className,
              c.className,
              o.props.className
            ),
            [a]: d,
          },
          u.controlled ? null : { onClick: u.onToggle }
        )
      );
    });
  Ia.displayName = "@mantine/core/PopoverTarget";
  const Va = Math.min,
    Wa = Math.max,
    Ha = Math.round,
    Ba = Math.floor,
    Ua = (e) => ({ x: e, y: e }),
    $a = { left: "right", right: "left", bottom: "top", top: "bottom" },
    qa = { start: "end", end: "start" };
  function Ya(e, t, n) {
    return Wa(e, Va(t, n));
  }
  function Ka(e, t) {
    return "function" === typeof e ? e(t) : e;
  }
  function Qa(e) {
    return e.split("-")[0];
  }
  function Xa(e) {
    return e.split("-")[1];
  }
  function Ga(e) {
    return "x" === e ? "y" : "x";
  }
  function Ja(e) {
    return "y" === e ? "height" : "width";
  }
  function Za(e) {
    return ["top", "bottom"].includes(Qa(e)) ? "y" : "x";
  }
  function el(e) {
    return Ga(Za(e));
  }
  function tl(e) {
    return e.replace(/start|end/g, (e) => qa[e]);
  }
  function nl(e) {
    return e.replace(/left|right|bottom|top/g, (e) => $a[e]);
  }
  function rl(e) {
    return "number" !== typeof e
      ? (function (e) {
          return f({ top: 0, right: 0, bottom: 0, left: 0 }, e);
        })(e)
      : { top: e, right: e, bottom: e, left: e };
  }
  function ol(e) {
    const { x: t, y: n, width: r, height: o } = e;
    return {
      width: r,
      height: o,
      top: n,
      left: t,
      right: t + r,
      bottom: n + o,
      x: t,
      y: n,
    };
  }
  const al = [
      "mainAxis",
      "crossAxis",
      "fallbackPlacements",
      "fallbackStrategy",
      "fallbackAxisSideDirection",
      "flipAlignment",
    ],
    ll = ["mainAxis", "crossAxis", "limiter"],
    il = ["apply"];
  function sl(e, t, n) {
    let { reference: r, floating: o } = e;
    const a = Za(t),
      l = el(t),
      i = Ja(l),
      s = Qa(t),
      c = "y" === a,
      u = r.x + r.width / 2 - o.width / 2,
      d = r.y + r.height / 2 - o.height / 2,
      f = r[i] / 2 - o[i] / 2;
    let p;
    switch (s) {
      case "top":
        p = { x: u, y: r.y - o.height };
        break;
      case "bottom":
        p = { x: u, y: r.y + r.height };
        break;
      case "right":
        p = { x: r.x + r.width, y: d };
        break;
      case "left":
        p = { x: r.x - o.width, y: d };
        break;
      default:
        p = { x: r.x, y: r.y };
    }
    switch (Xa(t)) {
      case "start":
        p[l] -= f * (n && c ? -1 : 1);
        break;
      case "end":
        p[l] += f * (n && c ? -1 : 1);
    }
    return p;
  }
  async function cl(e, t) {
    var n;
    void 0 === t && (t = {});
    const { x: r, y: o, platform: a, rects: l, elements: i, strategy: s } = e,
      {
        boundary: c = "clippingAncestors",
        rootBoundary: u = "viewport",
        elementContext: d = "floating",
        altBoundary: f = !1,
        padding: p = 0,
      } = Ka(t, e),
      m = rl(p),
      h = i[f ? ("floating" === d ? "reference" : "floating") : d],
      v = ol(
        await a.getClippingRect({
          element:
            null ==
              (n = await (null == a.isElement ? void 0 : a.isElement(h))) || n
              ? h
              : h.contextElement ||
                (await (null == a.getDocumentElement
                  ? void 0
                  : a.getDocumentElement(i.floating))),
          boundary: c,
          rootBoundary: u,
          strategy: s,
        })
      ),
      y =
        "floating" === d
          ? { x: r, y: o, width: l.floating.width, height: l.floating.height }
          : l.reference,
      g = await (null == a.getOffsetParent
        ? void 0
        : a.getOffsetParent(i.floating)),
      b = ((await (null == a.isElement ? void 0 : a.isElement(g))) &&
        (await (null == a.getScale ? void 0 : a.getScale(g)))) || {
        x: 1,
        y: 1,
      },
      w = ol(
        a.convertOffsetParentRelativeRectToViewportRelativeRect
          ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
              elements: i,
              rect: y,
              offsetParent: g,
              strategy: s,
            })
          : y
      );
    return {
      top: (v.top - w.top + m.top) / b.y,
      bottom: (w.bottom - v.bottom + m.bottom) / b.y,
      left: (v.left - w.left + m.left) / b.x,
      right: (w.right - v.right + m.right) / b.x,
    };
  }
  function ul(e) {
    const t = Va(...e.map((e) => e.left)),
      n = Va(...e.map((e) => e.top));
    return {
      x: t,
      y: n,
      width: Wa(...e.map((e) => e.right)) - t,
      height: Wa(...e.map((e) => e.bottom)) - n,
    };
  }
  function dl() {
    return "undefined" !== typeof window;
  }
  function fl(e) {
    return hl(e) ? (e.nodeName || "").toLowerCase() : "#document";
  }
  function pl(e) {
    var t;
    return (
      (null == e || null == (t = e.ownerDocument) ? void 0 : t.defaultView) ||
      window
    );
  }
  function ml(e) {
    var t;
    return null ==
      (t = (hl(e) ? e.ownerDocument : e.document) || window.document)
      ? void 0
      : t.documentElement;
  }
  function hl(e) {
    return !!dl() && (e instanceof Node || e instanceof pl(e).Node);
  }
  function vl(e) {
    return !!dl() && (e instanceof Element || e instanceof pl(e).Element);
  }
  function yl(e) {
    return (
      !!dl() && (e instanceof HTMLElement || e instanceof pl(e).HTMLElement)
    );
  }
  function gl(e) {
    return (
      !(!dl() || "undefined" === typeof ShadowRoot) &&
      (e instanceof ShadowRoot || e instanceof pl(e).ShadowRoot)
    );
  }
  function bl(e) {
    const { overflow: t, overflowX: n, overflowY: r, display: o } = El(e);
    return (
      /auto|scroll|overlay|hidden|clip/.test(t + r + n) &&
      !["inline", "contents"].includes(o)
    );
  }
  function wl(e) {
    return ["table", "td", "th"].includes(fl(e));
  }
  function xl(e) {
    return [":popover-open", ":modal"].some((t) => {
      try {
        return e.matches(t);
      } catch (ap) {
        return !1;
      }
    });
  }
  function Sl(e) {
    const t = kl(),
      n = vl(e) ? El(e) : e;
    return (
      "none" !== n.transform ||
      "none" !== n.perspective ||
      (!!n.containerType && "normal" !== n.containerType) ||
      (!t && !!n.backdropFilter && "none" !== n.backdropFilter) ||
      (!t && !!n.filter && "none" !== n.filter) ||
      ["transform", "perspective", "filter"].some((e) =>
        (n.willChange || "").includes(e)
      ) ||
      ["paint", "layout", "strict", "content"].some((e) =>
        (n.contain || "").includes(e)
      )
    );
  }
  function kl() {
    return (
      !("undefined" === typeof CSS || !CSS.supports) &&
      CSS.supports("-webkit-backdrop-filter", "none")
    );
  }
  function Cl(e) {
    return ["html", "body", "#document"].includes(fl(e));
  }
  function El(e) {
    return pl(e).getComputedStyle(e);
  }
  function Nl(e) {
    return vl(e)
      ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop }
      : { scrollLeft: e.scrollX, scrollTop: e.scrollY };
  }
  function Pl(e) {
    if ("html" === fl(e)) return e;
    const t = e.assignedSlot || e.parentNode || (gl(e) && e.host) || ml(e);
    return gl(t) ? t.host : t;
  }
  function jl(e) {
    const t = Pl(e);
    return Cl(t)
      ? e.ownerDocument
        ? e.ownerDocument.body
        : e.body
      : yl(t) && bl(t)
      ? t
      : jl(t);
  }
  function zl(e, t, n) {
    var r;
    void 0 === t && (t = []), void 0 === n && (n = !0);
    const o = jl(e),
      a = o === (null == (r = e.ownerDocument) ? void 0 : r.body),
      l = pl(o);
    if (a) {
      const e = Tl(l);
      return t.concat(
        l,
        l.visualViewport || [],
        bl(o) ? o : [],
        e && n ? zl(e) : []
      );
    }
    return t.concat(o, zl(o, [], n));
  }
  function Tl(e) {
    return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
  }
  function Rl(e) {
    const t = El(e);
    let n = parseFloat(t.width) || 0,
      r = parseFloat(t.height) || 0;
    const o = yl(e),
      a = o ? e.offsetWidth : n,
      l = o ? e.offsetHeight : r,
      i = Ha(n) !== a || Ha(r) !== l;
    return i && ((n = a), (r = l)), { width: n, height: r, $: i };
  }
  function _l(e) {
    return vl(e) ? e : e.contextElement;
  }
  function Ol(e) {
    const t = _l(e);
    if (!yl(t)) return Ua(1);
    const n = t.getBoundingClientRect(),
      { width: r, height: o, $: a } = Rl(t);
    let l = (a ? Ha(n.width) : n.width) / r,
      i = (a ? Ha(n.height) : n.height) / o;
    return (
      (l && Number.isFinite(l)) || (l = 1),
      (i && Number.isFinite(i)) || (i = 1),
      { x: l, y: i }
    );
  }
  const Al = Ua(0);
  function Ll(e) {
    const t = pl(e);
    return kl() && t.visualViewport
      ? { x: t.visualViewport.offsetLeft, y: t.visualViewport.offsetTop }
      : Al;
  }
  function Dl(e, t, n, r) {
    void 0 === t && (t = !1), void 0 === n && (n = !1);
    const o = e.getBoundingClientRect(),
      a = _l(e);
    let l = Ua(1);
    t && (r ? vl(r) && (l = Ol(r)) : (l = Ol(e)));
    const i = (function (e, t, n) {
      return void 0 === t && (t = !1), !(!n || (t && n !== pl(e))) && t;
    })(a, n, r)
      ? Ll(a)
      : Ua(0);
    let s = (o.left + i.x) / l.x,
      c = (o.top + i.y) / l.y,
      u = o.width / l.x,
      d = o.height / l.y;
    if (a) {
      const e = pl(a),
        t = r && vl(r) ? pl(r) : r;
      let n = e,
        o = Tl(n);
      for (; o && r && t !== n; ) {
        const e = Ol(o),
          t = o.getBoundingClientRect(),
          r = El(o),
          a = t.left + (o.clientLeft + parseFloat(r.paddingLeft)) * e.x,
          l = t.top + (o.clientTop + parseFloat(r.paddingTop)) * e.y;
        (s *= e.x),
          (c *= e.y),
          (u *= e.x),
          (d *= e.y),
          (s += a),
          (c += l),
          (n = pl(o)),
          (o = Tl(n));
      }
    }
    return ol({ width: u, height: d, x: s, y: c });
  }
  function Fl(e, t) {
    const n = Nl(e).scrollLeft;
    return t ? t.left + n : Dl(ml(e)).left + n;
  }
  function Ml(e, t, n) {
    void 0 === n && (n = !1);
    const r = e.getBoundingClientRect();
    return {
      x: r.left + t.scrollLeft - (n ? 0 : Fl(e, r)),
      y: r.top + t.scrollTop,
    };
  }
  function Il(e, t, n) {
    let r;
    if ("viewport" === t)
      r = (function (e, t) {
        const n = pl(e),
          r = ml(e),
          o = n.visualViewport;
        let a = r.clientWidth,
          l = r.clientHeight,
          i = 0,
          s = 0;
        if (o) {
          (a = o.width), (l = o.height);
          const e = kl();
          (!e || (e && "fixed" === t)) &&
            ((i = o.offsetLeft), (s = o.offsetTop));
        }
        return { width: a, height: l, x: i, y: s };
      })(e, n);
    else if ("document" === t)
      r = (function (e) {
        const t = ml(e),
          n = Nl(e),
          r = e.ownerDocument.body,
          o = Wa(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth),
          a = Wa(
            t.scrollHeight,
            t.clientHeight,
            r.scrollHeight,
            r.clientHeight
          );
        let l = -n.scrollLeft + Fl(e);
        const i = -n.scrollTop;
        return (
          "rtl" === El(r).direction &&
            (l += Wa(t.clientWidth, r.clientWidth) - o),
          { width: o, height: a, x: l, y: i }
        );
      })(ml(e));
    else if (vl(t))
      r = (function (e, t) {
        const n = Dl(e, !0, "fixed" === t),
          r = n.top + e.clientTop,
          o = n.left + e.clientLeft,
          a = yl(e) ? Ol(e) : Ua(1);
        return {
          width: e.clientWidth * a.x,
          height: e.clientHeight * a.y,
          x: o * a.x,
          y: r * a.y,
        };
      })(t, n);
    else {
      const n = Ll(e);
      r = { x: t.x - n.x, y: t.y - n.y, width: t.width, height: t.height };
    }
    return ol(r);
  }
  function Vl(e, t) {
    const n = Pl(e);
    return (
      !(n === t || !vl(n) || Cl(n)) && ("fixed" === El(n).position || Vl(n, t))
    );
  }
  function Wl(e, t, n) {
    const r = yl(t),
      o = ml(t),
      a = "fixed" === n,
      l = Dl(e, !0, a, t);
    let i = { scrollLeft: 0, scrollTop: 0 };
    const s = Ua(0);
    if (r || (!r && !a))
      if ((("body" !== fl(t) || bl(o)) && (i = Nl(t)), r)) {
        const e = Dl(t, !0, a, t);
        (s.x = e.x + t.clientLeft), (s.y = e.y + t.clientTop);
      } else o && (s.x = Fl(o));
    const c = !o || r || a ? Ua(0) : Ml(o, i);
    return {
      x: l.left + i.scrollLeft - s.x - c.x,
      y: l.top + i.scrollTop - s.y - c.y,
      width: l.width,
      height: l.height,
    };
  }
  function Hl(e) {
    return "static" === El(e).position;
  }
  function Bl(e, t) {
    if (!yl(e) || "fixed" === El(e).position) return null;
    if (t) return t(e);
    let n = e.offsetParent;
    return ml(e) === n && (n = n.ownerDocument.body), n;
  }
  function Ul(e, t) {
    const n = pl(e);
    if (xl(e)) return n;
    if (!yl(e)) {
      let t = Pl(e);
      for (; t && !Cl(t); ) {
        if (vl(t) && !Hl(t)) return t;
        t = Pl(t);
      }
      return n;
    }
    let r = Bl(e, t);
    for (; r && wl(r) && Hl(r); ) r = Bl(r, t);
    return r && Cl(r) && Hl(r) && !Sl(r)
      ? n
      : r ||
          (function (e) {
            let t = Pl(e);
            for (; yl(t) && !Cl(t); ) {
              if (Sl(t)) return t;
              if (xl(t)) return null;
              t = Pl(t);
            }
            return null;
          })(e) ||
          n;
  }
  const $l = {
    convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
      let { elements: t, rect: n, offsetParent: r, strategy: o } = e;
      const a = "fixed" === o,
        l = ml(r),
        i = !!t && xl(t.floating);
      if (r === l || (i && a)) return n;
      let s = { scrollLeft: 0, scrollTop: 0 },
        c = Ua(1);
      const u = Ua(0),
        d = yl(r);
      if (
        (d || (!d && !a)) &&
        (("body" !== fl(r) || bl(l)) && (s = Nl(r)), yl(r))
      ) {
        const e = Dl(r);
        (c = Ol(r)), (u.x = e.x + r.clientLeft), (u.y = e.y + r.clientTop);
      }
      const f = !l || d || a ? Ua(0) : Ml(l, s, !0);
      return {
        width: n.width * c.x,
        height: n.height * c.y,
        x: n.x * c.x - s.scrollLeft * c.x + u.x + f.x,
        y: n.y * c.y - s.scrollTop * c.y + u.y + f.y,
      };
    },
    getDocumentElement: ml,
    getClippingRect: function (e) {
      let { element: t, boundary: n, rootBoundary: r, strategy: o } = e;
      const a = [
          ...("clippingAncestors" === n
            ? xl(t)
              ? []
              : (function (e, t) {
                  const n = t.get(e);
                  if (n) return n;
                  let r = zl(e, [], !1).filter(
                      (e) => vl(e) && "body" !== fl(e)
                    ),
                    o = null;
                  const a = "fixed" === El(e).position;
                  let l = a ? Pl(e) : e;
                  for (; vl(l) && !Cl(l); ) {
                    const t = El(l),
                      n = Sl(l);
                    n || "fixed" !== t.position || (o = null),
                      (
                        a
                          ? !n && !o
                          : (!n &&
                              "static" === t.position &&
                              o &&
                              ["absolute", "fixed"].includes(o.position)) ||
                            (bl(l) && !n && Vl(e, l))
                      )
                        ? (r = r.filter((e) => e !== l))
                        : (o = t),
                      (l = Pl(l));
                  }
                  return t.set(e, r), r;
                })(t, this._c)
            : [].concat(n)),
          r,
        ],
        l = a[0],
        i = a.reduce((e, n) => {
          const r = Il(t, n, o);
          return (
            (e.top = Wa(r.top, e.top)),
            (e.right = Va(r.right, e.right)),
            (e.bottom = Va(r.bottom, e.bottom)),
            (e.left = Wa(r.left, e.left)),
            e
          );
        }, Il(t, l, o));
      return {
        width: i.right - i.left,
        height: i.bottom - i.top,
        x: i.left,
        y: i.top,
      };
    },
    getOffsetParent: Ul,
    getElementRects: async function (e) {
      const t = this.getOffsetParent || Ul,
        n = this.getDimensions,
        r = await n(e.floating);
      return {
        reference: Wl(e.reference, await t(e.floating), e.strategy),
        floating: { x: 0, y: 0, width: r.width, height: r.height },
      };
    },
    getClientRects: function (e) {
      return Array.from(e.getClientRects());
    },
    getDimensions: function (e) {
      const { width: t, height: n } = Rl(e);
      return { width: t, height: n };
    },
    getScale: Ol,
    isElement: vl,
    isRTL: function (e) {
      return "rtl" === El(e).direction;
    },
  };
  function ql(e, t, n, r) {
    void 0 === r && (r = {});
    const {
        ancestorScroll: o = !0,
        ancestorResize: a = !0,
        elementResize: l = "function" === typeof ResizeObserver,
        layoutShift: i = "function" === typeof IntersectionObserver,
        animationFrame: s = !1,
      } = r,
      c = _l(e),
      u = o || a ? [...(c ? zl(c) : []), ...zl(t)] : [];
    u.forEach((e) => {
      o && e.addEventListener("scroll", n, { passive: !0 }),
        a && e.addEventListener("resize", n);
    });
    const d =
      c && i
        ? (function (e, t) {
            let n,
              r = null;
            const o = ml(e);
            function a() {
              var e;
              clearTimeout(n), null == (e = r) || e.disconnect(), (r = null);
            }
            return (
              (function l(i, s) {
                void 0 === i && (i = !1), void 0 === s && (s = 1), a();
                const {
                  left: c,
                  top: u,
                  width: d,
                  height: p,
                } = e.getBoundingClientRect();
                if ((i || t(), !d || !p)) return;
                const m = {
                  rootMargin:
                    -Ba(u) +
                    "px " +
                    -Ba(o.clientWidth - (c + d)) +
                    "px " +
                    -Ba(o.clientHeight - (u + p)) +
                    "px " +
                    -Ba(c) +
                    "px",
                  threshold: Wa(0, Va(1, s)) || 1,
                };
                let h = !0;
                function v(e) {
                  const t = e[0].intersectionRatio;
                  if (t !== s) {
                    if (!h) return l();
                    t
                      ? l(!1, t)
                      : (n = setTimeout(() => {
                          l(!1, 1e-7);
                        }, 1e3));
                  }
                  h = !1;
                }
                try {
                  r = new IntersectionObserver(
                    v,
                    f(f({}, m), {}, { root: o.ownerDocument })
                  );
                } catch (ap) {
                  r = new IntersectionObserver(v, m);
                }
                r.observe(e);
              })(!0),
              a
            );
          })(c, n)
        : null;
    let p,
      m = -1,
      h = null;
    l &&
      ((h = new ResizeObserver((e) => {
        let [r] = e;
        r &&
          r.target === c &&
          h &&
          (h.unobserve(t),
          cancelAnimationFrame(m),
          (m = requestAnimationFrame(() => {
            var e;
            null == (e = h) || e.observe(t);
          }))),
          n();
      })),
      c && !s && h.observe(c),
      h.observe(t));
    let v = s ? Dl(e) : null;
    return (
      s &&
        (function t() {
          const r = Dl(e);
          !v ||
            (r.x === v.x &&
              r.y === v.y &&
              r.width === v.width &&
              r.height === v.height) ||
            n();
          (v = r), (p = requestAnimationFrame(t));
        })(),
      n(),
      () => {
        var e;
        u.forEach((e) => {
          o && e.removeEventListener("scroll", n),
            a && e.removeEventListener("resize", n);
        }),
          null == d || d(),
          null == (e = h) || e.disconnect(),
          (h = null),
          s && cancelAnimationFrame(p);
      }
    );
  }
  const Yl = function (e) {
      return (
        void 0 === e && (e = 0),
        {
          name: "offset",
          options: e,
          async fn(t) {
            var n, r;
            const { x: o, y: a, placement: l, middlewareData: i } = t,
              s = await (async function (e, t) {
                const { placement: n, platform: r, elements: o } = e,
                  a = await (null == r.isRTL ? void 0 : r.isRTL(o.floating)),
                  l = Qa(n),
                  i = Xa(n),
                  s = "y" === Za(n),
                  c = ["left", "top"].includes(l) ? -1 : 1,
                  u = a && s ? -1 : 1,
                  d = Ka(t, e);
                let {
                  mainAxis: f,
                  crossAxis: p,
                  alignmentAxis: m,
                } = "number" === typeof d
                  ? { mainAxis: d, crossAxis: 0, alignmentAxis: null }
                  : {
                      mainAxis: d.mainAxis || 0,
                      crossAxis: d.crossAxis || 0,
                      alignmentAxis: d.alignmentAxis,
                    };
                return (
                  i && "number" === typeof m && (p = "end" === i ? -1 * m : m),
                  s ? { x: p * u, y: f * c } : { x: f * c, y: p * u }
                );
              })(t, e);
            return l === (null == (n = i.offset) ? void 0 : n.placement) &&
              null != (r = i.arrow) &&
              r.alignmentOffset
              ? {}
              : {
                  x: o + s.x,
                  y: a + s.y,
                  data: f(f({}, s), {}, { placement: l }),
                };
          },
        }
      );
    },
    Kl = function (e) {
      return (
        void 0 === e && (e = {}),
        {
          name: "shift",
          options: e,
          async fn(t) {
            const { x: n, y: r, placement: o } = t,
              a = Ka(e, t),
              {
                mainAxis: l = !0,
                crossAxis: s = !1,
                limiter: c = {
                  fn: (e) => {
                    let { x: t, y: n } = e;
                    return { x: t, y: n };
                  },
                },
              } = a,
              u = i(a, ll),
              d = { x: n, y: r },
              p = await cl(t, u),
              m = Za(Qa(o)),
              h = Ga(m);
            let v = d[h],
              y = d[m];
            if (l) {
              const e = "y" === h ? "bottom" : "right";
              v = Ya(v + p["y" === h ? "top" : "left"], v, v - p[e]);
            }
            if (s) {
              const e = "y" === m ? "bottom" : "right";
              y = Ya(y + p["y" === m ? "top" : "left"], y, y - p[e]);
            }
            const g = c.fn(f(f({}, t), {}, { [h]: v, [m]: y }));
            return f(
              f({}, g),
              {},
              { data: { x: g.x - n, y: g.y - r, enabled: { [h]: l, [m]: s } } }
            );
          },
        }
      );
    },
    Ql = function (e) {
      return (
        void 0 === e && (e = {}),
        {
          name: "flip",
          options: e,
          async fn(t) {
            var n, r;
            const {
                placement: o,
                middlewareData: a,
                rects: l,
                initialPlacement: s,
                platform: c,
                elements: u,
              } = t,
              d = Ka(e, t),
              {
                mainAxis: f = !0,
                crossAxis: p = !0,
                fallbackPlacements: m,
                fallbackStrategy: h = "bestFit",
                fallbackAxisSideDirection: v = "none",
                flipAlignment: y = !0,
              } = d,
              g = i(d, al);
            if (null != (n = a.arrow) && n.alignmentOffset) return {};
            const b = Qa(o),
              w = Za(s),
              x = Qa(s) === s,
              S = await (null == c.isRTL ? void 0 : c.isRTL(u.floating)),
              k =
                m ||
                (x || !y
                  ? [nl(s)]
                  : (function (e) {
                      const t = nl(e);
                      return [tl(e), t, tl(t)];
                    })(s)),
              C = "none" !== v;
            !m &&
              C &&
              k.push(
                ...(function (e, t, n, r) {
                  const o = Xa(e);
                  let a = (function (e, t, n) {
                    const r = ["left", "right"],
                      o = ["right", "left"],
                      a = ["top", "bottom"],
                      l = ["bottom", "top"];
                    switch (e) {
                      case "top":
                      case "bottom":
                        return n ? (t ? o : r) : t ? r : o;
                      case "left":
                      case "right":
                        return t ? a : l;
                      default:
                        return [];
                    }
                  })(Qa(e), "start" === n, r);
                  return (
                    o &&
                      ((a = a.map((e) => e + "-" + o)),
                      t && (a = a.concat(a.map(tl)))),
                    a
                  );
                })(s, y, v, S)
              );
            const E = [s, ...k],
              N = await cl(t, g),
              P = [];
            let j = (null == (r = a.flip) ? void 0 : r.overflows) || [];
            if ((f && P.push(N[b]), p)) {
              const e = (function (e, t, n) {
                void 0 === n && (n = !1);
                const r = Xa(e),
                  o = el(e),
                  a = Ja(o);
                let l =
                  "x" === o
                    ? r === (n ? "end" : "start")
                      ? "right"
                      : "left"
                    : "start" === r
                    ? "bottom"
                    : "top";
                return (
                  t.reference[a] > t.floating[a] && (l = nl(l)), [l, nl(l)]
                );
              })(o, l, S);
              P.push(N[e[0]], N[e[1]]);
            }
            if (
              ((j = [...j, { placement: o, overflows: P }]),
              !P.every((e) => e <= 0))
            ) {
              var z, T;
              const e = ((null == (z = a.flip) ? void 0 : z.index) || 0) + 1,
                t = E[e];
              if (t)
                return {
                  data: { index: e, overflows: j },
                  reset: { placement: t },
                };
              let n =
                null ==
                (T = j
                  .filter((e) => e.overflows[0] <= 0)
                  .sort((e, t) => e.overflows[1] - t.overflows[1])[0])
                  ? void 0
                  : T.placement;
              if (!n)
                switch (h) {
                  case "bestFit": {
                    var R;
                    const e =
                      null ==
                      (R = j
                        .filter((e) => {
                          if (C) {
                            const t = Za(e.placement);
                            return t === w || "y" === t;
                          }
                          return !0;
                        })
                        .map((e) => [
                          e.placement,
                          e.overflows
                            .filter((e) => e > 0)
                            .reduce((e, t) => e + t, 0),
                        ])
                        .sort((e, t) => e[1] - t[1])[0])
                        ? void 0
                        : R[0];
                    e && (n = e);
                    break;
                  }
                  case "initialPlacement":
                    n = s;
                }
              if (o !== n) return { reset: { placement: n } };
            }
            return {};
          },
        }
      );
    },
    Xl = function (e) {
      return (
        void 0 === e && (e = {}),
        {
          name: "size",
          options: e,
          async fn(t) {
            var n, r;
            const { placement: o, rects: a, platform: l, elements: s } = t,
              c = Ka(e, t),
              { apply: u = () => {} } = c,
              d = i(c, il),
              p = await cl(t, d),
              m = Qa(o),
              h = Xa(o),
              v = "y" === Za(o),
              { width: y, height: g } = a.floating;
            let b, w;
            "top" === m || "bottom" === m
              ? ((b = m),
                (w =
                  h ===
                  ((await (null == l.isRTL ? void 0 : l.isRTL(s.floating)))
                    ? "start"
                    : "end")
                    ? "left"
                    : "right"))
              : ((w = m), (b = "end" === h ? "top" : "bottom"));
            const x = g - p.top - p.bottom,
              S = y - p.left - p.right,
              k = Va(g - p[b], x),
              C = Va(y - p[w], S),
              E = !t.middlewareData.shift;
            let N = k,
              P = C;
            if (
              (null != (n = t.middlewareData.shift) && n.enabled.x && (P = S),
              null != (r = t.middlewareData.shift) && r.enabled.y && (N = x),
              E && !h)
            ) {
              const e = Wa(p.left, 0),
                t = Wa(p.right, 0),
                n = Wa(p.top, 0),
                r = Wa(p.bottom, 0);
              v
                ? (P =
                    y - 2 * (0 !== e || 0 !== t ? e + t : Wa(p.left, p.right)))
                : (N =
                    g - 2 * (0 !== n || 0 !== r ? n + r : Wa(p.top, p.bottom)));
            }
            await u(f(f({}, t), {}, { availableWidth: P, availableHeight: N }));
            const j = await l.getDimensions(s.floating);
            return y !== j.width || g !== j.height
              ? { reset: { rects: !0 } }
              : {};
          },
        }
      );
    },
    Gl = (e) => ({
      name: "arrow",
      options: e,
      async fn(t) {
        const {
            x: n,
            y: r,
            placement: o,
            rects: a,
            platform: l,
            elements: i,
            middlewareData: s,
          } = t,
          { element: c, padding: u = 0 } = Ka(e, t) || {};
        if (null == c) return {};
        const d = rl(u),
          p = { x: n, y: r },
          m = el(o),
          h = Ja(m),
          v = await l.getDimensions(c),
          y = "y" === m,
          g = y ? "top" : "left",
          b = y ? "bottom" : "right",
          w = y ? "clientHeight" : "clientWidth",
          x = a.reference[h] + a.reference[m] - p[m] - a.floating[h],
          S = p[m] - a.reference[m],
          k = await (null == l.getOffsetParent ? void 0 : l.getOffsetParent(c));
        let C = k ? k[w] : 0;
        (C && (await (null == l.isElement ? void 0 : l.isElement(k)))) ||
          (C = i.floating[w] || a.floating[h]);
        const E = x / 2 - S / 2,
          N = C / 2 - v[h] / 2 - 1,
          P = Va(d[g], N),
          j = Va(d[b], N),
          z = P,
          T = C - v[h] - j,
          R = C / 2 - v[h] / 2 + E,
          _ = Ya(z, R, T),
          O =
            !s.arrow &&
            null != Xa(o) &&
            R !== _ &&
            a.reference[h] / 2 - (R < z ? P : j) - v[h] / 2 < 0,
          A = O ? (R < z ? R - z : R - T) : 0;
        return {
          [m]: p[m] + A,
          data: f(
            { [m]: _, centerOffset: R - _ - A },
            O && { alignmentOffset: A }
          ),
          reset: O,
        };
      },
    }),
    Jl = function (e) {
      return (
        void 0 === e && (e = {}),
        {
          name: "inline",
          options: e,
          async fn(t) {
            const {
                placement: n,
                elements: r,
                rects: o,
                platform: a,
                strategy: l,
              } = t,
              { padding: i = 2, x: s, y: c } = Ka(e, t),
              u = Array.from(
                (await (null == a.getClientRects
                  ? void 0
                  : a.getClientRects(r.reference))) || []
              ),
              d = (function (e) {
                const t = e.slice().sort((e, t) => e.y - t.y),
                  n = [];
                let r = null;
                for (let o = 0; o < t.length; o++) {
                  const e = t[o];
                  !r || e.y - r.y > r.height / 2
                    ? n.push([e])
                    : n[n.length - 1].push(e),
                    (r = e);
                }
                return n.map((e) => ol(ul(e)));
              })(u),
              f = ol(ul(u)),
              p = rl(i);
            const m = await a.getElementRects({
              reference: {
                getBoundingClientRect: function () {
                  if (
                    2 === d.length &&
                    d[0].left > d[1].right &&
                    null != s &&
                    null != c
                  )
                    return (
                      d.find(
                        (e) =>
                          s > e.left - p.left &&
                          s < e.right + p.right &&
                          c > e.top - p.top &&
                          c < e.bottom + p.bottom
                      ) || f
                    );
                  if (d.length >= 2) {
                    if ("y" === Za(n)) {
                      const e = d[0],
                        t = d[d.length - 1],
                        r = "top" === Qa(n),
                        o = e.top,
                        a = t.bottom,
                        l = r ? e.left : t.left,
                        i = r ? e.right : t.right;
                      return {
                        top: o,
                        bottom: a,
                        left: l,
                        right: i,
                        width: i - l,
                        height: a - o,
                        x: l,
                        y: o,
                      };
                    }
                    const e = "left" === Qa(n),
                      t = Wa(...d.map((e) => e.right)),
                      r = Va(...d.map((e) => e.left)),
                      o = d.filter((n) => (e ? n.left === r : n.right === t)),
                      a = o[0].top,
                      l = o[o.length - 1].bottom;
                    return {
                      top: a,
                      bottom: l,
                      left: r,
                      right: t,
                      width: t - r,
                      height: l - a,
                      x: r,
                      y: a,
                    };
                  }
                  return f;
                },
              },
              floating: r.floating,
              strategy: l,
            });
            return o.reference.x !== m.reference.x ||
              o.reference.y !== m.reference.y ||
              o.reference.width !== m.reference.width ||
              o.reference.height !== m.reference.height
              ? { reset: { rects: m } }
              : {};
          },
        }
      );
    },
    Zl = function (e) {
      return (
        void 0 === e && (e = {}),
        {
          options: e,
          fn(t) {
            const { x: n, y: r, placement: o, rects: a, middlewareData: l } = t,
              { offset: i = 0, mainAxis: s = !0, crossAxis: c = !0 } = Ka(e, t),
              u = { x: n, y: r },
              d = Za(o),
              p = Ga(d);
            let m = u[p],
              h = u[d];
            const v = Ka(i, t),
              y =
                "number" === typeof v
                  ? { mainAxis: v, crossAxis: 0 }
                  : f({ mainAxis: 0, crossAxis: 0 }, v);
            if (s) {
              const e = "y" === p ? "height" : "width",
                t = a.reference[p] - a.floating[e] + y.mainAxis,
                n = a.reference[p] + a.reference[e] - y.mainAxis;
              m < t ? (m = t) : m > n && (m = n);
            }
            if (c) {
              var g, b;
              const e = "y" === p ? "width" : "height",
                t = ["top", "left"].includes(Qa(o)),
                n =
                  a.reference[d] -
                  a.floating[e] +
                  ((t && (null == (g = l.offset) ? void 0 : g[d])) || 0) +
                  (t ? 0 : y.crossAxis),
                r =
                  a.reference[d] +
                  a.reference[e] +
                  (t ? 0 : (null == (b = l.offset) ? void 0 : b[d]) || 0) -
                  (t ? y.crossAxis : 0);
              h < n ? (h = n) : h > r && (h = r);
            }
            return { [p]: m, [d]: h };
          },
        }
      );
    },
    ei = (e, t, n) => {
      const r = new Map(),
        o = f({ platform: $l }, n),
        a = f(f({}, o.platform), {}, { _c: r });
      return (async (e, t, n) => {
        const {
            placement: r = "bottom",
            strategy: o = "absolute",
            middleware: a = [],
            platform: l,
          } = n,
          i = a.filter(Boolean),
          s = await (null == l.isRTL ? void 0 : l.isRTL(t));
        let c = await l.getElementRects({
            reference: e,
            floating: t,
            strategy: o,
          }),
          { x: u, y: d } = sl(c, r, s),
          p = r,
          m = {},
          h = 0;
        for (let v = 0; v < i.length; v++) {
          const { name: n, fn: a } = i[v],
            {
              x: y,
              y: g,
              data: b,
              reset: w,
            } = await a({
              x: u,
              y: d,
              initialPlacement: r,
              placement: p,
              strategy: o,
              middlewareData: m,
              rects: c,
              platform: l,
              elements: { reference: e, floating: t },
            });
          (u = null != y ? y : u),
            (d = null != g ? g : d),
            (m = f(f({}, m), {}, { [n]: f(f({}, m[n]), b) })),
            w &&
              h <= 50 &&
              (h++,
              "object" === typeof w &&
                (w.placement && (p = w.placement),
                w.rects &&
                  (c =
                    !0 === w.rects
                      ? await l.getElementRects({
                          reference: e,
                          floating: t,
                          strategy: o,
                        })
                      : w.rects),
                ({ x: u, y: d } = sl(c, p, s))),
              (v = -1));
        }
        return { x: u, y: d, placement: p, strategy: o, middlewareData: m };
      })(e, t, f(f({}, o), {}, { platform: a }));
    };
  var ti = "undefined" !== typeof document ? r.useLayoutEffect : r.useEffect;
  function ni(e, t) {
    if (e === t) return !0;
    if (typeof e !== typeof t) return !1;
    if ("function" === typeof e && e.toString() === t.toString()) return !0;
    let n, r, o;
    if (e && t && "object" === typeof e) {
      if (Array.isArray(e)) {
        if (((n = e.length), n !== t.length)) return !1;
        for (r = n; 0 !== r--; ) if (!ni(e[r], t[r])) return !1;
        return !0;
      }
      if (((o = Object.keys(e)), (n = o.length), n !== Object.keys(t).length))
        return !1;
      for (r = n; 0 !== r--; ) if (!{}.hasOwnProperty.call(t, o[r])) return !1;
      for (r = n; 0 !== r--; ) {
        const n = o[r];
        if (("_owner" !== n || !e.$$typeof) && !ni(e[n], t[n])) return !1;
      }
      return !0;
    }
    return e !== e && t !== t;
  }
  function ri(e) {
    if ("undefined" === typeof window) return 1;
    return (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
  }
  function oi(e, t) {
    const n = ri(e);
    return Math.round(t * n) / n;
  }
  function ai(e) {
    const t = r.useRef(e);
    return (
      ti(() => {
        t.current = e;
      }),
      t
    );
  }
  const li = (e, t) => f(f({}, Yl(e)), {}, { options: [e, t] }),
    ii = (e, t) => f(f({}, Zl(e)), {}, { options: [e, t] }),
    si = (e, t) => f(f({}, Ql(e)), {}, { options: [e, t] }),
    ci = (e, t) => f(f({}, Jl(e)), {}, { options: [e, t] }),
    ui = (e, t) =>
      f(
        f(
          {},
          ((e) => ({
            name: "arrow",
            options: e,
            fn(t) {
              const { element: n, padding: r } =
                "function" === typeof e ? e(t) : e;
              return n && ((o = n), {}.hasOwnProperty.call(o, "current"))
                ? null != n.current
                  ? Gl({ element: n.current, padding: r }).fn(t)
                  : {}
                : n
                ? Gl({ element: n, padding: r }).fn(t)
                : {};
              var o;
            },
          }))(e)
        ),
        {},
        { options: [e, t] }
      );
  const di = f({}, o),
    fi = di.useInsertionEffect || ((e) => e());
  function pi(e) {
    const t = r.useRef(() => {
      0;
    });
    return (
      fi(() => {
        t.current = e;
      }),
      r.useCallback(function () {
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
          n[r] = arguments[r];
        return null == t.current ? void 0 : t.current(...n);
      }, [])
    );
  }
  const mi = "ArrowUp",
    hi = "ArrowDown",
    vi = "ArrowLeft",
    yi = "ArrowRight";
  var gi = "undefined" !== typeof document ? r.useLayoutEffect : r.useEffect;
  const bi = [vi, yi],
    wi = [mi, hi];
  let xi = !1,
    Si = 0;
  const ki = () =>
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + Si++;
  const Ci =
    di.useId ||
    function () {
      const [e, t] = r.useState(() => (xi ? ki() : void 0));
      return (
        gi(() => {
          null == e && t(ki());
        }, []),
        r.useEffect(() => {
          xi = !0;
        }, []),
        e
      );
    };
  function Ei() {
    const e = new Map();
    return {
      emit(t, n) {
        var r;
        null == (r = e.get(t)) || r.forEach((e) => e(n));
      },
      on(t, n) {
        e.set(t, [...(e.get(t) || []), n]);
      },
      off(t, n) {
        var r;
        e.set(
          t,
          (null == (r = e.get(t)) ? void 0 : r.filter((e) => e !== n)) || []
        );
      },
    };
  }
  const Ni = r.createContext(null),
    Pi = r.createContext(null),
    ji = () => {
      var e;
      return (null == (e = r.useContext(Ni)) ? void 0 : e.id) || null;
    },
    zi = () => r.useContext(Pi);
  function Ti(e) {
    void 0 === e && (e = {});
    const { nodeId: t } = e,
      n = (function (e) {
        const { open: t = !1, onOpenChange: n, elements: o } = e,
          a = Ci(),
          l = r.useRef({}),
          [i] = r.useState(() => Ei()),
          s = null != ji(),
          [c, u] = r.useState(o.reference),
          d = pi((e, t, r) => {
            (l.current.openEvent = e ? t : void 0),
              i.emit("openchange", { open: e, event: t, reason: r, nested: s }),
              null == n || n(e, t, r);
          }),
          f = r.useMemo(() => ({ setPositionReference: u }), []),
          p = r.useMemo(
            () => ({
              reference: c || o.reference || null,
              floating: o.floating || null,
              domReference: o.reference,
            }),
            [c, o.reference, o.floating]
          );
        return r.useMemo(
          () => ({
            dataRef: l,
            open: t,
            onOpenChange: d,
            elements: p,
            events: i,
            floatingId: a,
            refs: f,
          }),
          [t, d, p, i, a, f]
        );
      })(
        f(
          f({}, e),
          {},
          { elements: f({ reference: null, floating: null }, e.elements) }
        )
      ),
      o = e.rootContext || n,
      a = o.elements,
      [l, i] = r.useState(null),
      [s, c] = r.useState(null),
      u = (null == a ? void 0 : a.domReference) || l,
      d = r.useRef(null),
      p = zi();
    gi(() => {
      u && (d.current = u);
    }, [u]);
    const m = (function (e) {
        void 0 === e && (e = {});
        const {
            placement: t = "bottom",
            strategy: n = "absolute",
            middleware: o = [],
            platform: a,
            elements: { reference: l, floating: i } = {},
            transform: s = !0,
            whileElementsMounted: c,
            open: u,
          } = e,
          [d, p] = r.useState({
            x: 0,
            y: 0,
            strategy: n,
            placement: t,
            middlewareData: {},
            isPositioned: !1,
          }),
          [m, h] = r.useState(o);
        ni(m, o) || h(o);
        const [v, y] = r.useState(null),
          [g, b] = r.useState(null),
          w = r.useCallback((e) => {
            e !== C.current && ((C.current = e), y(e));
          }, []),
          x = r.useCallback((e) => {
            e !== E.current && ((E.current = e), b(e));
          }, []),
          S = l || v,
          k = i || g,
          C = r.useRef(null),
          E = r.useRef(null),
          N = r.useRef(d),
          P = null != c,
          j = ai(c),
          z = ai(a),
          T = ai(u),
          R = r.useCallback(() => {
            if (!C.current || !E.current) return;
            const e = { placement: t, strategy: n, middleware: m };
            z.current && (e.platform = z.current),
              ei(C.current, E.current, e).then((e) => {
                const t = f(f({}, e), {}, { isPositioned: !1 !== T.current });
                _.current &&
                  !ni(N.current, t) &&
                  ((N.current = t),
                  ga.flushSync(() => {
                    p(t);
                  }));
              });
          }, [m, t, n, z, T]);
        ti(() => {
          !1 === u &&
            N.current.isPositioned &&
            ((N.current.isPositioned = !1),
            p((e) => f(f({}, e), {}, { isPositioned: !1 })));
        }, [u]);
        const _ = r.useRef(!1);
        ti(
          () => (
            (_.current = !0),
            () => {
              _.current = !1;
            }
          ),
          []
        ),
          ti(() => {
            if ((S && (C.current = S), k && (E.current = k), S && k)) {
              if (j.current) return j.current(S, k, R);
              R();
            }
          }, [S, k, R, j, P]);
        const O = r.useMemo(
            () => ({
              reference: C,
              floating: E,
              setReference: w,
              setFloating: x,
            }),
            [w, x]
          ),
          A = r.useMemo(() => ({ reference: S, floating: k }), [S, k]),
          L = r.useMemo(() => {
            const e = { position: n, left: 0, top: 0 };
            if (!A.floating) return e;
            const t = oi(A.floating, d.x),
              r = oi(A.floating, d.y);
            return s
              ? f(
                  f({}, e),
                  {},
                  { transform: "translate(" + t + "px, " + r + "px)" },
                  ri(A.floating) >= 1.5 && { willChange: "transform" }
                )
              : { position: n, left: t, top: r };
          }, [n, s, A.floating, d.x, d.y]);
        return r.useMemo(
          () =>
            f(
              f({}, d),
              {},
              { update: R, refs: O, elements: A, floatingStyles: L }
            ),
          [d, R, O, A, L]
        );
      })(f(f({}, e), {}, { elements: f(f({}, a), s && { reference: s }) })),
      h = r.useCallback(
        (e) => {
          const t = vl(e)
            ? {
                getBoundingClientRect: () => e.getBoundingClientRect(),
                contextElement: e,
              }
            : e;
          c(t), m.refs.setReference(t);
        },
        [m.refs]
      ),
      v = r.useCallback(
        (e) => {
          (vl(e) || null === e) && ((d.current = e), i(e)),
            (vl(m.refs.reference.current) ||
              null === m.refs.reference.current ||
              (null !== e && !vl(e))) &&
              m.refs.setReference(e);
        },
        [m.refs]
      ),
      y = r.useMemo(
        () =>
          f(
            f({}, m.refs),
            {},
            { setReference: v, setPositionReference: h, domReference: d }
          ),
        [m.refs, v, h]
      ),
      g = r.useMemo(
        () => f(f({}, m.elements), {}, { domReference: u }),
        [m.elements, u]
      ),
      b = r.useMemo(
        () => f(f(f({}, m), o), {}, { refs: y, elements: g, nodeId: t }),
        [m, y, g, t, o]
      );
    return (
      gi(() => {
        o.dataRef.current.floatingContext = b;
        const e =
          null == p ? void 0 : p.nodesRef.current.find((e) => e.id === t);
        e && (e.context = b);
      }),
      r.useMemo(
        () => f(f({}, m), {}, { context: b, refs: y, elements: g }),
        [m, y, g, b]
      )
    );
  }
  const Ri = ["rects", "availableWidth", "availableHeight"];
  function _i(e, t) {
    const n = (function (e) {
        if (void 0 === e) return { shift: !0, flip: !0 };
        const t = f({}, e);
        return (
          void 0 === e.shift && (t.shift = !0),
          void 0 === e.flip && (t.flip = !0),
          t
        );
      })(e.middlewares),
      r = [li(e.offset)];
    return (
      n.shift &&
        r.push(
          ((e, t) => f(f({}, Kl(e)), {}, { options: [e, t] }))(
            "boolean" === typeof n.shift
              ? { limiter: ii(), padding: 5 }
              : f({ limiter: ii(), padding: 5 }, n.shift)
          )
        ),
      n.flip && r.push("boolean" === typeof n.flip ? si() : si(n.flip)),
      n.inline && r.push("boolean" === typeof n.inline ? ci() : ci(n.inline)),
      r.push(ui({ element: e.arrowRef, padding: e.arrowOffset })),
      (n.size || "target" === e.width) &&
        r.push(
          ((e, t) => f(f({}, Xl(e)), {}, { options: [e, t] }))(
            f(
              f({}, "boolean" === typeof n.size ? {} : n.size),
              {},
              {
                apply(r) {
                  var o, a;
                  let { rects: l, availableWidth: s, availableHeight: c } = r,
                    u = i(r, Ri);
                  const d =
                    null !==
                      (o =
                        null === (a = t().refs.floating.current) || void 0 === a
                          ? void 0
                          : a.style) && void 0 !== o
                      ? o
                      : {};
                  n.size &&
                    ("object" === typeof n.size && n.size.apply
                      ? n.size.apply(
                          f(
                            { rects: l, availableWidth: s, availableHeight: c },
                            u
                          )
                        )
                      : Object.assign(d, {
                          maxWidth: "".concat(s, "px"),
                          maxHeight: "".concat(c, "px"),
                        })),
                    "target" === e.width &&
                      Object.assign(d, {
                        width: "".concat(l.reference.width, "px"),
                      });
                },
              }
            )
          )
        ),
      r
    );
  }
  function Oi(e) {
    const [t, n] = Vr({
        value: e.opened,
        defaultValue: e.defaultOpened,
        finalValue: !1,
        onChange: e.onChange,
      }),
      o = (0, r.useRef)(t),
      a = Ti({
        strategy: e.strategy,
        placement: e.position,
        middleware: _i(e, () => a),
      });
    return (
      (function (e) {
        let {
          opened: t,
          floating: n,
          position: o,
          positionDependencies: a,
        } = e;
        const [l, i] = (0, r.useState)(0);
        (0, r.useEffect)(() => {
          if (n.refs.reference.current && n.refs.floating.current && t)
            return ql(
              n.refs.reference.current,
              n.refs.floating.current,
              n.update
            );
        }, [n.refs.reference.current, n.refs.floating.current, t, l, o]),
          Yo(() => {
            n.update();
          }, a),
          Yo(() => {
            i((e) => e + 1);
          }, [t]);
      })({
        opened: t,
        position: e.position,
        positionDependencies: e.positionDependencies || [],
        floating: a,
      }),
      Yo(() => {
        var t;
        null === (t = e.onPositionChange) ||
          void 0 === t ||
          t.call(e, a.placement);
      }, [a.placement]),
      Yo(() => {
        var n, r;
        t !== o.current &&
          (t
            ? null === (n = e.onOpen) || void 0 === n || n.call(e)
            : null === (r = e.onClose) || void 0 === r || r.call(e));
        o.current = t;
      }, [t, e.onClose, e.onOpen]),
      {
        floating: a,
        controlled: "boolean" === typeof e.opened,
        opened: t,
        onClose: () => {
          t && n(!1);
        },
        onToggle: () => n(!t),
      }
    );
  }
  const Ai = [
      "children",
      "position",
      "offset",
      "onPositionChange",
      "positionDependencies",
      "opened",
      "transitionProps",
      "onExitTransitionEnd",
      "onEnterTransitionEnd",
      "width",
      "middlewares",
      "withArrow",
      "arrowSize",
      "arrowOffset",
      "arrowRadius",
      "arrowPosition",
      "unstyled",
      "classNames",
      "styles",
      "closeOnClickOutside",
      "withinPortal",
      "portalProps",
      "closeOnEscape",
      "clickOutsideEvents",
      "trapFocus",
      "onClose",
      "onOpen",
      "onChange",
      "zIndex",
      "radius",
      "shadow",
      "id",
      "defaultOpened",
      "__staticSelector",
      "withRoles",
      "disabled",
      "returnFocus",
      "variant",
      "keepMounted",
      "vars",
      "floatingStrategy",
    ],
    Li = {
      position: "bottom",
      offset: 8,
      positionDependencies: [],
      transitionProps: { transition: "fade", duration: 150 },
      middlewares: { flip: !0, shift: !0, inline: !1 },
      arrowSize: 7,
      arrowOffset: 5,
      arrowRadius: 0,
      arrowPosition: "side",
      closeOnClickOutside: !0,
      withinPortal: !0,
      closeOnEscape: !0,
      trapFocus: !1,
      withRoles: !0,
      returnFocus: !1,
      clickOutsideEvents: ["mousedown", "touchstart"],
      zIndex: Ho("popover"),
      __staticSelector: "Popover",
      width: "max-content",
    },
    Di = (e, t) => {
      let { radius: n, shadow: r } = t;
      return {
        dropdown: {
          "--popover-radius": void 0 === n ? void 0 : jt(n),
          "--popover-shadow": Tt(r),
        },
      };
    };
  function Fi(e) {
    var t, n;
    const o = nn("Popover", Li, e),
      {
        children: a,
        position: l,
        offset: s,
        onPositionChange: c,
        positionDependencies: u,
        opened: d,
        transitionProps: p,
        onExitTransitionEnd: m,
        onEnterTransitionEnd: h,
        width: v,
        middlewares: y,
        withArrow: g,
        arrowSize: b,
        arrowOffset: w,
        arrowRadius: x,
        arrowPosition: S,
        unstyled: k,
        classNames: C,
        styles: E,
        closeOnClickOutside: N,
        withinPortal: P,
        portalProps: j,
        closeOnEscape: z,
        clickOutsideEvents: T,
        trapFocus: R,
        onClose: _,
        onOpen: O,
        onChange: A,
        zIndex: L,
        radius: D,
        shadow: F,
        id: M,
        defaultOpened: I,
        __staticSelector: V,
        withRoles: W,
        disabled: H,
        returnFocus: B,
        variant: U,
        keepMounted: $,
        vars: q,
        floatingStrategy: Y,
      } = o,
      K = i(o, Ai),
      Q = bn({
        name: V,
        props: o,
        classes: _a,
        classNames: C,
        styles: E,
        unstyled: k,
        rootSelector: "dropdown",
        vars: q,
        varsResolver: Di,
      }),
      { resolvedStyles: X } = Do({ classNames: C, styles: E, props: o }),
      G = (0, r.useRef)(null),
      [J, Z] = (0, r.useState)(null),
      [ee, te] = (0, r.useState)(null),
      { dir: ne } = Nr(),
      re = wt(M),
      oe = Oi({
        middlewares: y,
        width: v,
        position: Bo(ne, l),
        offset: "number" === typeof s ? s + (g ? b / 2 : 0) : s,
        arrowRef: G,
        arrowOffset: w,
        onPositionChange: c,
        positionDependencies: u,
        opened: d,
        defaultOpened: I,
        onChange: A,
        onOpen: O,
        onClose: _,
        strategy: Y,
      });
    !(function (e, t, n) {
      const o = (0, r.useRef)(null);
      (0, r.useEffect)(() => {
        const r = (t) => {
          const { target: r } = null !== t && void 0 !== t ? t : {};
          if (Array.isArray(n)) {
            const o =
              (null === r || void 0 === r
                ? void 0
                : r.hasAttribute("data-ignore-outside-clicks")) ||
              (!document.body.contains(r) && "HTML" !== r.tagName);
            n.every((e) => !!e && !t.composedPath().includes(e)) && !o && e();
          } else o.current && !o.current.contains(r) && e();
        };
        return (
          (t || Vo).forEach((e) => document.addEventListener(e, r)),
          () => {
            (t || Vo).forEach((e) => document.removeEventListener(e, r));
          }
        );
      }, [o, e, n]);
    })(() => N && oe.onClose(), T, [J, ee]);
    const ae = (0, r.useCallback)(
        (e) => {
          Z(e), oe.floating.refs.setReference(e);
        },
        [oe.floating.refs.setReference]
      ),
      le = (0, r.useCallback)(
        (e) => {
          te(e), oe.floating.refs.setFloating(e);
        },
        [oe.floating.refs.setFloating]
      ),
      ie = (0, r.useCallback)(() => {
        var e;
        null === p ||
          void 0 === p ||
          null === (e = p.onExited) ||
          void 0 === e ||
          e.call(p),
          null === m || void 0 === m || m();
      }, [null === p || void 0 === p ? void 0 : p.onExited, m]),
      se = (0, r.useCallback)(() => {
        var e;
        null === p ||
          void 0 === p ||
          null === (e = p.onEntered) ||
          void 0 === e ||
          e.call(p),
          null === h || void 0 === h || h();
      }, [null === p || void 0 === p ? void 0 : p.onEntered, h]);
    return (0, vt.jsx)($o, {
      value: {
        returnFocus: B,
        disabled: H,
        controlled: oe.controlled,
        reference: ae,
        floating: le,
        x: oe.floating.x,
        y: oe.floating.y,
        arrowX:
          null === (t = oe.floating) ||
          void 0 === t ||
          null === (t = t.middlewareData) ||
          void 0 === t ||
          null === (t = t.arrow) ||
          void 0 === t
            ? void 0
            : t.x,
        arrowY:
          null === (n = oe.floating) ||
          void 0 === n ||
          null === (n = n.middlewareData) ||
          void 0 === n ||
          null === (n = n.arrow) ||
          void 0 === n
            ? void 0
            : n.y,
        opened: oe.opened,
        arrowRef: G,
        transitionProps: f(f({}, p), {}, { onExited: ie, onEntered: se }),
        width: v,
        withArrow: g,
        arrowSize: b,
        arrowOffset: w,
        arrowRadius: x,
        arrowPosition: S,
        placement: oe.floating.placement,
        trapFocus: R,
        withinPortal: P,
        portalProps: j,
        zIndex: L,
        radius: D,
        shadow: F,
        closeOnEscape: z,
        onClose: oe.onClose,
        onToggle: oe.onToggle,
        getTargetId: () => "".concat(re, "-target"),
        getDropdownId: () => "".concat(re, "-dropdown"),
        withRoles: W,
        targetProps: K,
        __staticSelector: V,
        classNames: C,
        styles: E,
        unstyled: k,
        variant: U,
        keepMounted: $,
        getStyles: Q,
        resolvedStyles: X,
        floatingStrategy: Y,
      },
      children: a,
    });
  }
  (Fi.Target = Ia),
    (Fi.Dropdown = La),
    (Fi.displayName = "@mantine/core/Popover"),
    (Fi.extend = (e) => e);
  const [Mi, Ii] = Uo("Combobox component was not found in tree");
  var Vi = {
    dropdown: "m_88b62a41",
    search: "m_985517d8",
    options: "m_b2821a6e",
    option: "m_92253aa5",
    empty: "m_2530cd1d",
    header: "m_858f94bd",
    footer: "m_82b967cb",
    group: "m_254f3e4f",
    groupLabel: "m_2bb2e9e5",
    chevron: "m_2943220b",
    optionsDropdownOption: "m_390b5f4",
    optionsDropdownCheckIcon: "m_8ee53fc2",
  };
  const Wi = [
      "size",
      "error",
      "style",
      "className",
      "classNames",
      "styles",
      "unstyled",
      "vars",
      "mod",
    ],
    Hi = { error: null },
    Bi = (e, t) => {
      let { size: n } = t;
      return {
        chevron: { "--combobox-chevron-size": Nt(n, "combobox-chevron-size") },
      };
    },
    Ui = $n((e, t) => {
      const n = nn("ComboboxChevron", Hi, e),
        {
          size: r,
          error: o,
          style: a,
          className: l,
          classNames: s,
          styles: c,
          unstyled: u,
          vars: d,
          mod: p,
        } = n,
        m = i(n, Wi),
        h = bn({
          name: "ComboboxChevron",
          classes: Vi,
          props: n,
          style: a,
          className: l,
          classNames: s,
          styles: c,
          unstyled: u,
          vars: d,
          varsResolver: Bi,
          rootSelector: "chevron",
        });
      return (0, vt.jsx)(
        Bn,
        f(
          f(f({ component: "svg" }, m), h("chevron")),
          {},
          {
            size: r,
            viewBox: "0 0 15 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            mod: ["combobox-chevron", { error: o }, p],
            ref: t,
            children: (0, vt.jsx)("path", {
              d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
              fill: "currentColor",
              fillRule: "evenodd",
              clipRule: "evenodd",
            }),
          }
        )
      );
    });
  (Ui.classes = Vi), (Ui.displayName = "@mantine/core/ComboboxChevron");
  const $i = ["size", "style"],
    qi = (0, r.forwardRef)((e, t) => {
      let { size: n = "var(--cb-icon-size, 70%)", style: r } = e,
        o = i(e, $i);
      return (0, vt.jsx)(
        "svg",
        f(
          f(
            {
              viewBox: "0 0 15 15",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              style: f(f({}, r), {}, { width: n, height: n }),
              ref: t,
            },
            o
          ),
          {},
          {
            children: (0, vt.jsx)("path", {
              d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
              fill: "currentColor",
              fillRule: "evenodd",
              clipRule: "evenodd",
            }),
          }
        )
      );
    });
  qi.displayName = "@mantine/core/CloseIcon";
  var Yi = { root: "m_86a44da5", "root--subtle": "m_220c80f2" };
  const Ki = [
      "iconSize",
      "children",
      "vars",
      "radius",
      "className",
      "classNames",
      "style",
      "styles",
      "unstyled",
      "data-disabled",
      "disabled",
      "variant",
      "icon",
      "mod",
    ],
    Qi = { variant: "subtle" },
    Xi = (e, t) => {
      let { size: n, radius: r, iconSize: o } = t;
      return {
        root: {
          "--cb-size": Nt(n, "cb-size"),
          "--cb-radius": void 0 === r ? void 0 : jt(r),
          "--cb-icon-size": Ct(o),
        },
      };
    },
    Gi = qn((e, t) => {
      const n = nn("CloseButton", Qi, e),
        {
          iconSize: r,
          children: o,
          vars: a,
          radius: l,
          className: s,
          classNames: c,
          style: u,
          styles: d,
          unstyled: p,
          "data-disabled": m,
          disabled: h,
          variant: v,
          icon: y,
          mod: g,
        } = n,
        b = i(n, Ki),
        w = bn({
          name: "CloseButton",
          props: n,
          className: s,
          style: u,
          classes: Yi,
          classNames: c,
          styles: d,
          unstyled: p,
          vars: a,
          varsResolver: Xi,
        });
      return (0, vt.jsxs)(
        Tr,
        f(
          f(
            f({ ref: t }, b),
            {},
            {
              unstyled: p,
              variant: v,
              disabled: h,
              mod: [{ disabled: h || m }, g],
            },
            w("root", { variant: v, active: !h && !m })
          ),
          {},
          { children: [y || (0, vt.jsx)(qi, {}), o] }
        )
      );
    });
  (Gi.classes = Yi), (Gi.displayName = "@mantine/core/CloseButton");
  const Ji = ["size", "onMouseDown", "onClick", "onClear"],
    Zi = (0, r.forwardRef)((e, t) => {
      let { size: n, onMouseDown: r, onClick: o, onClear: a } = e,
        l = i(e, Ji);
      return (0, vt.jsx)(
        Gi,
        f(
          f(
            {
              ref: t,
              size: n || "sm",
              variant: "transparent",
              tabIndex: -1,
              "aria-hidden": !0,
            },
            l
          ),
          {},
          {
            onMouseDown: (e) => {
              e.preventDefault(), null === r || void 0 === r || r(e);
            },
            onClick: (e) => {
              a(), null === o || void 0 === o || o(e);
            },
          }
        )
      );
    });
  Zi.displayName = "@mantine/core/ComboboxClearButton";
  const es = ["classNames", "styles", "className", "style", "hidden"],
    ts = {},
    ns = $n((e, t) => {
      const n = nn("ComboboxDropdown", ts, e),
        { classNames: r, styles: o, className: a, style: l, hidden: s } = n,
        c = i(n, es),
        u = Ii();
      return (0, vt.jsx)(
        Fi.Dropdown,
        f(
          f({}, c),
          {},
          { ref: t, role: "presentation", "data-hidden": s || void 0 },
          u.getStyles("dropdown", {
            className: a,
            style: l,
            classNames: r,
            styles: o,
          })
        )
      );
    });
  (ns.classes = Vi), (ns.displayName = "@mantine/core/ComboboxDropdown");
  const rs = { refProp: "ref" },
    os = $n((e, t) => {
      const { children: n, refProp: r } = nn("ComboboxDropdownTarget", rs, e);
      if ((Ii(), !da(n)))
        throw new Error(
          "Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
        );
      return (0, vt.jsx)(Fi.Target, { ref: t, refProp: r, children: n });
    });
  os.displayName = "@mantine/core/ComboboxDropdownTarget";
  const as = ["classNames", "className", "style", "styles", "vars"],
    ls = {},
    is = $n((e, t) => {
      const n = nn("ComboboxEmpty", ls, e),
        { classNames: r, className: o, style: a, styles: l, vars: s } = n,
        c = i(n, as),
        u = Ii();
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            { ref: t },
            u.getStyles("empty", {
              className: o,
              classNames: r,
              styles: l,
              style: a,
            })
          ),
          c
        )
      );
    });
  function ss(e) {
    let {
      onKeyDown: t,
      withKeyboardNavigation: n,
      withAriaAttributes: o,
      withExpandedAttribute: a,
      targetType: l,
      autoComplete: i,
    } = e;
    const s = Ii(),
      [c, u] = (0, r.useState)(null);
    return f(
      f(
        {},
        o
          ? {
              "aria-haspopup": "listbox",
              "aria-expanded":
                (a && !(!s.store.listId || !s.store.dropdownOpened)) || void 0,
              "aria-controls": s.store.dropdownOpened ? s.store.listId : void 0,
              "aria-activedescendant": (s.store.dropdownOpened && c) || void 0,
              autoComplete: i,
              "data-expanded": s.store.dropdownOpened || void 0,
              "data-mantine-stop-propagation": s.store.dropdownOpened || void 0,
            }
          : {}
      ),
      {},
      {
        onKeyDown: (e) => {
          if ((null === t || void 0 === t || t(e), !s.readOnly && n)) {
            if (e.nativeEvent.isComposing) return;
            if (
              ("ArrowDown" === e.nativeEvent.code &&
                (e.preventDefault(),
                s.store.dropdownOpened
                  ? u(s.store.selectNextOption())
                  : (s.store.openDropdown("keyboard"),
                    u(s.store.selectActiveOption()),
                    s.store.updateSelectedOptionIndex("selected", {
                      scrollIntoView: !0,
                    }))),
              "ArrowUp" === e.nativeEvent.code &&
                (e.preventDefault(),
                s.store.dropdownOpened
                  ? u(s.store.selectPreviousOption())
                  : (s.store.openDropdown("keyboard"),
                    u(s.store.selectActiveOption()),
                    s.store.updateSelectedOptionIndex("selected", {
                      scrollIntoView: !0,
                    }))),
              "Enter" === e.nativeEvent.code ||
                "NumpadEnter" === e.nativeEvent.code)
            ) {
              if (229 === e.nativeEvent.keyCode) return;
              const t = s.store.getSelectedOptionIndex();
              s.store.dropdownOpened && -1 !== t
                ? (e.preventDefault(), s.store.clickSelectedOption())
                : "button" === l &&
                  (e.preventDefault(), s.store.openDropdown("keyboard"));
            }
            "Escape" === e.nativeEvent.code &&
              s.store.closeDropdown("keyboard"),
              "Space" === e.nativeEvent.code &&
                "button" === l &&
                (e.preventDefault(), s.store.toggleDropdown("keyboard"));
          }
        },
      }
    );
  }
  (is.classes = Vi), (is.displayName = "@mantine/core/ComboboxEmpty");
  const cs = [
      "children",
      "refProp",
      "withKeyboardNavigation",
      "withAriaAttributes",
      "withExpandedAttribute",
      "targetType",
      "autoComplete",
    ],
    us = {
      refProp: "ref",
      targetType: "input",
      withKeyboardNavigation: !0,
      withAriaAttributes: !0,
      withExpandedAttribute: !1,
      autoComplete: "off",
    },
    ds = $n((e, t) => {
      const n = nn("ComboboxEventsTarget", us, e),
        {
          children: o,
          refProp: a,
          withKeyboardNavigation: l,
          withAriaAttributes: s,
          withExpandedAttribute: c,
          targetType: u,
          autoComplete: d,
        } = n,
        p = i(n, cs);
      if (!da(o))
        throw new Error(
          "Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
        );
      const m = Ii(),
        h = ss({
          targetType: u,
          withAriaAttributes: s,
          withKeyboardNavigation: l,
          withExpandedAttribute: c,
          onKeyDown: o.props.onKeyDown,
          autoComplete: d,
        });
      return (0, r.cloneElement)(
        o,
        f(f(f({}, h), p), {}, { [a]: Qo(t, m.store.targetRef, Da(o)) })
      );
    });
  ds.displayName = "@mantine/core/ComboboxEventsTarget";
  const fs = ["classNames", "className", "style", "styles", "vars"],
    ps = {},
    ms = $n((e, t) => {
      const n = nn("ComboboxFooter", ps, e),
        { classNames: r, className: o, style: a, styles: l, vars: s } = n,
        c = i(n, fs),
        u = Ii();
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            f(
              { ref: t },
              u.getStyles("footer", {
                className: o,
                classNames: r,
                style: a,
                styles: l,
              })
            ),
            c
          ),
          {},
          {
            onMouseDown: (e) => {
              e.preventDefault();
            },
          }
        )
      );
    });
  (ms.classes = Vi), (ms.displayName = "@mantine/core/ComboboxFooter");
  const hs = [
      "classNames",
      "className",
      "style",
      "styles",
      "vars",
      "children",
      "label",
    ],
    vs = {},
    ys = $n((e, t) => {
      const n = nn("ComboboxGroup", vs, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          vars: s,
          children: c,
          label: u,
        } = n,
        d = i(n, hs),
        p = Ii();
      return (0, vt.jsxs)(
        Bn,
        f(
          f(
            f(
              { ref: t },
              p.getStyles("group", {
                className: o,
                classNames: r,
                style: a,
                styles: l,
              })
            ),
            d
          ),
          {},
          {
            children: [
              u &&
                (0, vt.jsx)(
                  "div",
                  f(
                    f(
                      {},
                      p.getStyles("groupLabel", { classNames: r, styles: l })
                    ),
                    {},
                    { children: u }
                  )
                ),
              c,
            ],
          }
        )
      );
    });
  (ys.classes = Vi), (ys.displayName = "@mantine/core/ComboboxGroup");
  const gs = ["classNames", "className", "style", "styles", "vars"],
    bs = {},
    ws = $n((e, t) => {
      const n = nn("ComboboxHeader", bs, e),
        { classNames: r, className: o, style: a, styles: l, vars: s } = n,
        c = i(n, gs),
        u = Ii();
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            f(
              { ref: t },
              u.getStyles("header", {
                className: o,
                classNames: r,
                style: a,
                styles: l,
              })
            ),
            c
          ),
          {},
          {
            onMouseDown: (e) => {
              e.preventDefault();
            },
          }
        )
      );
    });
  (ws.classes = Vi), (ws.displayName = "@mantine/core/ComboboxHeader");
  const xs = ["value", "valuesDivider"];
  function Ss(e) {
    let { value: t, valuesDivider: n = "," } = e,
      r = i(e, xs);
    return (0, vt.jsx)(
      "input",
      f({ type: "hidden", value: Array.isArray(t) ? t.join(n) : t || "" }, r)
    );
  }
  Ss.displayName = "@mantine/core/ComboboxHiddenInput";
  const ks = [
      "classNames",
      "className",
      "style",
      "styles",
      "vars",
      "onClick",
      "id",
      "active",
      "onMouseDown",
      "onMouseOver",
      "disabled",
      "selected",
      "mod",
    ],
    Cs = {},
    Es = $n((e, t) => {
      const n = nn("ComboboxOption", Cs, e),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          vars: c,
          onClick: u,
          id: d,
          active: p,
          onMouseDown: m,
          onMouseOver: h,
          disabled: v,
          selected: y,
          mod: g,
        } = n,
        b = i(n, ks),
        w = Ii(),
        x = (0, r.useId)(),
        S = d || x;
      return (0, vt.jsx)(
        Bn,
        f(
          f(
            f(
              {},
              w.getStyles("option", {
                className: a,
                classNames: o,
                styles: s,
                style: l,
              })
            ),
            b
          ),
          {},
          {
            ref: t,
            id: S,
            mod: [
              "combobox-option",
              {
                "combobox-active": p,
                "combobox-disabled": v,
                "combobox-selected": y,
              },
              g,
            ],
            role: "option",
            onClick: (e) => {
              var t;
              v
                ? e.preventDefault()
                : (null === (t = w.onOptionSubmit) ||
                    void 0 === t ||
                    t.call(w, n.value, n),
                  null === u || void 0 === u || u(e));
            },
            onMouseDown: (e) => {
              e.preventDefault(), null === m || void 0 === m || m(e);
            },
            onMouseOver: (e) => {
              w.resetSelectionOnOptionHover && w.store.resetSelectedOption(),
                null === h || void 0 === h || h(e);
            },
          }
        )
      );
    });
  (Es.classes = Vi), (Es.displayName = "@mantine/core/ComboboxOption");
  const Ns = [
      "classNames",
      "className",
      "style",
      "styles",
      "id",
      "onMouseDown",
      "labelledBy",
    ],
    Ps = {},
    js = $n((e, t) => {
      const n = nn("ComboboxOptions", Ps, e),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          id: c,
          onMouseDown: u,
          labelledBy: d,
        } = n,
        p = i(n, Ns),
        m = Ii(),
        h = wt(c);
      return (
        (0, r.useEffect)(() => {
          m.store.setListId(h);
        }, [h]),
        (0, vt.jsx)(
          Bn,
          f(
            f(
              f(
                { ref: t },
                m.getStyles("options", {
                  className: a,
                  style: l,
                  classNames: o,
                  styles: s,
                })
              ),
              p
            ),
            {},
            {
              id: h,
              role: "listbox",
              "aria-labelledby": d,
              onMouseDown: (e) => {
                e.preventDefault(), null === u || void 0 === u || u(e);
              },
            }
          )
        )
      );
    });
  (js.classes = Vi), (js.displayName = "@mantine/core/ComboboxOptions");
  const zs = [
      "classNames",
      "styles",
      "unstyled",
      "vars",
      "withAriaAttributes",
      "onKeyDown",
      "withKeyboardNavigation",
      "size",
    ],
    Ts = { withAriaAttributes: !0, withKeyboardNavigation: !0 },
    Rs = $n((e, t) => {
      const n = nn("ComboboxSearch", Ts, e),
        {
          classNames: r,
          styles: o,
          unstyled: a,
          vars: l,
          withAriaAttributes: s,
          onKeyDown: c,
          withKeyboardNavigation: u,
          size: d,
        } = n,
        p = i(n, zs),
        m = Ii(),
        h = m.getStyles("search"),
        v = ss({
          targetType: "input",
          withAriaAttributes: s,
          withKeyboardNavigation: u,
          withExpandedAttribute: !1,
          onKeyDown: c,
          autoComplete: "off",
        });
      return (0, vt.jsx)(
        wr,
        f(
          f(
            f(
              {
                ref: Qo(t, m.store.searchRef),
                classNames: [{ input: h.className }, r],
                styles: [{ input: h.style }, o],
                size: d || m.size,
              },
              v
            ),
            p
          ),
          {},
          { __staticSelector: "Combobox" }
        )
      );
    });
  (Rs.classes = Vi), (Rs.displayName = "@mantine/core/ComboboxSearch");
  const _s = [
      "children",
      "refProp",
      "withKeyboardNavigation",
      "withAriaAttributes",
      "withExpandedAttribute",
      "targetType",
      "autoComplete",
    ],
    Os = {
      refProp: "ref",
      targetType: "input",
      withKeyboardNavigation: !0,
      withAriaAttributes: !0,
      withExpandedAttribute: !1,
      autoComplete: "off",
    },
    As = $n((e, t) => {
      const n = nn("ComboboxTarget", Os, e),
        {
          children: o,
          refProp: a,
          withKeyboardNavigation: l,
          withAriaAttributes: s,
          withExpandedAttribute: c,
          targetType: u,
          autoComplete: d,
        } = n,
        p = i(n, _s);
      if (!da(o))
        throw new Error(
          "Combobox.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
        );
      const m = Ii(),
        h = ss({
          targetType: u,
          withAriaAttributes: s,
          withKeyboardNavigation: l,
          withExpandedAttribute: c,
          onKeyDown: o.props.onKeyDown,
          autoComplete: d,
        }),
        v = (0, r.cloneElement)(o, f(f({}, h), p));
      return (0, vt.jsx)(Fi.Target, {
        ref: Qo(t, m.store.targetRef),
        children: v,
      });
    });
  function Ls() {
    let {
      defaultOpened: e,
      opened: t,
      onOpenedChange: n,
      onDropdownClose: o,
      onDropdownOpen: a,
      loop: l = !0,
      scrollBehavior: i = "instant",
    } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    const [s, c] = Vr({
        value: t,
        defaultValue: e,
        finalValue: !1,
        onChange: n,
      }),
      u = (0, r.useRef)(null),
      d = (0, r.useRef)(-1),
      f = (0, r.useRef)(null),
      p = (0, r.useRef)(null),
      m = (0, r.useRef)(-1),
      h = (0, r.useRef)(-1),
      v = (0, r.useRef)(-1),
      y = (0, r.useCallback)(
        function () {
          let e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "unknown";
          s || (c(!0), null === a || void 0 === a || a(e));
        },
        [c, a, s]
      ),
      g = (0, r.useCallback)(
        function () {
          let e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "unknown";
          s && (c(!1), null === o || void 0 === o || o(e));
        },
        [c, o, s]
      ),
      b = (0, r.useCallback)(
        function () {
          let e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "unknown";
          s ? g(e) : y(e);
        },
        [g, y, s]
      ),
      w = (0, r.useCallback)(() => {
        const e = document.querySelector(
          "#".concat(u.current, " [data-combobox-selected]")
        );
        null === e ||
          void 0 === e ||
          e.removeAttribute("data-combobox-selected"),
          null === e || void 0 === e || e.removeAttribute("aria-selected");
      }, []),
      x = (0, r.useCallback)(
        (e) => {
          const t = document.getElementById(u.current),
            n =
              null === t || void 0 === t
                ? void 0
                : t.querySelectorAll("[data-combobox-option]");
          if (!n) return null;
          const r = e >= n.length ? 0 : e < 0 ? n.length - 1 : e;
          return (
            (d.current = r),
            null !== n &&
            void 0 !== n &&
            n[r] &&
            !n[r].hasAttribute("data-combobox-disabled")
              ? (w(),
                n[r].setAttribute("data-combobox-selected", "true"),
                n[r].setAttribute("aria-selected", "true"),
                n[r].scrollIntoView({ block: "nearest", behavior: i }),
                n[r].id)
              : null
          );
        },
        [i, w]
      ),
      S = (0, r.useCallback)(() => {
        const e = document.querySelector(
          "#".concat(u.current, " [data-combobox-active]")
        );
        if (e) {
          const t = document.querySelectorAll(
              "#".concat(u.current, " [data-combobox-option]")
            ),
            n = Array.from(t).findIndex((t) => t === e);
          return x(n);
        }
        return x(0);
      }, [x]),
      k = (0, r.useCallback)(
        () =>
          x(
            (function (e, t, n) {
              for (let r = e + 1; r < t.length; r += 1)
                if (!t[r].hasAttribute("data-combobox-disabled")) return r;
              if (n)
                for (let r = 0; r < t.length; r += 1)
                  if (!t[r].hasAttribute("data-combobox-disabled")) return r;
              return e;
            })(
              d.current,
              document.querySelectorAll(
                "#".concat(u.current, " [data-combobox-option]")
              ),
              l
            )
          ),
        [x, l]
      ),
      C = (0, r.useCallback)(
        () =>
          x(
            (function (e, t, n) {
              for (let r = e - 1; r >= 0; r -= 1)
                if (!t[r].hasAttribute("data-combobox-disabled")) return r;
              if (n)
                for (let r = t.length - 1; r > -1; r -= 1)
                  if (!t[r].hasAttribute("data-combobox-disabled")) return r;
              return e;
            })(
              d.current,
              document.querySelectorAll(
                "#".concat(u.current, " [data-combobox-option]")
              ),
              l
            )
          ),
        [x, l]
      ),
      E = (0, r.useCallback)(
        () =>
          x(
            (function (e) {
              for (let t = 0; t < e.length; t += 1)
                if (!e[t].hasAttribute("data-combobox-disabled")) return t;
              return -1;
            })(
              document.querySelectorAll(
                "#".concat(u.current, " [data-combobox-option]")
              )
            )
          ),
        [x]
      ),
      N = (0, r.useCallback)(function () {
        let e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : "selected",
          t = arguments.length > 1 ? arguments[1] : void 0;
        v.current = window.setTimeout(() => {
          const n = document.querySelectorAll(
              "#".concat(u.current, " [data-combobox-option]")
            ),
            r = Array.from(n).findIndex((t) =>
              t.hasAttribute("data-combobox-".concat(e))
            );
          var o;
          ((d.current = r), null !== t && void 0 !== t && t.scrollIntoView) &&
            (null === (o = n[r]) ||
              void 0 === o ||
              o.scrollIntoView({ block: "nearest", behavior: i }));
        }, 0);
      }, []),
      P = (0, r.useCallback)(() => {
        (d.current = -1), w();
      }, [w]),
      j = (0, r.useCallback)(() => {
        const e = document.querySelectorAll(
            "#".concat(u.current, " [data-combobox-option]")
          ),
          t = null === e || void 0 === e ? void 0 : e[d.current];
        null === t || void 0 === t || t.click();
      }, []),
      z = (0, r.useCallback)((e) => {
        u.current = e;
      }, []),
      T = (0, r.useCallback)(() => {
        m.current = window.setTimeout(() => f.current.focus(), 0);
      }, []),
      R = (0, r.useCallback)(() => {
        h.current = window.setTimeout(() => p.current.focus(), 0);
      }, []),
      _ = (0, r.useCallback)(() => d.current, []);
    return (
      (0, r.useEffect)(
        () => () => {
          window.clearTimeout(m.current),
            window.clearTimeout(h.current),
            window.clearTimeout(v.current);
        },
        []
      ),
      {
        dropdownOpened: s,
        openDropdown: y,
        closeDropdown: g,
        toggleDropdown: b,
        selectedOptionIndex: d.current,
        getSelectedOptionIndex: _,
        selectOption: x,
        selectFirstOption: E,
        selectActiveOption: S,
        selectNextOption: k,
        selectPreviousOption: C,
        resetSelectedOption: P,
        updateSelectedOptionIndex: N,
        listId: u.current,
        setListId: z,
        clickSelectedOption: j,
        searchRef: f,
        focusSearchInput: T,
        targetRef: p,
        focusTarget: R,
      }
    );
  }
  As.displayName = "@mantine/core/ComboboxTarget";
  const Ds = [
      "classNames",
      "styles",
      "unstyled",
      "children",
      "store",
      "vars",
      "onOptionSubmit",
      "onClose",
      "size",
      "dropdownPadding",
      "resetSelectionOnOptionHover",
      "__staticSelector",
      "readOnly",
    ],
    Fs = {
      keepMounted: !0,
      withinPortal: !0,
      resetSelectionOnOptionHover: !1,
      width: "target",
      transitionProps: { transition: "fade", duration: 0 },
    },
    Ms = (e, t) => {
      let { size: n, dropdownPadding: r } = t;
      return {
        options: {
          "--combobox-option-fz": zt(n),
          "--combobox-option-padding": Nt(n, "combobox-option-padding"),
        },
        dropdown: {
          "--combobox-padding": void 0 === r ? void 0 : Ct(r),
          "--combobox-option-fz": zt(n),
          "--combobox-option-padding": Nt(n, "combobox-option-padding"),
        },
      };
    };
  function Is(e) {
    const t = nn("Combobox", Fs, e),
      {
        classNames: n,
        styles: r,
        unstyled: o,
        children: a,
        store: l,
        vars: s,
        onOptionSubmit: c,
        onClose: u,
        size: d,
        dropdownPadding: p,
        resetSelectionOnOptionHover: m,
        __staticSelector: h,
        readOnly: v,
      } = t,
      y = i(t, Ds),
      g = Ls(),
      b = l || g,
      w = bn({
        name: h || "Combobox",
        classes: Vi,
        props: t,
        classNames: n,
        styles: r,
        unstyled: o,
        vars: s,
        varsResolver: Ms,
      });
    return (0, vt.jsx)(Mi, {
      value: {
        getStyles: w,
        store: b,
        onOptionSubmit: c,
        size: d,
        resetSelectionOnOptionHover: m,
        readOnly: v,
      },
      children: (0, vt.jsx)(
        Fi,
        f(
          f({ opened: b.dropdownOpened }, y),
          {},
          {
            onChange: (e) =>
              !e && (null === u || void 0 === u || u(), void b.closeDropdown()),
            withRoles: !1,
            unstyled: o,
            children: a,
          }
        )
      ),
    });
  }
  (Is.extend = (e) => e),
    (Is.classes = Vi),
    (Is.displayName = "@mantine/core/Combobox"),
    (Is.Target = As),
    (Is.Dropdown = ns),
    (Is.Options = js),
    (Is.Option = Es),
    (Is.Search = Rs),
    (Is.Empty = is),
    (Is.Chevron = Ui),
    (Is.Footer = ms),
    (Is.Header = ws),
    (Is.EventsTarget = ds),
    (Is.DropdownTarget = os),
    (Is.Group = ys),
    (Is.ClearButton = Zi),
    (Is.HiddenInput = Ss);
  const [Vs, Ws] = Uo("ScrollArea.Root component was not found in tree");
  function Hs(e) {
    const t = (0, r.useRef)(e);
    return (
      (0, r.useEffect)(() => {
        t.current = e;
      }),
      (0, r.useMemo)(
        () =>
          function () {
            for (
              var e, n = arguments.length, r = new Array(n), o = 0;
              o < n;
              o++
            )
              r[o] = arguments[o];
            return null === (e = t.current) || void 0 === e
              ? void 0
              : e.call(t, ...r);
          },
        []
      )
    );
  }
  function Bs(e, t) {
    const n = Hs(t);
    yt(() => {
      let t = 0;
      if (e) {
        const r = new ResizeObserver(() => {
          cancelAnimationFrame(t), (t = window.requestAnimationFrame(n));
        });
        return (
          r.observe(e),
          () => {
            window.cancelAnimationFrame(t), r.unobserve(e);
          }
        );
      }
    }, [e, n]);
  }
  const Us = ["style"],
    $s = (0, r.forwardRef)((e, t) => {
      const { style: n } = e,
        o = i(e, Us),
        a = Ws(),
        [l, s] = (0, r.useState)(0),
        [c, u] = (0, r.useState)(0),
        d = Boolean(l && c);
      return (
        Bs(a.scrollbarX, () => {
          var e;
          const t =
            (null === (e = a.scrollbarX) || void 0 === e
              ? void 0
              : e.offsetHeight) || 0;
          a.onCornerHeightChange(t), u(t);
        }),
        Bs(a.scrollbarY, () => {
          var e;
          const t =
            (null === (e = a.scrollbarY) || void 0 === e
              ? void 0
              : e.offsetWidth) || 0;
          a.onCornerWidthChange(t), s(t);
        }),
        d
          ? (0, vt.jsx)(
              "div",
              f(
                f({}, o),
                {},
                { ref: t, style: f(f({}, n), {}, { width: l, height: c }) }
              )
            )
          : null
      );
    }),
    qs = (0, r.forwardRef)((e, t) => {
      const n = Ws(),
        r = Boolean(n.scrollbarX && n.scrollbarY);
      return "scroll" !== n.type && r
        ? (0, vt.jsx)($s, f(f({}, e), {}, { ref: t }))
        : null;
    }),
    Ys = ["type", "scrollHideDelay", "scrollbars"],
    Ks = { scrollHideDelay: 1e3, type: "hover" },
    Qs = (0, r.forwardRef)((e, t) => {
      const n = nn("ScrollAreaRoot", Ks, e),
        { type: o, scrollHideDelay: a, scrollbars: l } = n,
        s = i(n, Ys),
        [c, u] = (0, r.useState)(null),
        [d, p] = (0, r.useState)(null),
        [m, h] = (0, r.useState)(null),
        [v, y] = (0, r.useState)(null),
        [g, b] = (0, r.useState)(null),
        [w, x] = (0, r.useState)(0),
        [S, k] = (0, r.useState)(0),
        [C, E] = (0, r.useState)(!1),
        [N, P] = (0, r.useState)(!1),
        j = Qo(t, (e) => u(e));
      return (0, vt.jsx)(Vs, {
        value: {
          type: o,
          scrollHideDelay: a,
          scrollArea: c,
          viewport: d,
          onViewportChange: p,
          content: m,
          onContentChange: h,
          scrollbarX: v,
          onScrollbarXChange: y,
          scrollbarXEnabled: C,
          onScrollbarXEnabledChange: E,
          scrollbarY: g,
          onScrollbarYChange: b,
          scrollbarYEnabled: N,
          onScrollbarYEnabledChange: P,
          onCornerWidthChange: x,
          onCornerHeightChange: k,
        },
        children: (0, vt.jsx)(
          Bn,
          f(
            f({}, s),
            {},
            {
              ref: j,
              __vars: {
                "--sa-corner-width": "xy" !== l ? "0px" : "".concat(w, "px"),
                "--sa-corner-height": "xy" !== l ? "0px" : "".concat(S, "px"),
              },
            }
          )
        ),
      });
    });
  function Xs(e, t) {
    const n = Hs(e),
      o = (0, r.useRef)(0);
    return (
      (0, r.useEffect)(() => () => window.clearTimeout(o.current), []),
      (0, r.useCallback)(
        function () {
          for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++)
            r[a] = arguments[a];
          window.clearTimeout(o.current),
            (o.current = window.setTimeout(() => n(...r), t));
        },
        [n, t]
      )
    );
  }
  function Gs(e, t) {
    const n = e / t;
    return Number.isNaN(n) ? 0 : n;
  }
  function Js(e) {
    const t = Gs(e.viewport, e.content),
      n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd,
      r = (e.scrollbar.size - n) * t;
    return Math.max(r, 18);
  }
  function Zs(e, t) {
    return (n) => {
      if (e[0] === e[1] || t[0] === t[1]) return t[0];
      const r = (t[1] - t[0]) / (e[1] - e[0]);
      return t[0] + r * (n - e[0]);
    };
  }
  function ec(e, t) {
    let n =
      arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "ltr";
    const r = Js(t),
      o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd,
      a = t.scrollbar.size - o,
      l = t.content - t.viewport,
      i = a - r,
      s = (function (e, t) {
        let [n, r] = t;
        return Math.min(r, Math.max(n, e));
      })(e, "ltr" === n ? [0, l] : [-1 * l, 0]);
    return Zs([0, l], [0, i])(s);
  }
  function tc(e, t) {
    return e > 0 && e < t;
  }
  function nc(e) {
    return e ? parseInt(e, 10) : 0;
  }
  function rc(e, t) {
    let { checkForDefaultPrevented: n = !0 } =
      arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return (r) => {
      null === e || void 0 === e || e(r),
        (!1 !== n && r.defaultPrevented) || null === t || void 0 === t || t(r);
    };
  }
  Qs.displayName = "@mantine/core/ScrollAreaRoot";
  const [oc, ac] = Uo("ScrollAreaScrollbar was not found in tree"),
    lc = [
      "sizes",
      "hasThumb",
      "onThumbChange",
      "onThumbPointerUp",
      "onThumbPointerDown",
      "onThumbPositionChange",
      "onDragScroll",
      "onWheelScroll",
      "onResize",
    ],
    ic = (0, r.forwardRef)((e, t) => {
      const {
          sizes: n,
          hasThumb: o,
          onThumbChange: a,
          onThumbPointerUp: l,
          onThumbPointerDown: s,
          onThumbPositionChange: c,
          onDragScroll: u,
          onWheelScroll: d,
          onResize: p,
        } = e,
        m = i(e, lc),
        h = Ws(),
        [v, y] = (0, r.useState)(null),
        g = Qo(t, (e) => y(e)),
        b = (0, r.useRef)(null),
        w = (0, r.useRef)(""),
        { viewport: x } = h,
        S = n.content - n.viewport,
        k = Hs(d),
        C = Hs(c),
        E = Xs(p, 10),
        N = (e) => {
          if (b.current) {
            const t = e.clientX - b.current.left,
              n = e.clientY - b.current.top;
            u({ x: t, y: n });
          }
        };
      return (
        (0, r.useEffect)(() => {
          const e = (e) => {
            const t = e.target;
            (null === v || void 0 === v ? void 0 : v.contains(t)) && k(e, S);
          };
          return (
            document.addEventListener("wheel", e, { passive: !1 }),
            () => document.removeEventListener("wheel", e, { passive: !1 })
          );
        }, [x, v, S, k]),
        (0, r.useEffect)(C, [n, C]),
        Bs(v, E),
        Bs(h.content, E),
        (0, vt.jsx)(oc, {
          value: {
            scrollbar: v,
            hasThumb: o,
            onThumbChange: Hs(a),
            onThumbPointerUp: Hs(l),
            onThumbPositionChange: C,
            onThumbPointerDown: Hs(s),
          },
          children: (0, vt.jsx)(
            "div",
            f(
              f({}, m),
              {},
              {
                ref: g,
                "data-mantine-scrollbar": !0,
                style: f({ position: "absolute" }, m.style),
                onPointerDown: rc(e.onPointerDown, (e) => {
                  e.preventDefault();
                  if (0 === e.button) {
                    e.target.setPointerCapture(e.pointerId),
                      (b.current = v.getBoundingClientRect()),
                      (w.current = document.body.style.webkitUserSelect),
                      (document.body.style.webkitUserSelect = "none"),
                      N(e);
                  }
                }),
                onPointerMove: rc(e.onPointerMove, N),
                onPointerUp: rc(e.onPointerUp, (e) => {
                  e.preventDefault();
                  const t = e.target;
                  t.hasPointerCapture(e.pointerId) &&
                    t.releasePointerCapture(e.pointerId),
                    (document.body.style.webkitUserSelect = w.current),
                    (b.current = null);
                }),
              }
            )
          ),
        })
      );
    }),
    sc = ["sizes", "onSizesChange", "style"],
    cc = (0, r.forwardRef)((e, t) => {
      const { sizes: n, onSizesChange: o, style: a } = e,
        l = i(e, sc),
        s = Ws(),
        [c, u] = (0, r.useState)(),
        d = (0, r.useRef)(null),
        p = Qo(t, d, s.onScrollbarXChange);
      return (
        (0, r.useEffect)(() => {
          d.current && u(getComputedStyle(d.current));
        }, [d]),
        (0, vt.jsx)(
          ic,
          f(
            f({ "data-orientation": "horizontal" }, l),
            {},
            {
              ref: p,
              sizes: n,
              style: f(
                f({}, a),
                {},
                { "--sa-thumb-width": "".concat(Js(n), "px") }
              ),
              onThumbPointerDown: (t) => e.onThumbPointerDown(t.x),
              onDragScroll: (t) => e.onDragScroll(t.x),
              onWheelScroll: (t, n) => {
                if (s.viewport) {
                  const r = s.viewport.scrollLeft + t.deltaX;
                  e.onWheelScroll(r), tc(r, n) && t.preventDefault();
                }
              },
              onResize: () => {
                d.current &&
                  s.viewport &&
                  c &&
                  o({
                    content: s.viewport.scrollWidth,
                    viewport: s.viewport.offsetWidth,
                    scrollbar: {
                      size: d.current.clientWidth,
                      paddingStart: nc(c.paddingLeft),
                      paddingEnd: nc(c.paddingRight),
                    },
                  });
              },
            }
          )
        )
      );
    });
  cc.displayName = "@mantine/core/ScrollAreaScrollbarX";
  const uc = ["sizes", "onSizesChange", "style"],
    dc = (0, r.forwardRef)((e, t) => {
      const { sizes: n, onSizesChange: o, style: a } = e,
        l = i(e, uc),
        s = Ws(),
        [c, u] = (0, r.useState)(),
        d = (0, r.useRef)(null),
        p = Qo(t, d, s.onScrollbarYChange);
      return (
        (0, r.useEffect)(() => {
          d.current && u(window.getComputedStyle(d.current));
        }, []),
        (0, vt.jsx)(
          ic,
          f(
            f({}, l),
            {},
            {
              "data-orientation": "vertical",
              ref: p,
              sizes: n,
              style: f({ "--sa-thumb-height": "".concat(Js(n), "px") }, a),
              onThumbPointerDown: (t) => e.onThumbPointerDown(t.y),
              onDragScroll: (t) => e.onDragScroll(t.y),
              onWheelScroll: (t, n) => {
                if (s.viewport) {
                  const r = s.viewport.scrollTop + t.deltaY;
                  e.onWheelScroll(r), tc(r, n) && t.preventDefault();
                }
              },
              onResize: () => {
                d.current &&
                  s.viewport &&
                  c &&
                  o({
                    content: s.viewport.scrollHeight,
                    viewport: s.viewport.offsetHeight,
                    scrollbar: {
                      size: d.current.clientHeight,
                      paddingStart: nc(c.paddingTop),
                      paddingEnd: nc(c.paddingBottom),
                    },
                  });
              },
            }
          )
        )
      );
    });
  dc.displayName = "@mantine/core/ScrollAreaScrollbarY";
  const fc = ["orientation"],
    pc = (0, r.forwardRef)((e, t) => {
      const { orientation: n = "vertical" } = e,
        o = i(e, fc),
        { dir: a } = Nr(),
        l = Ws(),
        s = (0, r.useRef)(null),
        c = (0, r.useRef)(0),
        [u, d] = (0, r.useState)({
          content: 0,
          viewport: 0,
          scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 },
        }),
        p = Gs(u.viewport, u.content),
        m = f(
          f({}, o),
          {},
          {
            sizes: u,
            onSizesChange: d,
            hasThumb: Boolean(p > 0 && p < 1),
            onThumbChange: (e) => {
              s.current = e;
            },
            onThumbPointerUp: () => {
              c.current = 0;
            },
            onThumbPointerDown: (e) => {
              c.current = e;
            },
          }
        ),
        h = (e, t) =>
          (function (e, t, n) {
            let r =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : "ltr";
            const o = Js(n),
              a = t || o / 2,
              l = o - a,
              i = n.scrollbar.paddingStart + a,
              s = n.scrollbar.size - n.scrollbar.paddingEnd - l,
              c = n.content - n.viewport;
            return Zs([i, s], "ltr" === r ? [0, c] : [-1 * c, 0])(e);
          })(e, c.current, u, t);
      return "horizontal" === n
        ? (0, vt.jsx)(
            cc,
            f(
              f({}, m),
              {},
              {
                ref: t,
                onThumbPositionChange: () => {
                  if (l.viewport && s.current) {
                    const e = ec(l.viewport.scrollLeft, u, a);
                    s.current.style.transform = "translate3d(".concat(
                      e,
                      "px, 0, 0)"
                    );
                  }
                },
                onWheelScroll: (e) => {
                  l.viewport && (l.viewport.scrollLeft = e);
                },
                onDragScroll: (e) => {
                  l.viewport && (l.viewport.scrollLeft = h(e, a));
                },
              }
            )
          )
        : "vertical" === n
        ? (0, vt.jsx)(
            dc,
            f(
              f({}, m),
              {},
              {
                ref: t,
                onThumbPositionChange: () => {
                  if (l.viewport && s.current) {
                    const e = ec(l.viewport.scrollTop, u);
                    0 === u.scrollbar.size
                      ? s.current.style.setProperty("--thumb-opacity", "0")
                      : s.current.style.setProperty("--thumb-opacity", "1"),
                      (s.current.style.transform = "translate3d(0, ".concat(
                        e,
                        "px, 0)"
                      ));
                  }
                },
                onWheelScroll: (e) => {
                  l.viewport && (l.viewport.scrollTop = e);
                },
                onDragScroll: (e) => {
                  l.viewport && (l.viewport.scrollTop = h(e));
                },
              }
            )
          )
        : null;
    });
  pc.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
  const mc = ["forceMount"],
    hc = (0, r.forwardRef)((e, t) => {
      const n = Ws(),
        { forceMount: o } = e,
        a = i(e, mc),
        [l, s] = (0, r.useState)(!1),
        c = "horizontal" === e.orientation,
        u = Xs(() => {
          if (n.viewport) {
            const e = n.viewport.offsetWidth < n.viewport.scrollWidth,
              t = n.viewport.offsetHeight < n.viewport.scrollHeight;
            s(c ? e : t);
          }
        }, 10);
      return (
        Bs(n.viewport, u),
        Bs(n.content, u),
        o || l
          ? (0, vt.jsx)(
              pc,
              f(
                f({ "data-state": l ? "visible" : "hidden" }, a),
                {},
                { ref: t }
              )
            )
          : null
      );
    });
  hc.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
  const vc = ["forceMount"],
    yc = (0, r.forwardRef)((e, t) => {
      const { forceMount: n } = e,
        o = i(e, vc),
        a = Ws(),
        [l, s] = (0, r.useState)(!1);
      return (
        (0, r.useEffect)(() => {
          const { scrollArea: e } = a;
          let t = 0;
          if (e) {
            const n = () => {
                window.clearTimeout(t), s(!0);
              },
              r = () => {
                t = window.setTimeout(() => s(!1), a.scrollHideDelay);
              };
            return (
              e.addEventListener("pointerenter", n),
              e.addEventListener("pointerleave", r),
              () => {
                window.clearTimeout(t),
                  e.removeEventListener("pointerenter", n),
                  e.removeEventListener("pointerleave", r);
              }
            );
          }
        }, [a.scrollArea, a.scrollHideDelay]),
        n || l
          ? (0, vt.jsx)(
              hc,
              f(
                f({ "data-state": l ? "visible" : "hidden" }, o),
                {},
                { ref: t }
              )
            )
          : null
      );
    });
  yc.displayName = "@mantine/core/ScrollAreaScrollbarHover";
  const gc = ["forceMount"],
    bc = (0, r.forwardRef)((e, t) => {
      const { forceMount: n } = e,
        o = i(e, gc),
        a = Ws(),
        l = "horizontal" === e.orientation,
        [s, c] = (0, r.useState)("hidden"),
        u = Xs(() => c("idle"), 100);
      return (
        (0, r.useEffect)(() => {
          if ("idle" === s) {
            const e = window.setTimeout(() => c("hidden"), a.scrollHideDelay);
            return () => window.clearTimeout(e);
          }
        }, [s, a.scrollHideDelay]),
        (0, r.useEffect)(() => {
          const { viewport: e } = a,
            t = l ? "scrollLeft" : "scrollTop";
          if (e) {
            let n = e[t];
            const r = () => {
              const r = e[t];
              n !== r && (c("scrolling"), u()), (n = r);
            };
            return (
              e.addEventListener("scroll", r),
              () => e.removeEventListener("scroll", r)
            );
          }
        }, [a.viewport, l, u]),
        n || "hidden" !== s
          ? (0, vt.jsx)(
              pc,
              f(
                f({ "data-state": "hidden" === s ? "hidden" : "visible" }, o),
                {},
                {
                  ref: t,
                  onPointerEnter: rc(e.onPointerEnter, () => c("interacting")),
                  onPointerLeave: rc(e.onPointerLeave, () => c("idle")),
                }
              )
            )
          : null
      );
    }),
    wc = ["forceMount"],
    xc = (0, r.forwardRef)((e, t) => {
      const { forceMount: n } = e,
        o = i(e, wc),
        a = Ws(),
        { onScrollbarXEnabledChange: l, onScrollbarYEnabledChange: s } = a,
        c = "horizontal" === e.orientation;
      return (
        (0, r.useEffect)(
          () => (
            c ? l(!0) : s(!0),
            () => {
              c ? l(!1) : s(!1);
            }
          ),
          [c, l, s]
        ),
        "hover" === a.type
          ? (0, vt.jsx)(yc, f(f({}, o), {}, { ref: t, forceMount: n }))
          : "scroll" === a.type
          ? (0, vt.jsx)(bc, f(f({}, o), {}, { ref: t, forceMount: n }))
          : "auto" === a.type
          ? (0, vt.jsx)(hc, f(f({}, o), {}, { ref: t, forceMount: n }))
          : "always" === a.type
          ? (0, vt.jsx)(pc, f(f({}, o), {}, { ref: t }))
          : null
      );
    });
  xc.displayName = "@mantine/core/ScrollAreaScrollbar";
  const Sc = ["style"],
    kc = ["forceMount"],
    Cc = (0, r.forwardRef)((e, t) => {
      const { style: n } = e,
        o = i(e, Sc),
        a = Ws(),
        l = ac(),
        { onThumbPositionChange: s } = l,
        c = Qo(t, (e) => l.onThumbChange(e)),
        u = (0, r.useRef)(void 0),
        d = Xs(() => {
          u.current && (u.current(), (u.current = void 0));
        }, 100);
      return (
        (0, r.useEffect)(() => {
          const { viewport: e } = a;
          if (e) {
            const t = () => {
              if ((d(), !u.current)) {
                const t = (function (e) {
                  let t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : () => {},
                    n = { left: e.scrollLeft, top: e.scrollTop },
                    r = 0;
                  return (
                    (function o() {
                      const a = { left: e.scrollLeft, top: e.scrollTop },
                        l = n.left !== a.left,
                        i = n.top !== a.top;
                      (l || i) && t(),
                        (n = a),
                        (r = window.requestAnimationFrame(o));
                    })(),
                    () => window.cancelAnimationFrame(r)
                  );
                })(e, s);
                (u.current = t), s();
              }
            };
            return (
              s(),
              e.addEventListener("scroll", t),
              () => e.removeEventListener("scroll", t)
            );
          }
        }, [a.viewport, d, s]),
        (0, vt.jsx)(
          "div",
          f(
            f({ "data-state": l.hasThumb ? "visible" : "hidden" }, o),
            {},
            {
              ref: c,
              style: f(
                {
                  width: "var(--sa-thumb-width)",
                  height: "var(--sa-thumb-height)",
                },
                n
              ),
              onPointerDownCapture: rc(e.onPointerDownCapture, (e) => {
                const t = e.target.getBoundingClientRect(),
                  n = e.clientX - t.left,
                  r = e.clientY - t.top;
                l.onThumbPointerDown({ x: n, y: r });
              }),
              onPointerUp: rc(e.onPointerUp, l.onThumbPointerUp),
            }
          )
        )
      );
    });
  Cc.displayName = "@mantine/core/ScrollAreaThumb";
  const Ec = (0, r.forwardRef)((e, t) => {
    const { forceMount: n } = e,
      r = i(e, kc),
      o = ac();
    return n || o.hasThumb ? (0, vt.jsx)(Cc, f({ ref: t }, r)) : null;
  });
  Ec.displayName = "@mantine/core/ScrollAreaThumb";
  const Nc = ["children", "style"],
    Pc = (0, r.forwardRef)((e, t) => {
      let { children: n, style: r } = e,
        o = i(e, Nc);
      const a = Ws(),
        l = Qo(t, a.onViewportChange);
      return (0, vt.jsx)(
        Bn,
        f(
          f({}, o),
          {},
          {
            ref: l,
            style: f(
              {
                overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
                overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
              },
              r
            ),
            children: (0, vt.jsx)("div", {
              style: { minWidth: "100%", display: "table" },
              ref: a.onContentChange,
              children: n,
            }),
          }
        )
      );
    });
  Pc.displayName = "@mantine/core/ScrollAreaViewport";
  var jc = {
    root: "m_d57069b5",
    viewport: "m_c0783ff9",
    viewportInner: "m_f8f631dd",
    scrollbar: "m_c44ba933",
    thumb: "m_d8b5e363",
    corner: "m_21657268",
  };
  const zc = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "scrollbarSize",
      "vars",
      "type",
      "scrollHideDelay",
      "viewportProps",
      "viewportRef",
      "onScrollPositionChange",
      "children",
      "offsetScrollbars",
      "scrollbars",
      "onBottomReached",
      "onTopReached",
    ],
    Tc = [
      "children",
      "classNames",
      "styles",
      "scrollbarSize",
      "scrollHideDelay",
      "type",
      "dir",
      "offsetScrollbars",
      "viewportRef",
      "onScrollPositionChange",
      "unstyled",
      "variant",
      "viewportProps",
      "scrollbars",
      "style",
      "vars",
      "onBottomReached",
      "onTopReached",
    ],
    Rc = { scrollHideDelay: 1e3, type: "hover", scrollbars: "xy" },
    _c = (e, t) => {
      let { scrollbarSize: n } = t;
      return { root: { "--scrollarea-scrollbar-size": Ct(n) } };
    },
    Oc = $n((e, t) => {
      const n = nn("ScrollArea", Rc, e),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          scrollbarSize: u,
          vars: d,
          type: p,
          scrollHideDelay: m,
          viewportProps: h,
          viewportRef: v,
          onScrollPositionChange: y,
          children: g,
          offsetScrollbars: b,
          scrollbars: w,
          onBottomReached: x,
          onTopReached: S,
        } = n,
        k = i(n, zc),
        [C, E] = (0, r.useState)(!1),
        N = bn({
          name: "ScrollArea",
          props: n,
          classes: jc,
          className: a,
          style: l,
          classNames: o,
          styles: s,
          unstyled: c,
          vars: d,
          varsResolver: _c,
        });
      return (0, vt.jsxs)(
        Qs,
        f(
          f(
            f(
              {
                type: "never" === p ? "always" : p,
                scrollHideDelay: m,
                ref: t,
                scrollbars: w,
              },
              N("root")
            ),
            k
          ),
          {},
          {
            children: [
              (0, vt.jsx)(
                Pc,
                f(
                  f(
                    f({}, h),
                    N("viewport", {
                      style: null === h || void 0 === h ? void 0 : h.style,
                    })
                  ),
                  {},
                  {
                    ref: v,
                    "data-offset-scrollbars": !0 === b ? "xy" : b || void 0,
                    "data-scrollbars": w || void 0,
                    onScroll: (e) => {
                      var t;
                      null === h ||
                        void 0 === h ||
                        null === (t = h.onScroll) ||
                        void 0 === t ||
                        t.call(h, e),
                        null === y ||
                          void 0 === y ||
                          y({
                            x: e.currentTarget.scrollLeft,
                            y: e.currentTarget.scrollTop,
                          });
                      const {
                        scrollTop: n,
                        scrollHeight: r,
                        clientHeight: o,
                      } = e.currentTarget;
                      n - (r - o) >= 0 && (null === x || void 0 === x || x()),
                        0 === n && (null === S || void 0 === S || S());
                    },
                    children: g,
                  }
                )
              ),
              ("xy" === w || "x" === w) &&
                (0, vt.jsx)(
                  xc,
                  f(
                    f({}, N("scrollbar")),
                    {},
                    {
                      orientation: "horizontal",
                      "data-hidden": "never" === p || void 0,
                      forceMount: !0,
                      onMouseEnter: () => E(!0),
                      onMouseLeave: () => E(!1),
                      children: (0, vt.jsx)(Ec, f({}, N("thumb"))),
                    }
                  )
                ),
              ("xy" === w || "y" === w) &&
                (0, vt.jsx)(
                  xc,
                  f(
                    f({}, N("scrollbar")),
                    {},
                    {
                      orientation: "vertical",
                      "data-hidden": "never" === p || void 0,
                      forceMount: !0,
                      onMouseEnter: () => E(!0),
                      onMouseLeave: () => E(!1),
                      children: (0, vt.jsx)(Ec, f({}, N("thumb"))),
                    }
                  )
                ),
              (0, vt.jsx)(
                qs,
                f(
                  f({}, N("corner")),
                  {},
                  {
                    "data-hovered": C || void 0,
                    "data-hidden": "never" === p || void 0,
                  }
                )
              ),
            ],
          }
        )
      );
    });
  Oc.displayName = "@mantine/core/ScrollArea";
  const Ac = $n((e, t) => {
    const n = nn("ScrollAreaAutosize", Rc, e),
      {
        children: r,
        classNames: o,
        styles: a,
        scrollbarSize: l,
        scrollHideDelay: s,
        type: c,
        dir: u,
        offsetScrollbars: d,
        viewportRef: p,
        onScrollPositionChange: m,
        unstyled: h,
        variant: v,
        viewportProps: y,
        scrollbars: g,
        style: b,
        vars: w,
        onBottomReached: x,
        onTopReached: S,
      } = n,
      k = i(n, Tc);
    return (0, vt.jsx)(
      Bn,
      f(
        f({}, k),
        {},
        {
          ref: t,
          style: [{ display: "flex", overflow: "auto" }, b],
          children: (0, vt.jsx)(Bn, {
            style: { display: "flex", flexDirection: "column", flex: 1 },
            children: (0, vt.jsx)(Oc, {
              classNames: o,
              styles: a,
              scrollHideDelay: s,
              scrollbarSize: l,
              type: c,
              dir: u,
              offsetScrollbars: d,
              viewportRef: p,
              onScrollPositionChange: m,
              unstyled: h,
              variant: v,
              viewportProps: y,
              vars: w,
              scrollbars: g,
              onBottomReached: x,
              onTopReached: S,
              children: r,
            }),
          }),
        }
      )
    );
  });
  function Lc(e) {
    return "group" in e;
  }
  function Dc(e) {
    let { options: t, search: n, limit: r } = e;
    const o = n.trim().toLowerCase(),
      a = [];
    for (let l = 0; l < t.length; l += 1) {
      const e = t[l];
      if (a.length === r) return a;
      Lc(e) &&
        a.push({
          group: e.group,
          items: Dc({ options: e.items, search: n, limit: r - a.length }),
        }),
        Lc(e) || (e.label.toLowerCase().includes(o) && a.push(e));
    }
    return a;
  }
  function Fc(e) {
    let t =
      arguments.length > 1 && void 0 !== arguments[1]
        ? arguments[1]
        : new Set();
    if (Array.isArray(e))
      for (const n of e)
        if (Lc(n)) Fc(n.items, t);
        else {
          if ("undefined" === typeof n.value)
            throw new Error(
              "[@mantine/core] Each option must have value property"
            );
          if ("string" !== typeof n.value)
            throw new Error(
              "[@mantine/core] Option value must be a string, other data formats are not supported, got ".concat(
                typeof n.value
              )
            );
          if (t.has(n.value))
            throw new Error(
              '[@mantine/core] Duplicate options are not supported. Option with value "'.concat(
                n.value,
                '" was provided more than once'
              )
            );
          t.add(n.value);
        }
  }
  function Mc(e) {
    let {
      data: t,
      withCheckIcon: n,
      value: r,
      checkIconPosition: o,
      unstyled: a,
      renderOption: l,
    } = e;
    if (!Lc(t)) {
      const e = (function (e, t) {
          return Array.isArray(e) ? e.includes(t) : e === t;
        })(r, t.value),
        i =
          n && e && (0, vt.jsx)(Co, { className: Vi.optionsDropdownCheckIcon }),
        s = (0, vt.jsxs)(vt.Fragment, {
          children: [
            "left" === o && i,
            (0, vt.jsx)("span", { children: t.label }),
            "right" === o && i,
          ],
        });
      return (0, vt.jsx)(Is.Option, {
        value: t.value,
        disabled: t.disabled,
        className: sn({ [Vi.optionsDropdownOption]: !a }),
        "data-reverse": "right" === o || void 0,
        "data-checked": e || void 0,
        "aria-selected": e,
        active: e,
        children: "function" === typeof l ? l({ option: t, checked: e }) : s,
      });
    }
    const i = t.items.map((e) =>
      (0, vt.jsx)(
        Mc,
        {
          data: e,
          value: r,
          unstyled: a,
          withCheckIcon: n,
          checkIconPosition: o,
          renderOption: l,
        },
        e.value
      )
    );
    return (0, vt.jsx)(Is.Group, { label: t.group, children: i });
  }
  function Ic(e) {
    let {
      data: t,
      hidden: n,
      hiddenWhenEmpty: r,
      filter: o,
      search: a,
      limit: l,
      maxDropdownHeight: i,
      withScrollArea: s = !0,
      filterOptions: c = !0,
      withCheckIcon: u = !1,
      value: d,
      checkIconPosition: p,
      nothingFoundMessage: m,
      unstyled: h,
      labelId: v,
      renderOption: y,
      scrollAreaProps: g,
      "aria-label": b,
    } = e;
    Fc(t);
    const w =
        "string" === typeof a
          ? (o || Dc)({
              options: t,
              search: c ? a : "",
              limit: null !== l && void 0 !== l ? l : 1 / 0,
            })
          : t,
      x = (function (e) {
        if (0 === e.length) return !0;
        for (const t of e) {
          if (!("group" in t)) return !1;
          if (t.items.length > 0) return !1;
        }
        return !0;
      })(w),
      S = w.map((e) =>
        (0, vt.jsx)(
          Mc,
          {
            data: e,
            withCheckIcon: u,
            value: d,
            checkIconPosition: p,
            unstyled: h,
            renderOption: y,
          },
          Lc(e) ? e.group : e.value
        )
      );
    return (0, vt.jsx)(Is.Dropdown, {
      hidden: n || (r && x),
      children: (0, vt.jsxs)(Is.Options, {
        labelledBy: v,
        "aria-label": b,
        children: [
          s
            ? (0, vt.jsx)(
                Oc.Autosize,
                f(
                  f(
                    {
                      mah: null !== i && void 0 !== i ? i : 220,
                      type: "scroll",
                      scrollbarSize: "var(--combobox-padding)",
                      offsetScrollbars: "y",
                    },
                    g
                  ),
                  {},
                  { children: S }
                )
              )
            : S,
          x && m && (0, vt.jsx)(Is.Empty, { children: m }),
        ],
      }),
    });
  }
  (Oc.classes = jc),
    (Ac.displayName = "@mantine/core/ScrollAreaAutosize"),
    (Ac.classes = jc),
    (Oc.Autosize = Ac);
  const Vc = [
    "label",
    "description",
    "error",
    "required",
    "classNames",
    "styles",
    "className",
    "unstyled",
    "__staticSelector",
    "__stylesApiProps",
    "errorProps",
    "labelProps",
    "descriptionProps",
    "wrapperProps",
    "id",
    "size",
    "style",
    "inputContainer",
    "inputWrapperOrder",
    "withAsterisk",
    "variant",
    "vars",
    "mod",
  ];
  const Wc = ["inputProps", "wrapperProps"],
    Hc = { __staticSelector: "InputBase", withAria: !0 },
    Bc = qn((e, t) => {
      const n = (function (e, t, n) {
          const r = nn(e, t, n),
            {
              label: o,
              description: a,
              error: l,
              required: s,
              classNames: c,
              styles: u,
              className: d,
              unstyled: p,
              __staticSelector: m,
              __stylesApiProps: h,
              errorProps: v,
              labelProps: y,
              descriptionProps: g,
              wrapperProps: b,
              id: w,
              size: x,
              style: S,
              inputContainer: k,
              inputWrapperOrder: C,
              withAsterisk: E,
              variant: N,
              vars: P,
              mod: j,
            } = r,
            z = i(r, Vc),
            { styleProps: T, rest: R } = xn(z),
            _ = f(
              {
                label: o,
                description: a,
                error: l,
                required: s,
                classNames: c,
                className: d,
                __staticSelector: m,
                __stylesApiProps: h || r,
                errorProps: v,
                labelProps: y,
                descriptionProps: g,
                unstyled: p,
                styles: u,
                size: x,
                style: S,
                inputContainer: k,
                inputWrapperOrder: C,
                withAsterisk: E,
                variant: N,
                id: w,
                mod: j,
              },
              b
            );
          return f(
            f({}, R),
            {},
            {
              classNames: c,
              styles: u,
              unstyled: p,
              wrapperProps: f(f({}, _), T),
              inputProps: {
                required: s,
                classNames: c,
                styles: u,
                unstyled: p,
                size: x,
                __staticSelector: m,
                __stylesApiProps: h || r,
                error: l,
                variant: N,
                id: w,
              },
            }
          );
        })("InputBase", Hc, e),
        { inputProps: r, wrapperProps: o } = n,
        a = i(n, Wc);
      return (0, vt.jsx)(
        wr.Wrapper,
        f(
          f({}, o),
          {},
          { children: (0, vt.jsx)(wr, f(f(f({}, r), a), {}, { ref: t })) }
        )
      );
    });
  (Bc.classes = f(f({}, wr.classes), wr.Wrapper.classes)),
    (Bc.displayName = "@mantine/core/InputBase");
  const Uc = [
      "classNames",
      "styles",
      "unstyled",
      "vars",
      "dropdownOpened",
      "defaultDropdownOpened",
      "onDropdownClose",
      "onDropdownOpen",
      "onFocus",
      "onBlur",
      "onClick",
      "onChange",
      "data",
      "value",
      "defaultValue",
      "selectFirstOptionOnChange",
      "onOptionSubmit",
      "comboboxProps",
      "readOnly",
      "disabled",
      "filter",
      "limit",
      "withScrollArea",
      "maxDropdownHeight",
      "size",
      "searchable",
      "rightSection",
      "checkIconPosition",
      "withCheckIcon",
      "nothingFoundMessage",
      "name",
      "form",
      "searchValue",
      "defaultSearchValue",
      "onSearchChange",
      "allowDeselect",
      "error",
      "rightSectionPointerEvents",
      "id",
      "clearable",
      "clearButtonProps",
      "hiddenInputProps",
      "renderOption",
      "onClear",
      "autoComplete",
      "scrollAreaProps",
    ],
    $c = {
      searchable: !1,
      withCheckIcon: !0,
      allowDeselect: !0,
      checkIconPosition: "left",
    },
    qc = $n((e, t) => {
      const n = nn("Select", $c, e),
        {
          classNames: o,
          styles: a,
          unstyled: l,
          vars: s,
          dropdownOpened: c,
          defaultDropdownOpened: u,
          onDropdownClose: d,
          onDropdownOpen: p,
          onFocus: m,
          onBlur: h,
          onClick: v,
          onChange: y,
          data: g,
          value: b,
          defaultValue: w,
          selectFirstOptionOnChange: x,
          onOptionSubmit: S,
          comboboxProps: k,
          readOnly: C,
          disabled: E,
          filter: N,
          limit: P,
          withScrollArea: j,
          maxDropdownHeight: z,
          size: T,
          searchable: R,
          rightSection: _,
          checkIconPosition: O,
          withCheckIcon: A,
          nothingFoundMessage: L,
          name: D,
          form: F,
          searchValue: M,
          defaultSearchValue: I,
          onSearchChange: V,
          allowDeselect: W,
          error: H,
          rightSectionPointerEvents: B,
          id: U,
          clearable: $,
          clearButtonProps: q,
          hiddenInputProps: Y,
          renderOption: K,
          onClear: Q,
          autoComplete: X,
          scrollAreaProps: G,
        } = n,
        J = i(n, Uc),
        Z = (0, r.useMemo)(() => Mo(g), [g]),
        ee = (0, r.useMemo)(() => Io(Z), [Z]),
        te = wt(U),
        [ne, re, oe] = Vr({
          value: b,
          defaultValue: w,
          finalValue: null,
          onChange: y,
        }),
        ae = "string" === typeof ne ? ee[ne] : void 0,
        le = (function (e) {
          const t = (0, r.useRef)(void 0);
          return (
            (0, r.useEffect)(() => {
              t.current = e;
            }, [e]),
            t.current
          );
        })(ae),
        [ie, se] = Vr({
          value: M,
          defaultValue: I,
          finalValue: ae ? ae.label : "",
          onChange: V,
        }),
        ce = Ls({
          opened: c,
          defaultOpened: u,
          onDropdownOpen: () => {
            null === p || void 0 === p || p(),
              ce.updateSelectedOptionIndex("active", { scrollIntoView: !0 });
          },
          onDropdownClose: () => {
            null === d || void 0 === d || d(), ce.resetSelectedOption();
          },
        }),
        { resolvedClassNames: ue, resolvedStyles: de } = Do({
          props: n,
          styles: a,
          classNames: o,
        });
      (0, r.useEffect)(() => {
        x && ce.selectFirstOption();
      }, [x, ne]),
        (0, r.useEffect)(() => {
          null === b && se(""),
            "string" !== typeof b ||
              !ae ||
              ((null === le || void 0 === le ? void 0 : le.value) ===
                ae.value &&
                (null === le || void 0 === le ? void 0 : le.label) ===
                  ae.label) ||
              se(ae.label);
        }, [b, ae]);
      const fe =
        $ &&
        !!ne &&
        !E &&
        !C &&
        (0, vt.jsx)(
          Is.ClearButton,
          f(
            f({ size: T }, q),
            {},
            {
              onClear: () => {
                re(null, null), se(""), null === Q || void 0 === Q || Q();
              },
            }
          )
        );
      return (0, vt.jsxs)(vt.Fragment, {
        children: [
          (0, vt.jsxs)(
            Is,
            f(
              f(
                {
                  store: ce,
                  __staticSelector: "Select",
                  classNames: ue,
                  styles: de,
                  unstyled: l,
                  readOnly: C,
                  onOptionSubmit: (e) => {
                    null === S || void 0 === S || S(e);
                    const t = W && ee[e].value === ne ? null : ee[e],
                      n = t ? t.value : null;
                    n !== ne && re(n, t),
                      !oe &&
                        se(
                          ("string" === typeof n &&
                            (null === t || void 0 === t ? void 0 : t.label)) ||
                            ""
                        ),
                      ce.closeDropdown();
                  },
                  size: T,
                },
                k
              ),
              {},
              {
                children: [
                  (0, vt.jsx)(Is.Target, {
                    targetType: R ? "input" : "button",
                    autoComplete: X,
                    children: (0, vt.jsx)(
                      Bc,
                      f(
                        f(
                          {
                            id: te,
                            ref: t,
                            rightSection:
                              _ ||
                              fe ||
                              (0, vt.jsx)(Is.Chevron, {
                                size: T,
                                error: H,
                                unstyled: l,
                              }),
                            rightSectionPointerEvents:
                              B || (fe ? "all" : "none"),
                          },
                          J
                        ),
                        {},
                        {
                          size: T,
                          __staticSelector: "Select",
                          disabled: E,
                          readOnly: C || !R,
                          value: ie,
                          onChange: (e) => {
                            se(e.currentTarget.value),
                              ce.openDropdown(),
                              x && ce.selectFirstOption();
                          },
                          onFocus: (e) => {
                            R && ce.openDropdown(),
                              null === m || void 0 === m || m(e);
                          },
                          onBlur: (e) => {
                            var t;
                            R && ce.closeDropdown(),
                              se(
                                (null != ne &&
                                  (null === (t = ee[ne]) || void 0 === t
                                    ? void 0
                                    : t.label)) ||
                                  ""
                              ),
                              null === h || void 0 === h || h(e);
                          },
                          onClick: (e) => {
                            R ? ce.openDropdown() : ce.toggleDropdown(),
                              null === v || void 0 === v || v(e);
                          },
                          classNames: ue,
                          styles: de,
                          unstyled: l,
                          pointer: !R,
                          error: H,
                        }
                      )
                    ),
                  }),
                  (0, vt.jsx)(Ic, {
                    data: Z,
                    hidden: C || E,
                    filter: N,
                    search: ie,
                    limit: P,
                    hiddenWhenEmpty: !L,
                    withScrollArea: j,
                    maxDropdownHeight: z,
                    filterOptions:
                      R &&
                      (null === ae || void 0 === ae ? void 0 : ae.label) !== ie,
                    value: ne,
                    checkIconPosition: O,
                    withCheckIcon: A,
                    nothingFoundMessage: L,
                    unstyled: l,
                    labelId: J.label ? "".concat(te, "-label") : void 0,
                    "aria-label": J.label ? void 0 : J["aria-label"],
                    renderOption: K,
                    scrollAreaProps: G,
                  }),
                ],
              }
            )
          ),
          (0, vt.jsx)(
            Is.HiddenInput,
            f({ value: ne, name: D, form: F, disabled: E }, Y)
          ),
        ],
      });
    });
  (qc.classes = f(f({}, Bc.classes), Is.classes)),
    (qc.displayName = "@mantine/core/Select");
  const Yc = {},
    Kc = $n((e, t) => {
      const n = nn("TextInput", Yc, e);
      return (0, vt.jsx)(
        Bc,
        f(
          f({ component: "input", ref: t }, n),
          {},
          { __staticSelector: "TextInput" }
        )
      );
    });
  (Kc.classes = Bc.classes), (Kc.displayName = "@mantine/core/TextInput");
  const [Qc, Xc] = Uo("Grid component was not found in tree");
  function Gc(e) {
    const t = (function (e) {
      var t;
      return "string" === typeof e && e.includes("var(--mantine-scale)")
        ? null === (t = e.match(/^calc\((.*?)\)$/)) || void 0 === t
          ? void 0
          : t[1].split("*")[0].trim()
        : e;
    })(e);
    return "number" === typeof t
      ? t
      : "string" === typeof t
      ? t.includes("calc") || t.includes("var")
        ? t
        : t.includes("px")
        ? Number(t.replace("px", ""))
        : t.includes("rem")
        ? 16 * Number(t.replace("rem", ""))
        : t.includes("em")
        ? 16 * Number(t.replace("em", ""))
        : Number(t)
      : NaN;
  }
  function Jc(e, t) {
    return Gc(e in t ? t[e] : e);
  }
  function Zc(e, t) {
    const n = e.map((e) => ({ value: e, px: Jc(e, t) }));
    return n.sort((e, t) => e.px - t.px), n;
  }
  function eu(e) {
    return "object" === typeof e && null !== e
      ? "base" in e
        ? e.base
        : void 0
      : e;
  }
  const tu = (e, t) =>
      "content" === e
        ? "auto"
        : "auto" === e
        ? "0rem"
        : e
        ? "".concat(100 / (t / e), "%")
        : void 0,
    nu = (e, t, n) =>
      n || "auto" === e ? "100%" : "content" === e ? "unset" : tu(e, t),
    ru = (e, t) => {
      if (e) return "auto" === e || t ? "1" : "auto";
    },
    ou = (e, t) => (0 === e ? "0" : e ? "".concat(100 / (t / e), "%") : void 0);
  function au(e) {
    var t;
    let { span: n, order: r, offset: o, selector: a } = e;
    const l = en(),
      i = Xc(),
      s = i.breakpoints || l.breakpoints,
      c = void 0 === eu(n) ? 12 : eu(n),
      u = Wt({
        "--col-order":
          null === (t = eu(r)) || void 0 === t ? void 0 : t.toString(),
        "--col-flex-grow": ru(c, i.grow),
        "--col-flex-basis": tu(c, i.columns),
        "--col-width": "content" === c ? "auto" : void 0,
        "--col-max-width": nu(c, i.columns, i.grow),
        "--col-offset": ou(eu(o), i.columns),
      }),
      d = Sn(s).reduce((e, t) => {
        var a;
        (e[t] || (e[t] = {}), "object" === typeof r && void 0 !== r[t]) &&
          (e[t]["--col-order"] =
            null === (a = r[t]) || void 0 === a ? void 0 : a.toString());
        return (
          "object" === typeof n &&
            void 0 !== n[t] &&
            ((e[t]["--col-flex-grow"] = ru(n[t], i.grow)),
            (e[t]["--col-flex-basis"] = tu(n[t], i.columns)),
            (e[t]["--col-width"] = "content" === n[t] ? "auto" : void 0),
            (e[t]["--col-max-width"] = nu(n[t], i.columns, i.grow))),
          "object" === typeof o &&
            void 0 !== o[t] &&
            (e[t]["--col-offset"] = ou(o[t], i.columns)),
          e
        );
      }, {}),
      f = Zc(Sn(d), s)
        .filter((e) => Sn(d[e.value]).length > 0)
        .map((e) => ({
          query:
            "container" === i.type
              ? "mantine-grid (min-width: ".concat(s[e.value], ")")
              : "(min-width: ".concat(s[e.value], ")"),
          styles: d[e.value],
        }));
    return (0, vt.jsx)(En, {
      styles: u,
      media: "container" === i.type ? void 0 : f,
      container: "container" === i.type ? f : void 0,
      selector: a,
    });
  }
  var lu = {
    container: "m_8478a6da",
    root: "m_410352e9",
    inner: "m_dee7bd2f",
    col: "m_96bdd299",
  };
  const iu = [
      "classNames",
      "className",
      "style",
      "styles",
      "vars",
      "span",
      "order",
      "offset",
    ],
    su = { span: 12 },
    cu = $n((e, t) => {
      const n = nn("GridCol", su, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          vars: s,
          span: c,
          order: u,
          offset: d,
        } = n,
        p = i(n, iu),
        m = Xc(),
        h = Vn();
      return (0, vt.jsxs)(vt.Fragment, {
        children: [
          (0, vt.jsx)(au, {
            selector: ".".concat(h),
            span: c,
            order: u,
            offset: d,
          }),
          (0, vt.jsx)(
            Bn,
            f(
              f(
                { ref: t },
                m.getStyles("col", {
                  className: sn(o, h),
                  style: a,
                  classNames: r,
                  styles: l,
                })
              ),
              p
            )
          ),
        ],
      });
    });
  function uu(e) {
    let { gutter: t, selector: n, breakpoints: r, type: o } = e;
    const a = en(),
      l = r || a.breakpoints,
      i = Wt({ "--grid-gutter": Pt(eu(t)) }),
      s = Sn(l).reduce(
        (e, n) => (
          e[n] || (e[n] = {}),
          "object" === typeof t &&
            void 0 !== t[n] &&
            (e[n]["--grid-gutter"] = Pt(t[n])),
          e
        ),
        {}
      ),
      c = Zc(Sn(s), l)
        .filter((e) => Sn(s[e.value]).length > 0)
        .map((e) => ({
          query:
            "container" === o
              ? "mantine-grid (min-width: ".concat(l[e.value], ")")
              : "(min-width: ".concat(l[e.value], ")"),
          styles: s[e.value],
        }));
    return (0, vt.jsx)(En, {
      styles: i,
      media: "container" === o ? void 0 : c,
      container: "container" === o ? c : void 0,
      selector: n,
    });
  }
  (cu.classes = lu), (cu.displayName = "@mantine/core/GridCol");
  const du = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "grow",
      "gutter",
      "columns",
      "align",
      "justify",
      "children",
      "breakpoints",
      "type",
    ],
    fu = { gutter: "md", grow: !1, columns: 12 },
    pu = (e, t) => {
      let { justify: n, align: r, overflow: o } = t;
      return {
        root: { "--grid-justify": n, "--grid-align": r, "--grid-overflow": o },
      };
    },
    mu = $n((e, t) => {
      const n = nn("Grid", fu, e),
        {
          classNames: r,
          className: o,
          style: a,
          styles: l,
          unstyled: s,
          vars: c,
          grow: u,
          gutter: d,
          columns: p,
          align: m,
          justify: h,
          children: v,
          breakpoints: y,
          type: g,
        } = n,
        b = i(n, du),
        w = bn({
          name: "Grid",
          classes: lu,
          props: n,
          className: o,
          style: a,
          classNames: r,
          styles: l,
          unstyled: s,
          vars: c,
          varsResolver: pu,
        }),
        x = Vn();
      return "container" === g && y
        ? (0, vt.jsxs)(Qc, {
            value: {
              getStyles: w,
              grow: u,
              columns: p || 12,
              breakpoints: y,
              type: g,
            },
            children: [
              (0, vt.jsx)(uu, f({ selector: ".".concat(x) }, n)),
              (0, vt.jsx)(
                "div",
                f(
                  f({}, w("container")),
                  {},
                  {
                    children: (0, vt.jsx)(
                      Bn,
                      f(
                        f(f({ ref: t }, w("root", { className: x })), b),
                        {},
                        {
                          children: (0, vt.jsx)(
                            "div",
                            f(f({}, w("inner")), {}, { children: v })
                          ),
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          })
        : (0, vt.jsxs)(Qc, {
            value: {
              getStyles: w,
              grow: u,
              columns: p || 12,
              breakpoints: y,
              type: g,
            },
            children: [
              (0, vt.jsx)(uu, f({ selector: ".".concat(x) }, n)),
              (0, vt.jsx)(
                Bn,
                f(
                  f(f({ ref: t }, w("root", { className: x })), b),
                  {},
                  {
                    children: (0, vt.jsx)(
                      "div",
                      f(f({}, w("inner")), {}, { children: v })
                    ),
                  }
                )
              ),
            ],
          });
    });
  (mu.classes = lu), (mu.displayName = "@mantine/core/Grid"), (mu.Col = cu);
  var hu = {
    outline: {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    },
    filled: {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "currentColor",
      stroke: "none",
    },
  };
  const vu = ["color", "size", "stroke", "title", "className", "children"],
    yu = (e, t, n, o) => {
      const a = (0, r.forwardRef)((n, a) => {
        let {
            color: l = "currentColor",
            size: s = 24,
            stroke: c = 2,
            title: u,
            className: d,
            children: p,
          } = n,
          m = i(n, vu);
        return (0, r.createElement)(
          "svg",
          f(
            f(
              f({ ref: a }, hu[e]),
              {},
              {
                width: s,
                height: s,
                className: ["tabler-icon", "tabler-icon-".concat(t), d].join(
                  " "
                ),
              },
              "filled" === e ? { fill: l } : { strokeWidth: c, stroke: l }
            ),
            m
          ),
          [
            u && (0, r.createElement)("title", { key: "svg-title" }, u),
            ...o.map((e) => {
              let [t, n] = e;
              return (0, r.createElement)(t, n);
            }),
            ...(Array.isArray(p) ? p : [p]),
          ]
        );
      });
      return (a.displayName = "".concat(n)), a;
    };
  var gu = yu("outline", "user", "IconUser", [
      ["path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", key: "svg-0" }],
      [
        "path",
        { d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2", key: "svg-1" },
      ],
    ]),
    bu = yu("outline", "phone", "IconPhone", [
      [
        "path",
        {
          d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2",
          key: "svg-0",
        },
      ],
    ]),
    wu = yu("outline", "mail", "IconMail", [
      [
        "path",
        {
          d: "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z",
          key: "svg-0",
        },
      ],
      ["path", { d: "M3 7l9 6l9 -6", key: "svg-1" }],
    ]);
  function xu(e) {
    if (!/^[0-9a-zA-Z-]+$/.test(e))
      throw new Error(
        '[@mantine/use-form] Form name "'.concat(
          e,
          '" is invalid, it should contain only letters, numbers and dashes'
        )
      );
  }
  const Su = "undefined" !== typeof window ? r.useLayoutEffect : r.useEffect;
  function ku(e, t) {
    Su(() => {
      if (e)
        return (
          window.addEventListener(e, t), () => window.removeEventListener(e, t)
        );
    }, [e]);
  }
  function Cu(e) {
    return null === e || "object" !== typeof e
      ? {}
      : Object.keys(e).reduce((t, n) => {
          const r = e[n];
          return void 0 !== r && null !== r && !1 !== r && (t[n] = r), t;
        }, {});
  }
  function Eu(e, t) {
    if (null === t || "object" !== typeof t) return {};
    const n = f({}, t);
    return (
      Object.keys(t).forEach((t) => {
        t.includes("".concat(String(e), ".")) && delete n[t];
      }),
      n
    );
  }
  function Nu(e, t) {
    const n = e.substring(t.length + 1).split(".")[0];
    return parseInt(n, 10);
  }
  function Pu(e, t, n, r) {
    if (void 0 === t) return n;
    const o = "".concat(String(e));
    let a = n;
    -1 === r && (a = Eu("".concat(o, ".").concat(t), a));
    const l = f({}, a),
      i = new Set();
    return (
      Object.entries(a)
        .filter((e) => {
          let [n] = e;
          if (!n.startsWith("".concat(o, "."))) return !1;
          const r = Nu(n, o);
          return !Number.isNaN(r) && r >= t;
        })
        .forEach((e) => {
          let [t, n] = e;
          const a = Nu(t, o),
            s = t.replace(
              "".concat(o, ".").concat(a),
              "".concat(o, ".").concat(a + r)
            );
          (l[s] = n), i.add(s), i.has(t) || delete l[t];
        }),
      l
    );
  }
  function ju(e) {
    return "string" !== typeof e ? [] : e.split(".");
  }
  function zu(e, t) {
    const n = ju(e);
    if (0 === n.length || "object" !== typeof t || null === t) return;
    let r = t[n[0]];
    for (let o = 1; o < n.length && null != r; o += 1) r = r[n[o]];
    return r;
  }
  function Tu(e, t, n) {
    "object" === typeof n.value && (n.value = Ru(n.value)),
      n.enumerable &&
      !n.get &&
      !n.set &&
      n.configurable &&
      n.writable &&
      "__proto__" !== t
        ? (e[t] = n.value)
        : Object.defineProperty(e, t, n);
  }
  function Ru(e) {
    if ("object" !== typeof e) return e;
    var t,
      n,
      r,
      o = 0,
      a = Object.prototype.toString.call(e);
    if (
      ("[object Object]" === a
        ? (r = Object.create(e.__proto__ || null))
        : "[object Array]" === a
        ? (r = Array(e.length))
        : "[object Set]" === a
        ? ((r = new Set()),
          e.forEach(function (e) {
            r.add(Ru(e));
          }))
        : "[object Map]" === a
        ? ((r = new Map()),
          e.forEach(function (e, t) {
            r.set(Ru(t), Ru(e));
          }))
        : "[object Date]" === a
        ? (r = new Date(+e))
        : "[object RegExp]" === a
        ? (r = new RegExp(e.source, e.flags))
        : "[object DataView]" === a
        ? (r = new e.constructor(Ru(e.buffer)))
        : "[object ArrayBuffer]" === a
        ? (r = e.slice(0))
        : "Array]" === a.slice(-6) && (r = new e.constructor(e)),
      r)
    ) {
      for (n = Object.getOwnPropertySymbols(e); o < n.length; o++)
        Tu(r, n[o], Object.getOwnPropertyDescriptor(e, n[o]));
      for (o = 0, n = Object.getOwnPropertyNames(e); o < n.length; o++)
        (Object.hasOwnProperty.call(r, (t = n[o])) && r[t] === e[t]) ||
          Tu(r, t, Object.getOwnPropertyDescriptor(e, t));
    }
    return r || e;
  }
  function _u(e, t, n) {
    const r = ju(e);
    if (0 === r.length) return n;
    const o = Ru(n);
    if (1 === r.length) return (o[r[0]] = t), o;
    let a = o[r[0]];
    for (let l = 1; l < r.length - 1; l += 1) {
      if (void 0 === a) return o;
      a = a[r[l]];
    }
    return (a[r[r.length - 1]] = t), o;
  }
  function Ou(e, t, n) {
    let { from: r, to: o } = t;
    const a = zu(e, n);
    if (!Array.isArray(a)) return n;
    const l = [...a],
      i = a[r];
    return l.splice(r, 1), l.splice(o, 0, i), _u(e, l, n);
  }
  function Au(e, t, n, r) {
    const o = zu(e, r);
    if (!Array.isArray(o)) return r;
    const a = [...o];
    return a.splice("number" === typeof n ? n : a.length, 0, t), _u(e, a, r);
  }
  function Lu(e, t, n) {
    const r = zu(e, n);
    return Array.isArray(r)
      ? _u(
          e,
          r.filter((e, n) => n !== t),
          n
        )
      : n;
  }
  function Du(e, t, n, r) {
    const o = zu(e, r);
    if (!Array.isArray(o)) return r;
    if (o.length <= n) return r;
    const a = [...o];
    return (a[n] = t), _u(e, a, r);
  }
  function Fu(e) {
    let { $values: t, $errors: n, $status: o } = e;
    const a = (0, r.useCallback)((e, r) => {
        o.clearFieldDirty(e),
          n.setErrors((t) =>
            (function (e, t, n) {
              let { from: r, to: o } = t;
              const a = "".concat(e, ".").concat(r),
                l = "".concat(e, ".").concat(o),
                i = f({}, n);
              return (
                Object.keys(n).every((e) => {
                  let t, n;
                  if (
                    (e.startsWith(a) && ((t = e), (n = e.replace(a, l))),
                    e.startsWith(l) && ((t = e.replace(l, a)), (n = e)),
                    t && n)
                  ) {
                    const e = i[t],
                      r = i[n];
                    return (
                      void 0 === r ? delete i[t] : (i[t] = r),
                      void 0 === e ? delete i[n] : (i[n] = e),
                      !1
                    );
                  }
                  return !0;
                }),
                i
              );
            })(e, r, t)
          ),
          t.setValues({
            values: Ou(e, r, t.refValues.current),
            updateState: !0,
          });
      }, []),
      l = (0, r.useCallback)((e, r) => {
        o.clearFieldDirty(e),
          n.setErrors((t) => Pu(e, r, t, -1)),
          t.setValues({
            values: Lu(e, r, t.refValues.current),
            updateState: !0,
          });
      }, []),
      i = (0, r.useCallback)((e, r, a) => {
        o.clearFieldDirty(e),
          n.setErrors((t) => Pu(e, a, t, 1)),
          t.setValues({
            values: Au(e, r, a, t.refValues.current),
            updateState: !0,
          });
      }, []),
      s = (0, r.useCallback)((e, n, r) => {
        o.clearFieldDirty(e),
          t.setValues({
            values: Du(e, r, n, t.refValues.current),
            updateState: !0,
          });
      }, []);
    return {
      reorderListItem: a,
      removeListItem: l,
      insertListItem: i,
      replaceListItem: s,
    };
  }
  var Mu = n(122);
  function Iu(e, t) {
    const n = Object.keys(e);
    if ("string" === typeof t) {
      const r = n.filter((e) => e.startsWith("".concat(t, ".")));
      return e[t] || r.some((t) => e[t]) || !1;
    }
    return n.some((t) => e[t]);
  }
  function Vu(e, t) {
    return e ? "".concat(e, "-").concat(t.toString()) : t.toString();
  }
  function Wu(e) {
    const t = Cu(e);
    return { hasErrors: Object.keys(t).length > 0, errors: t };
  }
  function Hu(e, t) {
    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
      r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    return "object" !== typeof e || null === e
      ? r
      : Object.keys(e).reduce((r, o) => {
          const a = e[o],
            l = "".concat("" === n ? "" : "".concat(n, ".")).concat(o),
            i = zu(l, t);
          let s = !1;
          return (
            "function" === typeof a && (r[l] = a(i, t, l)),
            "object" === typeof a &&
              Array.isArray(i) &&
              ((s = !0),
              i.forEach((e, n) => Hu(a, t, "".concat(l, ".").concat(n), r))),
            "object" === typeof a &&
              "object" === typeof i &&
              null !== i &&
              (s || Hu(a, t, l, r)),
            r
          );
        }, r);
  }
  function Bu(e, t) {
    return Wu("function" === typeof e ? e(t) : Hu(e, t));
  }
  function Uu(e, t, n) {
    if ("string" !== typeof e) return { hasError: !1, error: null };
    const r = Bu(t, n),
      o = Object.keys(r.errors).find((t) =>
        e.split(".").every((e, n) => e === t.split(".")[n])
      );
    return { hasError: !!o, error: o ? r.errors[o] : null };
  }
  function $u(e, t) {
    return (
      !!t &&
      ("boolean" === typeof t
        ? t
        : !!Array.isArray(t) &&
          t.includes(
            e.replace(/[.][0-9]+/g, ".".concat("__MANTINE_FORM_INDEX__"))
          ))
    );
  }
  const qu = ["type", "withError", "withFocus"];
  function Yu() {
    let {
      name: e,
      mode: t = "controlled",
      initialValues: n,
      initialErrors: o = {},
      initialDirty: a = {},
      initialTouched: l = {},
      clearInputErrorOnChange: s = !0,
      validateInputOnChange: c = !1,
      validateInputOnBlur: u = !1,
      onValuesChange: d,
      transformValues: p = (e) => e,
      enhanceGetInputProps: m,
      validate: h,
      onSubmitPreventDefault: v = "always",
      touchTrigger: y = "change",
    } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    const g = (function (e) {
        const [t, n] = (0, r.useState)(Cu(e)),
          o = (0, r.useRef)(t),
          a = (0, r.useCallback)((e) => {
            n((t) => {
              const n = Cu("function" === typeof e ? e(t) : e);
              return (o.current = n), n;
            });
          }, []),
          l = (0, r.useCallback)(() => a({}), []),
          i = (0, r.useCallback)(
            (e) => {
              void 0 !== o.current[e] &&
                a((t) => {
                  const n = f({}, t);
                  return delete n[e], n;
                });
            },
            [t]
          ),
          s = (0, r.useCallback)(
            (e, t) => {
              null == t || !1 === t
                ? i(e)
                : o.current[e] !== t && a((n) => f(f({}, n), {}, { [e]: t }));
            },
            [t]
          );
        return {
          errorsState: t,
          setErrors: a,
          clearErrors: l,
          setFieldError: s,
          clearFieldError: i,
        };
      })(o),
      b = (function (e) {
        let { initialValues: t, onValuesChange: n, mode: o } = e;
        const a = (0, r.useRef)(!1),
          [l, i] = (0, r.useState)(t || {}),
          s = (0, r.useRef)(l),
          c = (0, r.useRef)(l),
          u = (0, r.useCallback)(
            (e) => {
              let {
                values: t,
                subscribers: r,
                updateState: o = !0,
                mergeWithPreviousValues: a = !0,
              } = e;
              const l = s.current,
                c = t instanceof Function ? t(s.current) : t,
                u = a ? f(f({}, l), c) : c;
              (s.current = u),
                o && i(u),
                null === n || void 0 === n || n(u, l),
                null === r ||
                  void 0 === r ||
                  r
                    .filter(Boolean)
                    .forEach((e) => e({ updatedValues: u, previousValues: l }));
            },
            [n]
          ),
          d = (0, r.useCallback)(
            (e) => {
              const t = zu(e.path, s.current),
                n = e.value instanceof Function ? e.value(t) : e.value;
              if (t !== n) {
                var r;
                const t = s.current,
                  o = _u(e.path, n, s.current);
                u({ values: o, updateState: e.updateState }),
                  null === (r = e.subscribers) ||
                    void 0 === r ||
                    r
                      .filter(Boolean)
                      .forEach((n) =>
                        n({ path: e.path, updatedValues: o, previousValues: t })
                      );
              }
            },
            [u]
          ),
          p = (0, r.useCallback)((e) => {
            c.current = e;
          }, []),
          m = (0, r.useCallback)(
            (e, t) => {
              a.current ||
                ((a.current = !0),
                u({ values: e, updateState: "controlled" === o }),
                p(e),
                t());
            },
            [u]
          ),
          h = (0, r.useCallback)(() => {
            u({
              values: c.current,
              updateState: !0,
              mergeWithPreviousValues: !1,
            });
          }, [u]),
          v = (0, r.useCallback)(() => s.current, []),
          y = (0, r.useCallback)(() => c.current, []);
        return {
          initialized: a,
          stateValues: l,
          refValues: s,
          valuesSnapshot: c,
          setValues: u,
          setFieldValue: d,
          resetValues: h,
          setValuesSnapshot: p,
          initialize: m,
          getValues: v,
          getValuesSnapshot: y,
        };
      })({ initialValues: n, onValuesChange: d, mode: t }),
      w = (function (e) {
        let { initialDirty: t, initialTouched: n, mode: o, $values: a } = e;
        const [l, i] = (0, r.useState)(n),
          [s, c] = (0, r.useState)(t),
          u = (0, r.useRef)(n),
          d = (0, r.useRef)(t),
          p = (0, r.useCallback)((e) => {
            const t = "function" === typeof e ? e(u.current) : e;
            (u.current = t), "controlled" === o && i(t);
          }, []),
          m = (0, r.useCallback)(function (e) {
            let t =
              arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            const n = "function" === typeof e ? e(d.current) : e;
            (d.current = n), ("controlled" === o || t) && c(n);
          }, []),
          h = (0, r.useCallback)(() => p({}), []),
          v = (0, r.useCallback)((e) => {
            const t = e
              ? f(f({}, e), a.refValues.current)
              : a.refValues.current;
            a.setValuesSnapshot(t), m({});
          }, []),
          y = (0, r.useCallback)((e, t) => {
            p((n) => (Iu(n, e) === t ? n : f(f({}, n), {}, { [e]: t })));
          }, []),
          g = (0, r.useCallback)((e, t, n) => {
            m((n) => (Iu(n, e) === t ? n : f(f({}, n), {}, { [e]: t })), n);
          }, []),
          b = (0, r.useCallback)((e, t) => {
            const n = Iu(d.current, e),
              r = !Mu(zu(e, a.getValuesSnapshot()), t),
              o = Eu(e, d.current);
            (o[e] = r), m(o, n !== r);
          }, []),
          w = (0, r.useCallback)((e) => Iu(u.current, e), []),
          x = (0, r.useCallback)(
            (e) =>
              m((t) => {
                if ("string" !== typeof e) return t;
                const n = Eu(e, t);
                return delete n[e], Mu(n, t) ? t : n;
              }),
            []
          ),
          S = (0, r.useCallback)((e) => {
            if (e) {
              const t = zu(e, d.current);
              if ("boolean" === typeof t) return t;
              const n = zu(e, a.refValues.current),
                r = zu(e, a.valuesSnapshot.current);
              return !Mu(n, r);
            }
            return Object.keys(d.current).length > 0
              ? Iu(d.current)
              : !Mu(a.refValues.current, a.valuesSnapshot.current);
          }, []),
          k = (0, r.useCallback)(() => d.current, []),
          C = (0, r.useCallback)(() => u.current, []);
        return {
          touchedState: l,
          dirtyState: s,
          touchedRef: u,
          dirtyRef: d,
          setTouched: p,
          setDirty: m,
          resetDirty: v,
          resetTouched: h,
          isTouched: w,
          setFieldTouched: y,
          setFieldDirty: g,
          setTouchedState: i,
          setDirtyState: c,
          clearFieldDirty: x,
          isDirty: S,
          getDirty: k,
          getTouched: C,
          setCalculatedFieldDirty: b,
        };
      })({ initialDirty: a, initialTouched: l, $values: b, mode: t }),
      x = Fu({ $values: b, $errors: g, $status: w }),
      S = (function (e) {
        let { $status: t } = e;
        const n = (0, r.useRef)({}),
          o = (0, r.useCallback)((e, t) => {
            (0, r.useEffect)(
              () => (
                (n.current[e] = n.current[e] || []),
                n.current[e].push(t),
                () => {
                  n.current[e] = n.current[e].filter((e) => e !== t);
                }
              ),
              [t]
            );
          }, []),
          a = (0, r.useCallback)(
            (e) =>
              n.current[e]
                ? n.current[e].map(
                    (n) => (r) =>
                      n({
                        previousValue: zu(e, r.previousValues),
                        value: zu(e, r.updatedValues),
                        touched: t.isTouched(e),
                        dirty: t.isDirty(e),
                      })
                  )
                : [],
            []
          );
        return { subscribers: n, watch: o, getFieldSubscribers: a };
      })({ $status: w }),
      [k, C] = (0, r.useState)(0),
      [E, N] = (0, r.useState)({}),
      [P, j] = (0, r.useState)(!1),
      z = (0, r.useCallback)(() => {
        b.resetValues(),
          g.clearErrors(),
          w.resetDirty(),
          w.resetTouched(),
          "uncontrolled" === t && C((e) => e + 1);
      }, []),
      T = (0, r.useCallback)(
        (e) => {
          s && g.clearErrors(),
            "uncontrolled" === t && C((e) => e + 1),
            Object.keys(S.subscribers.current).forEach((t) => {
              zu(t, b.refValues.current) !== zu(t, e) &&
                S.getFieldSubscribers(t).forEach((t) =>
                  t({ previousValues: e, updatedValues: b.refValues.current })
                );
            });
        },
        [s]
      ),
      R = (0, r.useCallback)(
        (e) => {
          const n = b.refValues.current;
          b.initialize(e, () => "uncontrolled" === t && C((e) => e + 1)), T(n);
        },
        [T]
      ),
      _ = (0, r.useCallback)(
        (e, n, r) => {
          const o = $u(e, c),
            a = n instanceof Function ? n(zu(e, b.refValues.current)) : n;
          w.setCalculatedFieldDirty(e, a),
            "change" === y && w.setFieldTouched(e, !0),
            !o && s && g.clearFieldError(e),
            b.setFieldValue({
              path: e,
              value: n,
              updateState: "controlled" === t,
              subscribers: [
                ...S.getFieldSubscribers(e),
                o
                  ? (t) => {
                      const n = Uu(e, h, t.updatedValues);
                      n.hasError
                        ? g.setFieldError(e, n.error)
                        : g.clearFieldError(e);
                    }
                  : null,
                !1 !== (null === r || void 0 === r ? void 0 : r.forceUpdate) &&
                "controlled" !== t
                  ? () => N((t) => f(f({}, t), {}, { [e]: (t[e] || 0) + 1 }))
                  : null,
              ],
            });
        },
        [d, h]
      ),
      O = (0, r.useCallback)(
        (e) => {
          const n = b.refValues.current;
          b.setValues({ values: e, updateState: "controlled" === t }), T(n);
        },
        [d, T]
      ),
      A = (0, r.useCallback)(() => {
        const e = Bu(h, b.refValues.current);
        return g.setErrors(e.errors), e;
      }, [h]),
      L = (0, r.useCallback)(
        (e) => {
          const t = Uu(e, h, b.refValues.current);
          return (
            t.hasError ? g.setFieldError(e, t.error) : g.clearFieldError(e), t
          );
        },
        [h]
      ),
      D = (0, r.useCallback)((e) => {
        e.preventDefault(), z();
      }, []),
      F = (0, r.useCallback)(
        (e) =>
          e
            ? !Uu(e, h, b.refValues.current).hasError
            : !Bu(h, b.refValues.current).hasErrors,
        [h]
      ),
      M = (0, r.useCallback)(
        (t) => document.querySelector('[data-path="'.concat(Vu(e, t), '"]')),
        []
      ),
      I = {
        watch: S.watch,
        initialized: b.initialized.current,
        values: b.stateValues,
        getValues: b.getValues,
        setInitialValues: b.setValuesSnapshot,
        initialize: R,
        setValues: O,
        setFieldValue: _,
        submitting: P,
        setSubmitting: j,
        errors: g.errorsState,
        setErrors: g.setErrors,
        setFieldError: g.setFieldError,
        clearFieldError: g.clearFieldError,
        clearErrors: g.clearErrors,
        resetDirty: w.resetDirty,
        setTouched: w.setTouched,
        setDirty: w.setDirty,
        isTouched: w.isTouched,
        resetTouched: w.resetTouched,
        isDirty: w.isDirty,
        getTouched: w.getTouched,
        getDirty: w.getDirty,
        reorderListItem: x.reorderListItem,
        insertListItem: x.insertListItem,
        removeListItem: x.removeListItem,
        replaceListItem: x.replaceListItem,
        reset: z,
        validate: A,
        validateField: L,
        getInputProps: function (n) {
          let r =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            { type: o = "input", withError: a = !0, withFocus: l = !0 } = r,
            s = i(r, qu);
          var c;
          const d = {
            onChange:
              ((c = (e) => _(n, e, { forceUpdate: !1 })),
              (e) => {
                if (e)
                  if ("function" === typeof e) c(e);
                  else if ("object" === typeof e && "nativeEvent" in e) {
                    const { currentTarget: t } = e;
                    t instanceof HTMLInputElement
                      ? "checkbox" === t.type
                        ? c(t.checked)
                        : c(t.value)
                      : (t instanceof HTMLTextAreaElement ||
                          t instanceof HTMLSelectElement) &&
                        c(t.value);
                  } else c(e);
                else c(e);
              }),
            "data-path": Vu(e, n),
          };
          return (
            a && (d.error = g.errorsState[n]),
            "checkbox" === o
              ? (d["controlled" === t ? "checked" : "defaultChecked"] = zu(
                  n,
                  b.refValues.current
                ))
              : (d["controlled" === t ? "value" : "defaultValue"] = zu(
                  n,
                  b.refValues.current
                )),
            l &&
              ((d.onFocus = () => w.setFieldTouched(n, !0)),
              (d.onBlur = () => {
                if ($u(n, u)) {
                  const e = Uu(n, h, b.refValues.current);
                  e.hasError
                    ? g.setFieldError(n, e.error)
                    : g.clearFieldError(n);
                }
              })),
            Object.assign(
              d,
              null === m || void 0 === m
                ? void 0
                : m({
                    inputProps: d,
                    field: n,
                    options: f({ type: o, withError: a, withFocus: l }, s),
                    form: I,
                  })
            )
          );
        },
        onSubmit: (e, t) => (n) => {
          "always" === v && (null === n || void 0 === n || n.preventDefault());
          const r = A();
          if (r.hasErrors)
            "validation-failed" === v &&
              (null === n || void 0 === n || n.preventDefault()),
              null === t || void 0 === t || t(r.errors, b.refValues.current, n);
          else {
            const t =
              null === e || void 0 === e
                ? void 0
                : e(p(b.refValues.current), n);
            t instanceof Promise && (j(!0), t.finally(() => j(!1)));
          }
        },
        onReset: D,
        isValid: F,
        getTransformedValues: (e) => p(e || b.refValues.current),
        key: (e) =>
          ""
            .concat(k, "-")
            .concat(e, "-")
            .concat(E[e] || 0),
        getInputNode: M,
      };
    return (
      (function (e, t) {
        e && xu(e),
          ku("mantine-form:".concat(e, ":set-field-value"), (e) =>
            t.setFieldValue(e.detail.path, e.detail.value)
          ),
          ku("mantine-form:".concat(e, ":set-values"), (e) =>
            t.setValues(e.detail)
          ),
          ku("mantine-form:".concat(e, ":set-initial-values"), (e) =>
            t.setInitialValues(e.detail)
          ),
          ku("mantine-form:".concat(e, ":set-errors"), (e) =>
            t.setErrors(e.detail)
          ),
          ku("mantine-form:".concat(e, ":set-field-error"), (e) =>
            t.setFieldError(e.detail.path, e.detail.error)
          ),
          ku("mantine-form:".concat(e, ":clear-field-error"), (e) =>
            t.clearFieldError(e.detail)
          ),
          ku("mantine-form:".concat(e, ":clear-errors"), t.clearErrors),
          ku("mantine-form:".concat(e, ":reset"), t.reset),
          ku("mantine-form:".concat(e, ":validate"), t.validate),
          ku("mantine-form:".concat(e, ":validate-field"), (e) =>
            t.validateField(e.detail)
          ),
          ku("mantine-form:".concat(e, ":reorder-list-item"), (e) =>
            t.reorderListItem(e.detail.path, e.detail.payload)
          ),
          ku("mantine-form:".concat(e, ":remove-list-item"), (e) =>
            t.removeListItem(e.detail.path, e.detail.index)
          ),
          ku("mantine-form:".concat(e, ":insert-list-item"), (e) =>
            t.insertListItem(e.detail.path, e.detail.item, e.detail.index)
          ),
          ku("mantine-form:".concat(e, ":set-dirty"), (e) =>
            t.setDirty(e.detail)
          ),
          ku("mantine-form:".concat(e, ":set-touched"), (e) =>
            t.setTouched(e.detail)
          ),
          ku("mantine-form:".concat(e, ":reset-dirty"), (e) =>
            t.resetDirty(e.detail)
          ),
          ku("mantine-form:".concat(e, ":reset-touched"), t.resetTouched);
      })(e, I),
      I
    );
  }
  const Ku = (function (e) {
      let t = e,
        n = !1;
      const r = new Set();
      return {
        getState: () => t,
        updateState(e) {
          t = "function" === typeof e ? e(t) : e;
        },
        setState(e) {
          this.updateState(e), r.forEach((e) => e(t));
        },
        initialize(e) {
          n || ((t = e), (n = !0));
        },
        subscribe: (e) => (r.add(e), () => r.delete(e)),
      };
    })({
      notifications: [],
      queue: [],
      defaultPosition: "bottom-right",
      limit: 5,
    }),
    Qu = function () {
      return (function (e) {
        return (0, r.useSyncExternalStore)(
          e.subscribe,
          () => e.getState(),
          () => e.getState()
        );
      })(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ku);
    };
  function Xu(e, t) {
    const n = e.getState(),
      r = (function (e, t, n) {
        const r = [],
          o = [],
          a = {};
        for (const l of e) {
          const e = l.position || t;
          (a[e] = a[e] || 0), (a[e] += 1), a[e] <= n ? o.push(l) : r.push(l);
        }
        return { notifications: o, queue: r };
      })(t([...n.notifications, ...n.queue]), n.defaultPosition, n.limit);
    e.setState({
      notifications: r.notifications,
      queue: r.queue,
      limit: n.limit,
      defaultPosition: n.defaultPosition,
    });
  }
  function Gu(e) {
    return (
      Xu(
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ku,
        (t) =>
          t.filter((t) => {
            var n;
            return (
              t.id !== e ||
              (null === (n = t.onClose) || void 0 === n || n.call(t, t), !1)
            );
          })
      ),
      e
    );
  }
  const Ju = {
      show: function (e) {
        let t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ku;
        const n = e.id || gt();
        return (
          Xu(t, (t) =>
            e.id && t.some((t) => t.id === e.id)
              ? t
              : [...t, f(f({}, e), {}, { id: n })]
          ),
          n
        );
      },
      hide: Gu,
      update: function (e) {
        return (
          Xu(
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ku,
            (t) => t.map((t) => (t.id === e.id ? f(f({}, t), e) : t))
          ),
          e.id
        );
      },
      clean: function () {
        Xu(
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ku,
          () => []
        );
      },
      cleanQueue: function () {
        let e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ku;
        Xu(e, (t) => t.slice(0, e.getState().limit));
      },
      updateState: Xu,
    },
    Zu = "http://localhost:3000";
  const ed = () => {
      const e = Yu({
          initialValues: {
            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            year: "",
            make: "",
            model: "",
            mileage: "",
            vin: "",
            driveType: "",
            engineSize: "",
            catsMissing: !1,
            aluminumWheels: !1,
            vehicleComplete: "",
            realTitle: "",
            needTow: "",
            vehicleIssue: "",
            heardAboutUs: "",
          },
          validate: {
            firstName: (e) =>
              e.trim().length > 0 ? null : "First name is required ",
            lastName: (e) =>
              e.trim().length > 0 ? null : "Last name is required",
            phone: (e) =>
              /^\d{10}$/.test(e) ? null : "Phone number must be 10 digits",
            email: (e) =>
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
                ? null
                : "Invalid email format",
            address: (e) =>
              e.trim().length > 0 ? null : "Address is required",
            city: (e) => (e.trim().length > 0 ? null : "City is required"),
            state: (e) => (e.trim().length > 0 ? null : "State is required"),
            zip: (e) => (e.trim().length > 0 ? null : "Zip is required"),
            year: (e) => (e.trim().length > 0 ? null : "Year is required"),
            make: (e) => (e.trim().length > 0 ? null : "Make is required"),
            model: (e) => (e.trim().length > 0 ? null : "Model is required"),
            mileage: (e) =>
              e.trim().length > 0 ? null : "Mileage is required",
            vin: (e) => (e.trim().length > 0 ? null : "VIN is required"),
            driveType: (e) => (e ? null : "Please select a drive type"),
            engineSize: (e) => (e ? null : "Please write an engine size"),
            vehicleComplete: (e) =>
              e ? null : "Please select whether the vehicle is complete",
            realTitle: (e) =>
              e ? null : "Please select whether you have the real title",
            needTow: (e) =>
              e ? null : "Please select whether towing is needed",
            vehicleIssue: (e) =>
              e.length > 5
                ? null
                : "Please describe the issue (min 5 characters)",
            heardAboutUs: (e) =>
              e ? null : "Please select how you heard about us",
          },
        }),
        t = (0, vt.jsx)(gu, {
          style: { width: "24px", height: "24px" },
          stroke: 1.5,
          color: "#01AD13",
        });
      return (0, vt.jsxs)("div", {
        children: [
          (0, vt.jsx)("div", {
            className: "top-layer",
            children: (0, vt.jsxs)("div", {
              className: "content",
              children: [
                (0, vt.jsxs)("div", {
                  className: "breadcrumbs",
                  children: [
                    (0, vt.jsxs)("li", {
                      className: "home",
                      children: [
                        " ",
                        (0, vt.jsx)("a", { href: "/", children: " Home " }),
                      ],
                    }),
                    " ",
                    (0, vt.jsx)("span", {
                      className: "separator",
                      children: " / ",
                    }),
                    (0, vt.jsxs)("li", {
                      className: "sell-my-car",
                      children: [
                        " ",
                        (0, vt.jsx)("a", {
                          href: "/sell-my-car",
                          children: " Sell My Car ",
                        }),
                      ],
                    }),
                  ],
                }),
                (0, vt.jsx)("h2", { children: " Sell My Car " }),
                (0, vt.jsx)("p", {
                  className: "para",
                  children:
                    "Put some extra cash in your pocket by selling your car to OEM Used Auto Parts . We offer the highest amount in the industry for your old unwanted car.",
                }),
              ],
            }),
          }),
          (0, vt.jsx)("form", {
            onSubmit: e.onSubmit((t) => {
              (async (e) => {
                const t = e.getValues().firstName,
                  n = e.getValues().lastName,
                  r =
                    (e.getValues().email,
                    "New User Query from ".concat(t, " ").concat(n)),
                  o = ((e) => {
                    const {
                      firstName: t,
                      lastName: n,
                      phone: r,
                      email: o,
                      address: a,
                      city: l,
                      state: i,
                      zip: s,
                      year: c,
                      make: u,
                      model: d,
                      mileage: f,
                      vin: p,
                      driveType: m,
                      engineSize: h,
                      catsMissing: v,
                      aluminumWheels: y,
                      vehicleComplete: g,
                      realTitle: b,
                      needTow: w,
                      vehicleIssue: x,
                      heardAboutUs: S,
                    } = e.getValues();
                    return "\n      Hello,\n  \n      You have received a new vehicle inquiry from "
                      .concat(t, " ")
                      .concat(
                        n,
                        ".\n  \n      Here are the details:\n  \n      **Contact Information:**\n      - Phone: "
                      )
                      .concat(r, "\n      - Email: ")
                      .concat(o, "\n      - Address: ")
                      .concat(a, ", ")
                      .concat(l, ", ")
                      .concat(i, ", ")
                      .concat(
                        s,
                        "\n  \n      **Vehicle Information:**\n      - Year: "
                      )
                      .concat(c, "\n      - Make: ")
                      .concat(u, "\n      - Model: ")
                      .concat(d, "\n      - Mileage: ")
                      .concat(f, "\n      - VIN: ")
                      .concat(p, "\n      - Drive Type: ")
                      .concat(m, "\n      - Engine Size: ")
                      .concat(
                        h,
                        "\n      \n      **Vehicle Condition:**\n      - Cats Missing: "
                      )
                      .concat(v ? "Yes" : "No", "\n      - Aluminum Wheels: ")
                      .concat(y ? "Yes" : "No", "\n      - Vehicle Complete: ")
                      .concat(g, "\n      - Real Title: ")
                      .concat(b, "\n      - Need Tow: ")
                      .concat(w, "\n      - Vehicle Issue: ")
                      .concat(
                        x,
                        "\n      \n      **Additional Information:**\n      - Heard About Us: "
                      )
                      .concat(
                        S,
                        "\n  \n      Please follow up with the user as soon as possible.\n\n    "
                      );
                  })(e),
                  a = await fetch("/a/api/sell-my-car", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ subject: r, body: o }),
                  }),
                  l = await a.json();
                a.ok
                  ? (Ju.show({
                      withCloseButton: !1,
                      position: "top-right",
                      title: "Success",
                      message: "Submitted successfully!",
                      color: "#01AD13",
                      icon: (0, vt.jsx)("img", {
                        width: 40.2,
                        height: 40.2,
                        src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/tick-mark.png",
                        alt: "success",
                      }),
                      className: "my-notification-class",
                      style: { backgroundColor: "#01AD13" },
                    }),
                    e.reset())
                  : (l.error || l.message) &&
                    Ju.show({
                      withCloseButton: !1,
                      position: "top-right",
                      title: "Error",
                      message: l.error || l.message,
                      color: "red",
                      icon: (0, vt.jsx)("img", {
                        width: 40.2,
                        height: 40.2,
                        src: "/salvage-yard/cross.svg",
                        alt: "success",
                      }),
                      className: "my-notification-class",
                      style: { backgroundColor: "red" },
                      autoClose: 5e3,
                    });
              })(e);
            }),
            children: (0, vt.jsxs)("div", {
              className: "query-form",
              children: [
                (0, vt.jsxs)("div", {
                  className: "first-section",
                  children: [
                    (0, vt.jsxs)("div", {
                      className: "heading-section ",
                      children: [
                        (0, vt.jsx)("div", {
                          className: "icon",
                          children: (0, vt.jsx)("img", {
                            src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/user_circle.svg",
                            alt: "",
                          }),
                        }),
                        (0, vt.jsx)("span", {
                          className: "tell-your-self",
                          children: " Tell us About Yourself ",
                        }),
                      ],
                    }),
                    (0, vt.jsxs)(mu, {
                      className: "mt-4",
                      children: [
                        (0, vt.jsxs)(mu.Col, {
                          span: 6,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "First name" },
                                  e.getInputProps("firstName")
                                ),
                                {},
                                {
                                  rightSection: t,
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsx)(mu.Col, {
                          span: 6,
                          children: (0, vt.jsx)(
                            Kc,
                            f(
                              f({}, e.getInputProps("lastName")),
                              {},
                              {
                                rightSection: t,
                                placeholder: "Last name",
                                styles: {
                                  input: {
                                    fontFamily: "var(--font-inter)",
                                    height: "50px",
                                    background: "#F1F2F2",
                                    fontSize: "15.41px",
                                    color: "#000000",
                                    fontWeight: "500",
                                  },
                                },
                              }
                            )
                          ),
                        }),
                      ],
                    }),
                    (0, vt.jsxs)(mu, {
                      className: "mt-2",
                      children: [
                        (0, vt.jsxs)(mu.Col, {
                          span: 6,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "Phone" },
                                  e.getInputProps("phone")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                  rightSection: (0, vt.jsx)(bu, {
                                    style: { width: "24px", height: "24px" },
                                    stroke: 1.5,
                                    color: "#01AD13",
                                  }),
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsx)(mu.Col, {
                          span: 6,
                          children: (0, vt.jsx)(
                            Kc,
                            f(
                              f(
                                { placeholder: "Email" },
                                e.getInputProps("email")
                              ),
                              {},
                              {
                                styles: {
                                  input: {
                                    fontFamily: "var(--font-inter)",
                                    height: "50px",
                                    background: "#F1F2F2",
                                    fontSize: "15.41px",
                                    color: "#000000",
                                    fontWeight: "500",
                                  },
                                },
                                rightSection: (0, vt.jsx)(wu, {
                                  style: { width: "24px", height: "24px" },
                                  stroke: 1.5,
                                  color: "#01AD13",
                                }),
                              }
                            )
                          ),
                        }),
                      ],
                    }),
                    (0, vt.jsx)(mu, {
                      className: "mt-2",
                      children: (0, vt.jsxs)(mu.Col, {
                        span: 12,
                        children: [
                          " ",
                          (0, vt.jsx)(
                            Kc,
                            f(
                              f(
                                { placeholder: "Address" },
                                e.getInputProps("address")
                              ),
                              {},
                              {
                                styles: {
                                  input: {
                                    fontFamily: "var(--font-inter)",
                                    height: "50px",
                                    background: "#F1F2F2",
                                    fontSize: "15.41px",
                                    color: "#000000",
                                    fontWeight: "500",
                                  },
                                },
                              }
                            )
                          ),
                          " ",
                        ],
                      }),
                    }),
                    (0, vt.jsxs)(mu, {
                      className: "mt-2",
                      children: [
                        (0, vt.jsxs)(mu.Col, {
                          span: 4,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "City" },
                                  e.getInputProps("city")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsxs)(mu.Col, {
                          span: 4,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "State" },
                                  e.getInputProps("state")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsxs)(mu.Col, {
                          span: 4,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "Zip" },
                                  e.getInputProps("zip")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
                (0, vt.jsxs)("div", {
                  className: "second-section",
                  children: [
                    (0, vt.jsxs)("div", {
                      className: "heading-section ",
                      children: [
                        (0, vt.jsx)("div", {
                          className: "icon",
                          children: (0, vt.jsx)("img", {
                            src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/car.svg",
                            alt: "",
                          }),
                        }),
                        (0, vt.jsx)("span", {
                          className: "tell-your-self",
                          children: " Tell us About Your Car ",
                        }),
                      ],
                    }),
                    (0, vt.jsxs)(mu, {
                      className: "mt-2",
                      children: [
                        (0, vt.jsxs)(mu.Col, {
                          span: 6,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "Year" },
                                  e.getInputProps("year")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsxs)(mu.Col, {
                          span: 6,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "Make" },
                                  e.getInputProps("make")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsxs)(mu.Col, {
                          span: 6,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "Model" },
                                  e.getInputProps("model")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsxs)(mu.Col, {
                          span: 6,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  { placeholder: "Milage" },
                                  e.getInputProps("mileage")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                        (0, vt.jsxs)(mu.Col, {
                          span: 12,
                          children: [
                            " ",
                            (0, vt.jsx)(
                              Kc,
                              f(
                                f(
                                  {
                                    placeholder:
                                      "VIN Number(Vehicle identification Number)",
                                  },
                                  e.getInputProps("vin")
                                ),
                                {},
                                {
                                  styles: {
                                    input: {
                                      fontFamily: "var(--font-inter)",
                                      height: "50px",
                                      background: "#F1F2F2",
                                      fontSize: "15.41px",
                                      color: "#000000",
                                      fontWeight: "500",
                                    },
                                  },
                                }
                              )
                            ),
                            " ",
                          ],
                        }),
                      ],
                    }),
                    (0, vt.jsx)("div", {
                      className: "mt-4 mb-2 ",
                      children: (0, vt.jsx)(mu, {
                        children: (0, vt.jsx)(mu.Col, {
                          span: 12,
                          children: (0, vt.jsx)(no.Group, {
                            styles: {
                              root: {
                                fontFamily: "var(--font-inter)",
                                fontSize: "90px",
                              },
                            },
                            name: "",
                            label: "",
                            description: "",
                            withAsterisk: !0,
                            children: (0, vt.jsx)(io, {
                              mt: "xs",
                              children: (0, vt.jsxs)("div", {
                                className: "traction-radio-layer",
                                style: {
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                },
                                children: [
                                  (0, vt.jsx)(
                                    no.Group,
                                    f(
                                      f({}, e.getInputProps("driveType")),
                                      {},
                                      {
                                        children: (0, vt.jsxs)("div", {
                                          style: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          },
                                          children: [
                                            (0, vt.jsxs)("p", {
                                              className: "traction-label",
                                              style: {
                                                fontFamily: "var(--font-inter)",
                                                fontSize: "15.41px",
                                                fontWeight: "500",
                                                lineHeight: "19.26px",
                                                color: "#000000",
                                                marginRight: "0.6em",
                                              },
                                              children: [
                                                " ",
                                                "Drive Type :",
                                                " ",
                                              ],
                                            }),
                                            (0, vt.jsx)(no, {
                                              color: "#516186",
                                              styles: {
                                                radio: {
                                                  borderColor: "#49454F",
                                                  color: "#516186",
                                                },
                                                label: {
                                                  fontSize: "15.41px",
                                                  fontWeight: "500",
                                                  lineHeight: "19.26px",
                                                  color: "#000000",
                                                },
                                              },
                                              value: "4*4",
                                              label:
                                                "Four-Wheel Drive (4WD)(4x4)",
                                            }),
                                            (0, vt.jsx)(no, {
                                              color: "#516186",
                                              styles: {
                                                root: { marginLeft: "0.2em" },
                                                radio: {
                                                  borderColor: "#49454F",
                                                },
                                                label: {
                                                  fontSize: "15.41px",
                                                  fontWeight: "500",
                                                  lineHeight: "19.26px",
                                                  color: "#000000",
                                                },
                                              },
                                              value:
                                                "Two-Wheel Drive (2WD)(4x2)",
                                              label:
                                                "Two-Wheel Drive (2WD)(4x2)",
                                            }),
                                          ],
                                        }),
                                      }
                                    )
                                  ),
                                  (0, vt.jsx)("div", {
                                    className: "engine-dropdown",
                                    children: (0, vt.jsx)(
                                      Kc,
                                      f(
                                        f(
                                          {
                                            leftSection: (0, vt.jsx)("img", {
                                              src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/car-green.svg",
                                              alt: "image",
                                            }),
                                            label: "",
                                          },
                                          e.getInputProps("engineSize")
                                        ),
                                        {},
                                        {
                                          placeholder: "Engine size(liters)",
                                          styles: {
                                            input: {
                                              fontFamily: "var(--font-inter)",
                                              height: "50px",
                                              background: "#F1F2F2",
                                            },
                                          },
                                        }
                                      )
                                    ),
                                  }),
                                ],
                              }),
                            }),
                          }),
                        }),
                      }),
                    }),
                    (0, vt.jsx)(mu, {
                      className: "mt-2",
                      children: (0, vt.jsxs)(mu.Col, {
                        span: 12,
                        children: [
                          " ",
                          (0, vt.jsxs)("div", {
                            style: { display: "flex" },
                            children: [
                              (0, vt.jsx)("div", {
                                className: "",
                                children: (0, vt.jsx)(
                                  Lo,
                                  f(
                                    f(
                                      { color: "#516186" },
                                      e.getInputProps("catsMissing", {
                                        type: "checkbox",
                                      })
                                    ),
                                    {},
                                    {
                                      styles: {
                                        root: {
                                          fontFamily: "var(--font-inter)",
                                        },
                                        label: {
                                          fontSize: "15.41px",
                                          fontWeight: "500",
                                          lineHeight: "19.26px",
                                        },
                                      },
                                      labelPosition: "left",
                                      label: "Cats missing",
                                    }
                                  )
                                ),
                              }),
                              (0, vt.jsx)("div", {
                                className: "ml-2",
                                children: (0, vt.jsx)(
                                  Lo,
                                  f(
                                    f(
                                      { color: "#516186" },
                                      e.getInputProps("aluminumWheels", {
                                        type: "checkbox",
                                      })
                                    ),
                                    {},
                                    {
                                      styles: {
                                        root: {
                                          fontFamily: "var(--font-inter)",
                                        },
                                        label: {
                                          fontSize: "15.41px",
                                          fontWeight: "500",
                                          lineHeight: "19.26px",
                                        },
                                      },
                                      labelPosition: "left",
                                      label: "Alluminium wheels",
                                    }
                                  )
                                ),
                              }),
                            ],
                          }),
                        ],
                      }),
                    }),
                    (0, vt.jsxs)(mu, {
                      className: "mt-2",
                      children: [
                        (0, vt.jsx)(mu.Col, {
                          span: 6,
                          children: (0, vt.jsx)(
                            no.Group,
                            f(
                              f({}, e.getInputProps("vehicleComplete")),
                              {},
                              {
                                styles: {
                                  root: { fontFamily: "var(--font-inter)" },
                                  label: {
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    lineHeight: "21.26px",
                                  },
                                },
                                name: "favoriteFramework",
                                label:
                                  "Is the vehicle complete(Engine transmission , wheels ,battery,etc)?",
                                children: (0, vt.jsxs)(io, {
                                  mt: "xs",
                                  children: [
                                    (0, vt.jsx)(no, {
                                      color: "#516186",
                                      styles: {
                                        radio: { borderColor: "#49454F" },
                                        label: {
                                          fontSize: "16px",
                                          fontWeight: "500",
                                          lineHeight: "19.26px",
                                        },
                                      },
                                      value: "yes",
                                      label: "yes",
                                    }),
                                    (0, vt.jsx)(no, {
                                      color: "#516186",
                                      styles: {
                                        radio: { borderColor: "#49454F" },
                                        label: {
                                          fontSize: "16px",
                                          fontWeight: "500",
                                          lineHeight: "19.26px",
                                        },
                                      },
                                      value: "no",
                                      label: "no",
                                    }),
                                  ],
                                }),
                              }
                            )
                          ),
                        }),
                        (0, vt.jsx)(mu.Col, {
                          span: 6,
                          children: (0, vt.jsx)(
                            no.Group,
                            f(
                              f({}, e.getInputProps("realTitle")),
                              {},
                              {
                                styles: {
                                  root: { fontFamily: "var(--font-inter)" },
                                  label: {
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    lineHeight: "19.26px",
                                  },
                                },
                                name: "favoriteFramework1",
                                label: "Do you have real title to the vehicle?",
                                children: (0, vt.jsxs)(io, {
                                  mt: "xs",
                                  children: [
                                    (0, vt.jsx)(no, {
                                      color: "#516186",
                                      styles: {
                                        radio: { borderColor: "#49454F" },
                                        label: {
                                          fontSize: "15.41px",
                                          fontWeight: "500",
                                          lineHeight: "19.26px",
                                          color: "#000000",
                                        },
                                      },
                                      value: "yes",
                                      label: "yes",
                                    }),
                                    (0, vt.jsx)(no, {
                                      color: "#516186",
                                      styles: {
                                        radio: { borderColor: "#49454F" },
                                        label: {
                                          fontSize: "15.41px",
                                          fontWeight: "500",
                                          lineHeight: "19.26px",
                                          color: "#000000",
                                        },
                                      },
                                      value: "no",
                                      label: "no",
                                    }),
                                  ],
                                }),
                              }
                            )
                          ),
                        }),
                      ],
                    }),
                    (0, vt.jsx)("div", {
                      className: "mt-4",
                      children: (0, vt.jsx)(
                        no.Group,
                        f(
                          f({ color: "#516186" }, e.getInputProps("needTow")),
                          {},
                          {
                            styles: {
                              root: { fontFamily: "var(--font-inter)" },
                              label: {
                                fontSize: "16px",
                                fontWeight: "500",
                                lineHeight: "19.26px",
                                color: "#000000",
                              },
                            },
                            name: "favoriteFramewor2",
                            label: "Do we need to tow the vehicle?",
                            children: (0, vt.jsxs)(io, {
                              mt: "xs",
                              children: [
                                (0, vt.jsx)(no, {
                                  color: "#516186",
                                  styles: {
                                    radio: { borderColor: "#49454F" },
                                    label: {
                                      fontSize: "15.41px",
                                      fontWeight: "500",
                                      lineHeight: "19.26px",
                                      color: "#000000",
                                    },
                                  },
                                  value: "yes",
                                  label: "yes",
                                }),
                                (0, vt.jsx)(no, {
                                  color: "#516186",
                                  styles: {
                                    radio: { borderColor: "#49454F" },
                                    label: {
                                      fontSize: "15.41px",
                                      fontWeight: "500",
                                      lineHeight: "19.26px",
                                      color: "#000000",
                                    },
                                  },
                                  value: "no",
                                  label: "no",
                                }),
                              ],
                            }),
                          }
                        )
                      ),
                    }),
                    (0, vt.jsx)(mu, {
                      className: "mt-2",
                      children: (0, vt.jsxs)(mu.Col, {
                        span: 12,
                        children: [
                          " ",
                          (0, vt.jsx)(
                            Kc,
                            f(
                              f({}, e.getInputProps("vehicleIssue")),
                              {},
                              {
                                placeholder:
                                  "What\u2019s wrong with the vehicle?",
                                styles: {
                                  input: {
                                    fontFamily: "var(--font-inter)",
                                    height: "50px",
                                    background: "#F1F2F2",
                                    fontSize: "15.41px",
                                    color: "#000000",
                                    fontWeight: "500",
                                  },
                                },
                              }
                            )
                          ),
                          " ",
                        ],
                      }),
                    }),
                    (0, vt.jsx)("div", {
                      className: "mt-4",
                      children: (0, vt.jsx)(
                        qc,
                        f(
                          f({ label: "" }, e.getInputProps("heardAboutUs")),
                          {},
                          {
                            placeholder: "How did you hear about us",
                            data: [
                              "Social Media",
                              "Google Ads",
                              "Friend",
                              "Mechanic",
                            ],
                            styles: {
                              input: {
                                fontFamily: "var(--font-inter)",
                                height: "50px",
                                background: "#F1F2F2",
                              },
                            },
                          }
                        )
                      ),
                    }),
                    (0, vt.jsx)("div", {
                      className: "align-end",
                      children: (0, vt.jsx)("button", {
                        className: "form-submit-btn",
                        children: "Submit",
                      }),
                    }),
                  ],
                }),
              ],
            }),
          }),
        ],
      });
    },
    td = () => {
      const e = ue();
      return (0, vt.jsx)("div", {
        children: (0, vt.jsxs)("div", {
          className: "header-component",
          children: [
            (0, vt.jsx)("div", {
              className: "top-header",
              children: (0, vt.jsxs)("div", {
                className: "top-header-links",
                children: [
                  (0, vt.jsxs)("button", {
                    className: "call-us-btn",
                    children: [
                      (0, vt.jsx)("div", {
                        className: "icon",
                        children: (0, vt.jsx)("img", {
                          src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/telephone-icon.svg",
                          alt: "icon",
                        }),
                      }),
                      (0, vt.jsx)("p", {
                        children: (0, vt.jsx)("span", {
                          children: (0, vt.jsx)("a", {
                            href: "tel:+1 260-493-1553",
                            children: "Call Us",
                          }),
                        }),
                      }),
                    ],
                  }),
                  (0, vt.jsxs)("button", {
                    className: "email-us-btn",
                    children: [
                      (0, vt.jsx)("div", {
                        className: "icon",
                        children: (0, vt.jsx)("img", {
                          src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/email-icon.svg",
                          alt: "icon",
                        }),
                      }),
                      (0, vt.jsx)("p", {
                        children: (0, vt.jsx)("a", {
                          href: "mailto:support@oemuap.com",
                          children: "Email Us",
                        }),
                      }),
                    ],
                  }),
                ],
              }),
            }),
            (0, vt.jsxs)("div", {
              className: "navigation",
              children: [
                (0, vt.jsx)("div", {
                  className: "nav-logo",
                  children: (0, vt.jsx)("a", {
                    href: "/pages/yard",
                    children: (0, vt.jsx)("img", {
                      className: "image cursor",
                      src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/logo.svg",
                      height: 100,
                      alt: "logo",
                    }),
                  }),
                }),
                (0, vt.jsxs)("div", {
                  className: "navigation-links",
                  children: [
                    (0, vt.jsx)("li", {
                      className: "/pages/yard" === e.pathname ? "active" : "",
                      children: (0, vt.jsx)("a", {
                        href: "/pages/yard",
                        children: "Home",
                      }),
                    }),
                    (0, vt.jsx)("li", {
                      children: (0, vt.jsx)("a", {
                        href: "http://search3371.used-auto-parts.biz/inventory/retail.htm",
                        children: "Search Inventory",
                      }),
                    }),
                    (0, vt.jsx)("a", {
                      href: "/pages/sell-my-car",
                      children: (0, vt.jsx)("button", {
                        className: "junk-my-car",
                        children: "Sell My Car",
                      }),
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      });
    };
  function nd(e) {
    return "auto" === e || "dark" === e || "light" === e;
  }
  function rd() {
    let e,
      { key: t = "mantine-color-scheme-value" } =
        arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return {
      get: (e) => {
        if ("undefined" === typeof window) return e;
        try {
          const n = window.localStorage.getItem(t);
          return nd(n) ? n : e;
        } catch (n) {
          return e;
        }
      },
      set: (e) => {
        try {
          window.localStorage.setItem(t, e);
        } catch (n) {
          console.warn(
            "[@mantine/core] Local storage color scheme manager was unable to save color scheme.",
            n
          );
        }
      },
      subscribe: (n) => {
        (e = (e) => {
          e.storageArea === window.localStorage &&
            e.key === t &&
            nd(e.newValue) &&
            n(e.newValue);
        }),
          window.addEventListener("storage", e);
      },
      unsubscribe: () => {
        window.removeEventListener("storage", e);
      },
      clear: () => {
        window.localStorage.removeItem(t);
      },
    };
  }
  function od() {
    const e = en(),
      t = an(),
      n = Sn(e.breakpoints).reduce((t, n) => {
        const r = e.breakpoints[n].includes("px"),
          o = Gc(e.breakpoints[n]),
          a = r ? "".concat(o - 0.1, "px") : Et(o - 0.1),
          l = r ? "".concat(o, "px") : Et(o);
        return ""
          .concat(t, "@media (max-width: ")
          .concat(a, ") {.mantine-visible-from-")
          .concat(n, " {display: none !important;}}@media (min-width: ")
          .concat(l, ") {.mantine-hidden-from-")
          .concat(n, " {display: none !important;}}");
      }, "");
    return (0, vt.jsx)("style", {
      "data-mantine-styles": "classes",
      nonce: null === t || void 0 === t ? void 0 : t(),
      dangerouslySetInnerHTML: { __html: n },
    });
  }
  function ad(e) {
    return Object.entries(e)
      .map((e) => {
        let [t, n] = e;
        return "".concat(t, ": ").concat(n, ";");
      })
      .join("");
  }
  function ld(e, t) {
    return (Array.isArray(e) ? e : [e]).reduce(
      (e, t) => "".concat(t, "{").concat(e, "}"),
      t
    );
  }
  function id(e) {
    let {
      theme: t,
      color: n,
      colorScheme: r,
      name: o = n,
      withColorValues: a = !0,
    } = e;
    if (!t.colors[n]) return {};
    if ("light" === r) {
      const e = Rt(t, "light"),
        r = {
          ["--mantine-color-".concat(o, "-text")]:
            "var(--mantine-color-".concat(o, "-filled)"),
          ["--mantine-color-".concat(o, "-filled")]: "var(--mantine-color-"
            .concat(o, "-")
            .concat(e, ")"),
          ["--mantine-color-".concat(o, "-filled-hover")]:
            "var(--mantine-color-"
              .concat(o, "-")
              .concat(9 === e ? 8 : e + 1, ")"),
          ["--mantine-color-".concat(o, "-light")]: $t(t.colors[n][e], 0.1),
          ["--mantine-color-".concat(o, "-light-hover")]: $t(
            t.colors[n][e],
            0.12
          ),
          ["--mantine-color-".concat(o, "-light-color")]: "var(--mantine-color-"
            .concat(o, "-")
            .concat(e, ")"),
          ["--mantine-color-".concat(o, "-outline")]: "var(--mantine-color-"
            .concat(o, "-")
            .concat(e, ")"),
          ["--mantine-color-".concat(o, "-outline-hover")]: $t(
            t.colors[n][e],
            0.05
          ),
        };
      return a
        ? f(
            {
              ["--mantine-color-".concat(o, "-0")]: t.colors[n][0],
              ["--mantine-color-".concat(o, "-1")]: t.colors[n][1],
              ["--mantine-color-".concat(o, "-2")]: t.colors[n][2],
              ["--mantine-color-".concat(o, "-3")]: t.colors[n][3],
              ["--mantine-color-".concat(o, "-4")]: t.colors[n][4],
              ["--mantine-color-".concat(o, "-5")]: t.colors[n][5],
              ["--mantine-color-".concat(o, "-6")]: t.colors[n][6],
              ["--mantine-color-".concat(o, "-7")]: t.colors[n][7],
              ["--mantine-color-".concat(o, "-8")]: t.colors[n][8],
              ["--mantine-color-".concat(o, "-9")]: t.colors[n][9],
            },
            r
          )
        : r;
    }
    const l = Rt(t, "dark"),
      i = {
        ["--mantine-color-".concat(o, "-text")]: "var(--mantine-color-".concat(
          o,
          "-4)"
        ),
        ["--mantine-color-".concat(o, "-filled")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(l, ")"),
        ["--mantine-color-".concat(o, "-filled-hover")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(9 === l ? 8 : l + 1, ")"),
        ["--mantine-color-".concat(o, "-light")]: $t(
          t.colors[n][Math.max(0, l - 2)],
          0.15
        ),
        ["--mantine-color-".concat(o, "-light-hover")]: $t(
          t.colors[n][Math.max(0, l - 2)],
          0.2
        ),
        ["--mantine-color-".concat(o, "-light-color")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(Math.max(l - 5, 0), ")"),
        ["--mantine-color-".concat(o, "-outline")]: "var(--mantine-color-"
          .concat(o, "-")
          .concat(Math.max(l - 4, 0), ")"),
        ["--mantine-color-".concat(o, "-outline-hover")]: $t(
          t.colors[n][Math.max(l - 4, 0)],
          0.05
        ),
      };
    return a
      ? f(
          {
            ["--mantine-color-".concat(o, "-0")]: t.colors[n][0],
            ["--mantine-color-".concat(o, "-1")]: t.colors[n][1],
            ["--mantine-color-".concat(o, "-2")]: t.colors[n][2],
            ["--mantine-color-".concat(o, "-3")]: t.colors[n][3],
            ["--mantine-color-".concat(o, "-4")]: t.colors[n][4],
            ["--mantine-color-".concat(o, "-5")]: t.colors[n][5],
            ["--mantine-color-".concat(o, "-6")]: t.colors[n][6],
            ["--mantine-color-".concat(o, "-7")]: t.colors[n][7],
            ["--mantine-color-".concat(o, "-8")]: t.colors[n][8],
            ["--mantine-color-".concat(o, "-9")]: t.colors[n][9],
          },
          i
        )
      : i;
  }
  function sd(e, t, n) {
    Sn(t).forEach((r) =>
      Object.assign(e, { ["--mantine-".concat(n, "-").concat(r)]: t[r] })
    );
  }
  const cd = (e) => {
    const t = Rt(e, "light"),
      n =
        e.defaultRadius in e.radius
          ? e.radius[e.defaultRadius]
          : Ct(e.defaultRadius),
      r = {
        variables: {
          "--mantine-scale": e.scale.toString(),
          "--mantine-cursor-type": e.cursorType,
          "--mantine-color-scheme": "light dark",
          "--mantine-webkit-font-smoothing": e.fontSmoothing
            ? "antialiased"
            : "unset",
          "--mantine-moz-font-smoothing": e.fontSmoothing
            ? "grayscale"
            : "unset",
          "--mantine-color-white": e.white,
          "--mantine-color-black": e.black,
          "--mantine-line-height": e.lineHeights.md,
          "--mantine-font-family": e.fontFamily,
          "--mantine-font-family-monospace": e.fontFamilyMonospace,
          "--mantine-font-family-headings": e.headings.fontFamily,
          "--mantine-heading-font-weight": e.headings.fontWeight,
          "--mantine-heading-text-wrap": e.headings.textWrap,
          "--mantine-radius-default": n,
          "--mantine-primary-color-filled": "var(--mantine-color-".concat(
            e.primaryColor,
            "-filled)"
          ),
          "--mantine-primary-color-filled-hover": "var(--mantine-color-".concat(
            e.primaryColor,
            "-filled-hover)"
          ),
          "--mantine-primary-color-light": "var(--mantine-color-".concat(
            e.primaryColor,
            "-light)"
          ),
          "--mantine-primary-color-light-hover": "var(--mantine-color-".concat(
            e.primaryColor,
            "-light-hover)"
          ),
          "--mantine-primary-color-light-color": "var(--mantine-color-".concat(
            e.primaryColor,
            "-light-color)"
          ),
        },
        light: {
          "--mantine-primary-color-contrast": It(e, "light"),
          "--mantine-color-bright": "var(--mantine-color-black)",
          "--mantine-color-text": e.black,
          "--mantine-color-body": e.white,
          "--mantine-color-error": "var(--mantine-color-red-6)",
          "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
          "--mantine-color-anchor": "var(--mantine-color-"
            .concat(e.primaryColor, "-")
            .concat(t, ")"),
          "--mantine-color-default": "var(--mantine-color-white)",
          "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
          "--mantine-color-default-color": "var(--mantine-color-black)",
          "--mantine-color-default-border": "var(--mantine-color-gray-4)",
          "--mantine-color-dimmed": "var(--mantine-color-gray-6)",
        },
        dark: {
          "--mantine-primary-color-contrast": It(e, "dark"),
          "--mantine-color-bright": "var(--mantine-color-white)",
          "--mantine-color-text": "var(--mantine-color-dark-0)",
          "--mantine-color-body": "var(--mantine-color-dark-7)",
          "--mantine-color-error": "var(--mantine-color-red-8)",
          "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
          "--mantine-color-anchor": "var(--mantine-color-".concat(
            e.primaryColor,
            "-4)"
          ),
          "--mantine-color-default": "var(--mantine-color-dark-6)",
          "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
          "--mantine-color-default-color": "var(--mantine-color-white)",
          "--mantine-color-default-border": "var(--mantine-color-dark-4)",
          "--mantine-color-dimmed": "var(--mantine-color-dark-2)",
        },
      };
    sd(r.variables, e.breakpoints, "breakpoint"),
      sd(r.variables, e.spacing, "spacing"),
      sd(r.variables, e.fontSizes, "font-size"),
      sd(r.variables, e.lineHeights, "line-height"),
      sd(r.variables, e.shadows, "shadow"),
      sd(r.variables, e.radius, "radius"),
      e.colors[e.primaryColor].forEach((t, n) => {
        r.variables["--mantine-primary-color-".concat(n)] =
          "var(--mantine-color-".concat(e.primaryColor, "-").concat(n, ")");
      }),
      Sn(e.colors).forEach((t) => {
        const n = e.colors[t];
        if (
          (function (e) {
            return !!e && "object" === typeof e && "mantine-virtual-color" in e;
          })(n)
        )
          return (
            Object.assign(
              r.light,
              id({
                theme: e,
                name: n.name,
                color: n.light,
                colorScheme: "light",
                withColorValues: !0,
              })
            ),
            void Object.assign(
              r.dark,
              id({
                theme: e,
                name: n.name,
                color: n.dark,
                colorScheme: "dark",
                withColorValues: !0,
              })
            )
          );
        n.forEach((e, n) => {
          r.variables["--mantine-color-".concat(t, "-").concat(n)] = e;
        }),
          Object.assign(
            r.light,
            id({
              theme: e,
              color: t,
              colorScheme: "light",
              withColorValues: !1,
            })
          ),
          Object.assign(
            r.dark,
            id({ theme: e, color: t, colorScheme: "dark", withColorValues: !1 })
          );
      });
    const o = e.headings.sizes;
    return (
      Sn(o).forEach((t) => {
        (r.variables["--mantine-".concat(t, "-font-size")] = o[t].fontSize),
          (r.variables["--mantine-".concat(t, "-line-height")] =
            o[t].lineHeight),
          (r.variables["--mantine-".concat(t, "-font-weight")] =
            o[t].fontWeight || e.headings.fontWeight);
      }),
      r
    );
  };
  const ud = cd(Yt);
  function dd(e) {
    let { cssVariablesSelector: t, deduplicateCssVariables: n } = e;
    const r = en(),
      o = an(),
      a = (function (e) {
        let { theme: t, generator: n } = e;
        const r = cd(t),
          o = null === n || void 0 === n ? void 0 : n(t);
        return o ? Qt(r, o) : r;
      })({ theme: r, generator: on().cssVariablesResolver }),
      l = ":root" === t && n,
      i = (function (e, t) {
        const n = ad(e.variables),
          r = n ? ld(t, n) : "",
          o = ad(e.dark),
          a = ad(e.light),
          l = o
            ? ld(
                "".concat(
                  t,
                  ":host" === t
                    ? '([data-mantine-color-scheme="dark"])'
                    : '[data-mantine-color-scheme="dark"]'
                ),
                o
              )
            : "",
          i = a
            ? ld(
                "".concat(
                  t,
                  ":host" === t
                    ? '([data-mantine-color-scheme="light"])'
                    : '[data-mantine-color-scheme="light"]'
                ),
                a
              )
            : "";
        return "".concat(r).concat(l).concat(i);
      })(
        l
          ? (function (e) {
              const t = { variables: {}, light: {}, dark: {} };
              return (
                Sn(e.variables).forEach((n) => {
                  ud.variables[n] !== e.variables[n] &&
                    (t.variables[n] = e.variables[n]);
                }),
                Sn(e.light).forEach((n) => {
                  ud.light[n] !== e.light[n] && (t.light[n] = e.light[n]);
                }),
                Sn(e.dark).forEach((n) => {
                  ud.dark[n] !== e.dark[n] && (t.dark[n] = e.dark[n]);
                }),
                t
              );
            })(a)
          : a,
        t
      );
    return i
      ? (0, vt.jsx)("style", {
          "data-mantine-styles": !0,
          nonce: null === o || void 0 === o ? void 0 : o(),
          dangerouslySetInnerHTML: {
            __html: ""
              .concat(i)
              .concat(
                l
                  ? ""
                  : ((s = t),
                    "\n  "
                      .concat(
                        s,
                        '[data-mantine-color-scheme="dark"] { --mantine-color-scheme: dark; }\n  '
                      )
                      .concat(
                        s,
                        '[data-mantine-color-scheme="light"] { --mantine-color-scheme: light; }\n'
                      ))
              ),
          },
        })
      : null;
    var s;
  }
  function fd(e, t) {
    var n;
    const r =
        "undefined" !== typeof window &&
        "matchMedia" in window &&
        window.matchMedia("(prefers-color-scheme: dark)").matches,
      o = "auto" !== e ? e : r ? "dark" : "light";
    null === (n = t()) ||
      void 0 === n ||
      n.setAttribute("data-mantine-color-scheme", o);
  }
  function pd(e) {
    let {
      theme: t,
      children: n,
      getStyleNonce: o,
      withStaticClasses: a = !0,
      withGlobalClasses: l = !0,
      deduplicateCssVariables: i = !0,
      withCssVariables: s = !0,
      cssVariablesSelector: c = ":root",
      classNamesPrefix: u = "mantine",
      colorSchemeManager: d = rd(),
      defaultColorScheme: f = "light",
      getRootElement: p = () => document.documentElement,
      cssVariablesResolver: m,
      forceColorScheme: h,
      stylesTransform: v,
    } = e;
    const {
      colorScheme: y,
      setColorScheme: g,
      clearColorScheme: b,
    } = (function (e) {
      let {
        manager: t,
        defaultColorScheme: n,
        getRootElement: o,
        forceColorScheme: a,
      } = e;
      const l = (0, r.useRef)(null),
        [i, s] = (0, r.useState)(() => t.get(n)),
        c = a || i,
        u = (0, r.useCallback)(
          (e) => {
            a || (fd(e, o), s(e), t.set(e));
          },
          [t.set, c, a]
        ),
        d = (0, r.useCallback)(() => {
          s(n), fd(n, o), t.clear();
        }, [t.clear, n]);
      return (
        (0, r.useEffect)(
          () => (t.subscribe(u), t.unsubscribe),
          [t.subscribe, t.unsubscribe]
        ),
        yt(() => {
          fd(t.get(n), o);
        }, []),
        (0, r.useEffect)(() => {
          var e;
          if (a) return fd(a, o), () => {};
          void 0 === a && fd(i, o),
            "undefined" !== typeof window &&
              "matchMedia" in window &&
              (l.current = window.matchMedia("(prefers-color-scheme: dark)"));
          const t = (e) => {
            "auto" === i && fd(e.matches ? "dark" : "light", o);
          };
          return (
            null === (e = l.current) ||
              void 0 === e ||
              e.addEventListener("change", t),
            () => {
              var e;
              return null === (e = l.current) || void 0 === e
                ? void 0
                : e.removeEventListener("change", t);
            }
          );
        }, [i, a]),
        { colorScheme: c, setColorScheme: u, clearColorScheme: d }
      );
    })({
      defaultColorScheme: f,
      forceColorScheme: h,
      manager: d,
      getRootElement: p,
    });
    return (
      (function (e) {
        let { respectReducedMotion: t, getRootElement: n } = e;
        yt(() => {
          var e;
          t &&
            (null === (e = n()) ||
              void 0 === e ||
              e.setAttribute("data-respect-reduced-motion", "true"));
        }, [t]);
      })({
        respectReducedMotion:
          (null === t || void 0 === t ? void 0 : t.respectReducedMotion) || !1,
        getRootElement: p,
      }),
      (0, vt.jsx)(rn.Provider, {
        value: {
          colorScheme: y,
          setColorScheme: g,
          clearColorScheme: b,
          getRootElement: p,
          classNamesPrefix: u,
          getStyleNonce: o,
          cssVariablesResolver: m,
          cssVariablesSelector: c,
          withStaticClasses: a,
          stylesTransform: v,
        },
        children: (0, vt.jsxs)(tn, {
          theme: t,
          children: [
            s &&
              (0, vt.jsx)(dd, {
                cssVariablesSelector: c,
                deduplicateCssVariables: i,
              }),
            l && (0, vt.jsx)(od, {}),
            n,
          ],
        }),
      })
    );
  }
  function md(e, t) {
    return (
      (md = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (e, t) {
            return (e.__proto__ = t), e;
          }),
      md(e, t)
    );
  }
  function hd(e, t) {
    (e.prototype = Object.create(t.prototype)),
      (e.prototype.constructor = e),
      md(e, t);
  }
  (dd.displayName = "@mantine/CssVariables"),
    (function () {
      const e = console.error;
      console.error = function () {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
          n[r] = arguments[r];
        (n.length > 1 &&
          "string" === typeof n[0] &&
          n[0].toLowerCase().includes("extra attributes from the server") &&
          "string" === typeof n[1] &&
          n[1].toLowerCase().includes("data-mantine-color-scheme")) ||
          e(...n);
      };
    })(),
    (pd.displayName = "@mantine/core/MantineProvider");
  const vd = !1,
    yd = r.createContext(null);
  var gd = "unmounted",
    bd = "exited",
    wd = "entering",
    xd = "entered",
    Sd = "exiting",
    kd = (function (e) {
      function t(t, n) {
        var r;
        r = e.call(this, t, n) || this;
        var o,
          a = n && !n.isMounting ? t.enter : t.appear;
        return (
          (r.appearStatus = null),
          t.in
            ? a
              ? ((o = bd), (r.appearStatus = wd))
              : (o = xd)
            : (o = t.unmountOnExit || t.mountOnEnter ? gd : bd),
          (r.state = { status: o }),
          (r.nextCallback = null),
          r
        );
      }
      hd(t, e),
        (t.getDerivedStateFromProps = function (e, t) {
          return e.in && t.status === gd ? { status: bd } : null;
        });
      var n = t.prototype;
      return (
        (n.componentDidMount = function () {
          this.updateStatus(!0, this.appearStatus);
        }),
        (n.componentDidUpdate = function (e) {
          var t = null;
          if (e !== this.props) {
            var n = this.state.status;
            this.props.in
              ? n !== wd && n !== xd && (t = wd)
              : (n !== wd && n !== xd) || (t = Sd);
          }
          this.updateStatus(!1, t);
        }),
        (n.componentWillUnmount = function () {
          this.cancelNextCallback();
        }),
        (n.getTimeouts = function () {
          var e,
            t,
            n,
            r = this.props.timeout;
          return (
            (e = t = n = r),
            null != r &&
              "number" !== typeof r &&
              ((e = r.exit),
              (t = r.enter),
              (n = void 0 !== r.appear ? r.appear : t)),
            { exit: e, enter: t, appear: n }
          );
        }),
        (n.updateStatus = function (e, t) {
          if ((void 0 === e && (e = !1), null !== t))
            if ((this.cancelNextCallback(), t === wd)) {
              if (this.props.unmountOnExit || this.props.mountOnEnter) {
                var n = this.props.nodeRef
                  ? this.props.nodeRef.current
                  : ga.findDOMNode(this);
                n &&
                  (function (e) {
                    e.scrollTop;
                  })(n);
              }
              this.performEnter(e);
            } else this.performExit();
          else
            this.props.unmountOnExit &&
              this.state.status === bd &&
              this.setState({ status: gd });
        }),
        (n.performEnter = function (e) {
          var t = this,
            n = this.props.enter,
            r = this.context ? this.context.isMounting : e,
            o = this.props.nodeRef ? [r] : [ga.findDOMNode(this), r],
            a = o[0],
            l = o[1],
            i = this.getTimeouts(),
            s = r ? i.appear : i.enter;
          (!e && !n) || vd
            ? this.safeSetState({ status: xd }, function () {
                t.props.onEntered(a);
              })
            : (this.props.onEnter(a, l),
              this.safeSetState({ status: wd }, function () {
                t.props.onEntering(a, l),
                  t.onTransitionEnd(s, function () {
                    t.safeSetState({ status: xd }, function () {
                      t.props.onEntered(a, l);
                    });
                  });
              }));
        }),
        (n.performExit = function () {
          var e = this,
            t = this.props.exit,
            n = this.getTimeouts(),
            r = this.props.nodeRef ? void 0 : ga.findDOMNode(this);
          t && !vd
            ? (this.props.onExit(r),
              this.safeSetState({ status: Sd }, function () {
                e.props.onExiting(r),
                  e.onTransitionEnd(n.exit, function () {
                    e.safeSetState({ status: bd }, function () {
                      e.props.onExited(r);
                    });
                  });
              }))
            : this.safeSetState({ status: bd }, function () {
                e.props.onExited(r);
              });
        }),
        (n.cancelNextCallback = function () {
          null !== this.nextCallback &&
            (this.nextCallback.cancel(), (this.nextCallback = null));
        }),
        (n.safeSetState = function (e, t) {
          (t = this.setNextCallback(t)), this.setState(e, t);
        }),
        (n.setNextCallback = function (e) {
          var t = this,
            n = !0;
          return (
            (this.nextCallback = function (r) {
              n && ((n = !1), (t.nextCallback = null), e(r));
            }),
            (this.nextCallback.cancel = function () {
              n = !1;
            }),
            this.nextCallback
          );
        }),
        (n.onTransitionEnd = function (e, t) {
          this.setNextCallback(t);
          var n = this.props.nodeRef
              ? this.props.nodeRef.current
              : ga.findDOMNode(this),
            r = null == e && !this.props.addEndListener;
          if (n && !r) {
            if (this.props.addEndListener) {
              var o = this.props.nodeRef
                  ? [this.nextCallback]
                  : [n, this.nextCallback],
                a = o[0],
                l = o[1];
              this.props.addEndListener(a, l);
            }
            null != e && setTimeout(this.nextCallback, e);
          } else setTimeout(this.nextCallback, 0);
        }),
        (n.render = function () {
          var e = this.state.status;
          if (e === gd) return null;
          var t = this.props,
            n = t.children,
            o =
              (t.in,
              t.mountOnEnter,
              t.unmountOnExit,
              t.appear,
              t.enter,
              t.exit,
              t.timeout,
              t.addEndListener,
              t.onEnter,
              t.onEntering,
              t.onEntered,
              t.onExit,
              t.onExiting,
              t.onExited,
              t.nodeRef,
              l(t, [
                "children",
                "in",
                "mountOnEnter",
                "unmountOnExit",
                "appear",
                "enter",
                "exit",
                "timeout",
                "addEndListener",
                "onEnter",
                "onEntering",
                "onEntered",
                "onExit",
                "onExiting",
                "onExited",
                "nodeRef",
              ]));
          return r.createElement(
            yd.Provider,
            { value: null },
            "function" === typeof n
              ? n(e, o)
              : r.cloneElement(r.Children.only(n), o)
          );
        }),
        t
      );
    })(r.Component);
  function Cd() {}
  (kd.contextType = yd),
    (kd.propTypes = {}),
    (kd.defaultProps = {
      in: !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: Cd,
      onEntering: Cd,
      onEntered: Cd,
      onExit: Cd,
      onExiting: Cd,
      onExited: Cd,
    }),
    (kd.UNMOUNTED = gd),
    (kd.EXITED = bd),
    (kd.ENTERING = wd),
    (kd.ENTERED = xd),
    (kd.EXITING = Sd);
  const Ed = kd;
  function Nd() {
    return (
      (Nd = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
      Nd.apply(null, arguments)
    );
  }
  function Pd(e, t) {
    var n = Object.create(null);
    return (
      e &&
        r.Children.map(e, function (e) {
          return e;
        }).forEach(function (e) {
          n[e.key] = (function (e) {
            return t && (0, r.isValidElement)(e) ? t(e) : e;
          })(e);
        }),
      n
    );
  }
  function jd(e, t, n) {
    return null != n[t] ? n[t] : e.props[t];
  }
  function zd(e, t, n) {
    var o = Pd(e.children),
      a = (function (e, t) {
        function n(n) {
          return n in t ? t[n] : e[n];
        }
        (e = e || {}), (t = t || {});
        var r,
          o = Object.create(null),
          a = [];
        for (var l in e)
          l in t ? a.length && ((o[l] = a), (a = [])) : a.push(l);
        var i = {};
        for (var s in t) {
          if (o[s])
            for (r = 0; r < o[s].length; r++) {
              var c = o[s][r];
              i[o[s][r]] = n(c);
            }
          i[s] = n(s);
        }
        for (r = 0; r < a.length; r++) i[a[r]] = n(a[r]);
        return i;
      })(t, o);
    return (
      Object.keys(a).forEach(function (l) {
        var i = a[l];
        if ((0, r.isValidElement)(i)) {
          var s = l in t,
            c = l in o,
            u = t[l],
            d = (0, r.isValidElement)(u) && !u.props.in;
          !c || (s && !d)
            ? c || !s || d
              ? c &&
                s &&
                (0, r.isValidElement)(u) &&
                (a[l] = (0, r.cloneElement)(i, {
                  onExited: n.bind(null, i),
                  in: u.props.in,
                  exit: jd(i, "exit", e),
                  enter: jd(i, "enter", e),
                }))
              : (a[l] = (0, r.cloneElement)(i, { in: !1 }))
            : (a[l] = (0, r.cloneElement)(i, {
                onExited: n.bind(null, i),
                in: !0,
                exit: jd(i, "exit", e),
                enter: jd(i, "enter", e),
              }));
        }
      }),
      a
    );
  }
  var Td =
      Object.values ||
      function (e) {
        return Object.keys(e).map(function (t) {
          return e[t];
        });
      },
    Rd = (function (e) {
      function t(t, n) {
        var r,
          o = (r = e.call(this, t, n) || this).handleExited.bind(
            (function (e) {
              if (void 0 === e)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called"
                );
              return e;
            })(r)
          );
        return (
          (r.state = {
            contextValue: { isMounting: !0 },
            handleExited: o,
            firstRender: !0,
          }),
          r
        );
      }
      hd(t, e);
      var n = t.prototype;
      return (
        (n.componentDidMount = function () {
          (this.mounted = !0),
            this.setState({ contextValue: { isMounting: !1 } });
        }),
        (n.componentWillUnmount = function () {
          this.mounted = !1;
        }),
        (t.getDerivedStateFromProps = function (e, t) {
          var n,
            o,
            a = t.children,
            l = t.handleExited;
          return {
            children: t.firstRender
              ? ((n = e),
                (o = l),
                Pd(n.children, function (e) {
                  return (0,
                  r.cloneElement)(e, { onExited: o.bind(null, e), in: !0, appear: jd(e, "appear", n), enter: jd(e, "enter", n), exit: jd(e, "exit", n) });
                }))
              : zd(e, a, l),
            firstRender: !1,
          };
        }),
        (n.handleExited = function (e, t) {
          var n = Pd(this.props.children);
          e.key in n ||
            (e.props.onExited && e.props.onExited(t),
            this.mounted &&
              this.setState(function (t) {
                var n = Nd({}, t.children);
                return delete n[e.key], { children: n };
              }));
        }),
        (n.render = function () {
          var e = this.props,
            t = e.component,
            n = e.childFactory,
            o = l(e, ["component", "childFactory"]),
            a = this.state.contextValue,
            i = Td(this.state.children).map(n);
          return (
            delete o.appear,
            delete o.enter,
            delete o.exit,
            null === t
              ? r.createElement(yd.Provider, { value: a }, i)
              : r.createElement(
                  yd.Provider,
                  { value: a },
                  r.createElement(t, o, i)
                )
          );
        }),
        t
      );
    })(r.Component);
  (Rd.propTypes = {}),
    (Rd.defaultProps = {
      component: "div",
      childFactory: function (e) {
        return e;
      },
    });
  const _d = Rd;
  var Od = function () {
    return (
      (Od =
        Object.assign ||
        function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++)
            for (var o in (t = arguments[n]))
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e;
        }),
      Od.apply(this, arguments)
    );
  };
  function Ad(e, t) {
    var n = {};
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) &&
        t.indexOf(r) < 0 &&
        (n[r] = e[r]);
    if (null != e && "function" === typeof Object.getOwnPropertySymbols) {
      var o = 0;
      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++)
        t.indexOf(r[o]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(e, r[o]) &&
          (n[r[o]] = e[r[o]]);
    }
    return n;
  }
  Object.create;
  function Ld(e, t, n) {
    if (n || 2 === arguments.length)
      for (var r, o = 0, a = t.length; o < a; o++)
        (!r && o in t) ||
          (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
    return e.concat(r || Array.prototype.slice.call(t));
  }
  Object.create;
  "function" === typeof SuppressedError && SuppressedError;
  var Dd = "right-scroll-bar-position",
    Fd = "width-before-scroll-bar";
  function Md(e, t) {
    return "function" === typeof e ? e(t) : e && (e.current = t), e;
  }
  var Id = "undefined" !== typeof window ? r.useLayoutEffect : r.useEffect,
    Vd = new WeakMap();
  function Wd(e, t) {
    var n = (function (e, t) {
      var n = (0, r.useState)(function () {
        return {
          value: e,
          callback: t,
          facade: {
            get current() {
              return n.value;
            },
            set current(e) {
              var t = n.value;
              t !== e && ((n.value = e), n.callback(e, t));
            },
          },
        };
      })[0];
      return (n.callback = t), n.facade;
    })(t || null, function (t) {
      return e.forEach(function (e) {
        return Md(e, t);
      });
    });
    return (
      Id(
        function () {
          var t = Vd.get(n);
          if (t) {
            var r = new Set(t),
              o = new Set(e),
              a = n.current;
            r.forEach(function (e) {
              o.has(e) || Md(e, null);
            }),
              o.forEach(function (e) {
                r.has(e) || Md(e, a);
              });
          }
          Vd.set(n, e);
        },
        [e]
      ),
      n
    );
  }
  function Hd(e) {
    return e;
  }
  function Bd(e, t) {
    void 0 === t && (t = Hd);
    var n = [],
      r = !1,
      o = {
        read: function () {
          if (r)
            throw new Error(
              "Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`."
            );
          return n.length ? n[n.length - 1] : e;
        },
        useMedium: function (e) {
          var o = t(e, r);
          return (
            n.push(o),
            function () {
              n = n.filter(function (e) {
                return e !== o;
              });
            }
          );
        },
        assignSyncMedium: function (e) {
          for (r = !0; n.length; ) {
            var t = n;
            (n = []), t.forEach(e);
          }
          n = {
            push: function (t) {
              return e(t);
            },
            filter: function () {
              return n;
            },
          };
        },
        assignMedium: function (e) {
          r = !0;
          var t = [];
          if (n.length) {
            var o = n;
            (n = []), o.forEach(e), (t = n);
          }
          var a = function () {
              var n = t;
              (t = []), n.forEach(e);
            },
            l = function () {
              return Promise.resolve().then(a);
            };
          l(),
            (n = {
              push: function (e) {
                t.push(e), l();
              },
              filter: function (e) {
                return (t = t.filter(e)), n;
              },
            });
        },
      };
    return o;
  }
  var Ud = (function (e) {
      void 0 === e && (e = {});
      var t = Bd(null);
      return (t.options = Od({ async: !0, ssr: !1 }, e)), t;
    })(),
    $d = function () {},
    qd = r.forwardRef(function (e, t) {
      var n = r.useRef(null),
        o = r.useState({
          onScrollCapture: $d,
          onWheelCapture: $d,
          onTouchMoveCapture: $d,
        }),
        a = o[0],
        l = o[1],
        i = e.forwardProps,
        s = e.children,
        c = e.className,
        u = e.removeScrollBar,
        d = e.enabled,
        f = e.shards,
        p = e.sideCar,
        m = e.noIsolation,
        h = e.inert,
        v = e.allowPinchZoom,
        y = e.as,
        g = void 0 === y ? "div" : y,
        b = e.gapMode,
        w = Ad(e, [
          "forwardProps",
          "children",
          "className",
          "removeScrollBar",
          "enabled",
          "shards",
          "sideCar",
          "noIsolation",
          "inert",
          "allowPinchZoom",
          "as",
          "gapMode",
        ]),
        x = p,
        S = Wd([n, t]),
        k = Od(Od({}, w), a);
      return r.createElement(
        r.Fragment,
        null,
        d &&
          r.createElement(x, {
            sideCar: Ud,
            removeScrollBar: u,
            shards: f,
            noIsolation: m,
            inert: h,
            setCallbacks: l,
            allowPinchZoom: !!v,
            lockRef: n,
            gapMode: b,
          }),
        i
          ? r.cloneElement(r.Children.only(s), Od(Od({}, k), { ref: S }))
          : r.createElement(g, Od({}, k, { className: c, ref: S }), s)
      );
    });
  (qd.defaultProps = { enabled: !0, removeScrollBar: !0, inert: !1 }),
    (qd.classNames = { fullWidth: Fd, zeroRight: Dd });
  var Yd,
    Kd = function (e) {
      var t = e.sideCar,
        n = Ad(e, ["sideCar"]);
      if (!t)
        throw new Error(
          "Sidecar: please provide `sideCar` property to import the right car"
        );
      var o = t.read();
      if (!o) throw new Error("Sidecar medium not found");
      return r.createElement(o, Od({}, n));
    };
  Kd.isSideCarExport = !0;
  function Qd() {
    if (!document) return null;
    var e = document.createElement("style");
    e.type = "text/css";
    var t = Yd || n.nc;
    return t && e.setAttribute("nonce", t), e;
  }
  var Xd = function () {
      var e = 0,
        t = null;
      return {
        add: function (n) {
          var r, o;
          0 == e &&
            (t = Qd()) &&
            ((o = n),
            (r = t).styleSheet
              ? (r.styleSheet.cssText = o)
              : r.appendChild(document.createTextNode(o)),
            (function (e) {
              (
                document.head || document.getElementsByTagName("head")[0]
              ).appendChild(e);
            })(t)),
            e++;
        },
        remove: function () {
          !--e &&
            t &&
            (t.parentNode && t.parentNode.removeChild(t), (t = null));
        },
      };
    },
    Gd = function () {
      var e = (function () {
        var e = Xd();
        return function (t, n) {
          r.useEffect(
            function () {
              return (
                e.add(t),
                function () {
                  e.remove();
                }
              );
            },
            [t && n]
          );
        };
      })();
      return function (t) {
        var n = t.styles,
          r = t.dynamic;
        return e(n, r), null;
      };
    },
    Jd = { left: 0, top: 0, right: 0, gap: 0 },
    Zd = function (e) {
      return parseInt(e || "", 10) || 0;
    },
    ef = function (e) {
      if ((void 0 === e && (e = "margin"), "undefined" === typeof window))
        return Jd;
      var t = (function (e) {
          var t = window.getComputedStyle(document.body),
            n = t["padding" === e ? "paddingLeft" : "marginLeft"],
            r = t["padding" === e ? "paddingTop" : "marginTop"],
            o = t["padding" === e ? "paddingRight" : "marginRight"];
          return [Zd(n), Zd(r), Zd(o)];
        })(e),
        n = document.documentElement.clientWidth,
        r = window.innerWidth;
      return {
        left: t[0],
        top: t[1],
        right: t[2],
        gap: Math.max(0, r - n + t[2] - t[0]),
      };
    },
    tf = Gd(),
    nf = "data-scroll-locked",
    rf = function (e, t, n, r) {
      var o = e.left,
        a = e.top,
        l = e.right,
        i = e.gap;
      return (
        void 0 === n && (n = "margin"),
        "\n  ."
          .concat("with-scroll-bars-hidden", " {\n   overflow: hidden ")
          .concat(r, ";\n   padding-right: ")
          .concat(i, "px ")
          .concat(r, ";\n  }\n  body[")
          .concat(nf, "] {\n    overflow: hidden ")
          .concat(r, ";\n    overscroll-behavior: contain;\n    ")
          .concat(
            [
              t && "position: relative ".concat(r, ";"),
              "margin" === n &&
                "\n    padding-left: "
                  .concat(o, "px;\n    padding-top: ")
                  .concat(a, "px;\n    padding-right: ")
                  .concat(
                    l,
                    "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: "
                  )
                  .concat(i, "px ")
                  .concat(r, ";\n    "),
              "padding" === n &&
                "padding-right: ".concat(i, "px ").concat(r, ";"),
            ]
              .filter(Boolean)
              .join(""),
            "\n  }\n  \n  ."
          )
          .concat(Dd, " {\n    right: ")
          .concat(i, "px ")
          .concat(r, ";\n  }\n  \n  .")
          .concat(Fd, " {\n    margin-right: ")
          .concat(i, "px ")
          .concat(r, ";\n  }\n  \n  .")
          .concat(Dd, " .")
          .concat(Dd, " {\n    right: 0 ")
          .concat(r, ";\n  }\n  \n  .")
          .concat(Fd, " .")
          .concat(Fd, " {\n    margin-right: 0 ")
          .concat(r, ";\n  }\n  \n  body[")
          .concat(nf, "] {\n    ")
          .concat("--removed-body-scroll-bar-size", ": ")
          .concat(i, "px;\n  }\n")
      );
    },
    of = function () {
      var e = parseInt(document.body.getAttribute(nf) || "0", 10);
      return isFinite(e) ? e : 0;
    },
    af = function (e) {
      var t = e.noRelative,
        n = e.noImportant,
        o = e.gapMode,
        a = void 0 === o ? "margin" : o;
      r.useEffect(function () {
        return (
          document.body.setAttribute(nf, (of() + 1).toString()),
          function () {
            var e = of() - 1;
            e <= 0
              ? document.body.removeAttribute(nf)
              : document.body.setAttribute(nf, e.toString());
          }
        );
      }, []);
      var l = r.useMemo(
        function () {
          return ef(a);
        },
        [a]
      );
      return r.createElement(tf, {
        styles: rf(l, !t, a, n ? "" : "!important"),
      });
    },
    lf = !1;
  if ("undefined" !== typeof window)
    try {
      var sf = Object.defineProperty({}, "passive", {
        get: function () {
          return (lf = !0), !0;
        },
      });
      window.addEventListener("test", sf, sf),
        window.removeEventListener("test", sf, sf);
    } catch (lp) {
      lf = !1;
    }
  var cf = !!lf && { passive: !1 },
    uf = function (e, t) {
      if (!(e instanceof Element)) return !1;
      var n = window.getComputedStyle(e);
      return (
        "hidden" !== n[t] &&
        !(
          n.overflowY === n.overflowX &&
          !(function (e) {
            return "TEXTAREA" === e.tagName;
          })(e) &&
          "visible" === n[t]
        )
      );
    },
    df = function (e, t) {
      var n = t.ownerDocument,
        r = t;
      do {
        if (
          ("undefined" !== typeof ShadowRoot &&
            r instanceof ShadowRoot &&
            (r = r.host),
          ff(e, r))
        ) {
          var o = pf(e, r);
          if (o[1] > o[2]) return !0;
        }
        r = r.parentNode;
      } while (r && r !== n.body);
      return !1;
    },
    ff = function (e, t) {
      return "v" === e
        ? (function (e) {
            return uf(e, "overflowY");
          })(t)
        : (function (e) {
            return uf(e, "overflowX");
          })(t);
    },
    pf = function (e, t) {
      return "v" === e
        ? [(n = t).scrollTop, n.scrollHeight, n.clientHeight]
        : (function (e) {
            return [e.scrollLeft, e.scrollWidth, e.clientWidth];
          })(t);
      var n;
    },
    mf = function (e) {
      return "changedTouches" in e
        ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY]
        : [0, 0];
    },
    hf = function (e) {
      return [e.deltaX, e.deltaY];
    },
    vf = function (e) {
      return e && "current" in e ? e.current : e;
    },
    yf = function (e) {
      return "\n  .block-interactivity-"
        .concat(e, " {pointer-events: none;}\n  .allow-interactivity-")
        .concat(e, " {pointer-events: all;}\n");
    },
    gf = 0,
    bf = [];
  function wf(e) {
    for (var t = null; null !== e; )
      e instanceof ShadowRoot && ((t = e.host), (e = e.host)),
        (e = e.parentNode);
    return t;
  }
  const xf =
    ((Sf = function (e) {
      var t = r.useRef([]),
        n = r.useRef([0, 0]),
        o = r.useRef(),
        a = r.useState(gf++)[0],
        l = r.useState(Gd)[0],
        i = r.useRef(e);
      r.useEffect(
        function () {
          i.current = e;
        },
        [e]
      ),
        r.useEffect(
          function () {
            if (e.inert) {
              document.body.classList.add("block-interactivity-".concat(a));
              var t = Ld(
                [e.lockRef.current],
                (e.shards || []).map(vf),
                !0
              ).filter(Boolean);
              return (
                t.forEach(function (e) {
                  return e.classList.add("allow-interactivity-".concat(a));
                }),
                function () {
                  document.body.classList.remove(
                    "block-interactivity-".concat(a)
                  ),
                    t.forEach(function (e) {
                      return e.classList.remove(
                        "allow-interactivity-".concat(a)
                      );
                    });
                }
              );
            }
          },
          [e.inert, e.lockRef.current, e.shards]
        );
      var s = r.useCallback(function (e, t) {
          if (
            ("touches" in e && 2 === e.touches.length) ||
            ("wheel" === e.type && e.ctrlKey)
          )
            return !i.current.allowPinchZoom;
          var r,
            a = mf(e),
            l = n.current,
            s = "deltaX" in e ? e.deltaX : l[0] - a[0],
            c = "deltaY" in e ? e.deltaY : l[1] - a[1],
            u = e.target,
            d = Math.abs(s) > Math.abs(c) ? "h" : "v";
          if ("touches" in e && "h" === d && "range" === u.type) return !1;
          var f = df(d, u);
          if (!f) return !0;
          if ((f ? (r = d) : ((r = "v" === d ? "h" : "v"), (f = df(d, u))), !f))
            return !1;
          if (
            (!o.current && "changedTouches" in e && (s || c) && (o.current = r),
            !r)
          )
            return !0;
          var p = o.current || r;
          return (function (e, t, n, r, o) {
            var a = (function (e, t) {
                return "h" === e && "rtl" === t ? -1 : 1;
              })(e, window.getComputedStyle(t).direction),
              l = a * r,
              i = n.target,
              s = t.contains(i),
              c = !1,
              u = l > 0,
              d = 0,
              f = 0;
            do {
              var p = pf(e, i),
                m = p[0],
                h = p[1] - p[2] - a * m;
              (m || h) && ff(e, i) && ((d += h), (f += m)),
                (i = i instanceof ShadowRoot ? i.host : i.parentNode);
            } while ((!s && i !== document.body) || (s && (t.contains(i) || t === i)));
            return (
              ((u && ((o && Math.abs(d) < 1) || (!o && l > d))) ||
                (!u && ((o && Math.abs(f) < 1) || (!o && -l > f)))) &&
                (c = !0),
              c
            );
          })(p, t, e, "h" === p ? s : c, !0);
        }, []),
        c = r.useCallback(function (e) {
          var n = e;
          if (bf.length && bf[bf.length - 1] === l) {
            var r = "deltaY" in n ? hf(n) : mf(n),
              o = t.current.filter(function (e) {
                return (
                  e.name === n.type &&
                  (e.target === n.target || n.target === e.shadowParent) &&
                  ((t = e.delta), (o = r), t[0] === o[0] && t[1] === o[1])
                );
                var t, o;
              })[0];
            if (o && o.should) n.cancelable && n.preventDefault();
            else if (!o) {
              var a = (i.current.shards || [])
                .map(vf)
                .filter(Boolean)
                .filter(function (e) {
                  return e.contains(n.target);
                });
              (a.length > 0 ? s(n, a[0]) : !i.current.noIsolation) &&
                n.cancelable &&
                n.preventDefault();
            }
          }
        }, []),
        u = r.useCallback(function (e, n, r, o) {
          var a = {
            name: e,
            delta: n,
            target: r,
            should: o,
            shadowParent: wf(r),
          };
          t.current.push(a),
            setTimeout(function () {
              t.current = t.current.filter(function (e) {
                return e !== a;
              });
            }, 1);
        }, []),
        d = r.useCallback(function (e) {
          (n.current = mf(e)), (o.current = void 0);
        }, []),
        f = r.useCallback(function (t) {
          u(t.type, hf(t), t.target, s(t, e.lockRef.current));
        }, []),
        p = r.useCallback(function (t) {
          u(t.type, mf(t), t.target, s(t, e.lockRef.current));
        }, []);
      r.useEffect(function () {
        return (
          bf.push(l),
          e.setCallbacks({
            onScrollCapture: f,
            onWheelCapture: f,
            onTouchMoveCapture: p,
          }),
          document.addEventListener("wheel", c, cf),
          document.addEventListener("touchmove", c, cf),
          document.addEventListener("touchstart", d, cf),
          function () {
            (bf = bf.filter(function (e) {
              return e !== l;
            })),
              document.removeEventListener("wheel", c, cf),
              document.removeEventListener("touchmove", c, cf),
              document.removeEventListener("touchstart", d, cf);
          }
        );
      }, []);
      var m = e.removeScrollBar,
        h = e.inert;
      return r.createElement(
        r.Fragment,
        null,
        h ? r.createElement(l, { styles: yf(a) }) : null,
        m ? r.createElement(af, { gapMode: e.gapMode }) : null
      );
    }),
    Ud.useMedium(Sf),
    Kd);
  var Sf,
    kf = r.forwardRef(function (e, t) {
      return r.createElement(qd, Od({}, e, { ref: t, sideCar: xf }));
    });
  kf.classNames = qd.classNames;
  const Cf = kf,
    Ef = (e) => (e + 1) % 1e6;
  const Nf = [
    "bottom-center",
    "bottom-left",
    "bottom-right",
    "top-center",
    "top-left",
    "top-right",
  ];
  const Pf = {
      left: "translateX(-100%)",
      right: "translateX(100%)",
      "top-center": "translateY(-100%)",
      "bottom-center": "translateY(100%)",
    },
    jf = {
      left: "translateX(0)",
      right: "translateX(0)",
      "top-center": "translateY(0)",
      "bottom-center": "translateY(0)",
    };
  function zf(e) {
    let { state: t, maxHeight: n, position: r, transitionDuration: o } = e;
    const [a, l] = r.split("-"),
      i = "center" === l ? "".concat(a, "-center") : l,
      s = {
        opacity: 0,
        maxHeight: n,
        transform: Pf[i],
        transitionDuration: ""
          .concat(o, "ms, ")
          .concat(o, "ms, ")
          .concat(o, "ms"),
        transitionTimingFunction:
          "cubic-bezier(.51,.3,0,1.21), cubic-bezier(.51,.3,0,1.21), linear",
        transitionProperty: "opacity, transform, max-height",
      },
      c = { opacity: 1, transform: jf[i] },
      u = { opacity: 0, maxHeight: 0, transform: Pf[i] },
      d = { entering: c, entered: c, exiting: u, exited: u };
    return f(f({}, s), d[t]);
  }
  var Tf = {
    root: "m_5ae2e3c",
    barsLoader: "m_7a2bd4cd",
    bar: "m_870bb79",
    "bars-loader-animation": "m_5d2b3b9d",
    dotsLoader: "m_4e3f22d7",
    dot: "m_870c4af",
    "loader-dots-animation": "m_aac34a1",
    ovalLoader: "m_b34414df",
    "oval-loader-animation": "m_f8e89c4b",
  };
  const Rf = ["className"],
    _f = (0, r.forwardRef)((e, t) => {
      let { className: n } = e,
        r = i(e, Rf);
      return (0, vt.jsxs)(
        Bn,
        f(
          f({ component: "span", className: sn(Tf.barsLoader, n) }, r),
          {},
          {
            ref: t,
            children: [
              (0, vt.jsx)("span", { className: Tf.bar }),
              (0, vt.jsx)("span", { className: Tf.bar }),
              (0, vt.jsx)("span", { className: Tf.bar }),
            ],
          }
        )
      );
    });
  _f.displayName = "@mantine/core/Bars";
  const Of = ["className"],
    Af = (0, r.forwardRef)((e, t) => {
      let { className: n } = e,
        r = i(e, Of);
      return (0, vt.jsxs)(
        Bn,
        f(
          f({ component: "span", className: sn(Tf.dotsLoader, n) }, r),
          {},
          {
            ref: t,
            children: [
              (0, vt.jsx)("span", { className: Tf.dot }),
              (0, vt.jsx)("span", { className: Tf.dot }),
              (0, vt.jsx)("span", { className: Tf.dot }),
            ],
          }
        )
      );
    });
  Af.displayName = "@mantine/core/Dots";
  const Lf = ["className"],
    Df = (0, r.forwardRef)((e, t) => {
      let { className: n } = e,
        r = i(e, Lf);
      return (0, vt.jsx)(
        Bn,
        f(
          f({ component: "span", className: sn(Tf.ovalLoader, n) }, r),
          {},
          { ref: t }
        )
      );
    });
  Df.displayName = "@mantine/core/Oval";
  const Ff = [
      "size",
      "color",
      "type",
      "vars",
      "className",
      "style",
      "classNames",
      "styles",
      "unstyled",
      "loaders",
      "variant",
      "children",
    ],
    Mf = { bars: _f, oval: Df, dots: Af },
    If = { loaders: Mf, type: "oval" },
    Vf = (e, t) => {
      let { size: n, color: r } = t;
      return {
        root: {
          "--loader-size": Nt(n, "loader-size"),
          "--loader-color": r ? Ft(r, e) : void 0,
        },
      };
    },
    Wf = $n((e, t) => {
      const n = nn("Loader", If, e),
        {
          size: r,
          color: o,
          type: a,
          vars: l,
          className: s,
          style: c,
          classNames: u,
          styles: d,
          unstyled: p,
          loaders: m,
          variant: h,
          children: v,
        } = n,
        y = i(n, Ff),
        g = bn({
          name: "Loader",
          props: n,
          classes: Tf,
          className: s,
          style: c,
          classNames: u,
          styles: d,
          unstyled: p,
          vars: l,
          varsResolver: Vf,
        });
      return v
        ? (0, vt.jsx)(
            Bn,
            f(f(f({}, g("root")), {}, { ref: t }, y), {}, { children: v })
          )
        : (0, vt.jsx)(
            Bn,
            f(
              f({}, g("root")),
              {},
              { ref: t, component: m[a], variant: h, size: r },
              y
            )
          );
    });
  (Wf.defaultLoaders = Mf),
    (Wf.classes = Tf),
    (Wf.displayName = "@mantine/core/Loader");
  var Hf = {
    root: "m_a513464",
    icon: "m_a4ceffb",
    loader: "m_b0920b15",
    body: "m_a49ed24",
    title: "m_3feedf16",
    description: "m_3d733a3a",
    closeButton: "m_919a4d88",
  };
  const Bf = [
      "className",
      "color",
      "radius",
      "loading",
      "withCloseButton",
      "withBorder",
      "title",
      "icon",
      "children",
      "onClose",
      "closeButtonProps",
      "classNames",
      "style",
      "styles",
      "unstyled",
      "variant",
      "vars",
      "mod",
    ],
    Uf = { withCloseButton: !0 },
    $f = (e, t) => {
      let { radius: n, color: r } = t;
      return {
        root: {
          "--notification-radius": void 0 === n ? void 0 : jt(n),
          "--notification-color": r ? Ft(r, e) : void 0,
        },
      };
    },
    qf = $n((e, t) => {
      const n = nn("Notification", Uf, e),
        {
          className: r,
          color: o,
          radius: a,
          loading: l,
          withCloseButton: s,
          withBorder: c,
          title: u,
          icon: d,
          children: p,
          onClose: m,
          closeButtonProps: h,
          classNames: v,
          style: y,
          styles: g,
          unstyled: b,
          variant: w,
          vars: x,
          mod: S,
        } = n,
        k = i(n, Bf),
        C = bn({
          name: "Notification",
          classes: Hf,
          props: n,
          className: r,
          style: y,
          classNames: v,
          styles: g,
          unstyled: b,
          vars: x,
          varsResolver: $f,
        });
      return (0, vt.jsxs)(
        Bn,
        f(
          f(
            f({}, C("root")),
            {},
            {
              mod: [{ "data-with-icon": !!d || l, "data-with-border": c }, S],
              ref: t,
              variant: w,
            },
            k
          ),
          {},
          {
            role: "alert",
            children: [
              d &&
                !l &&
                (0, vt.jsx)("div", f(f({}, C("icon")), {}, { children: d })),
              l && (0, vt.jsx)(Wf, f({ size: 28, color: o }, C("loader"))),
              (0, vt.jsxs)(
                "div",
                f(
                  f({}, C("body")),
                  {},
                  {
                    children: [
                      u &&
                        (0, vt.jsx)(
                          "div",
                          f(f({}, C("title")), {}, { children: u })
                        ),
                      (0, vt.jsx)(
                        Bn,
                        f(
                          f({}, C("description")),
                          {},
                          { mod: { "data-with-title": !!u }, children: p }
                        )
                      ),
                    ],
                  }
                )
              ),
              s &&
                (0, vt.jsx)(
                  Gi,
                  f(
                    f({ iconSize: 16, color: "gray" }, h),
                    {},
                    { unstyled: b, onClick: m },
                    C("closeButton")
                  )
                ),
            ],
          }
        )
      );
    });
  (qf.classes = Hf), (qf.displayName = "@mantine/core/Notification");
  const Yf = ["data", "onHide", "autoClose"],
    Kf = ["autoClose", "message"],
    Qf = (0, r.forwardRef)((e, t) => {
      let { data: n, onHide: o, autoClose: a } = e,
        l = i(e, Yf);
      const { autoClose: s, message: c } = n,
        u = i(n, Kf),
        d = (function (e, t) {
          return "number" === typeof t ? t : !1 !== t && !1 !== e && e;
        })(a, n.autoClose),
        p = (0, r.useRef)(-1),
        m = () => window.clearTimeout(p.current),
        h = () => {
          o(n.id), m();
        },
        v = () => {
          "number" === typeof d && (p.current = window.setTimeout(h, d));
        };
      return (
        (0, r.useEffect)(() => {
          var e;
          null === (e = n.onOpen) || void 0 === e || e.call(n, n);
        }, []),
        (0, r.useEffect)(() => (v(), m), [d]),
        (0, vt.jsx)(
          qf,
          f(
            f(f({}, l), u),
            {},
            {
              onClose: h,
              ref: t,
              onMouseEnter: m,
              onMouseLeave: v,
              children: c,
            }
          )
        )
      );
    });
  Qf.displayName = "@mantine/notifications/NotificationContainer";
  var Xf = { root: "m_b37d9ac7", notification: "m_5ed0edd0" };
  const Gf = [
      "classNames",
      "className",
      "style",
      "styles",
      "unstyled",
      "vars",
      "position",
      "autoClose",
      "transitionDuration",
      "containerWidth",
      "notificationMaxHeight",
      "limit",
      "zIndex",
      "store",
      "portalProps",
      "withinPortal",
    ],
    Jf = ["style"],
    Zf = Ed,
    ep = {
      position: "bottom-right",
      autoClose: 4e3,
      transitionDuration: 250,
      containerWidth: 440,
      notificationMaxHeight: 200,
      limit: 5,
      zIndex: Ho("overlay"),
      store: Ku,
      withinPortal: !0,
    },
    tp = (e, t) => {
      let { zIndex: n, containerWidth: r } = t;
      return {
        root: {
          "--notifications-z-index":
            null === n || void 0 === n ? void 0 : n.toString(),
          "--notifications-container-width": Ct(r),
        },
      };
    },
    np = $n((e, t) => {
      const n = nn("Notifications", ep, e),
        {
          classNames: o,
          className: a,
          style: l,
          styles: s,
          unstyled: c,
          vars: u,
          position: d,
          autoClose: p,
          transitionDuration: m,
          containerWidth: h,
          notificationMaxHeight: v,
          limit: y,
          zIndex: g,
          store: b,
          portalProps: w,
          withinPortal: x,
        } = n,
        S = i(n, Gf),
        k = en(),
        C = Qu(b),
        E = (function () {
          const [, e] = (0, r.useReducer)(Ef, 0);
          return e;
        })(),
        N = za(),
        P = (0, r.useRef)({}),
        j = (0, r.useRef)(0),
        z = !!k.respectReducedMotion && N ? 1 : m,
        T = bn({
          name: "Notifications",
          classes: Xf,
          props: n,
          className: a,
          style: l,
          classNames: o,
          styles: s,
          unstyled: c,
          vars: u,
          varsResolver: tp,
        });
      (0, r.useEffect)(() => {
        null === b ||
          void 0 === b ||
          b.updateState((e) =>
            f(f({}, e), {}, { limit: y || 5, defaultPosition: d })
          );
      }, [y, d]),
        Yo(() => {
          C.notifications.length > j.current && setTimeout(() => E(), 0),
            (j.current = C.notifications.length);
        }, [C.notifications]);
      const R = (function (e, t) {
          return e.reduce(
            (e, n) => (e[n.position || t].push(n), e),
            Nf.reduce((e, t) => ((e[t] = []), e), {})
          );
        })(C.notifications, d),
        _ = Nf.reduce(
          (e, t) => (
            (e[t] = R[t].map((e) => {
              let { style: n } = e,
                r = i(e, Jf);
              return (0, vt.jsx)(
                Zf,
                {
                  timeout: z,
                  onEnter: () => P.current[r.id].offsetHeight,
                  nodeRef: { current: P.current[r.id] },
                  children: (e) =>
                    (0, vt.jsx)(
                      Qf,
                      f(
                        {
                          ref: (e) => {
                            P.current[r.id] = e;
                          },
                          data: r,
                          onHide: (e) => Gu(e, b),
                          autoClose: p,
                        },
                        T("notification", {
                          style: f(
                            f(
                              {},
                              zf({
                                state: e,
                                position: t,
                                transitionDuration: z,
                                maxHeight: v,
                              })
                            ),
                            n
                          ),
                        })
                      )
                    ),
                },
                r.id
              );
            })),
            e
          ),
          {}
        );
      return (0, vt.jsxs)(
        ka,
        f(
          f({ withinPortal: x }, w),
          {},
          {
            children: [
              (0, vt.jsx)(
                Bn,
                f(
                  f(
                    f({}, T("root")),
                    {},
                    { "data-position": "top-center", ref: t },
                    S
                  ),
                  {},
                  { children: (0, vt.jsx)(_d, { children: _["top-center"] }) }
                )
              ),
              (0, vt.jsx)(
                Bn,
                f(
                  f(f({}, T("root")), {}, { "data-position": "top-left" }, S),
                  {},
                  { children: (0, vt.jsx)(_d, { children: _["top-left"] }) }
                )
              ),
              (0, vt.jsx)(
                Bn,
                f(
                  f(
                    f({}, T("root", { className: Cf.classNames.fullWidth })),
                    {},
                    { "data-position": "top-right" },
                    S
                  ),
                  {},
                  { children: (0, vt.jsx)(_d, { children: _["top-right"] }) }
                )
              ),
              (0, vt.jsx)(
                Bn,
                f(
                  f(
                    f({}, T("root", { className: Cf.classNames.fullWidth })),
                    {},
                    { "data-position": "bottom-right" },
                    S
                  ),
                  {},
                  { children: (0, vt.jsx)(_d, { children: _["bottom-right"] }) }
                )
              ),
              (0, vt.jsx)(
                Bn,
                f(
                  f(
                    f({}, T("root")),
                    {},
                    { "data-position": "bottom-left" },
                    S
                  ),
                  {},
                  { children: (0, vt.jsx)(_d, { children: _["bottom-left"] }) }
                )
              ),
              (0, vt.jsx)(
                Bn,
                f(
                  f(
                    f({}, T("root")),
                    {},
                    { "data-position": "bottom-center" },
                    S
                  ),
                  {},
                  {
                    children: (0, vt.jsx)(_d, { children: _["bottom-center"] }),
                  }
                )
              ),
            ],
          }
        )
      );
    });
  (np.classes = Xf),
    (np.displayName = "@mantine/notifications/Notifications"),
    (np.show = Ju.show),
    (np.hide = Ju.hide),
    (np.update = Ju.update),
    (np.clean = Ju.clean),
    (np.cleanQueue = Ju.cleanQueue),
    (np.updateState = Ju.updateState);
  const rp = () =>
    (0, vt.jsx)("div", {
      children: (0, vt.jsxs)("div", {
        className: "footer-section",
        children: [
          (0, vt.jsxs)("div", {
            className: "left-section",
            children: [
              (0, vt.jsx)("div", {
                className: "logo",
                children: (0, vt.jsx)("img", {
                  className: "main-logo",
                  src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/footer-logo.svg",
                  width: 111,
                  height: 47,
                  alt: "logo",
                }),
              }),
              (0, vt.jsx)("p", {
                className: "copy-right-para",
                children: "\xa9 2024 All rights reserved",
              }),
            ],
          }),
          (0, vt.jsxs)("div", {
            className: "right-section",
            children: [
              (0, vt.jsx)("div", {
                className: "links",
                children: (0, vt.jsx)("li", {
                  className: "terms-of-service mr-2",
                  children: (0, vt.jsx)("a", {
                    href: "/pages/terms-of-service",
                    children: "Terms of service & Privacy Policy",
                  }),
                }),
              }),
              (0, vt.jsxs)("div", {
                className: "follow-us",
                children: [
                  (0, vt.jsx)("h4", { children: "Follow Us:" }),
                  (0, vt.jsxs)("div", {
                    className: "section",
                    children: [
                      (0, vt.jsx)("li", {
                        children: (0, vt.jsx)("a", {
                          target: "_blank",
                          href: "https://www.instagram.com/oemuap/?hl=en",
                          rel: "noopener noreferrer",
                          children: (0, vt.jsx)("img", {
                            src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/instagram.svg",
                            alt: "Instagram",
                          }),
                        }),
                      }),
                      (0, vt.jsx)("li", {
                        children: (0, vt.jsx)("a", {
                          target: "_blank",
                          href: "https://www.facebook.com/people/OEM-Used-Auto-Parts-Fort-Wayne-Indiana/61560464334137/",
                          rel: "noopener noreferrer",
                          children: (0, vt.jsx)("img", {
                            src: "https://cdn.shopify.com/s/files/1/1225/1056/t/13/assets/facebook.svg",
                            alt: "Facebook",
                          }),
                        }),
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
    });
  function op(e) {
    let { children: t } = e;
    return (0, vt.jsxs)("div", {
      children: [
        (0, vt.jsx)(td, {}),
        (0, vt.jsxs)(pd, {
          children: [(0, vt.jsx)(np, {}), t, (0, vt.jsx)(rp, {})],
        }),
      ],
    });
  }
  a.createRoot(document.getElementById("sell-my-car")).render(
    (0, vt.jsx)(r.StrictMode, {
      children: (0, vt.jsx)(it, {
        children: (0, vt.jsx)(op, { children: (0, vt.jsx)(ed, {}) }),
      }),
    })
  );
})();
//# sourceMappingURL=sellMyCar.86aedd5eb7b8193f6ae9.js.map
